
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e4d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e4d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cgCz9", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")), (parcelRequire("dOqqi")), (parcelRequire("dkHeo")), (parcelRequire("33Dov")), (parcelRequire("4Gs7i")), (parcelRequire("3v7ey")), (parcelRequire("9xtq3")), (parcelRequire("dCBbD")), (parcelRequire("ch0KT")), (parcelRequire("QV0jx")), (parcelRequire("9jPYZ")), (parcelRequire("1z9jS")), (parcelRequire("k6BGg")), (parcelRequire("6gSsW")), (parcelRequire("4QIA3")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")), (parcelRequire("jl5kK")), (parcelRequire("5F0ko")), (parcelRequire("lxABR")), (parcelRequire("2Qhlr")), (parcelRequire("dITey")), (parcelRequire("cVYKW")), (parcelRequire("2MnMp")), (parcelRequire("5n9UW")), (parcelRequire("2X3cT")), (parcelRequire("fXAPg")), (parcelRequire("6AdsH")), (parcelRequire("52GAb")), (parcelRequire("fWyuT")), (parcelRequire("8A2QT")), (parcelRequire("4lLjY")), (parcelRequire("iHWrV")), (parcelRequire("en8DC")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("3OBZa", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== 'undefined' && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== 'undefined' && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== 'undefined' && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== 'undefined' && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== 'undefined' && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("kjyEk"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === 'function') try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === 'function') try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error('Native crypto module could not be used to get secure random number.');
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty('init') || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty('toString')) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join('');
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join('');
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error('Malformed UTF-8 data');
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == 'string') data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("jN34i", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("dOqqi", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != 'function') return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("dkHeo", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join('');
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join('');
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("33Dov", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("4Gs7i", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join('');
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("3v7ey", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("9xtq3", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("dCBbD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("ch0KT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("QV0jx", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("9jPYZ", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")), (parcelRequire("QV0jx")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("1z9jS", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("jN34i")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("k6BGg", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("6gSsW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == 'string') key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("4QIA3", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("dCBbD")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("8fUCE", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("9xtq3")), (parcelRequire("6gSsW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("lgRCb", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("8fUCE")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == 'string') return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == 'string') return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("jl5kK", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("5F0ko", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("lxABR", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("2Qhlr", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("dITey", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("cVYKW", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("2MnMp", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("5n9UW", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("2X3cT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("fXAPg", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("6AdsH", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("52GAb", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("fWyuT", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("8A2QT", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("4lLjY", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("iHWrV", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("en8DC", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("3OBZa")), (parcelRequire("33Dov")), (parcelRequire("3v7ey")), (parcelRequire("8fUCE")), (parcelRequire("lgRCb")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});


parcelRegister("dECyV", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + w[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("O5ywn", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;

var $5KQLs = parcelRequire("5KQLs");
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $5KQLs(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $0968fae43eb53960$var$Hash;

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("5KQLs", function(module, exports) {
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $430a2d85d7cad11c$require$Buffer = $1U9GM.Buffer;

var $5RgoW = parcelRequire("5RgoW");

var $aErU4 = parcelRequire("aErU4");
var $430a2d85d7cad11c$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $aErU4(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $430a2d85d7cad11c$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $430a2d85d7cad11c$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $430a2d85d7cad11c$var$useFromArrayBuffer = $430a2d85d7cad11c$var$useArrayBuffer && ($430a2d85d7cad11c$require$Buffer.prototype instanceof Uint8Array || $430a2d85d7cad11c$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($430a2d85d7cad11c$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $430a2d85d7cad11c$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $430a2d85d7cad11c$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($430a2d85d7cad11c$var$useArrayBuffer && $430a2d85d7cad11c$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $430a2d85d7cad11c$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($430a2d85d7cad11c$var$useFromArrayBuffer) {
            var res = $430a2d85d7cad11c$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $430a2d85d7cad11c$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($430a2d85d7cad11c$var$useUint8Array && data instanceof Uint8Array) return $430a2d85d7cad11c$require$Buffer.from(data);
    var isArr = $5RgoW(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $430a2d85d7cad11c$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $430a2d85d7cad11c$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("5RgoW", function(module, exports) {
var $443e9fef32a42cac$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $443e9fef32a42cac$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("aErU4", function(module, exports) {
'use strict';

var $eEkyn = parcelRequire("eEkyn");

var $eW390 = parcelRequire("eW390");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $7c1348d7c62af12b$var$$typedArrayBuffer = $eW390('TypedArray.prototype.buffer', true);

var $hN833 = parcelRequire("hN833");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $7c1348d7c62af12b$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$hN833(x)) throw new $eEkyn('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("eEkyn", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("eW390", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $jyxCz = parcelRequire("jyxCz");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $jyxCz([
    $1zENl('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $jyxCz(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;

var $90JBs = parcelRequire("90JBs");

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");

var $bdePV = parcelRequire("bdePV");

var $dK8VM = parcelRequire("dK8VM");

var $7F9c3 = parcelRequire("7F9c3");

var $4l7TM = parcelRequire("4l7TM");

var $brYbP = parcelRequire("brYbP");

var $1rWQg = parcelRequire("1rWQg");

var $4J7z9 = parcelRequire("4J7z9");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $dYOee = parcelRequire("dYOee");

var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $dYOee ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $dYOee(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $3ERI6 = parcelRequire("3ERI6");

var $eim86 = parcelRequire("eim86");

var $TxOUG = parcelRequire("TxOUG");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$3ERI6 ? undefined : $3ERI6(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5A49f,
    '%eval%': eval,
    '%EvalError%': $hDtVy,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6($3ERI6([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $90JBs,
    '%Object.getOwnPropertyDescriptor%': $dYOee,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9RC8m,
    '%ReferenceError%': $2BaZq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5Ox6r,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $eEkyn,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hFSMY,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9pzbV,
    '%Function.prototype.apply%': $xMvSJ,
    '%Object.defineProperty%': $jAy3M,
    '%Object.getPrototypeOf%': $eim86,
    '%Math.abs%': $bdePV,
    '%Math.floor%': $dK8VM,
    '%Math.max%': $7F9c3,
    '%Math.min%': $4l7TM,
    '%Math.pow%': $brYbP,
    '%Math.round%': $1rWQg,
    '%Math.sign%': $4J7z9,
    '%Reflect.getPrototypeOf%': $TxOUG
};
if ($3ERI6) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $3ERI6($3ERI6(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3ERI6) value = $3ERI6(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call($9pzbV, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call($xMvSJ, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call($9pzbV, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call($9pzbV, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call($9pzbV, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eEkyn('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eEkyn('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5Ox6r('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($dYOee && i + 1 >= parts.length) {
                var desc = $dYOee(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("90JBs", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5A49f", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("hFSMY", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bdePV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("dK8VM", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("7F9c3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4l7TM", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("brYbP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1rWQg", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4J7z9", function(module, exports) {
'use strict';

var $4oiz9 = parcelRequire("4oiz9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4oiz9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4oiz9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("dYOee", function(module, exports) {
'use strict';

var $d4L75 = parcelRequire("d4L75");
var $a2d7d74e83f6c3ed$require$$gOPD = $d4L75;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$require$$gOPD;

});
parcelRegister("d4L75", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("3ERI6", function(module, exports) {
'use strict';

var $TxOUG = parcelRequire("TxOUG");

var $eim86 = parcelRequire("eim86");

var $7kfw3 = parcelRequire("7kfw3");
/** @type {import('.')} */ module.exports = $TxOUG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TxOUG(O);
} : $eim86 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eim86(O);
} : $7kfw3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7kfw3(O);
} : null;

});
parcelRegister("TxOUG", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eim86", function(module, exports) {
'use strict';

var $90JBs = parcelRequire("90JBs");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $90JBs.getPrototypeOf || null;

});

parcelRegister("7kfw3", function(module, exports) {
'use strict';

var $jyxCz = parcelRequire("jyxCz");

var $dYOee = parcelRequire("dYOee");
var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $dYOee && $dYOee(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $jyxCz([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;

});
parcelRegister("jyxCz", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $eEkyn = parcelRequire("eEkyn");

var $9pzbV = parcelRequire("9pzbV");

var $3YvJT = parcelRequire("3YvJT");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eEkyn('a function is required');
    return $3YvJT($gvair, $9pzbV, args);
};

});
parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pzbV", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3YvJT", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");

var $8qWPV = parcelRequire("8qWPV");
/** @type {import('./actualApply')} */ module.exports = $8qWPV || $gvair.call($9pzbV, $xMvSJ);

});
parcelRegister("xMvSJ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("8qWPV", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("4c4Ky", function(module, exports) {
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});



parcelRegister("hN833", function(module, exports) {
'use strict';

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});
parcelRegister("gJrpv", function(module, exports) {
'use strict';

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $eW390 = parcelRequire("eW390");

var $dYOee = parcelRequire("dYOee");

var $3ERI6 = parcelRequire("3ERI6");
var $c2e61c703a2c9ae0$var$$toString = $eW390('Object.prototype.toString');

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $eW390('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $eW390('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $3ERI6) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3ERI6) {
        var proto = $3ERI6(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3ERI6(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $c2e61c703a2c9ae0$var$cache['$' + typedArray] = $cOB0F(descriptor.get);
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $cOB0F(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        /** @type {string} */ var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
'use strict';

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c21e1d005400ef2a$var$isArray(x) {
    return $c21e1d005400ef2a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$isArray(list)) $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("63RD0", function(module, exports) {
'use strict';
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = '[object Object]';
var $469c9f4bd3a650de$var$fnClass = '[object Function]';
var $469c9f4bd3a650de$var$genClass = '[object GeneratorFunction]';
var $469c9f4bd3a650de$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = '[object HTML document.all class]';
var $469c9f4bd3a650de$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
'use strict';

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === 'function') // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("cOB0F", function(module, exports) {
'use strict';

var $BPe9e = parcelRequire("BPe9e");

var $jAy3M = parcelRequire("jAy3M");

var $jyxCz = parcelRequire("jyxCz");

var $1uOip = parcelRequire("1uOip");
module.exports = function callBind(originalFunction) {
    var func = $jyxCz(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $BPe9e(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($jAy3M) $jAy3M(module.exports, 'apply', {
    value: $1uOip
});
else module.exports.apply = $1uOip;

});
parcelRegister("BPe9e", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eEkyn('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $dYOee) {
        var desc = $dYOee(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eEkyn('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eEkyn('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eEkyn('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eEkyn('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eEkyn('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eEkyn('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("i16wS", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRegister("1uOip", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $3YvJT = parcelRequire("3YvJT");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $3YvJT($gvair, $xMvSJ, arguments);
};

});


parcelRegister("3KyxH", function(module, exports) {
'use strict';

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});







parcelRegister("dVcFO", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $a22a6de6a357c37a$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + w[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W; // new Array(64)
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W; // new Array(64)
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $2a05499bef58a0cf$var$gamma1(w[i - 2]) + w[i - 7] + $2a05499bef58a0cf$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + w[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {
'use strict';

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});


parcelRegister("enfq1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha1 = void 0;

var $8Z3pj = parcelRequire("8Z3pj");

var $4VZJ5 = parcelRequire("4VZJ5");

var $ev7Sh = parcelRequire("ev7Sh");

var $5J2Ch = parcelRequire("5J2Ch");

var $b3AtY = parcelRequire("b3AtY");

var $8XVZm = parcelRequire("8XVZm");
var $a76f2c873e1c7f1e$var$Sha1 = /** @class */ function() {
    function Sha1(secret) {
        if ((0, $ev7Sh.supportsWebCrypto)((0, $b3AtY.locateWindow)())) this.hash = new $4VZJ5.Sha1(secret);
        else if ((0, $5J2Ch.isMsWindow)((0, $b3AtY.locateWindow)())) this.hash = new $8Z3pj.Sha1(secret);
        else throw new Error("SHA1 not supported");
    }
    Sha1.prototype.update = function(data, encoding) {
        this.hash.update((0, $8XVZm.convertToBuffer)(data));
    };
    Sha1.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha1.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha1;
}();
module.exports.Sha1 = $a76f2c873e1c7f1e$var$Sha1;

});
parcelRegister("8Z3pj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha1 = void 0;

var $7AggR = parcelRequire("7AggR");

var $eHysl = parcelRequire("eHysl");

var $iqmfT = parcelRequire("iqmfT");

var $b3AtY = parcelRequire("b3AtY");
var $68a6a9d6a4c96a8d$var$Sha1 = /** @class */ function() {
    function Sha1(secret) {
        this.secret = secret;
        this.reset();
    }
    Sha1.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $7AggR.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($68a6a9d6a4c96a8d$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha1.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    Sha1.prototype.reset = function() {
        if (this.secret) {
            this.operation = $68a6a9d6a4c96a8d$var$getKeyPromise(this.secret).then(function(keyData) {
                return (0, $b3AtY.locateWindow)().msCrypto.subtle.sign($eHysl.SHA_1_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $b3AtY.locateWindow)().msCrypto.subtle.digest("SHA-1"));
    };
    return Sha1;
}();
module.exports.Sha1 = $68a6a9d6a4c96a8d$var$Sha1;
function $68a6a9d6a4c96a8d$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $b3AtY.locateWindow)().msCrypto.subtle.importKey("raw", $68a6a9d6a4c96a8d$var$toArrayBufferView(secret), $eHysl.SHA_1_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $68a6a9d6a4c96a8d$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $iqmfT.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("7AggR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $58588446e68c0974$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $58588446e68c0974$var$isEmptyData;

});

parcelRegister("eHysl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_1 = module.exports.SHA_1_HMAC_ALGO = module.exports.SHA_1_HASH = void 0;
module.exports.SHA_1_HASH = {
    name: "SHA-1"
};
module.exports.SHA_1_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_1_HASH
};
module.exports.EMPTY_DATA_SHA_1 = new Uint8Array([
    218,
    57,
    163,
    238,
    94,
    107,
    75,
    13,
    50,
    85,
    191,
    239,
    149,
    96,
    24,
    144,
    175,
    216,
    7,
    9
]);

});

parcelRegister("iqmfT", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $d69beb215036a813$export$c7c5cef950a4d2fc);

var $krfVd = parcelRequire("krfVd");

var $3lZTG = parcelRequire("3lZTG");
var $d69beb215036a813$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $3lZTG.fromUtf8)(input) : (0, $krfVd.fromUtf8)(input);
};
var $d69beb215036a813$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $3lZTG.toUtf8)(input) : (0, $krfVd.toUtf8)(input);
};

});
parcelRegister("krfVd", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $ee12ae0367269f41$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $ee12ae0367269f41$export$b4b216764bb846eb);
var $ee12ae0367269f41$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $ee12ae0367269f41$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("3lZTG", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $271358b93759ea16$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $271358b93759ea16$export$b4b216764bb846eb);
function $271358b93759ea16$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $271358b93759ea16$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});


parcelRegister("b3AtY", function(module, exports) {

$parcel$export(module.exports, "locateWindow", () => $80cc462e9f5bf099$export$2a77db4d0e0dd1ff);
var $80cc462e9f5bf099$var$fallbackWindow = {};
function $80cc462e9f5bf099$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $80cc462e9f5bf099$var$fallbackWindow;
}

});


parcelRegister("4VZJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha1 = void 0;

var $iqmfT = parcelRequire("iqmfT");

var $7AggR = parcelRequire("7AggR");

var $eHysl = parcelRequire("eHysl");

var $b3AtY = parcelRequire("b3AtY");
var $397c5dd5ae89541d$var$Sha1 = /** @class */ function() {
    function Sha1(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $b3AtY.locateWindow)().crypto.subtle.importKey("raw", $397c5dd5ae89541d$var$convertToBuffer(secret), $eHysl.SHA_1_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    }
    Sha1.prototype.update = function(data) {
        if ((0, $7AggR.isEmptyData)(data)) return;
        var update = $397c5dd5ae89541d$var$convertToBuffer(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha1.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $b3AtY.locateWindow)().crypto.subtle.sign($eHysl.SHA_1_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $7AggR.isEmptyData)(this.toHash)) return Promise.resolve($eHysl.EMPTY_DATA_SHA_1);
        return Promise.resolve().then(function() {
            return (0, $b3AtY.locateWindow)().crypto.subtle.digest($eHysl.SHA_1_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha1.prototype.reset = function() {
        this.toHash = new Uint8Array(0);
    };
    return Sha1;
}();
module.exports.Sha1 = $397c5dd5ae89541d$var$Sha1;
function $397c5dd5ae89541d$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $iqmfT.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});

parcelRegister("ev7Sh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kzTHY = parcelRequire("kzTHY");

$kzTHY.__exportStar((parcelRequire("kxobH")), module.exports);

});
parcelRegister("kzTHY", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $efb24a0743932879$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $efb24a0743932879$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $efb24a0743932879$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $efb24a0743932879$var$extendStatics = function(d, b) {
    $efb24a0743932879$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $efb24a0743932879$var$extendStatics(d, b);
};
function $efb24a0743932879$export$a8ba968b8961cb8a(d, b) {
    $efb24a0743932879$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $efb24a0743932879$export$18ce0697a983be9b = function() {
    $efb24a0743932879$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $efb24a0743932879$export$18ce0697a983be9b.apply(this, arguments);
};
function $efb24a0743932879$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $efb24a0743932879$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $efb24a0743932879$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $efb24a0743932879$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $efb24a0743932879$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $efb24a0743932879$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $efb24a0743932879$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $efb24a0743932879$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $efb24a0743932879$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $efb24a0743932879$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $efb24a0743932879$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($efb24a0743932879$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $efb24a0743932879$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $efb24a0743932879$export$10c90e4f7922046c(v) {
    return this instanceof $efb24a0743932879$export$10c90e4f7922046c ? (this.v = v, this) : new $efb24a0743932879$export$10c90e4f7922046c(v);
}
function $efb24a0743932879$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $efb24a0743932879$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $efb24a0743932879$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $efb24a0743932879$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $efb24a0743932879$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $efb24a0743932879$export$19a8beecd37a4c45 === "function" ? $efb24a0743932879$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $efb24a0743932879$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $efb24a0743932879$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $efb24a0743932879$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $efb24a0743932879$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $efb24a0743932879$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("kxobH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $kzTHY = parcelRequire("kzTHY");
var $ef39a6e4a29d7d1f$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $ef39a6e4a29d7d1f$var$supportsWebCrypto(window) {
    if ($ef39a6e4a29d7d1f$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $ef39a6e4a29d7d1f$var$supportsWebCrypto;
function $ef39a6e4a29d7d1f$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $ef39a6e4a29d7d1f$var$supportsSecureRandom;
function $ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle) {
    return subtle && $ef39a6e4a29d7d1f$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $ef39a6e4a29d7d1f$var$supportsSubtleCrypto;
function $ef39a6e4a29d7d1f$var$supportsZeroByteGCM(subtle) {
    return $kzTHY.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return $kzTHY.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$ef39a6e4a29d7d1f$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $ef39a6e4a29d7d1f$var$supportsZeroByteGCM;

});


parcelRegister("5J2Ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eQfwo = parcelRequire("eQfwo");

$eQfwo.__exportStar((parcelRequire("eMy2l")), module.exports);

$eQfwo.__exportStar((parcelRequire("inKXX")), module.exports);

$eQfwo.__exportStar((parcelRequire("cNnlx")), module.exports);

$eQfwo.__exportStar((parcelRequire("8ShfB")), module.exports);

$eQfwo.__exportStar((parcelRequire("5zgQn")), module.exports);

});
parcelRegister("eQfwo", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $ace1f64193e2e0e6$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ace1f64193e2e0e6$var$extendStatics = function(d, b) {
    $ace1f64193e2e0e6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ace1f64193e2e0e6$var$extendStatics(d, b);
};
function $ace1f64193e2e0e6$export$a8ba968b8961cb8a(d, b) {
    $ace1f64193e2e0e6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ace1f64193e2e0e6$export$18ce0697a983be9b = function() {
    $ace1f64193e2e0e6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ace1f64193e2e0e6$export$18ce0697a983be9b.apply(this, arguments);
};
function $ace1f64193e2e0e6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ace1f64193e2e0e6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ace1f64193e2e0e6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ace1f64193e2e0e6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ace1f64193e2e0e6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ace1f64193e2e0e6$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ace1f64193e2e0e6$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ace1f64193e2e0e6$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ace1f64193e2e0e6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ace1f64193e2e0e6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ace1f64193e2e0e6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ace1f64193e2e0e6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ace1f64193e2e0e6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ace1f64193e2e0e6$export$10c90e4f7922046c(v) {
    return this instanceof $ace1f64193e2e0e6$export$10c90e4f7922046c ? (this.v = v, this) : new $ace1f64193e2e0e6$export$10c90e4f7922046c(v);
}
function $ace1f64193e2e0e6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ace1f64193e2e0e6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ace1f64193e2e0e6$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ace1f64193e2e0e6$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ace1f64193e2e0e6$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ace1f64193e2e0e6$export$19a8beecd37a4c45 === "function" ? $ace1f64193e2e0e6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ace1f64193e2e0e6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ace1f64193e2e0e6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ace1f64193e2e0e6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ace1f64193e2e0e6$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ace1f64193e2e0e6$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("eMy2l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("inKXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cNnlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8ShfB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5zgQn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $40dd49703035fb84$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $40dd49703035fb84$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $40dd49703035fb84$var$isMsWindow(window) {
    if ($40dd49703035fb84$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $40dd49703035fb84$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $40dd49703035fb84$var$isMsWindow;

});


parcelRegister("8XVZm", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $j519d = parcelRequire("j519d");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $j519d.convertToBuffer;
    }
});

var $7aVm5 = parcelRequire("7aVm5");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $7aVm5.isEmptyData;
    }
});

var $lBxdf = parcelRequire("lBxdf");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $lBxdf.numToUint8;
    }
});

var $3vXlk = parcelRequire("3vXlk");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $3vXlk.uint32ArrayFrom;
    }
});

});
parcelRegister("j519d", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $de3f5fda7f197684$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $iqmfT = parcelRequire("iqmfT");
// Quick polyfill
var $de3f5fda7f197684$var$fromUtf8 = typeof $de3f5fda7f197684$require$Buffer !== "undefined" && $de3f5fda7f197684$require$Buffer.from ? function(input) {
    return $de3f5fda7f197684$require$Buffer.from(input, "utf8");
} : $iqmfT.fromUtf8;
function $de3f5fda7f197684$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $de3f5fda7f197684$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $de3f5fda7f197684$var$convertToBuffer;

});

parcelRegister("7aVm5", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $5395f51d1bf94cce$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $5395f51d1bf94cce$var$isEmptyData;

});

parcelRegister("lBxdf", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $fba6d101f936c0d0$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $fba6d101f936c0d0$var$numToUint8;

});

parcelRegister("3vXlk", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $28f24c9fc7bfd47c$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $28f24c9fc7bfd47c$var$uint32ArrayFrom;

});



parcelRegister("dZNvx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $jLgwE = parcelRequire("jLgwE");

var $iS0p3 = parcelRequire("iS0p3");

var $hMqoc = parcelRequire("hMqoc");

var $ev7Sh = parcelRequire("ev7Sh");

var $5J2Ch = parcelRequire("5J2Ch");

var $b3AtY = parcelRequire("b3AtY");

var $8XVZm = parcelRequire("8XVZm");
var $a30760100f159708$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $ev7Sh.supportsWebCrypto)((0, $b3AtY.locateWindow)())) this.hash = new $iS0p3.Sha256(secret);
        else if ((0, $5J2Ch.isMsWindow)((0, $b3AtY.locateWindow)())) this.hash = new $jLgwE.Sha256(secret);
        else this.hash = new $hMqoc.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update((0, $8XVZm.convertToBuffer)(data));
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha256;
}();
module.exports.Sha256 = $a30760100f159708$var$Sha256;

});
parcelRegister("jLgwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $5W33V = parcelRequire("5W33V");

var $HuE2p = parcelRequire("HuE2p");

var $iqmfT = parcelRequire("iqmfT");

var $b3AtY = parcelRequire("b3AtY");
var $e62f39bfe4c4c07c$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $5W33V.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($e62f39bfe4c4c07c$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    Sha256.prototype.reset = function() {
        if (this.secret) {
            this.operation = $e62f39bfe4c4c07c$var$getKeyPromise(this.secret).then(function(keyData) {
                return (0, $b3AtY.locateWindow)().msCrypto.subtle.sign($HuE2p.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $b3AtY.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    };
    return Sha256;
}();
module.exports.Sha256 = $e62f39bfe4c4c07c$var$Sha256;
function $e62f39bfe4c4c07c$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $b3AtY.locateWindow)().msCrypto.subtle.importKey("raw", $e62f39bfe4c4c07c$var$toArrayBufferView(secret), $HuE2p.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $e62f39bfe4c4c07c$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $iqmfT.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("5W33V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $4524bea7fa1c3c18$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $4524bea7fa1c3c18$var$isEmptyData;

});

parcelRegister("HuE2p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});


parcelRegister("iS0p3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $8XVZm = parcelRequire("8XVZm");

var $HuE2p = parcelRequire("HuE2p");

var $b3AtY = parcelRequire("b3AtY");
var $dbcd95333c2a53f2$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(data) {
        if ((0, $8XVZm.isEmptyData)(data)) return;
        var update = (0, $8XVZm.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $b3AtY.locateWindow)().crypto.subtle.sign($HuE2p.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $8XVZm.isEmptyData)(this.toHash)) return Promise.resolve($HuE2p.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $b3AtY.locateWindow)().crypto.subtle.digest($HuE2p.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha256.prototype.reset = function() {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $b3AtY.locateWindow)().crypto.subtle.importKey("raw", (0, $8XVZm.convertToBuffer)(_this.secret), $HuE2p.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    };
    return Sha256;
}();
module.exports.Sha256 = $dbcd95333c2a53f2$var$Sha256;

});

parcelRegister("hMqoc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hOJwo = parcelRequire("hOJwo");

$hOJwo.__exportStar((parcelRequire("5PPry")), module.exports);

});
parcelRegister("hOJwo", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $cf8a6ac5d624fdcb$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $cf8a6ac5d624fdcb$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $cf8a6ac5d624fdcb$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $cf8a6ac5d624fdcb$var$extendStatics = function(d, b) {
    $cf8a6ac5d624fdcb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $cf8a6ac5d624fdcb$var$extendStatics(d, b);
};
function $cf8a6ac5d624fdcb$export$a8ba968b8961cb8a(d, b) {
    $cf8a6ac5d624fdcb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cf8a6ac5d624fdcb$export$18ce0697a983be9b = function() {
    $cf8a6ac5d624fdcb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cf8a6ac5d624fdcb$export$18ce0697a983be9b.apply(this, arguments);
};
function $cf8a6ac5d624fdcb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cf8a6ac5d624fdcb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cf8a6ac5d624fdcb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cf8a6ac5d624fdcb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cf8a6ac5d624fdcb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cf8a6ac5d624fdcb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $cf8a6ac5d624fdcb$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $cf8a6ac5d624fdcb$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $cf8a6ac5d624fdcb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cf8a6ac5d624fdcb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cf8a6ac5d624fdcb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cf8a6ac5d624fdcb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cf8a6ac5d624fdcb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cf8a6ac5d624fdcb$export$10c90e4f7922046c(v) {
    return this instanceof $cf8a6ac5d624fdcb$export$10c90e4f7922046c ? (this.v = v, this) : new $cf8a6ac5d624fdcb$export$10c90e4f7922046c(v);
}
function $cf8a6ac5d624fdcb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cf8a6ac5d624fdcb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cf8a6ac5d624fdcb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cf8a6ac5d624fdcb$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $cf8a6ac5d624fdcb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cf8a6ac5d624fdcb$export$19a8beecd37a4c45 === "function" ? $cf8a6ac5d624fdcb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cf8a6ac5d624fdcb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $cf8a6ac5d624fdcb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $cf8a6ac5d624fdcb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cf8a6ac5d624fdcb$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $cf8a6ac5d624fdcb$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("5PPry", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $hOJwo = parcelRequire("hOJwo");

var $1c8c5 = parcelRequire("1c8c5");

var $kr8mE = parcelRequire("kr8mE");

var $8XVZm = parcelRequire("8XVZm");
var $43f99ec25bf03fdb$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new $kr8mE.RawSha256();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $8XVZm.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $8XVZm.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $hOJwo.__awaiter(this, void 0, void 0, function() {
            return $hOJwo.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new $kr8mE.RawSha256();
        if (this.secret) {
            this.outer = new $kr8mE.RawSha256();
            var inner = $43f99ec25bf03fdb$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array($1c8c5.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $1c8c5.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
module.exports.Sha256 = $43f99ec25bf03fdb$var$Sha256;
function $43f99ec25bf03fdb$var$bufferFromSecret(secret) {
    var input = (0, $8XVZm.convertToBuffer)(secret);
    if (input.byteLength > $1c8c5.BLOCK_SIZE) {
        var bufferHash = new $kr8mE.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($1c8c5.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("1c8c5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("kr8mE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $1c8c5 = parcelRequire("1c8c5");
/**
 * @internal
 */ var $ee0cd14483f8bfb8$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($1c8c5.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $1c8c5.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $1c8c5.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $1c8c5.BLOCK_SIZE >= $1c8c5.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $1c8c5.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $1c8c5.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($1c8c5.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($1c8c5.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($1c8c5.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $1c8c5.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($1c8c5.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $ee0cd14483f8bfb8$var$RawSha256;

});




"use strict";
var $4532b754c156253d$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $4532b754c156253d$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $cgCz9 = parcelRequire("cgCz9");
var $45b3c90d57600982$exports = {};
'use strict';
$45b3c90d57600982$exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$45b3c90d57600982$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$exports.sha512 = (parcelRequire("bZI17"));


var $df9de36cc74f2de2$exports = {};
/*! MIT License. Copyright 2015-2018 Richard Moore <me@ricmoo.com>. See LICENSE.txt. */ (function(root) {
    "use strict";
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && arg.name === 'Uint8Array') {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error('Array contains invalid value: ' + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error('unsupported array-like object');
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join('');
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = '0123456789abcdef';
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join('');
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error('AES must be instanitated with `new`');
        Object.defineProperty(this, 'key', {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error('invalid key size (must be 16, 24 or 32 bytes)');
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error('invalid plaintext size (must be 16 bytes)');
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error('invalid ciphertext size (must be 16 bytes)');
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error('AES must be instanitated with `new`');
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error('AES must be instanitated with `new`');
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error('invalid initialation vector size (must be 16 bytes)');
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error('AES must be instanitated with `new`');
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error('invalid initialation vector size (must be 16 size)');
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error('invalid plaintext size (must be segmentSize bytes)');
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error('invalid ciphertext size (must be segmentSize bytes)');
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error('AES must be instanitated with `new`');
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error('invalid initialation vector size (must be 16 bytes)');
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error('Counter must be instanitated with `new`');
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === 'number') {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== 'number' || parseInt(value) != value) throw new Error('invalid counter value (must be an integer)');
        // We cannot safely handle numbers beyond the safe range for integers
        if (value > Number.MAX_SAFE_INTEGER) throw new Error('integer value out of safe range');
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = parseInt(value / 256);
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error('invalid counter bytes size (must be 16 bytes)');
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error('AES must be instanitated with `new`');
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error('PKCS#7 invalid length');
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error('PKCS#7 padding byte out of range');
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error('PKCS#7 invalid padding byte');
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    $df9de36cc74f2de2$exports = aesjs;
})($df9de36cc74f2de2$exports);


var $6e04ea9f19082e40$exports = {};
var $6e04ea9f19082e40$var$DEF_PAD_LENGTH = 16;
/**
 * Append PKCS#7 padding to a buffer or a string.
 *
 * @see {@link http://tools.ietf.org/html/rfc5652|RFC 5652 section 6.3}
 *
 * @param {!(string|Uint8Array|Uint8ClampedArray)} data - the data to be padded
 * @param {number=} size - the block size to pad for
 * @return {!(string|Uint8Array|Uint8ClampedArray)} the padded data, if the function succeed
 */ function $6e04ea9f19082e40$var$pad(data, size) {
    var out = data;
    if (typeof size !== 'number') size = $6e04ea9f19082e40$var$DEF_PAD_LENGTH;
    else if (size > 255) throw new RangeError('pad(): PKCS#7 padding cannot be longer than 255 bytes');
    else if (size < 0) throw new RangeError('pad(): PKCS#7 padding size must be positive');
    if (typeof data === 'string') {
        var padLen = size - data.length % size;
        if (isNaN(padLen)) padLen = 0;
        var padChar = String.fromCharCode(padLen);
        for(var i = 0; i < padLen; i++)out += padChar;
    } else if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) {
        var baseLen = data.byteLength;
        padLen = size - baseLen % size;
        if (isNaN(padLen)) padLen = 0;
        var newLen = baseLen + padLen;
        out = new data.constructor(newLen);
        out.set(data);
        for(i = baseLen; i < newLen; i++)out[i] = padLen;
    } else throw new TypeError('pad(): data could not be padded');
    return out;
}
/**
 * Remove the PKCS#7 padding from a buffer or a string.
 *
 * @see {@link http://tools.ietf.org/html/rfc5652|RFC 5652 section 6.3}
 *
 * @param {!(string|Uint8Array|Uint8ClampedArray)} data - the data to be unpadded
 * @return {!(string|Uint8Array|Uint8ClampedArray)} the unpadded data, if the function succeed
 */ function $6e04ea9f19082e40$var$unpad(data) {
    var out = data;
    if (typeof data === 'string' && data.length > 0) {
        var padLen = data.charCodeAt(data.length - 1);
        if (padLen > data.length) throw new Error('unpad(): cannot remove ' + padLen + ' bytes from a ' + data.length + '-byte(s) string');
        for(var i = data.length - 2, end = data.length - padLen; i >= end; i--){
            if (data.charCodeAt(i) !== padLen) throw new Error('unpad(): found a padding byte of ' + data.charCodeAt(i) + ' instead of ' + padLen + ' at position ' + i);
        }
        out = data.substring(0, end);
    } else if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) {
        var baseLen = data.byteLength;
        padLen = data[baseLen - 1];
        var newLen = baseLen - padLen;
        if (newLen < 0) throw new Error('unpad(): cannot remove ' + padLen + ' bytes from a ' + baseLen + '-byte(s) string');
        for(i = baseLen - 2; i >= newLen; i--){
            if (data[i] !== padLen) throw new Error('unpad(): found a padding byte of ' + data[i] + ' instead of ' + padLen + ' at position ' + i);
        }
        out = data.slice(0, newLen);
    }
    return out;
}
$6e04ea9f19082e40$exports = {
    pad: $6e04ea9f19082e40$var$pad,
    unpad: $6e04ea9f19082e40$var$unpad
};


var $2163fab358138a9e$exports = {};
"use strict";
// Get parameter value from url
const $2163fab358138a9e$var$getUrlPar = function(url, parName) {
    if (url === '' || url === null) return null;
    const urlObj = new URL(url);
    return urlObj.searchParams.get(parName);
};
// Removes a parameters along with its value from a query string
const $2163fab358138a9e$var$removeUrlPar = function(querystring, parName) {
    let newQueryString = '';
    if (querystring[0] === '?') {
        newQueryString += '?';
        querystring = querystring.substring(1, querystring.length);
    }
    let parts = querystring.split('&');
    let i = 0;
    let n = parts.length;
    let newParts = [];
    for(i = 0; i < n; i++){
        let part = parts[i];
        if (!part.startsWith(parName + '=')) newParts.push(part);
    }
    for(i = 0; i < newParts.length; i++)newQueryString += (i !== 0 ? "&" : "") + newParts[i];
    if (newQueryString === "?") newQueryString = "";
    return newQueryString;
};
const $2163fab358138a9e$var$prep0IfMissing = function(str, n) {
    let output = str + "";
    const strlen = output.length;
    if (strlen < n) {
        const m = n - strlen;
        for(var i = 0; i < m; i++)output = "0" + output;
        return output;
    }
    return str;
};
// Converts a date string from cloud index file
// to a date object
// Example of such a string:
// "06/27/2022 14:30:55"
const $2163fab358138a9e$var$cloudEntryDateStringToDate = function(datestr) {
    let datemod = datestr.trim();
    let dt = datemod.split(' ');
    let d = dt[0];
    let t = dt[1];
    let dateParts = d.split('/');
    let timeParts = t.split(':');
    let month = dateParts[0];
    let day = dateParts[1];
    let year = dateParts[2];
    let hour = timeParts[0];
    let minutes = timeParts[1];
    let seconds = timeParts[2];
    // Create a date string that will be interpreted as an UTC date
    // The Z at the end of the string makes in interpreted as UTC
    let utcDateStr = year + '-' + month + '-' + day + 'T' + hour + ':' + minutes + ':' + seconds + 'Z';
    let utcDate = new Date(utcDateStr);
    return utcDate;
};
// Convert a date object to a formatted date string.
// Example of output
// "06/27/2022 14:30:55"
const $2163fab358138a9e$var$getFormattedUTCDate = function(date) {
    const utcdatestr = $2163fab358138a9e$var$prep0IfMissing(date.getUTCMonth() + 1, 2) + '/' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCDate(), 2) + '/' + date.getUTCFullYear() + ' ' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCHours(), 2) + ':' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCMinutes(), 2) + ':' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCSeconds(), 2);
    return utcdatestr;
};
// Convert a date object to a formatted date and time string for displaying in the UI
// Example of output
// "2022/06/27 14:30:55"
const $2163fab358138a9e$var$getFormattedUTCDateTimeForUI = function(date) {
    return $2163fab358138a9e$var$getFormattedUTCDateForUI(date) + ' ' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCHours(), 2) + ':' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCMinutes(), 2) + ':' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCSeconds(), 2);
};
// Convert a date object to a formatted date string for displaying in the UI
// Example of output
// "2022/06/27"
const $2163fab358138a9e$var$getFormattedUTCDateForUI = function(date) {
    return date.getUTCFullYear() + '/' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCMonth() + 1, 2) + '/' + $2163fab358138a9e$var$prep0IfMissing(date.getUTCDate(), 2);
};
// Get current formatted UTC date time
const $2163fab358138a9e$var$getCurrentFormattedUTCDate = function() {
    const date = new Date();
    const dateStr = $2163fab358138a9e$var$getFormattedUTCDate(date);
    return dateStr;
};
// Get current formatted UTC date time for displaying in the UI
const $2163fab358138a9e$var$getCurrentFormattedUTCDateTimeForUI = function() {
    return $2163fab358138a9e$var$getFormattedUTCDateTimeForUI(new Date());
};
// Get current formatted UTC date for displaying in the UI
const $2163fab358138a9e$var$getCurrentFormattedUTCDateForUI = function() {
    return $2163fab358138a9e$var$getFormattedUTCDateForUI(new Date());
};
const $2163fab358138a9e$var$getFilenameWithoutExtension = function(filename) {
    let i = filename.lastIndexOf(".");
    if (i >= 0) {
        let result = filename.substring(0, i);
        return result;
    }
    return filename;
};
// Get filename from a full file path
const $2163fab358138a9e$var$getFilenameFromPath = function(path) {
    let parts = path.split(/[\\\/]/);
    let filename = parts[parts.length - 1];
    return filename;
};
// Normalize a relative path to a safe, canonical form for use inside archives.
// - Converts backslashes to forward slashes
// - Collapses repeated slashes
// - Trims leading slashes (keeps paths relative)
// - Resolves '.' and '..' segments
const $2163fab358138a9e$var$normalizeRelativePath = function(p) {
    if (!p) return '';
    let s = String(p).replace(/\\/g, '/');
    s = s.replace(/\/+/g, '/');
    s = s.replace(/^\/+/, '');
    const out = [];
    const parts = s.split('/');
    for(let i = 0; i < parts.length; i++){
        const part = parts[i];
        if (!part || part === '.') continue;
        if (part === '..') {
            if (out.length) out.pop();
            continue;
        }
        out.push(part);
    }
    return out.join('/');
};
// call with with await inside async method to let
// executing method sleep for so many milliseconds
const $2163fab358138a9e$var$sleep = async function(millisec) {
    return new Promise((resolve)=>{
        setTimeout(resolve, millisec);
    });
};
// Repeat a function forever with a delay
const $2163fab358138a9e$var$repeatForever = async function(func, delayMilliseconds) {
    while(true){
        await func();
        await Util.sleep(delayMilliseconds);
    }
};
// Adds or updates a GET parameter in a URL
const $2163fab358138a9e$var$addOrUpdateUrlParameter = function(url, paramName, paramValue) {
    try {
        // Create a new URL object
        const urlObj = new URL(url);
        // Get the URLSearchParams object from the URL
        const params = urlObj.searchParams;
        params.set(paramName, paramValue);
        return urlObj.toString();
    } catch (error) {
        // Handle invalid URLs
        console.error('Invalid URL:', error);
        return url;
    }
};
$2163fab358138a9e$exports = {
    prep0IfMissing: $2163fab358138a9e$var$prep0IfMissing,
    getFormattedUTCDate: $2163fab358138a9e$var$getFormattedUTCDate,
    cloudEntryDateStringToDate: $2163fab358138a9e$var$cloudEntryDateStringToDate,
    getCurrentFormattedUTCDate: $2163fab358138a9e$var$getCurrentFormattedUTCDate,
    getFilenameWithoutExtension: $2163fab358138a9e$var$getFilenameWithoutExtension,
    getFilenameFromPath: $2163fab358138a9e$var$getFilenameFromPath,
    sleep: $2163fab358138a9e$var$sleep,
    repeatForever: $2163fab358138a9e$var$repeatForever,
    getUrlPar: $2163fab358138a9e$var$getUrlPar,
    removeUrlPar: $2163fab358138a9e$var$removeUrlPar,
    addOrUpdateUrlParameter: $2163fab358138a9e$var$addOrUpdateUrlParameter,
    getCurrentFormattedUTCDateTimeForUI: $2163fab358138a9e$var$getCurrentFormattedUTCDateTimeForUI,
    getCurrentFormattedUTCDateForUI: $2163fab358138a9e$var$getCurrentFormattedUTCDateForUI,
    getFormattedUTCDateTimeForUI: $2163fab358138a9e$var$getFormattedUTCDateTimeForUI,
    normalizeRelativePath: $2163fab358138a9e$var$normalizeRelativePath
};


// Creates a random encryption key made up of
// 32 bytes
// Returns Uint8Array object
const $4532b754c156253d$var$createRandomEncryptionKey = function() {
    var bytes = [];
    for(var i = 0; i < 32; i++){
        var b = Math.floor(Math.random() * 256);
        bytes.push(b);
    }
    const arr = new Uint8Array(bytes);
    return arr;
};
// Create random string of length n with the specified letters
// letters : string containing the allowed letters in the generated string
// n : the length of the generated string
const $4532b754c156253d$var$createRandomString = function(letters, n) {
    let lettersLen = letters.length;
    let code = "";
    for(let i = 0; i < n; i++){
        let randIndex = Math.floor(Math.random() * lettersLen);
        code += letters[randIndex];
    }
    return code;
};
// Creates a random GUID
const $4532b754c156253d$var$createGUID = function() {
    let letters = "0123456789abcdef";
    let code = $4532b754c156253d$var$createRandomString(letters, 8) + "-" + $4532b754c156253d$var$createRandomString(letters, 4) + "-" + $4532b754c156253d$var$createRandomString(letters, 4) + "-" + $4532b754c156253d$var$createRandomString(letters, 4) + "-" + $4532b754c156253d$var$createRandomString(letters, 12);
    return code;
};
// Create random small invite code
const $4532b754c156253d$var$createRandomInviteCode = function() {
    // numbers and english uppercase alphabet
    // without the look-alike characters 0, O, 1, I and L
    let letters = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";
    let n = 6;
    let code = $4532b754c156253d$var$createRandomString(letters, n);
    return code;
};
// Convert an array of bytes to an array of words.
// Each word represents 4 bytes
const $4532b754c156253d$var$bytesToWords = function(bytes) {
    return $cgCz9.lib.WordArray.create(bytes.buffer, bytes.length);
};
const $4532b754c156253d$var$wordsToBytes = function(wordArray) {
    var wordCount = wordArray.words.length;
    var byteCount = wordArray.sigBytes;
    const u8arr = new Uint8Array(byteCount);
    var collectedBytes = 0;
    for(let i = 0; i < wordCount; i++){
        var word = wordArray.words[i];
        if (collectedBytes == byteCount) break;
        u8arr[collectedBytes] = word >> 24;
        collectedBytes++;
        if (collectedBytes == byteCount) break;
        u8arr[collectedBytes] = word >> 16 & 0xff;
        collectedBytes++;
        if (collectedBytes == byteCount) break;
        u8arr[collectedBytes] = word >> 8 & 0xff;
        collectedBytes++;
        if (collectedBytes == byteCount) break;
        u8arr[collectedBytes] = word & 0xff;
        collectedBytes++;
    }
    return u8arr;
};
const $4532b754c156253d$var$bytesToBase64 = function(bytes) {
    var words = $4532b754c156253d$var$bytesToWords(bytes);
    var base64 = $cgCz9.enc.Base64.stringify(words);
    return base64;
};
const $4532b754c156253d$var$base64ToBytes = function(base64) {
    var words = $cgCz9.enc.Base64.parse(base64);
    var bytes = $4532b754c156253d$var$wordsToBytes(words);
    return bytes;
};
const $4532b754c156253d$var$byteToHexString = function(byte) {
    var hex = byte.toString(16);
    hex = $2163fab358138a9e$exports.prep0IfMissing(hex, 2);
    hex = hex.toUpperCase();
    return hex;
};
const $4532b754c156253d$var$byteArrayToHexString = function(byteArray) {
    var hex = "";
    var n = byteArray.length;
    var i;
    for(i = 0; i < n; i++){
        var hexByte = $4532b754c156253d$var$byteToHexString(byteArray[i]);
        hex = hex + hexByte;
    }
    return hex;
};
// Creates a base64 hash for an array of bytes
const $4532b754c156253d$var$createHashBase64 = (bytes)=>{
    return $45b3c90d57600982$exports('sha1').update(bytes).digest('base64');
};
// Similar to createHashBase64, but takes in a string
const $4532b754c156253d$var$createHashBase64OfString = (str)=>{
    return $45b3c90d57600982$exports('sha1').update($4532b754c156253d$require$Buffer.from(str, 'ascii')).digest('base64');
};
// Creates a hash for an array of bytes
const $4532b754c156253d$var$createHash = (bytes)=>{
    return $45b3c90d57600982$exports('sha1').update(bytes).digest('hex').toUpperCase();
};
// Creates a random hash that looks like a hash created with createHash
const $4532b754c156253d$var$createRandomHash = ()=>{
    let bytes = [];
    for(let i = 0; i < 256; i++)bytes.push(Math.floor(Math.random() * 256));
    return $4532b754c156253d$var$createHash(new Uint8Array(bytes));
};
// Create a 16 byte i vector word array from hash
const $4532b754c156253d$var$createIV = function(hash) {
    var parsedHash = $cgCz9.enc.Base64.parse(hash);
    var words = [];
    for(var i = 0; i < 4; i++)words.push(parsedHash.words[i]);
    var ivWords = $cgCz9.lib.WordArray.create(words, 16);
    return ivWords;
};
// Deterministicly generate a 16 byte IV using a combination of a hash and a counter.
// Useful when encrypting streams, when a unique IV needs to be used
// when encrypting each block.
// Returns the IV as a Uint8Array
const $4532b754c156253d$var$createIVWithCounter = async function(subtleCrypto, hash, counter) {
    // Concatenate hash and counter and then hash the result
    const dataToHash = hash + counter;
    const hashBuffer = await subtleCrypto.digest('SHA-256', new TextEncoder().encode(dataToHash));
    return new Uint8Array(hashBuffer, 0, 16);
};
const $4532b754c156253d$var$nativeEncrypt = async function(subtleCrypto, encryptionKey, objectName, bytes) {
    let algorithm = "AES-CBC";
    let ivWords = $4532b754c156253d$var$createIV(objectName);
    let ivBytes = $4532b754c156253d$var$wordsToBytes(ivWords);
    const key_encoded = await subtleCrypto.importKey("raw", encryptionKey, algorithm, false, [
        "encrypt"
    ]);
    const encrypted_content = await subtleCrypto.encrypt({
        name: algorithm,
        iv: ivBytes
    }, key_encoded, bytes);
    return encrypted_content;
};
// This is a method for encryptiong a stream.
// In case we will be using streams for uploading sometime
// in the future it might be useful to keep this code around.
// subtleCrypto: window.crypto.subtle object to use for encrypting
// encryptionKey: The encryption key
// objectName: Name/hash of object
// readableStream: The stream to encrypt
// Returns a stream with encrypted data.
const $4532b754c156253d$var$nativeEncryptStream = async function(subtleCrypto, encryptionKey, objectName, readableStream) {
    const algorithm = 'AES-CBC';
    let counter = 0;
    // Chunk size
    // The encrypted chunk size will be this size plus 16
    // Because of the padded bytes
    // So when decrypting that has to be kept in mind
    // Might be simplest if this value is always a multiple of 16
    // TODO Automatically add/subtract 16 on this value
    // I think it might be better to have this number a lot larger
    // for better performance, but not too large, we still want
    // to be streaming and not storing large chunks in memory.
    // TODO find out what is a good number to use here
    const partSize = 64;
    let nextPart = new Uint8Array(partSize); // Next output chunk
    // Number of bytes in nextPart that have been written to
    let filledBytes = 0;
    try {
        const key_encoded = await subtleCrypto.importKey('raw', encryptionKey, algorithm, false, [
            'encrypt'
        ]);
        const encryptStream = new TransformStream({
            async transform (chunk, controller) {
                // Total length of chunk
                let chunkLength = chunk.length;
                // Index of next byte in chunk to be copied
                let nextChunkIndex = 0;
                // Continue consuming chunk while there are bytes left to be consumed
                while(nextChunkIndex < chunkLength)// If there are bytes in nextPart remaining to be filled
                if (filledBytes < partSize) {
                    let fillSize = partSize - filledBytes; // Number of bytes in nextPart to fill
                    // Compute the end index in chunks to get data from
                    let topChunkIndex = nextChunkIndex + fillSize;
                    if (topChunkIndex > chunkLength) {
                        topChunkIndex = chunkLength;
                        // Adjust fillSize
                        fillSize = topChunkIndex - nextChunkIndex;
                    }
                    // Copy from chunk to nextPart
                    nextPart.set(chunk.subarray(nextChunkIndex, topChunkIndex), filledBytes);
                    nextChunkIndex += fillSize;
                    filledBytes += fillSize;
                } else {
                    let data = nextPart.slice();
                    // Creating a unique iv
                    // The counter ensures that it is unique
                    let ivBytes = await $4532b754c156253d$var$createIVWithCounter(subtleCrypto, objectName, counter);
                    counter++;
                    let encryptedChunk = await subtleCrypto.encrypt({
                        name: algorithm,
                        iv: ivBytes
                    }, key_encoded, data);
                    controller.enqueue(encryptedChunk);
                    filledBytes = 0;
                }
            },
            async flush (controller) {
                // This method is called after all chunks have been processed
                // Any finalization or cleanup logic can be done here
                // In case there are still some filled bytes
                if (filledBytes > 0) {
                    let data = nextPart.subarray(0, filledBytes);
                    let ivBytes = await $4532b754c156253d$var$createIVWithCounter(subtleCrypto, objectName, counter);
                    counter++;
                    let encryptedChunk = await subtleCrypto.encrypt({
                        name: algorithm,
                        iv: ivBytes
                    }, key_encoded, data);
                    controller.enqueue(encryptedChunk);
                }
            }
        });
        // Piping the readable stream through the encryption stream
        const encryptedStream = readableStream.pipeThrough(encryptStream);
        return encryptedStream;
    } catch (error) {
        console.error('Error in nativeEncryptStream:', error);
        throw error; // rethrow the error for further handling if necessary
    }
};
const $4532b754c156253d$var$nativeEncryptStreamOld = async function(subtleCrypto, encryptionKey, objectName, readableStream) {
    const algorithm = 'AES-CBC';
    const ivWords = $4532b754c156253d$var$createIV(objectName);
    const ivBytes = $4532b754c156253d$var$wordsToBytes(ivWords);
    let counter = 0;
    try {
        const key_encoded = await subtleCrypto.importKey('raw', encryptionKey, algorithm, false, [
            'encrypt'
        ]);
        const encryptStream = new TransformStream({
            async transform (chunk, controller) {
                console.log('got chunk ' + counter);
                counter++;
                const encryptedChunk = await subtleCrypto.encrypt({
                    name: algorithm,
                    iv: ivBytes
                }, key_encoded, chunk);
                controller.enqueue(encryptedChunk);
            }
        });
        // Piping the readable stream through the encryption stream
        const encryptedStream = readableStream.pipeThrough(encryptStream);
        return encryptedStream;
    } catch (error) {
        console.error('Error in nativeEncryptStream:', error);
        throw error; // rethrow the error for further handling if necessary
    }
};
const $4532b754c156253d$var$nativeDecrypt = async function(subtleCrypto, encryptionKey, objectName, encryptedBytes) {
    let algorithm = "AES-CBC";
    let ivWords = $4532b754c156253d$var$createIV(objectName);
    let ivBytes = $4532b754c156253d$var$wordsToBytes(ivWords);
    const keyEncoded = await subtleCrypto.importKey("raw", encryptionKey, algorithm, false, [
        "decrypt"
    ]);
    const decryptedContent = await subtleCrypto.decrypt({
        name: algorithm,
        iv: ivBytes
    }, keyEncoded, encryptedBytes);
    return decryptedContent;
};
function $4532b754c156253d$var$convert32BitIntArrayToByteArray(arr) {
    const out = [];
    for (const int32 of arr){
        const byte1 = 0xff & int32;
        const byte2 = 0xff & int32 >> 8;
        const byte3 = 0xff & int32 >> 16;
        const byte4 = 0xff & int32 >> 24;
        out.push(byte4, byte3, byte2, byte1);
    }
    return out;
}
// Encrypt bytes for an object using an encryption key and name of object
const $4532b754c156253d$var$encryptObjectData = function(encryptionKey, objectName, bytes) {
    const iv = $4532b754c156253d$var$createIV(objectName);
    const ivBytes = $4532b754c156253d$var$convert32BitIntArrayToByteArray(iv.words);
    // Pad bytes using PKCS7 padding
    //
    // Because ArrayBuffers (and by extension Uint8Arrays) are fixed-size, this
    // creates a new Uint8Array (i.e. duplicates it in memory).
    bytes = $6e04ea9f19082e40$exports.pad(bytes);
    const aesCbc = new $df9de36cc74f2de2$exports.ModeOfOperation.cbc(encryptionKey, ivBytes);
    const encryptedBytes = aesCbc.encrypt(bytes);
    return encryptedBytes;
};
// Decrypt bytes for an object using an encryption key and name of object
const $4532b754c156253d$var$decryptObjectData = function(encryptionKey, objectName, encryptedBytes) {
    var ivWords = $4532b754c156253d$var$createIV(objectName);
    var encryptionKeyWords = $4532b754c156253d$var$bytesToWords(encryptionKey);
    var encryptedByteWords = $4532b754c156253d$var$bytesToWords(encryptedBytes);
    var cipherParams = $cgCz9.lib.CipherParams.create({
        ciphertext: encryptedByteWords
    });
    const cipherDecryption = $cgCz9.AES.decrypt(cipherParams, encryptionKeyWords, {
        iv: ivWords,
        padding: $cgCz9.pad.Pkcs7,
        mode: $cgCz9.mode.CBC
    });
    var decryptedBytes = $4532b754c156253d$var$wordsToBytes(cipherDecryption);
    return decryptedBytes;
};
const $4532b754c156253d$var$encryptString = function(encryptionKey, objectName, plaintext) {
    // Convert the plaintext string into a byte array (Uint8Array)
    let encoder = new TextEncoder();
    let plaintextBytes = encoder.encode(plaintext);
    // Encrypt the byte array using the encryptObjectData method
    let encryptedBytes = $4532b754c156253d$var$encryptObjectData(encryptionKey, objectName, plaintextBytes);
    // Convert the encrypted bytes to a base64 string for easier transmission/storage
    let base64Encrypted = $4532b754c156253d$var$bytesToBase64(encryptedBytes);
    return base64Encrypted;
};
const $4532b754c156253d$var$decryptString = function(encryptionKey, objectName, encryptedBase64) {
    // Convert the base64-encoded encrypted string back to a byte array (Uint8Array)
    let encryptedBytes = $4532b754c156253d$var$base64ToBytes(encryptedBase64);
    // Decrypt the byte array using the decryptObjectData method
    let decryptedBytes = $4532b754c156253d$var$decryptObjectData(encryptionKey, objectName, encryptedBytes);
    // Convert the decrypted byte array back to a string
    let decoder = new TextDecoder();
    let decryptedText = decoder.decode(decryptedBytes);
    return decryptedText;
};
$4532b754c156253d$exports = {
    createRandomInviteCode: $4532b754c156253d$var$createRandomInviteCode,
    createRandomEncryptionKey: $4532b754c156253d$var$createRandomEncryptionKey,
    bytesToWords: $4532b754c156253d$var$bytesToWords,
    bytesToBase64: $4532b754c156253d$var$bytesToBase64,
    base64ToBytes: $4532b754c156253d$var$base64ToBytes,
    createHash: $4532b754c156253d$var$createHash,
    createHashBase64: $4532b754c156253d$var$createHashBase64,
    createHashBase64OfString: $4532b754c156253d$var$createHashBase64OfString,
    createRandomHash: $4532b754c156253d$var$createRandomHash,
    encryptObjectData: $4532b754c156253d$var$encryptObjectData,
    decryptObjectData: $4532b754c156253d$var$decryptObjectData,
    createGUID: $4532b754c156253d$var$createGUID,
    nativeEncrypt: $4532b754c156253d$var$nativeEncrypt,
    nativeDecrypt: $4532b754c156253d$var$nativeDecrypt,
    nativeEncryptStream: $4532b754c156253d$var$nativeEncryptStream,
    encryptString: $4532b754c156253d$var$encryptString,
    decryptString: $4532b754c156253d$var$decryptString
};


var $fbf091ffd61010f8$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $fbf091ffd61010f8$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $ff323866fb43afa6$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ff323866fb43afa6$require$Buffer = $6ZWSX.Buffer;
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


!function(e) {
    $ff323866fb43afa6$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $ff323866fb43afa6$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($ff323866fb43afa6$require$Buffer.from && $ff323866fb43afa6$require$Buffer.from !== Uint8Array.from) return $ff323866fb43afa6$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $ff323866fb43afa6$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($ff323866fb43afa6$require$Buffer.alloc) return $ff323866fb43afa6$require$Buffer.alloc(e);
                        var t = new $ff323866fb43afa6$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $ff323866fb43afa6$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $ff323866fb43afa6$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $ff323866fb43afa6$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $cfae44f0dfdf62c0$exports.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


// Converts data from a ReadableStream object
// to a Buffer
const $fbf091ffd61010f8$var$streamToBuffer = async (stream)=>{
    let buffers = [];
    let reader = stream.getReader();
    while(true){
        const { done: done, value: value } = await reader.read();
        if (done) break;
        buffers.push($fbf091ffd61010f8$require$Buffer.from(value));
    }
    let buffer = $fbf091ffd61010f8$require$Buffer.concat(buffers);
    return buffer;
};
const $fbf091ffd61010f8$var$readFileToBuffer = async function(file) {
    return new Promise((resolve, reject)=>{
        var reader = new FileReader();
        reader.onerror = function() {
            reject(reader.error);
        };
        reader.onload = function(e) {
            resolve(reader.result);
        };
        reader.readAsArrayBuffer(file);
    });
};
// Loads a zip archive from File submitted by user.
// Returns an object representing the zip archive.
const $fbf091ffd61010f8$var$loadZipArchive = async function(file) {
    let zip = new $ff323866fb43afa6$exports();
    let zipData = await zip.loadAsync(file);
    return zipData;
};
// Adds a file inside a zip file
// zipArchive: jszip object representing the zip archive
// fileName: Name of the file to be added inside the zip file
// fileContent: The content of the file to be added
// Returns the content of the zip file as an arraybuffer
const $fbf091ffd61010f8$var$addFileToZip = async function(zipArchive, filename, fileContent) {
    // Add the file inside the zip file
    zipArchive.file(filename, fileContent);
    // Recreate the zip file
    const modifiedZipData = await zipArchive.generateAsync({
        type: 'arraybuffer',
        compression: "DEFLATE"
    });
    return modifiedZipData;
};
// Zip files into a single archive while preserving (optional) folder structure.
// Inputs:
// - files: Either
//     a) an array-like of File objects (legacy path), or
//     b) an array of items shaped like { file: File, path: string } where
//        `path` is a relative path using forward slashes.
// - extraFileName: Optional name of an additional file to add at the zip root
// - extraFileContent: Content of that additional file
//
// Notes:
// - We accept both input shapes to remain backward compatible with existing
//   callers while enabling the new folder upload pipeline.
// - For legacy File[], we derive each path from file.webkitRelativePath (when
//   provided by <input webkitdirectory>) or fall back to file.name.
// - Paths are normalized to keep the archive safe and consistent:
//   forward slashes, no leading slash, collapse repeated slashes, and no '..'.
// - We add files sequentially to limit peak memory usage.
const $fbf091ffd61010f8$var$zipFiles = async function(files, extraFileName, extraFileContent) {
    const zip = new $ff323866fb43afa6$exports();
    // Helper: normalize a prospective zip path
    const normalizeZipPath = (p)=>Util.normalizeRelativePath(p);
    // Iterate and add file contents to the archive
    const n = files ? files.length : 0;
    for(let i = 0; i < n; i++){
        const item = files[i];
        // Determine input shape
        const isStructured = item && typeof item === 'object' && 'file' in item && 'path' in item;
        const fileObj = isStructured ? item.file : item;
        if (!fileObj) continue;
        // Derive the intended path inside the archive
        let path = isStructured ? item.path : fileObj.webkitRelativePath || fileObj.name;
        path = normalizeZipPath(path);
        if (!path || path.indexOf('..') !== -1) {
            console.warn('Skipping unsafe or empty path inside zip:', path);
            continue;
        }
        // Read content as ArrayBuffer to ensure compatibility with FileSystemEntry-based Files
        // Some environments can throw NotFoundError when JSZip reads Blob lazily from
        // FileSystem entries during generateAsync. Reading eagerly avoids that.
        const buffer = await $fbf091ffd61010f8$var$readFileToBuffer(fileObj);
        zip.file(path, buffer);
    }
    if (extraFileName != null) // Add the extra metadata file at the zip root
    zip.file(extraFileName, extraFileContent);
    /*
    Output type options for generateAsync:
    base64 | binarystring | array | uint8array | arraybuffer | blob | nodebuffer
    */ const content = await zip.generateAsync({
        type: 'uint8array',
        compression: "DEFLATE"
    });
    // Example: to allow users to download the zip directly, one could use FileSaver
    // FileSaver.saveAs(content, 'download.zip');
    // (FileSaver must be imported at top if used.)
    return content;
};
// Gets filenames inside zip file
// zipFileContent: Then zip file bytes
const $fbf091ffd61010f8$var$getFilenamesInZip = async function(zipFileContent) {
    return new Promise((resolve, reject)=>{
        let filenames = [];
        try {
            $ff323866fb43afa6$exports.loadAsync(zipFileContent).then(function(zip) {
                for (let [filename, file] of Object.entries(zip.files))filenames.push(filename);
                resolve(filenames);
            }).catch(function(err) {
                reject(err);
            });
        } catch (err) {
            reject(err);
        }
    });
};
// Get file in zip given the ending of the filename. E.g. the extension of the file
// or just some string that the filename ends with.
// zipFileContent: bytes of the zip file
// fileEnding: String that the filename ends with
// Returns the first file whose name ends with fileEnding
// If no file is found then null is returned
const $fbf091ffd61010f8$var$getFileInZipByEnding = async function(zipFileContent, fileEnding) {
    return new Promise((resolve, reject)=>{
        let fileFound = null;
        try {
            $ff323866fb43afa6$exports.loadAsync(zipFileContent).then(function(zip) {
                for (let [filename, file] of Object.entries(zip.files))if (filename.endsWith(fileEnding)) {
                    fileFound = file;
                    break;
                }
                resolve(fileFound);
            }).catch(function(err) {
                reject(err);
            });
        } catch (err) {
            reject(err);
        }
    });
};
// Infer the icon string to use for cloud entry
// given the contents of a .arkioimport file
// as a string
const $fbf091ffd61010f8$var$inferIconFromArkioImport = function(arkioImportStr) {
    let icon = null;
    let arkioImport = null;
    try {
        arkioImport = JSON.parse(arkioImportStr);
    } catch (e) {
        return null;
    }
    if (arkioImport.Product != null) switch(arkioImport.Product){
        case "Revit":
            icon = Constants.Icon.Revit;
            break;
        case "Rhino":
            icon = Constants.Icon.Rhino;
            break;
        case "SketchUp":
            icon = Constants.Icon.SketchUp;
            break;
        case "Archicad":
            icon = Constants.Icon.Archicad;
            break;
        case "Navisworks":
            icon = Constants.Icon.Navisworks;
            break;
        default:
            break;
    }
    return icon;
};
// Check zip file content
// and return icon string based on contents of .arkioimport
// file if it is found inside the zip
// zipFileContent: bytes of a zip file
const $fbf091ffd61010f8$var$inferIconFromZip = async function(zipFileContent) {
    // try finding a file in the zip that ends with ".arkioimport"
    let file = await $fbf091ffd61010f8$var$getFileInZipByEnding(zipFileContent, ".arkioimport");
    if (file != null) {
        let text = await file.async('string');
        let icon = $fbf091ffd61010f8$var$inferIconFromArkioImport(text);
        return icon;
    }
    return null;
};
const $fbf091ffd61010f8$var$inferIconFromFiles = async function(files) {
    let n = files.length;
    for(let i = 0; i < n; i++)if (files[i].name.endsWith(".arkioimport")) {
        let buffer = await $fbf091ffd61010f8$var$readFileToBuffer(files[i]);
        let uint8arr = new Uint8Array(buffer);
        let str = new TextDecoder().decode(uint8arr);
        let icon = $fbf091ffd61010f8$var$inferIconFromArkioImport(str);
        return icon;
    }
    return null;
};
const $fbf091ffd61010f8$var$processIssuesZip = async (zipFileContent)=>{
    const zip = await $ff323866fb43afa6$exports.loadAsync(zipFileContent);
    let jsonFile = null;
    for(const filename in zip.files)if (filename.endsWith(".json")) {
        jsonFile = zip.files[filename];
        break;
    }
    if (!jsonFile) throw new Error("No .json file found in the archive.");
    const jsonString = await jsonFile.async('string');
    const issueData = JSON.parse(jsonString);
    if (issueData.Issues) for(const issueId in issueData.Issues){
        const issue = issueData.Issues[issueId];
        if (issue.ViewPointImageFilename) {
            const imageFile = zip.file(issue.ViewPointImageFilename);
            if (imageFile) {
                const base64 = await imageFile.async('base64');
                issue.ViewPointImageDataBase64 = `data:image/jpeg;base64,${base64}`;
            }
        }
    }
    return issueData;
};
// Returns a fresh JSZip instance. This exists so plain (non-CommonJS)
// scripts like ExportUtil.js can build zip archives without needing
// access to the bundled JSZip module - they call DataUtil.createZip()
// since DataUtil is exposed on window by main.js.
const $fbf091ffd61010f8$var$createZip = ()=>new $ff323866fb43afa6$exports();
$fbf091ffd61010f8$exports = {
    streamToBuffer: $fbf091ffd61010f8$var$streamToBuffer,
    readFileToBuffer: $fbf091ffd61010f8$var$readFileToBuffer,
    zipFiles: $fbf091ffd61010f8$var$zipFiles,
    getFilenamesInZip: $fbf091ffd61010f8$var$getFilenamesInZip,
    getFileInZipByEnding: $fbf091ffd61010f8$var$getFileInZipByEnding,
    inferIconFromZip: $fbf091ffd61010f8$var$inferIconFromZip,
    inferIconFromFiles: $fbf091ffd61010f8$var$inferIconFromFiles,
    addFileToZip: $fbf091ffd61010f8$var$addFileToZip,
    loadZipArchive: $fbf091ffd61010f8$var$loadZipArchive,
    processIssuesZip: $fbf091ffd61010f8$var$processIssuesZip,
    createZip: $fbf091ffd61010f8$var$createZip
};



var $b9e88d59535bb3ce$exports = {};
"use strict";
const $b9e88d59535bb3ce$var$versionZero = '0';
const $b9e88d59535bb3ce$var$versionOne = '1';
$b9e88d59535bb3ce$exports = {
    CloudSystemVersionZero: $b9e88d59535bb3ce$var$versionZero,
    CloudSystemVersionOne: $b9e88d59535bb3ce$var$versionOne,
    // Version of cloud system
    CurrentVersion: $b9e88d59535bb3ce$var$versionOne,
    EncryptionKeyItemName: "ArkioCloudPortalEncryptionKey",
    CloudGroupVersionItemName: "ArkioCloudPortalGroupVersion",
    MultipartNrOfParts: 10,
    EntryLifespan: 2592000000,
    // Time between verification attempts in milliseconds,
    // when verfiying that something got written to the cloud
    VerificationSleepTime: 2000,
    // Timeout in milliseconds when verifying that data got sent to the cloud
    VerificationTimeout: 300000,
    // Reserved for future backend service base URIs
    // Icon strings in the cloud entries
    Icon: {
        Revit: 'Revit',
        Rhino: 'Rhino',
        SketchUp: 'SketchUp',
        Unity: 'Unity',
        Models: 'Models',
        Images: 'Images',
        Archicad: 'Archicad',
        Navisworks: 'Navisworks'
    },
    // Milliseconds between table updates
    TableUpdateDelay: 500
};


var $a86455099caa6415$exports = {};
"use strict";
const $a86455099caa6415$var$AwsExchangeKeyBucketName = "exchangekey.arkio.is";
const $a86455099caa6415$var$AwsExchangeIndexBucketName = "exchangeindex.arkio.is";
const $a86455099caa6415$var$AwsExchangeFileBucketName = "exchangefile.arkio.is";
const $3b573adc0d37fb20$export$972ee8f9276654f0 = async (endpointParams)=>{
    const bucket = endpointParams?.Bucket || "";
    if (typeof endpointParams.Bucket === "string") endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
    if ($3b573adc0d37fb20$export$fe7fec9fee338b98(bucket)) {
        if (endpointParams.ForcePathStyle === true) throw new Error("Path-style addressing cannot be used with ARN buckets");
    } else if (!$3b573adc0d37fb20$export$360a1e07839d0d27(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) endpointParams.ForcePathStyle = true;
    if (endpointParams.DisableMultiRegionAccessPoints) {
        endpointParams.disableMultiRegionAccessPoints = true;
        endpointParams.DisableMRAP = true;
    }
    return endpointParams;
};
const $3b573adc0d37fb20$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
const $3b573adc0d37fb20$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
const $3b573adc0d37fb20$var$DOTS_PATTERN = /\.\./;
const $3b573adc0d37fb20$export$b0b24e5455be29b0 = /\./;
const $3b573adc0d37fb20$export$43f53815580748f = /^(.+\.)?s3(-fips)?(\.dualstack)?[.-]([a-z0-9-]+)\./;
const $3b573adc0d37fb20$export$360a1e07839d0d27 = (bucketName)=>$3b573adc0d37fb20$var$DOMAIN_PATTERN.test(bucketName) && !$3b573adc0d37fb20$var$IP_ADDRESS_PATTERN.test(bucketName) && !$3b573adc0d37fb20$var$DOTS_PATTERN.test(bucketName);
const $3b573adc0d37fb20$export$fe7fec9fee338b98 = (bucketName)=>{
    const [arn, partition, service, region, account, typeOrId] = bucketName.split(":");
    const isArn = arn === "arn" && bucketName.split(":").length >= 6;
    const isValidArn = [
        arn,
        partition,
        service,
        account,
        typeOrId
    ].filter(Boolean).length === 5;
    if (isArn && !isValidArn) throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
    return arn === "arn" && !!partition && !!service && !!account && !!typeOrId;
};




const $6fa43d1e922a902d$export$47243fd4b8e52f1e = (configKey, canonicalEndpointParamKey, config)=>{
    const configProvider = async ()=>{
        const configValue = config[configKey] ?? config[canonicalEndpointParamKey];
        if (typeof configValue === "function") return configValue();
        return configValue;
    };
    if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") return async ()=>{
        const endpoint = await configProvider();
        if (endpoint && typeof endpoint === "object") {
            if ("url" in endpoint) return endpoint.url.href;
            if ("hostname" in endpoint) {
                const { protocol: protocol, hostname: hostname, port: port, path: path } = endpoint;
                return `${protocol}//${hostname}${port ? ":" + port : ""}${path}`;
            }
        }
        return endpoint;
    };
    return configProvider;
};


const $ea781f297cdd2a45$export$deed4544608f82ff = async (commandInput, instructionsSupplier, clientConfig, context)=>{
    const endpointParams = await $ea781f297cdd2a45$export$a4c001b14047c450(commandInput, instructionsSupplier, clientConfig);
    if (typeof clientConfig.endpointProvider !== "function") throw new Error("config.endpointProvider is not set.");
    const endpoint = clientConfig.endpointProvider(endpointParams, context);
    return endpoint;
};
const $ea781f297cdd2a45$export$a4c001b14047c450 = async (commandInput, instructionsSupplier, clientConfig)=>{
    const endpointParams = {};
    const instructions = instructionsSupplier?.getEndpointParameterInstructions?.() || {};
    for (const [name, instruction] of Object.entries(instructions))switch(instruction.type){
        case "staticContextParams":
            endpointParams[name] = instruction.value;
            break;
        case "contextParams":
            endpointParams[name] = commandInput[instruction.name];
            break;
        case "clientContextParams":
        case "builtInParams":
            endpointParams[name] = await (0, $6fa43d1e922a902d$export$47243fd4b8e52f1e)(instruction.name, name, clientConfig)();
            break;
        default:
            throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
    }
    if (Object.keys(instructions).length === 0) Object.assign(endpointParams, clientConfig);
    if (String(clientConfig.serviceId).toLowerCase() === "s3") await (0, $3b573adc0d37fb20$export$972ee8f9276654f0)(endpointParams);
    return endpointParams;
};


function $7282496b0a30759e$export$66256f83798e5415(querystring) {
    const query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) for (const pair of querystring.split("&")){
        let [key, value = null] = pair.split("=");
        key = decodeURIComponent(key);
        if (value) value = decodeURIComponent(value);
        if (!(key in query)) query[key] = value;
        else if (Array.isArray(query[key])) query[key].push(value);
        else query[key] = [
            query[key],
            value
        ];
    }
    return query;
}


const $b71e56dcf280298d$export$7a5253c0f62e0150 = (url)=>{
    if (typeof url === "string") return $b71e56dcf280298d$export$7a5253c0f62e0150(new URL(url));
    const { hostname: hostname, pathname: pathname, port: port, protocol: protocol, search: search } = url;
    let query;
    if (search) query = (0, $7282496b0a30759e$export$66256f83798e5415)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};


const $a47e1014d07c2c5c$export$32d52e935fceeb99 = (endpoint)=>{
    if (typeof endpoint === "object") {
        if ("url" in endpoint) return (0, $b71e56dcf280298d$export$7a5253c0f62e0150)(endpoint.url);
        return endpoint;
    }
    return (0, $b71e56dcf280298d$export$7a5253c0f62e0150)(endpoint);
};





const $20e87dbf25d113aa$export$aa1c2d132a457833 = ({ config: config, instructions: instructions })=>{
    return (next, context)=>async (args)=>{
            const endpoint = await (0, $ea781f297cdd2a45$export$deed4544608f82ff)(args.input, {
                getEndpointParameterInstructions () {
                    return instructions;
                }
            }, {
                ...config
            }, context);
            context.endpointV2 = endpoint;
            context.authSchemes = endpoint.properties?.authSchemes;
            const authScheme = context.authSchemes?.[0];
            if (authScheme) {
                context["signing_region"] = authScheme.signingRegion;
                context["signing_service"] = authScheme.signingName;
            }
            return next({
                ...args
            });
        };
};


const $3fa7e84457157be9$export$d10196e291075f95 = (options, deserializer)=>(next, context)=>async (args)=>{
            const { response: response } = await next(args);
            try {
                const parsed = await deserializer(response, options);
                return {
                    response: response,
                    output: parsed
                };
            } catch (error) {
                Object.defineProperty(error, "$response", {
                    value: response
                });
                if (!("$metadata" in error)) {
                    const hint = `Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.`;
                    error.message += "\n  " + hint;
                }
                throw error;
            }
        };



const $2d9085fb3f09b86b$export$125a23d36094c5de = (options, serializer)=>(next, context)=>async (args)=>{
            const endpoint = context.endpointV2?.url && options.urlParser ? async ()=>options.urlParser(context.endpointV2.url) : options.endpoint;
            if (!endpoint) throw new Error("No valid endpoint provider available.");
            const request = await serializer(args.input, {
                ...options,
                endpoint: endpoint
            });
            return next({
                ...args,
                request: request
            });
        };


const $7b67ff6108e5be33$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
const $7b67ff6108e5be33$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $7b67ff6108e5be33$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: (commandStack)=>{
            commandStack.add((0, $3fa7e84457157be9$export$d10196e291075f95)(config, deserializer), $7b67ff6108e5be33$export$f5d82b333b4f39c9);
            commandStack.add((0, $2d9085fb3f09b86b$export$125a23d36094c5de)(config, serializer), $7b67ff6108e5be33$export$1bd449976e9c484d);
        }
    };
}






const $e3a5472d351bf15f$export$1e040b8d263b920b = {
    step: "serialize",
    tags: [
        "ENDPOINT_PARAMETERS",
        "ENDPOINT_V2",
        "ENDPOINT"
    ],
    name: "endpointV2Middleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $7b67ff6108e5be33$export$1bd449976e9c484d).name
};
const $e3a5472d351bf15f$export$946c80457b765eab = (config, instructions)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $20e87dbf25d113aa$export$aa1c2d132a457833)({
                config: config,
                instructions: instructions
            }), $e3a5472d351bf15f$export$1e040b8d263b920b);
        }
    });


const $184c4781feb1f814$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};





const $2b8ecfb31dd9a46b$export$8c5b66831e3f26ff = (input)=>{
    const tls = input.tls ?? true;
    const { endpoint: endpoint } = input;
    const customEndpointProvider = endpoint != null ? async ()=>(0, $a47e1014d07c2c5c$export$32d52e935fceeb99)(await (0, $184c4781feb1f814$export$b1276c07738d6325)(endpoint)()) : undefined;
    const isCustomEndpoint = !!endpoint;
    return {
        ...input,
        endpoint: customEndpointProvider,
        tls: tls,
        isCustomEndpoint: isCustomEndpoint,
        useDualstackEndpoint: (0, $184c4781feb1f814$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false),
        useFipsEndpoint: (0, $184c4781feb1f814$export$b1276c07738d6325)(input.useFipsEndpoint ?? false)
    };
};







class $7a64dcbd6d1e06f1$export$4147bde06f294c2e {
    trace() {}
    debug() {}
    info() {}
    warn() {}
    error() {}
}


const $42e9f9e04e987c3d$export$73604a93307363d8 = ()=>{
    let absoluteEntries = [];
    let relativeEntries = [];
    const entriesNameSet = new Set();
    const sort = (entries)=>entries.sort((a, b)=>$42e9f9e04e987c3d$var$stepWeights[b.step] - $42e9f9e04e987c3d$var$stepWeights[a.step] || $42e9f9e04e987c3d$var$priorityWeights[b.priority || "normal"] - $42e9f9e04e987c3d$var$priorityWeights[a.priority || "normal"]);
    const removeByName = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const removeByReference = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name) entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const cloneTo = (toStack)=>{
        absoluteEntries.forEach((entry)=>{
            toStack.add(entry.middleware, {
                ...entry
            });
        });
        relativeEntries.forEach((entry)=>{
            toStack.addRelativeTo(entry.middleware, {
                ...entry
            });
        });
        return toStack;
    };
    const expandRelativeMiddlewareList = (from)=>{
        const expandedMiddlewareList = [];
        from.before.forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        return expandedMiddlewareList;
    };
    const getMiddlewareList = (debug = false)=>{
        const normalizedAbsoluteEntries = [];
        const normalizedRelativeEntries = [];
        const normalizedEntriesNameMap = {};
        absoluteEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            if (normalizedEntry.name) normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach((entry)=>{
            if (entry.toMiddleware) {
                const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error(`${entry.toMiddleware} is not found when adding ${entry.name || "anonymous"} middleware ${entry.relation} ${entry.toMiddleware}`);
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        const mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce((wholeList, expandedMiddlewareList)=>{
            wholeList.push(...expandedMiddlewareList);
            return wholeList;
        }, []);
        return mainChain;
    };
    const stack = {
        add: (middleware, options = {})=>{
            const { name: name, override: override } = options;
            const entry = {
                step: "initialize",
                priority: "normal",
                middleware: middleware,
                ...options
            };
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error(`Duplicate middleware name '${name}'`);
                    const toOverrideIndex = absoluteEntries.findIndex((entry)=>entry.name === name);
                    const toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) throw new Error(`"${name}" middleware with ${toOverride.priority} priority in ${toOverride.step} step cannot be ` + `overridden by same-name middleware with ${entry.priority} priority in ${entry.step} step.`);
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: (middleware, options)=>{
            const { name: name, override: override } = options;
            const entry = {
                middleware: middleware,
                ...options
            };
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override) throw new Error(`Duplicate middleware name '${name}'`);
                    const toOverrideIndex = relativeEntries.findIndex((entry)=>entry.name === name);
                    const toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error(`"${name}" middleware ${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden ` + `by same-name middleware ${entry.relation} "${entry.toMiddleware}" middleware.`);
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: ()=>cloneTo($42e9f9e04e987c3d$export$73604a93307363d8()),
        use: (plugin)=>{
            plugin.applyToStack(stack);
        },
        remove: (toRemove)=>{
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: (toRemove)=>{
            let isRemoved = false;
            const filterCb = (entry)=>{
                const { tags: tags, name: name } = entry;
                if (tags && tags.includes(toRemove)) {
                    if (name) entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: (from)=>{
            const cloned = cloneTo($42e9f9e04e987c3d$export$73604a93307363d8());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: ()=>{
            return getMiddlewareList(true).map((mw)=>{
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: (handler, context)=>{
            for (const middleware of getMiddlewareList().map((entry)=>entry.middleware).reverse())handler = middleware(handler, context);
            return handler;
        }
    };
    return stack;
};
const $42e9f9e04e987c3d$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
const $42e9f9e04e987c3d$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};




class $1e332f05d1ae8c15$export$1f2bb630327ac4b6 {
    constructor(config){
        this.middlewareStack = (0, $42e9f9e04e987c3d$export$73604a93307363d8)();
        this.config = config;
    }
    send(command, optionsOrCb, cb) {
        const options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        const callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        const handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then((result)=>callback(null, result.output), (err)=>callback(err)).catch(()=>{});
        else return handler(command).then((result)=>result.output);
    }
    destroy() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    }
}


const $a1f83572e1efebc8$export$7753813254d72972 = {};
const $a1f83572e1efebc8$export$8f4022378ddff4c7 = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    $a1f83572e1efebc8$export$7753813254d72972[char] = i;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    $a1f83572e1efebc8$export$7753813254d72972[char] = index;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[index] = char;
}
for(let i = 0; i < 10; i++){
    $a1f83572e1efebc8$export$7753813254d72972[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    $a1f83572e1efebc8$export$7753813254d72972[char] = index;
    $a1f83572e1efebc8$export$8f4022378ddff4c7[index] = char;
}
$a1f83572e1efebc8$export$7753813254d72972["+"] = 62;
$a1f83572e1efebc8$export$8f4022378ddff4c7[62] = "+";
$a1f83572e1efebc8$export$7753813254d72972["/"] = 63;
$a1f83572e1efebc8$export$8f4022378ddff4c7[63] = "/";
const $a1f83572e1efebc8$export$1c5cfd5e95b84581 = 6;
const $a1f83572e1efebc8$export$79b97ac4c24c9385 = 8;
const $a1f83572e1efebc8$export$43e943b030ae3d73 = 63;


const $26e2ba55729a8e75$export$c537b38001c583b7 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, $a1f83572e1efebc8$export$7753813254d72972))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, $a1f83572e1efebc8$export$7753813254d72972)[input[j]] << (limit - j) * (0, $a1f83572e1efebc8$export$1c5cfd5e95b84581);
            bitLength += (0, $a1f83572e1efebc8$export$1c5cfd5e95b84581);
        } else bits >>= (0, $a1f83572e1efebc8$export$1c5cfd5e95b84581);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, $a1f83572e1efebc8$export$79b97ac4c24c9385);
        const byteLength = Math.floor(bitLength / (0, $a1f83572e1efebc8$export$79b97ac4c24c9385));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, $a1f83572e1efebc8$export$79b97ac4c24c9385);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};



function $b8e9e9e3b0dc2c27$export$37cc283d8fbd3462(input) {
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, $a1f83572e1efebc8$export$79b97ac4c24c9385);
            bitLength += (0, $a1f83572e1efebc8$export$79b97ac4c24c9385);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, $a1f83572e1efebc8$export$1c5cfd5e95b84581));
        bits <<= bitClusterCount * (0, $a1f83572e1efebc8$export$1c5cfd5e95b84581) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, $a1f83572e1efebc8$export$1c5cfd5e95b84581);
            str += (0, $a1f83572e1efebc8$export$8f4022378ddff4c7)[(bits & (0, $a1f83572e1efebc8$export$43e943b030ae3d73) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}




const $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $e548b91235db5cfc$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $2554f7a5fe934436$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);





function $7719c21ad0ffc017$export$e9aa0d127315abe(payload, encoding = "utf-8") {
    if (encoding === "base64") return (0, $b8e9e9e3b0dc2c27$export$37cc283d8fbd3462)(payload);
    return (0, $2554f7a5fe934436$export$b4b216764bb846eb)(payload);
}
function $7719c21ad0ffc017$export$ed8c0e91f57de3aa(str, encoding) {
    if (encoding === "base64") return (0, $a4bc27afde7d71d9$export$1465fbad93f83f0a).mutate((0, $26e2ba55729a8e75$export$c537b38001c583b7)(str));
    return (0, $a4bc27afde7d71d9$export$1465fbad93f83f0a).mutate((0, $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc)(str));
}


class $a4bc27afde7d71d9$export$1465fbad93f83f0a extends Uint8Array {
    static fromString(source, encoding = "utf-8") {
        switch(typeof source){
            case "string":
                return (0, $7719c21ad0ffc017$export$ed8c0e91f57de3aa)(source, encoding);
            default:
                throw new Error(`Unsupported conversion from ${typeof source} to Uint8ArrayBlobAdapter.`);
        }
    }
    static mutate(source) {
        Object.setPrototypeOf(source, $a4bc27afde7d71d9$export$1465fbad93f83f0a.prototype);
        return source;
    }
    transformToString(encoding = "utf-8") {
        return (0, $7719c21ad0ffc017$export$e9aa0d127315abe)(this, encoding);
    }
}


const $bf7e86ef23159abe$export$cc0c9507624e70d1 = (readableStream, options)=>{
    const { base64Encoder: base64Encoder, bodyLengthChecker: bodyLengthChecker, checksumAlgorithmFn: checksumAlgorithmFn, checksumLocationName: checksumLocationName, streamHasher: streamHasher } = options;
    const checksumRequired = base64Encoder !== undefined && bodyLengthChecker !== undefined && checksumAlgorithmFn !== undefined && checksumLocationName !== undefined && streamHasher !== undefined;
    const digest = checksumRequired ? streamHasher(checksumAlgorithmFn, readableStream) : undefined;
    const reader = readableStream.getReader();
    return new ReadableStream({
        async pull (controller) {
            const { value: value, done: done } = await reader.read();
            if (done) {
                controller.enqueue(`0\r\n`);
                if (checksumRequired) {
                    const checksum = base64Encoder(await digest);
                    controller.enqueue(`${checksumLocationName}:${checksum}\r\n`);
                    controller.enqueue(`\r\n`);
                }
                controller.close();
            } else controller.enqueue(`${(bodyLengthChecker(value) || 0).toString(16)}\r\n${value}\r\n`);
        }
    });
};




var $806fbbcf55fe1da7$export$e24756d4ad084ce1;
(function(HttpAuthLocation) {
    HttpAuthLocation["HEADER"] = "header";
    HttpAuthLocation["QUERY"] = "query";
})($806fbbcf55fe1da7$export$e24756d4ad084ce1 || ($806fbbcf55fe1da7$export$e24756d4ad084ce1 = {}));






















var $4dccccca93fbe3a1$export$b141d049add1dcb5;
(function(EndpointURLScheme) {
    EndpointURLScheme["HTTP"] = "http";
    EndpointURLScheme["HTTPS"] = "https";
})($4dccccca93fbe3a1$export$b141d049add1dcb5 || ($4dccccca93fbe3a1$export$b141d049add1dcb5 = {}));
















var $19c444025ae5faab$export$54765d03252bd9ed;
(function(FieldPosition) {
    FieldPosition[FieldPosition["HEADER"] = 0] = "HEADER";
    FieldPosition[FieldPosition["TRAILER"] = 1] = "TRAILER";
})($19c444025ae5faab$export$54765d03252bd9ed || ($19c444025ae5faab$export$54765d03252bd9ed = {}));


































var $6620f292f63e1498$export$6431f3fda9a48da2;
(function(RequestHandlerProtocol) {
    RequestHandlerProtocol["HTTP_0_9"] = "http/0.9";
    RequestHandlerProtocol["HTTP_1_0"] = "http/1.0";
    RequestHandlerProtocol["TDS_8_0"] = "tds/8.0";
})($6620f292f63e1498$export$6431f3fda9a48da2 || ($6620f292f63e1498$export$6431f3fda9a48da2 = {}));














class $c94b02bf893e75d8$export$a455218a85c89869 {
    constructor({ name: name, kind: kind = (0, $19c444025ae5faab$export$54765d03252bd9ed).HEADER, values: values = [] }){
        this.name = name;
        this.kind = kind;
        this.values = values;
    }
    add(value) {
        this.values.push(value);
    }
    set(values) {
        this.values = values;
    }
    remove(value) {
        this.values = this.values.filter((v)=>v !== value);
    }
    toString() {
        return this.values.map((v)=>v.includes(",") || v.includes(" ") ? `"${v}"` : v).join(", ");
    }
    get() {
        return this.values;
    }
}


class $a7167cafc9d081ea$export$833b3e5a19fb8939 {
    constructor({ fields: fields = [], encoding: encoding = "utf-8" }){
        this.entries = {};
        fields.forEach(this.setField.bind(this));
        this.encoding = encoding;
    }
    setField(field) {
        this.entries[field.name.toLowerCase()] = field;
    }
    getField(name) {
        return this.entries[name.toLowerCase()];
    }
    removeField(name) {
        delete this.entries[name.toLowerCase()];
    }
    getByType(kind) {
        return Object.values(this.entries).filter((field)=>field.kind === kind);
    }
}




class $76db987a884ad8a2$export$7587955500404ec3 {
    constructor(options){
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? `${options.protocol}:` : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? `/${options.path}` : options.path : "/";
        this.username = options.username;
        this.password = options.password;
        this.fragment = options.fragment;
    }
    static isInstance(request) {
        if (!request) return false;
        const req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
    clone() {
        const cloned = new $76db987a884ad8a2$export$7587955500404ec3({
            ...this,
            headers: {
                ...this.headers
            }
        });
        if (cloned.query) cloned.query = $76db987a884ad8a2$var$cloneQuery(cloned.query);
        return cloned;
    }
}
function $76db987a884ad8a2$var$cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});
}


class $2c63d34427c28f98$export$1d94dfe0d9d1f1e7 {
    constructor(options){
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    static isInstance(response) {
        if (!response) return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
}


function $d7aef99e0ec8cee0$export$e024c793399bdd01(hostname) {
    const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}






const $44b4089172bbcee0$export$c3b4775ad75a73db = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $44b4089172bbcee0$var$hexEncode);
const $44b4089172bbcee0$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;



const $fe16244244f29c08$export$547c045505a754ef = (uri)=>uri.split("/").map((0, $44b4089172bbcee0$export$c3b4775ad75a73db)).join("/");




function $b1b8956416c9f9fe$export$6b17a39e52c8ee53(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()){
        const value = query[key];
        key = (0, $44b4089172bbcee0$export$c3b4775ad75a73db)(key);
        if (Array.isArray(value)) for(let i = 0, iLen = value.length; i < iLen; i++)parts.push(`${key}=${(0, $44b4089172bbcee0$export$c3b4775ad75a73db)(value[i])}`);
        else {
            let qsEntry = key;
            if (value || typeof value === "string") qsEntry += `=${(0, $44b4089172bbcee0$export$c3b4775ad75a73db)(value)}`;
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}


function $56e18dfdfb3dcfa8$export$363ac302bdbd807b(timeoutInMs = 0) {
    return new Promise((resolve, reject)=>{
        if (timeoutInMs) setTimeout(()=>{
            const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


class $9cbb653eb839bbf4$export$83588b87edbfa7e0 {
    constructor(options){
        if (typeof options === "function") this.configProvider = options().then((opts)=>opts || {});
        else {
            this.config = options ?? {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    destroy() {}
    async handle(request, { abortSignal: abortSignal } = {}) {
        if (!this.config) this.config = await this.configProvider;
        const requestTimeoutInMs = this.config.requestTimeout;
        if (abortSignal?.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        const queryString = (0, $b1b8956416c9f9fe$export$6b17a39e52c8ee53)(request.query || {});
        if (queryString) path += `?${queryString}`;
        if (request.fragment) path += `#${request.fragment}`;
        let auth = "";
        if (request.username != null || request.password != null) {
            const username = request.username ?? "";
            const password = request.password ?? "";
            auth = `${username}:${password}@`;
        }
        const { port: port, method: method } = request;
        const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        const fetchRequest = new Request(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response)=>{
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries())transformedHeaders[pair[0]] = pair[1];
                const hasReadableStream = response.body != undefined;
                if (!hasReadableStream) return response.blob().then((body)=>({
                        response: new (0, $2c63d34427c28f98$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            reason: response.statusText,
                            statusCode: response.status,
                            body: body
                        })
                    }));
                return {
                    response: new (0, $2c63d34427c28f98$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        reason: response.statusText,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $56e18dfdfb3dcfa8$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise((resolve, reject)=>{
            abortSignal.onabort = ()=>{
                const abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    }
}



const $08bb3d04fbb6f025$export$17bf97b72e307d52 = (stream)=>{
    if (typeof Blob === "function" && stream instanceof Blob) return $08bb3d04fbb6f025$var$collectBlob(stream);
    return $08bb3d04fbb6f025$var$collectStream(stream);
};
async function $08bb3d04fbb6f025$var$collectBlob(blob) {
    const base64 = await $08bb3d04fbb6f025$var$readToBase64(blob);
    const arrayBuffer = (0, $26e2ba55729a8e75$export$c537b38001c583b7)(base64);
    return new Uint8Array(arrayBuffer);
}
async function $08bb3d04fbb6f025$var$collectStream(stream) {
    let res = new Uint8Array(0);
    const reader = stream.getReader();
    let isDone = false;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            const prior = res;
            res = new Uint8Array(prior.length + value.length);
            res.set(prior);
            res.set(value, prior.length);
        }
        isDone = done;
    }
    return res;
}
function $08bb3d04fbb6f025$var$readToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            const result = reader.result ?? "";
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = ()=>reject(new Error("Read aborted"));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(blob);
    });
}





const $ff463032e6a14a0a$var$SHORT_TO_HEX = {};
const $ff463032e6a14a0a$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $ff463032e6a14a0a$var$SHORT_TO_HEX[i] = encodedByte;
    $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte] = i;
}
function $ff463032e6a14a0a$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $ff463032e6a14a0a$var$HEX_TO_SHORT) out[i / 2] = $ff463032e6a14a0a$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $ff463032e6a14a0a$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $ff463032e6a14a0a$var$SHORT_TO_HEX[bytes[i]];
    return out;
}



const $4afa527ae68dfced$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED = "The stream has already been transformed.";
const $4afa527ae68dfced$export$5f9760b56bbf9f65 = (stream)=>{
    if (!$4afa527ae68dfced$var$isBlobInstance(stream) && !$4afa527ae68dfced$var$isReadableStreamInstance(stream)) {
        const name = stream?.__proto__?.constructor?.name || stream;
        throw new Error(`Unexpected stream implementation, expect Blob or ReadableStream, got ${name}`);
    }
    let transformed = false;
    const transformToByteArray = async ()=>{
        if (transformed) throw new Error($4afa527ae68dfced$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
        transformed = true;
        return await (0, $08bb3d04fbb6f025$export$17bf97b72e307d52)(stream);
    };
    const blobToWebStream = (blob)=>{
        if (typeof blob.stream !== "function") throw new Error("Cannot transform payload Blob to web stream. Please make sure the Blob.stream() is polyfilled.\nIf you are using React Native, this API is not yet supported, see: https://react-native.canny.io/feature-requests/p/fetch-streaming-body");
        return blob.stream();
    };
    return Object.assign(stream, {
        transformToByteArray: transformToByteArray,
        transformToString: async (encoding)=>{
            const buf = await transformToByteArray();
            if (encoding === "base64") return (0, $b8e9e9e3b0dc2c27$export$37cc283d8fbd3462)(buf);
            else if (encoding === "hex") return (0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(buf);
            else if (encoding === undefined || encoding === "utf8" || encoding === "utf-8") return (0, $2554f7a5fe934436$export$b4b216764bb846eb)(buf);
            else if (typeof TextDecoder === "function") return new TextDecoder(encoding).decode(buf);
            else throw new Error("TextDecoder is not available, please make sure polyfill is provided.");
        },
        transformToWebStream: ()=>{
            if (transformed) throw new Error($4afa527ae68dfced$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
            transformed = true;
            if ($4afa527ae68dfced$var$isBlobInstance(stream)) return blobToWebStream(stream);
            else if ($4afa527ae68dfced$var$isReadableStreamInstance(stream)) return stream;
            else throw new Error(`Cannot transform payload to web stream, got ${stream}`);
        }
    });
};
const $4afa527ae68dfced$var$isBlobInstance = (stream)=>typeof Blob === "function" && stream instanceof Blob;
const $4afa527ae68dfced$var$isReadableStreamInstance = (stream)=>typeof ReadableStream === "function" && stream instanceof ReadableStream;




const $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca = async (streamBody = new Uint8Array(), context)=>{
    if (streamBody instanceof Uint8Array) return (0, $a4bc27afde7d71d9$export$1465fbad93f83f0a).mutate(streamBody);
    if (!streamBody) return (0, $a4bc27afde7d71d9$export$1465fbad93f83f0a).mutate(new Uint8Array());
    const fromContext = context.streamCollector(streamBody);
    return (0, $a4bc27afde7d71d9$export$1465fbad93f83f0a).mutate(await fromContext);
};



class $9b91565ddaedd0f1$export$cc7e12c76513e857 {
    constructor(){
        this.middlewareStack = (0, $42e9f9e04e987c3d$export$73604a93307363d8)();
    }
}


const $8922e83afabc5012$export$17127055dc9ac067 = "***SensitiveInformation***";


const $b5c12f6f44721cae$export$d13079724e1f0e8b = (commands, Client)=>{
    for (const command of Object.keys(commands)){
        const CommandCtor = commands[command];
        const methodImpl = async function(args, optionsOrCb, cb) {
            const command = new CommandCtor(args);
            if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
            else if (typeof cb === "function") {
                if (typeof optionsOrCb !== "object") throw new Error(`Expected http options but got ${typeof optionsOrCb}`);
                this.send(command, optionsOrCb || {}, cb);
            } else return this.send(command, optionsOrCb);
        };
        const methodName = (command[0].toLowerCase() + command.slice(1)).replace(/Command$/, "");
        Client.prototype[methodName] = methodImpl;
    }
};


const $f10fb2b359b91940$export$3fb54149990fb5b5 = (value)=>{
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error(`Unable to parse boolean value "${value}"`);
    }
};
const $f10fb2b359b91940$export$259b2ebfc29bf466 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) $f10fb2b359b91940$export$af88d00dbe7f521.warn($f10fb2b359b91940$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        const lower = value.toLowerCase();
        if (lower === "false" || lower === "true") $f10fb2b359b91940$export$af88d00dbe7f521.warn($f10fb2b359b91940$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError(`Expected boolean, got ${typeof value}: ${value}`);
};
const $f10fb2b359b91940$export$f3945e48fdb5f9a = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) $f10fb2b359b91940$export$af88d00dbe7f521.warn($f10fb2b359b91940$var$stackTraceWarning(`Expected number but observed string: ${value}`));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError(`Expected number, got ${typeof value}: ${value}`);
};
const $f10fb2b359b91940$var$MAX_FLOAT = Math.ceil(2 ** 127 * (2 - 2 ** -23));
const $f10fb2b359b91940$export$44880ec4d8d4909d = (value)=>{
    const expected = $f10fb2b359b91940$export$f3945e48fdb5f9a(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > $f10fb2b359b91940$var$MAX_FLOAT) throw new TypeError(`Expected 32-bit float, got ${value}`);
    }
    return expected;
};
const $f10fb2b359b91940$export$a883517a83c9c18 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError(`Expected integer, got ${typeof value}: ${value}`);
};
const $f10fb2b359b91940$export$dbec7593c34ded08 = $f10fb2b359b91940$export$a883517a83c9c18;
const $f10fb2b359b91940$export$99c64e845cdac9c1 = (value)=>$f10fb2b359b91940$var$expectSizedInt(value, 32);
const $f10fb2b359b91940$export$d4f903340b146129 = (value)=>$f10fb2b359b91940$var$expectSizedInt(value, 16);
const $f10fb2b359b91940$export$3e4c4435b3b19562 = (value)=>$f10fb2b359b91940$var$expectSizedInt(value, 8);
const $f10fb2b359b91940$var$expectSizedInt = (value, size)=>{
    const expected = $f10fb2b359b91940$export$a883517a83c9c18(value);
    if (expected !== undefined && $f10fb2b359b91940$var$castInt(expected, size) !== expected) throw new TypeError(`Expected ${size}-bit integer, got ${value}`);
    return expected;
};
const $f10fb2b359b91940$var$castInt = (value, size)=>{
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
const $f10fb2b359b91940$export$8413a63dbe548a49 = (value, location)=>{
    if (value === null || value === undefined) {
        if (location) throw new TypeError(`Expected a non-null value for ${location}`);
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
const $f10fb2b359b91940$export$cf825aadce530e7e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    const receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError(`Expected object, got ${receivedType}: ${value}`);
};
const $f10fb2b359b91940$export$7ed80f53fe336639 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        $f10fb2b359b91940$export$af88d00dbe7f521.warn($f10fb2b359b91940$var$stackTraceWarning(`Expected string, got ${typeof value}: ${value}`));
        return String(value);
    }
    throw new TypeError(`Expected string, got ${typeof value}: ${value}`);
};
const $f10fb2b359b91940$export$9ef77073e45b6301 = (value)=>{
    if (value === null || value === undefined) return undefined;
    const asObject = $f10fb2b359b91940$export$cf825aadce530e7e(value);
    const setKeys = Object.entries(asObject).filter(([, v])=>v != null).map(([k])=>k);
    if (setKeys.length === 0) throw new TypeError(`Unions must have exactly one non-null member. None were found.`);
    if (setKeys.length > 1) throw new TypeError(`Unions must have exactly one non-null member. Keys ${setKeys} were not null.`);
    return asObject;
};
const $f10fb2b359b91940$export$89e17ed633a86621 = (value)=>{
    if (typeof value == "string") return $f10fb2b359b91940$export$f3945e48fdb5f9a($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$f3945e48fdb5f9a(value);
};
const $f10fb2b359b91940$export$884f8e3b42a6cfbf = $f10fb2b359b91940$export$89e17ed633a86621;
const $f10fb2b359b91940$export$b15cbcea8b4c492f = (value)=>{
    if (typeof value == "string") return $f10fb2b359b91940$export$44880ec4d8d4909d($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$44880ec4d8d4909d(value);
};
const $f10fb2b359b91940$var$NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
const $f10fb2b359b91940$var$parseNumber = (value)=>{
    const matches = value.match($f10fb2b359b91940$var$NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError(`Expected real number, got implicit NaN`);
    return parseFloat(value);
};
const $f10fb2b359b91940$export$11335e83c8af2784 = (value)=>{
    if (typeof value == "string") return $f10fb2b359b91940$var$parseFloatString(value);
    return $f10fb2b359b91940$export$f3945e48fdb5f9a(value);
};
const $f10fb2b359b91940$export$b6a7906d2e4b31df = $f10fb2b359b91940$export$11335e83c8af2784;
const $f10fb2b359b91940$export$50b04c19f942a079 = $f10fb2b359b91940$export$11335e83c8af2784;
const $f10fb2b359b91940$export$f14938f3036dd492 = (value)=>{
    if (typeof value == "string") return $f10fb2b359b91940$var$parseFloatString(value);
    return $f10fb2b359b91940$export$44880ec4d8d4909d(value);
};
const $f10fb2b359b91940$var$parseFloatString = (value)=>{
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error(`Unable to parse float value: ${value}`);
    }
};
const $f10fb2b359b91940$export$f90617f39a736d36 = (value)=>{
    if (typeof value === "string") return $f10fb2b359b91940$export$a883517a83c9c18($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$a883517a83c9c18(value);
};
const $f10fb2b359b91940$export$39b7be5d28a09fe1 = $f10fb2b359b91940$export$f90617f39a736d36;
const $f10fb2b359b91940$export$c3c2f00b115709e6 = (value)=>{
    if (typeof value === "string") return $f10fb2b359b91940$export$99c64e845cdac9c1($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$99c64e845cdac9c1(value);
};
const $f10fb2b359b91940$export$813d4a13f25c6b38 = (value)=>{
    if (typeof value === "string") return $f10fb2b359b91940$export$d4f903340b146129($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$d4f903340b146129(value);
};
const $f10fb2b359b91940$export$f18d20ea3b6b353 = (value)=>{
    if (typeof value === "string") return $f10fb2b359b91940$export$3e4c4435b3b19562($f10fb2b359b91940$var$parseNumber(value));
    return $f10fb2b359b91940$export$3e4c4435b3b19562(value);
};
const $f10fb2b359b91940$var$stackTraceWarning = (message)=>{
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter((s)=>!s.includes("stackTraceWarning")).join("\n");
};
const $f10fb2b359b91940$export$af88d00dbe7f521 = {
    warn: console.warn
};


const $d519855744bca7a8$var$DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $d519855744bca7a8$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $d519855744bca7a8$export$5b50865171ed23a9(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const dayOfWeek = date.getUTCDay();
    const dayOfMonthInt = date.getUTCDate();
    const hoursInt = date.getUTCHours();
    const minutesInt = date.getUTCMinutes();
    const secondsInt = date.getUTCSeconds();
    const dayOfMonthString = dayOfMonthInt < 10 ? `0${dayOfMonthInt}` : `${dayOfMonthInt}`;
    const hoursString = hoursInt < 10 ? `0${hoursInt}` : `${hoursInt}`;
    const minutesString = minutesInt < 10 ? `0${minutesInt}` : `${minutesInt}`;
    const secondsString = secondsInt < 10 ? `0${secondsInt}` : `${secondsInt}`;
    return `${$d519855744bca7a8$var$DAYS[dayOfWeek]}, ${dayOfMonthString} ${$d519855744bca7a8$var$MONTHS[month]} ${year} ${hoursString}:${minutesString}:${secondsString} GMT`;
}
const $d519855744bca7a8$var$RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
const $d519855744bca7a8$export$202e14f4d6038b6c = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $d519855744bca7a8$var$RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds] = match;
    const year = (0, $f10fb2b359b91940$export$813d4a13f25c6b38)($d519855744bca7a8$var$stripLeadingZeroes(yearStr));
    const month = $d519855744bca7a8$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $d519855744bca7a8$var$parseDateValue(dayStr, "day", 1, 31);
    return $d519855744bca7a8$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
const $d519855744bca7a8$var$RFC3339_WITH_OFFSET = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(([-+]\d{2}\:\d{2})|[zZ])$/);
const $d519855744bca7a8$export$3cb821e2875b4b7d = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $d519855744bca7a8$var$RFC3339_WITH_OFFSET.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, offsetStr] = match;
    const year = (0, $f10fb2b359b91940$export$813d4a13f25c6b38)($d519855744bca7a8$var$stripLeadingZeroes(yearStr));
    const month = $d519855744bca7a8$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $d519855744bca7a8$var$parseDateValue(dayStr, "day", 1, 31);
    const date = $d519855744bca7a8$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
    if (offsetStr.toUpperCase() != "Z") date.setTime(date.getTime() - $d519855744bca7a8$var$parseOffsetToMilliseconds(offsetStr));
    return date;
};
const $d519855744bca7a8$var$IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $d519855744bca7a8$var$RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $d519855744bca7a8$var$ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
const $d519855744bca7a8$export$cf3a566289648a1e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    let match = $d519855744bca7a8$var$IMF_FIXDATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $d519855744bca7a8$var$buildDate((0, $f10fb2b359b91940$export$813d4a13f25c6b38)($d519855744bca7a8$var$stripLeadingZeroes(yearStr)), $d519855744bca7a8$var$parseMonthByShortName(monthStr), $d519855744bca7a8$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = $d519855744bca7a8$var$RFC_850_DATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $d519855744bca7a8$var$adjustRfc850Year($d519855744bca7a8$var$buildDate($d519855744bca7a8$var$parseTwoDigitYear(yearStr), $d519855744bca7a8$var$parseMonthByShortName(monthStr), $d519855744bca7a8$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = $d519855744bca7a8$var$ASC_TIME.exec(value);
    if (match) {
        const [_, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, yearStr] = match;
        return $d519855744bca7a8$var$buildDate((0, $f10fb2b359b91940$export$813d4a13f25c6b38)($d519855744bca7a8$var$stripLeadingZeroes(yearStr)), $d519855744bca7a8$var$parseMonthByShortName(monthStr), $d519855744bca7a8$var$parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
const $d519855744bca7a8$export$685da212e4e79e10 = (value)=>{
    if (value === null || value === undefined) return undefined;
    let valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, $f10fb2b359b91940$export$89e17ed633a86621)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
const $d519855744bca7a8$var$buildDate = (year, month, day, time)=>{
    const adjustedMonth = month - 1;
    $d519855744bca7a8$var$validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, $d519855744bca7a8$var$parseDateValue(time.hours, "hour", 0, 23), $d519855744bca7a8$var$parseDateValue(time.minutes, "minute", 0, 59), $d519855744bca7a8$var$parseDateValue(time.seconds, "seconds", 0, 60), $d519855744bca7a8$var$parseMilliseconds(time.fractionalMilliseconds)));
};
const $d519855744bca7a8$var$parseTwoDigitYear = (value)=>{
    const thisYear = new Date().getUTCFullYear();
    const valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, $f10fb2b359b91940$export$813d4a13f25c6b38)($d519855744bca7a8$var$stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
const $d519855744bca7a8$var$FIFTY_YEARS_IN_MILLIS = 1576800000000;
const $d519855744bca7a8$var$adjustRfc850Year = (input)=>{
    if (input.getTime() - new Date().getTime() > $d519855744bca7a8$var$FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
const $d519855744bca7a8$var$parseMonthByShortName = (value)=>{
    const monthIdx = $d519855744bca7a8$var$MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError(`Invalid month: ${value}`);
    return monthIdx + 1;
};
const $d519855744bca7a8$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $d519855744bca7a8$var$validateDayOfMonth = (year, month, day)=>{
    let maxDays = $d519855744bca7a8$var$DAYS_IN_MONTH[month];
    if (month === 1 && $d519855744bca7a8$var$isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError(`Invalid day for ${$d519855744bca7a8$var$MONTHS[month]} in ${year}: ${day}`);
};
const $d519855744bca7a8$var$isLeapYear = (year)=>{
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
const $d519855744bca7a8$var$parseDateValue = (value, type, lower, upper)=>{
    const dateVal = (0, $f10fb2b359b91940$export$f18d20ea3b6b353)($d519855744bca7a8$var$stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError(`${type} must be between ${lower} and ${upper}, inclusive`);
    return dateVal;
};
const $d519855744bca7a8$var$parseMilliseconds = (value)=>{
    if (value === null || value === undefined) return 0;
    return (0, $f10fb2b359b91940$export$b15cbcea8b4c492f)("0." + value) * 1000;
};
const $d519855744bca7a8$var$parseOffsetToMilliseconds = (value)=>{
    const directionStr = value[0];
    let direction = 1;
    if (directionStr == "+") direction = 1;
    else if (directionStr == "-") direction = -1;
    else throw new TypeError(`Offset direction, ${directionStr}, must be "+" or "-"`);
    const hour = Number(value.substring(1, 3));
    const minute = Number(value.substring(4, 6));
    return direction * (hour * 60 + minute) * 60000;
};
const $d519855744bca7a8$var$stripLeadingZeroes = (value)=>{
    let idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};


class $f4d6e6bcf25435f5$export$29647f3b4097d3c0 extends Error {
    constructor(options){
        super(options.message);
        Object.setPrototypeOf(this, $f4d6e6bcf25435f5$export$29647f3b4097d3c0.prototype);
        this.name = options.name;
        this.$fault = options.$fault;
        this.$metadata = options.$metadata;
    }
}
const $f4d6e6bcf25435f5$export$db01f0c43e877a50 = (exception, additions = {})=>{
    Object.entries(additions).filter(([, v])=>v !== undefined).forEach(([k, v])=>{
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    const message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};


const $7890e3748e9b15a4$export$3df0f68aaf858737 = ({ output: output, parsedBody: parsedBody, exceptionCtor: exceptionCtor, errorCode: errorCode })=>{
    const $metadata = $7890e3748e9b15a4$var$deserializeMetadata(output);
    const statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    const response = new exceptionCtor({
        name: parsedBody?.code || parsedBody?.Code || errorCode || statusCode || "UnknownError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(response, parsedBody);
};
const $7890e3748e9b15a4$export$62ac8acba1748a85 = (ExceptionCtor)=>{
    return ({ output: output, parsedBody: parsedBody, errorCode: errorCode })=>{
        $7890e3748e9b15a4$export$3df0f68aaf858737({
            output: output,
            parsedBody: parsedBody,
            exceptionCtor: ExceptionCtor,
            errorCode: errorCode
        });
    };
};
const $7890e3748e9b15a4$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });


const $76d6722ee679f099$export$b6e2b46631b45a92 = (mode)=>{
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};


let $7a71961dd24090a7$var$warningEmitted = false;
const $7a71961dd24090a7$export$96550b8fa3e6f65a = (version)=>{
    if (version && !$7a71961dd24090a7$var$warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) $7a71961dd24090a7$var$warningEmitted = true;
};



function $1d52c41f10162b1d$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}


const $7e6ebdfaa9b33533$export$52272e038712c64e = (mayBeArray)=>Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];


const $85f1f2fc8f60827c$export$113d90026b452881 = (obj)=>{
    const textNodeName = "#text";
    for(const key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $85f1f2fc8f60827c$export$113d90026b452881(obj[key]);
    }
    return obj;
};


const $941049e874f424ad$export$40e2db4f1ce24b10 = function() {
    const Class = Object.getPrototypeOf(this).constructor;
    const Constructor = Function.bind.apply(String, [
        null,
        ...arguments
    ]);
    const instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$941049e874f424ad$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $941049e874f424ad$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($941049e874f424ad$export$40e2db4f1ce24b10, String);
class $941049e874f424ad$export$494ed5148690ecaf extends $941049e874f424ad$export$40e2db4f1ce24b10 {
    deserializeJSON() {
        return JSON.parse(super.toString());
    }
    toJSON() {
        return super.toString();
    }
    static fromObject(object) {
        if (object instanceof $941049e874f424ad$export$494ed5148690ecaf) return object;
        else if (object instanceof String || typeof object === "string") return new $941049e874f424ad$export$494ed5148690ecaf(object);
        return new $941049e874f424ad$export$494ed5148690ecaf(JSON.stringify(object));
    }
}


function $c5dd53748caa092b$export$871de8747c9eaa88(arg0, arg1, arg2) {
    let target;
    let filter;
    let instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return $c5dd53748caa092b$var$mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    for (const key of Object.keys(instructions)){
        if (!Array.isArray(instructions[key])) {
            target[key] = instructions[key];
            continue;
        }
        $c5dd53748caa092b$var$applyInstruction(target, null, instructions, key);
    }
    return target;
}
const $c5dd53748caa092b$export$a2c0df515c751f13 = (target)=>{
    const output = {};
    for (const [k, v] of Object.entries(target || {}))output[k] = [
        ,
        v
    ];
    return output;
};
const $c5dd53748caa092b$export$b7df5d561049483a = (source, instructions)=>{
    const out = {};
    for(const key in instructions)$c5dd53748caa092b$var$applyInstruction(out, source, instructions, key);
    return out;
};
const $c5dd53748caa092b$var$mapWithFilter = (target, filter, instructions)=>{
    return $c5dd53748caa092b$export$871de8747c9eaa88(target, Object.entries(instructions).reduce((_instructions, [key, value])=>{
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};
const $c5dd53748caa092b$var$applyInstruction = (target, source, instructions, targetKey)=>{
    if (source !== null) {
        let instruction = instructions[targetKey];
        if (typeof instruction === "function") instruction = [
            ,
            instruction
        ];
        const [filter = $c5dd53748caa092b$var$nonNullish, valueFn = $c5dd53748caa092b$var$pass, sourceKey = targetKey] = instruction;
        if (typeof filter === "function" && filter(source[sourceKey]) || typeof filter !== "function" && !!filter) target[targetKey] = valueFn(source[sourceKey]);
        return;
    }
    let [filter, value] = instructions[targetKey];
    if (typeof value === "function") {
        let _value;
        const defaultFilterPassed = filter === undefined && (_value = value()) != null;
        const customFilterPassed = typeof filter === "function" && !!filter(void 0) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed) target[targetKey] = _value;
        else if (customFilterPassed) target[targetKey] = value();
    } else {
        const defaultFilterPassed = filter === undefined && value != null;
        const customFilterPassed = typeof filter === "function" && !!filter(value) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed || customFilterPassed) target[targetKey] = value;
    }
};
const $c5dd53748caa092b$var$nonNullish = (_)=>_ != null;
const $c5dd53748caa092b$var$pass = (_)=>_;




const $70dbc58951792150$export$405ac9a9ce1cbd80 = (resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel)=>{
    if (input != null && input[memberName] !== undefined) {
        const labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map((segment)=>(0, $1d52c41f10162b1d$export$7640f3c16fe7f54b)(segment)).join("/") : (0, $1d52c41f10162b1d$export$7640f3c16fe7f54b)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};


const $489ba385804e8644$export$4a2bea4ecaa09ba7 = (value)=>{
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};


const $ebe451dc94a22d0f$export$e0ede334cf6ab53c = (obj)=>{
    if (obj == null) return {};
    if (Array.isArray(obj)) return obj.filter((_)=>_ != null);
    if (typeof obj === "object") {
        const target = {};
        for (const key of Object.keys(obj)){
            if (obj[key] == null) continue;
            target[key] = $ebe451dc94a22d0f$export$e0ede334cf6ab53c(obj[key]);
        }
        return target;
    }
    return obj;
};


function $ff1a0eaa8d696784$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    const segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    const compoundSegments = [];
    let currentSegment = "";
    for(let i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}




function $1bc0b96603e46f7b$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}


function $62dc38c152d54087$export$e5104ffd394b43ec(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#x0D;").replace(/\n/g, "&#x0A;").replace(/\u0085/g, "&#x85;").replace(/\u2028/, "&#x2028;");
}


class $74950727763df02e$export$b35b8f45887823df {
    constructor(value){
        this.value = value;
    }
    toString() {
        return (0, $62dc38c152d54087$export$e5104ffd394b43ec)("" + this.value);
    }
}


class $e5feeac9197fd5d3$export$e775a15d806cbddc {
    static of(name, childText, withName) {
        const node = new $e5feeac9197fd5d3$export$e775a15d806cbddc(name);
        if (childText !== undefined) node.addChildNode(new (0, $74950727763df02e$export$b35b8f45887823df)(childText));
        if (withName !== undefined) node.withName(withName);
        return node;
    }
    constructor(name, children = []){
        this.name = name;
        this.children = children;
        this.attributes = {};
    }
    withName(name) {
        this.name = name;
        return this;
    }
    addAttribute(name, value) {
        this.attributes[name] = value;
        return this;
    }
    addChildNode(child) {
        this.children.push(child);
        return this;
    }
    removeAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    toString() {
        const hasChildren = Boolean(this.children.length);
        let xmlText = `<${this.name}`;
        const attributes = this.attributes;
        for (const attributeName of Object.keys(attributes)){
            const attribute = attributes[attributeName];
            if (typeof attribute !== "undefined" && attribute !== null) xmlText += ` ${attributeName}="${(0, $1bc0b96603e46f7b$export$30330f3d5eb70e11)("" + attribute)}"`;
        }
        return xmlText += !hasChildren ? "/>" : `>${this.children.map((c)=>c.toString()).join("")}</${this.name}>`;
    }
}







var $2b87ce1df293278b$exports = {};
'use strict';
var $e6697f46f4a0942a$exports = {};

$parcel$export($e6697f46f4a0942a$exports, "validate", () => $e6697f46f4a0942a$export$a22775fa5e2eebd9, (v) => $e6697f46f4a0942a$export$a22775fa5e2eebd9 = v);
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $e6697f46f4a0942a$export$a22775fa5e2eebd9;
'use strict';
var $f62ff286a4f745fa$export$a5edf3f35b6dd392;
var $f62ff286a4f745fa$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $f62ff286a4f745fa$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $f62ff286a4f745fa$export$bf7199a9ebcb84a9;
// const fakeCall = function(a) {return a;};
// const fakeCallNoReturn = function() {};
var $f62ff286a4f745fa$export$998d7ff9801e90bb;
var $f62ff286a4f745fa$export$aaa9734c55cb7a19;
var $f62ff286a4f745fa$export$e8f2644f7085b4b1;
'use strict';
const $f62ff286a4f745fa$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $f62ff286a4f745fa$var$nameChar = $f62ff286a4f745fa$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $f62ff286a4f745fa$var$nameRegexp = '[' + $f62ff286a4f745fa$var$nameStartChar + '][' + $f62ff286a4f745fa$var$nameChar + ']*';
const $f62ff286a4f745fa$var$regexName = new RegExp('^' + $f62ff286a4f745fa$var$nameRegexp + '$');
const $f62ff286a4f745fa$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $f62ff286a4f745fa$var$isName = function(string) {
    const match = $f62ff286a4f745fa$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$f62ff286a4f745fa$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$f62ff286a4f745fa$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$f62ff286a4f745fa$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$f62ff286a4f745fa$export$bf7199a9ebcb84a9 = function(v) {
    if ($f62ff286a4f745fa$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
$f62ff286a4f745fa$export$998d7ff9801e90bb = $f62ff286a4f745fa$var$isName;
$f62ff286a4f745fa$export$aaa9734c55cb7a19 = $f62ff286a4f745fa$var$getAllMatches;
$f62ff286a4f745fa$export$e8f2644f7085b4b1 = $f62ff286a4f745fa$var$nameRegexp;


const $e6697f46f4a0942a$var$defaultOptions = {
    allowBooleanAttributes: false,
    unpairedTags: []
};
$e6697f46f4a0942a$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = Object.assign({}, $e6697f46f4a0942a$var$defaultOptions, options);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $e6697f46f4a0942a$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$e6697f46f4a0942a$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $e6697f46f4a0942a$var$readAttributeStr(xmlData, i);
                if (result === false) return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $e6697f46f4a0942a$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $e6697f46f4a0942a$var$getErrorObject(isValid.err.code, isValid.err.msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $e6697f46f4a0942a$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $e6697f46f4a0942a$var$getErrorObject(isValid.err.code, isValid.err.msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else if (options.unpairedTags.indexOf(tagName) !== -1) ;
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $e6697f46f4a0942a$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $e6697f46f4a0942a$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $e6697f46f4a0942a$var$getErrorObject('InvalidChar', "char '&' is not expected.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    } else {
                        if (reachedRoot === true && !$e6697f46f4a0942a$var$isWhiteSpace(xmlData[i])) return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', "Extra text at the end", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if ($e6697f46f4a0942a$var$isWhiteSpace(xmlData[i])) continue;
            return $e6697f46f4a0942a$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
function $e6697f46f4a0942a$var$isWhiteSpace(char) {
    return char === ' ' || char === '\t' || char === '\n' || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $e6697f46f4a0942a$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $e6697f46f4a0942a$var$doubleQuote = '"';
const $e6697f46f4a0942a$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $e6697f46f4a0942a$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $e6697f46f4a0942a$var$doubleQuote || xmlData[i] === $e6697f46f4a0942a$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $e6697f46f4a0942a$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $e6697f46f4a0942a$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $f62ff286a4f745fa$export$aaa9734c55cb7a19(attrStr, $e6697f46f4a0942a$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] !== undefined && matches[i][4] === undefined) return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$e6697f46f4a0942a$var$validateAttrName(attrName)) return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $e6697f46f4a0942a$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $e6697f46f4a0942a$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $e6697f46f4a0942a$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $e6697f46f4a0942a$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $e6697f46f4a0942a$var$validateAttrName(attrName) {
    return $f62ff286a4f745fa$export$998d7ff9801e90bb(attrName);
}
// const startsWithXML = /^xml/i;
function $e6697f46f4a0942a$var$validateTagName(tagname) {
    return $f62ff286a4f745fa$export$998d7ff9801e90bb(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $e6697f46f4a0942a$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}


var $fc10b5bda729ad87$exports = {};
var $aad9c96aff038f10$export$ecbd7d678ac4909b;
var $aad9c96aff038f10$export$ba43bf67f3d48107;
const $aad9c96aff038f10$var$defaultOptions = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true,
    cdataPropName: false,
    numberParseOptions: {
        hex: true,
        leadingZeros: true,
        eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
        return val;
    },
    attributeValueProcessor: function(attrName, val) {
        return val;
    },
    stopNodes: [],
    alwaysCreateTextNode: false,
    isArray: ()=>false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs) {
        return tagName;
    }
};
const $aad9c96aff038f10$var$buildOptions = function(options) {
    return Object.assign({}, $aad9c96aff038f10$var$defaultOptions, options);
};
$aad9c96aff038f10$export$ecbd7d678ac4909b = $aad9c96aff038f10$var$buildOptions;
$aad9c96aff038f10$export$ba43bf67f3d48107 = $aad9c96aff038f10$var$defaultOptions;


var $fc10b5bda729ad87$require$buildOptions = $aad9c96aff038f10$export$ecbd7d678ac4909b;
var $ffe42f7d6492ea5b$exports = {};
'use strict';

var $b89beca15b40c3b5$exports = {};
'use strict';
class $b89beca15b40c3b5$var$XmlNode {
    constructor(tagname){
        this.tagname = tagname;
        this.child = []; //nested tags, text, cdata, comments in order
        this[":@"] = {}; //attributes map
    }
    add(key, val) {
        // this.child.push( {name : key, val: val, isCdata: isCdata });
        if (key === "__proto__") key = "#__proto__";
        this.child.push({
            [key]: val
        });
    }
    addChild(node) {
        if (node.tagname === "__proto__") node.tagname = "#__proto__";
        if (node[":@"] && Object.keys(node[":@"]).length > 0) this.child.push({
            [node.tagname]: node.child,
            [":@"]: node[":@"]
        });
        else this.child.push({
            [node.tagname]: node.child
        });
    }
}
$b89beca15b40c3b5$exports = $b89beca15b40c3b5$var$XmlNode;


var $f29e32ddf0f58f56$exports = {};

//TODO: handle comments
function $f29e32ddf0f58f56$var$readDocType(xmlData, i) {
    const entities = {};
    if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
        i = i + 9;
        let angleBracketsCount = 1;
        let hasBody = false, comment = false;
        let exp = "";
        for(; i < xmlData.length; i++){
            if (xmlData[i] === '<' && !comment) {
                if (hasBody && $f29e32ddf0f58f56$var$isEntity(xmlData, i)) {
                    i += 7;
                    [entityName, val, i] = $f29e32ddf0f58f56$var$readEntityExp(xmlData, i + 1);
                    if (val.indexOf("&") === -1) entities[$f29e32ddf0f58f56$var$validateEntityName(entityName)] = {
                        regx: RegExp(`&${entityName};`, "g"),
                        val: val
                    };
                } else if (hasBody && $f29e32ddf0f58f56$var$isElement(xmlData, i)) i += 8; //Not supported
                else if (hasBody && $f29e32ddf0f58f56$var$isAttlist(xmlData, i)) i += 8; //Not supported
                else if (hasBody && $f29e32ddf0f58f56$var$isNotation(xmlData, i)) i += 9; //Not supported
                else if ($f29e32ddf0f58f56$var$isComment) comment = true;
                else throw new Error("Invalid DOCTYPE");
                angleBracketsCount++;
                exp = "";
            } else if (xmlData[i] === '>') {
                if (comment) {
                    if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
                        comment = false;
                        angleBracketsCount--;
                    }
                } else angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            } else if (xmlData[i] === '[') hasBody = true;
            else exp += xmlData[i];
        }
        if (angleBracketsCount !== 0) throw new Error(`Unclosed DOCTYPE`);
    } else throw new Error(`Invalid Tag instead of DOCTYPE`);
    return {
        entities: entities,
        i: i
    };
}
function $f29e32ddf0f58f56$var$readEntityExp(xmlData, i) {
    //External entities are not supported
    //    <!ENTITY ext SYSTEM "http://normal-website.com" >
    //Parameter entities are not supported
    //    <!ENTITY entityname "&anotherElement;">
    //Internal entities are supported
    //    <!ENTITY entityname "replacement text">
    //read EntityName
    let entityName1 = "";
    for(; i < xmlData.length && xmlData[i] !== "'" && xmlData[i] !== '"'; i++)// if(xmlData[i] === " ") continue;
    // else 
    entityName1 += xmlData[i];
    entityName1 = entityName1.trim();
    if (entityName1.indexOf(" ") !== -1) throw new Error("External entites are not supported");
    //read Entity Value
    const startChar = xmlData[i++];
    let val1 = "";
    for(; i < xmlData.length && xmlData[i] !== startChar; i++)val1 += xmlData[i];
    return [
        entityName1,
        val1,
        i
    ];
}
function $f29e32ddf0f58f56$var$isComment(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === '-' && xmlData[i + 3] === '-') return true;
    return false;
}
function $f29e32ddf0f58f56$var$isEntity(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'N' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'I' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'Y') return true;
    return false;
}
function $f29e32ddf0f58f56$var$isElement(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'E' && xmlData[i + 3] === 'L' && xmlData[i + 4] === 'E' && xmlData[i + 5] === 'M' && xmlData[i + 6] === 'E' && xmlData[i + 7] === 'N' && xmlData[i + 8] === 'T') return true;
    return false;
}
function $f29e32ddf0f58f56$var$isAttlist(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'A' && xmlData[i + 3] === 'T' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'L' && xmlData[i + 6] === 'I' && xmlData[i + 7] === 'S' && xmlData[i + 8] === 'T') return true;
    return false;
}
function $f29e32ddf0f58f56$var$isNotation(xmlData, i) {
    if (xmlData[i + 1] === '!' && xmlData[i + 2] === 'N' && xmlData[i + 3] === 'O' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'A' && xmlData[i + 6] === 'T' && xmlData[i + 7] === 'I' && xmlData[i + 8] === 'O' && xmlData[i + 9] === 'N') return true;
    return false;
}
function $f29e32ddf0f58f56$var$validateEntityName(name) {
    if ($f62ff286a4f745fa$export$998d7ff9801e90bb(name)) return name;
    else throw new Error(`Invalid entity name ${name}`);
}
$f29e32ddf0f58f56$exports = $f29e32ddf0f58f56$var$readDocType;


var $b7a28001cd116d9a$exports = {};
const $b7a28001cd116d9a$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $b7a28001cd116d9a$var$numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
// const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $b7a28001cd116d9a$var$consider = {
    hex: true,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $b7a28001cd116d9a$var$toNumber(str, options = {}) {
    // const options = Object.assign({}, consider);
    // if(opt.leadingZeros === false){
    //     options.leadingZeros = false;
    // }else if(opt.hex === false){
    //     options.hex = false;
    // }
    options = Object.assign({}, $b7a28001cd116d9a$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    // if(trimmedStr === "0.0") return 0;
    // else if(trimmedStr === "+0.0") return 0;
    // else if(trimmedStr === "-0.0") return -0;
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (options.hex && $b7a28001cd116d9a$var$hexRegex.test(trimmedStr)) return Number.parseInt(trimmedStr, 16);
    else {
        //separate negative sign, leading zeros, and rest number
        const match = $b7a28001cd116d9a$var$numRegex.exec(trimmedStr);
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $b7a28001cd116d9a$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            const eNotation = match[4] || match[6];
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (eNotation) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    // const decimalPart = match[5].substr(1);
                    // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));
                    // const p = numStr.indexOf(".");
                    // const givenIntPart = numStr.substr(0,p);
                    // const givenDecPart = numStr.substr(p+1);
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) {
                    // if(numTrimmedByZeros === numStr){
                    //     if(options.leadingZeros) return num;
                    //     else return str;
                    // }else return str;
                    if (numTrimmedByZeros === numStr) return num;
                    else if (sign + numTrimmedByZeros === numStr) return num;
                    else return str;
                }
                if (trimmedStr === numStr) return num;
                else if (trimmedStr === sign + numStr) return num;
                // else{
                //     //number with +/- sign
                //     trimmedStr.test(/[-+][0-9]);
                // }
                return str;
            }
        // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $b7a28001cd116d9a$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
$b7a28001cd116d9a$exports = $b7a28001cd116d9a$var$toNumber;


const $ffe42f7d6492ea5b$var$regx = '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'.replace(/NAME/g, $f62ff286a4f745fa$export$e8f2644f7085b4b1);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
class $ffe42f7d6492ea5b$var$OrderedObjParser {
    constructor(options){
        this.options = options;
        this.currentNode = null;
        this.tagsNodeStack = [];
        this.docTypeEntities = {};
        this.lastEntities = {
            "apos": {
                regex: /&(apos|#39|#x27);/g,
                val: "'"
            },
            "gt": {
                regex: /&(gt|#62|#x3E);/g,
                val: ">"
            },
            "lt": {
                regex: /&(lt|#60|#x3C);/g,
                val: "<"
            },
            "quot": {
                regex: /&(quot|#34|#x22);/g,
                val: "\""
            }
        };
        this.ampEntity = {
            regex: /&(amp|#38|#x26);/g,
            val: "&"
        };
        this.htmlEntities = {
            "space": {
                regex: /&(nbsp|#160);/g,
                val: " "
            },
            // "lt" : { regex: /&(lt|#60);/g, val: "<" },
            // "gt" : { regex: /&(gt|#62);/g, val: ">" },
            // "amp" : { regex: /&(amp|#38);/g, val: "&" },
            // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
            // "apos" : { regex: /&(apos|#39);/g, val: "'" },
            "cent": {
                regex: /&(cent|#162);/g,
                val: "\xa2"
            },
            "pound": {
                regex: /&(pound|#163);/g,
                val: "\xa3"
            },
            "yen": {
                regex: /&(yen|#165);/g,
                val: "\xa5"
            },
            "euro": {
                regex: /&(euro|#8364);/g,
                val: "\u20AC"
            },
            "copyright": {
                regex: /&(copy|#169);/g,
                val: "\xa9"
            },
            "reg": {
                regex: /&(reg|#174);/g,
                val: "\xae"
            },
            "inr": {
                regex: /&(inr|#8377);/g,
                val: "\u20B9"
            }
        };
        this.addExternalEntities = $ffe42f7d6492ea5b$var$addExternalEntities;
        this.parseXml = $ffe42f7d6492ea5b$var$parseXml;
        this.parseTextData = $ffe42f7d6492ea5b$var$parseTextData;
        this.resolveNameSpace = $ffe42f7d6492ea5b$var$resolveNameSpace;
        this.buildAttributesMap = $ffe42f7d6492ea5b$var$buildAttributesMap;
        this.isItStopNode = $ffe42f7d6492ea5b$var$isItStopNode;
        this.replaceEntitiesValue = $ffe42f7d6492ea5b$var$replaceEntitiesValue;
        this.readStopNodeData = $ffe42f7d6492ea5b$var$readStopNodeData;
        this.saveTextToParentTag = $ffe42f7d6492ea5b$var$saveTextToParentTag;
        this.addChild = $ffe42f7d6492ea5b$var$addChild;
    }
}
function $ffe42f7d6492ea5b$var$addExternalEntities(externalEntities) {
    const entKeys = Object.keys(externalEntities);
    for(let i = 0; i < entKeys.length; i++){
        const ent = entKeys[i];
        this.lastEntities[ent] = {
            regex: new RegExp("&" + ent + ";", "g"),
            val: externalEntities[ent]
        };
    }
}
/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */ function $ffe42f7d6492ea5b$var$parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
    if (val !== undefined) {
        if (this.options.trimValues && !dontTrim) val = val.trim();
        if (val.length > 0) {
            if (!escapeEntities) val = this.replaceEntitiesValue(val);
            const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
            if (newval === null || newval === undefined) //don't parse
            return val;
            else if (typeof newval !== typeof val || newval !== val) //overwrite
            return newval;
            else if (this.options.trimValues) return $ffe42f7d6492ea5b$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
            else {
                const trimmedVal = val.trim();
                if (trimmedVal === val) return $ffe42f7d6492ea5b$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
                else return val;
            }
        }
    }
}
function $ffe42f7d6492ea5b$var$resolveNameSpace(tagname) {
    if (this.options.removeNSPrefix) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $ffe42f7d6492ea5b$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');
function $ffe42f7d6492ea5b$var$buildAttributesMap(attrStr, jPath, tagName) {
    if (!this.options.ignoreAttributes && typeof attrStr === 'string') {
        // attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $f62ff286a4f745fa$export$aaa9734c55cb7a19(attrStr, $ffe42f7d6492ea5b$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = this.resolveNameSpace(matches[i][1]);
            let oldVal = matches[i][4];
            let aName = this.options.attributeNamePrefix + attrName;
            if (attrName.length) {
                if (this.options.transformAttributeName) aName = this.options.transformAttributeName(aName);
                if (aName === "__proto__") aName = "#__proto__";
                if (oldVal !== undefined) {
                    if (this.options.trimValues) oldVal = oldVal.trim();
                    oldVal = this.replaceEntitiesValue(oldVal);
                    const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
                    if (newVal === null || newVal === undefined) //don't parse
                    attrs[aName] = oldVal;
                    else if (typeof newVal !== typeof oldVal || newVal !== oldVal) //overwrite
                    attrs[aName] = newVal;
                    else //parse
                    attrs[aName] = $ffe42f7d6492ea5b$var$parseValue(oldVal, this.options.parseAttributeValue, this.options.numberParseOptions);
                } else if (this.options.allowBooleanAttributes) attrs[aName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (this.options.attributesGroupName) {
            const attrCollection = {};
            attrCollection[this.options.attributesGroupName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $ffe42f7d6492ea5b$var$parseXml = function(xmlData) {
    xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
    const xmlObj = new $b89beca15b40c3b5$exports('!xml');
    let currentNode = xmlObj;
    let textData = "";
    let jPath = "";
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            // const nextIndex = i+1;
            // const _2ndChar = xmlData[nextIndex];
            if (xmlData[i + 1] === '/') {
                const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (this.options.removeNSPrefix) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                if (currentNode) textData = this.saveTextToParentTag(textData, currentNode, jPath);
                //check if last tag of nested tag was unpaired tag
                const lastTagName = jPath.substring(jPath.lastIndexOf(".") + 1);
                if (tagName && this.options.unpairedTags.indexOf(tagName) !== -1) throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
                let propIndex = 0;
                if (lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1) {
                    propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.') - 1);
                    this.tagsNodeStack.pop();
                } else propIndex = jPath.lastIndexOf(".");
                jPath = jPath.substring(0, propIndex);
                currentNode = this.tagsNodeStack.pop(); //avoid recursion, set the parent tag scope
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') {
                let tagData = $ffe42f7d6492ea5b$var$readTagExp(xmlData, i, false, "?>");
                if (!tagData) throw new Error("Pi Tag is not closed.");
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) ;
                else {
                    const childNode = new $b89beca15b40c3b5$exports(tagData.tagName);
                    childNode.add(this.options.textNodeName, "");
                    if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
                    this.addChild(currentNode, childNode, jPath);
                }
                i = tagData.closeIndex + 1;
            } else if (xmlData.substr(i + 1, 3) === '!--') {
                const endIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");
                if (this.options.commentPropName) {
                    const comment = xmlData.substring(i + 4, endIndex - 2);
                    textData = this.saveTextToParentTag(textData, currentNode, jPath);
                    currentNode.add(this.options.commentPropName, [
                        {
                            [this.options.textNodeName]: comment
                        }
                    ]);
                }
                i = endIndex;
            } else if (xmlData.substr(i + 1, 2) === '!D') {
                const result = $f29e32ddf0f58f56$exports(xmlData, i);
                this.docTypeEntities = result.entities;
                i = result.i;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                //cdata should be set even if it is 0 length string
                if (this.options.cdataPropName) // let val = this.parseTextData(tagExp, this.options.cdataPropName, jPath + "." + this.options.cdataPropName, true, false, true);
                // if(!val) val = "";
                currentNode.add(this.options.cdataPropName, [
                    {
                        [this.options.textNodeName]: tagExp
                    }
                ]);
                else {
                    let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true);
                    if (val == undefined) val = "";
                    currentNode.add(this.options.textNodeName, val);
                }
                i = closeIndex + 2;
            } else {
                let result = $ffe42f7d6492ea5b$var$readTagExp(xmlData, i, this.options.removeNSPrefix);
                let tagName = result.tagName;
                let tagExp = result.tagExp;
                let attrExpPresent = result.attrExpPresent;
                let closeIndex = result.closeIndex;
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                //save text as child node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') //when nested tag is found
                    textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
                }
                //check if last tag was unpaired tag
                const lastTag = currentNode;
                if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
                    currentNode = this.tagsNodeStack.pop();
                    jPath = jPath.substring(0, jPath.lastIndexOf("."));
                }
                if (tagName !== xmlObj.tagname) jPath += jPath ? "." + tagName : tagName;
                if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) {
                    let tagContent = "";
                    //self-closing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) i = result.closeIndex;
                    else if (this.options.unpairedTags.indexOf(tagName) !== -1) i = result.closeIndex;
                    else {
                        //read until closing tag is found
                        const result = this.readStopNodeData(xmlData, tagName, closeIndex + 1);
                        if (!result) throw new Error(`Unexpected end of ${tagName}`);
                        i = result.i;
                        tagContent = result.tagContent;
                    }
                    const childNode = new $b89beca15b40c3b5$exports(tagName);
                    if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                    if (tagContent) tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
                    jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    childNode.add(this.options.textNodeName, tagContent);
                    this.addChild(currentNode, childNode, jPath);
                } else {
                    //selfClosing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                        const childNode = new $b89beca15b40c3b5$exports(tagName);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    } else {
                        const childNode = new $b89beca15b40c3b5$exports(tagName);
                        this.tagsNodeStack.push(currentNode);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        currentNode = childNode;
                    }
                    textData = "";
                    i = closeIndex;
                }
            }
        } else textData += xmlData[i];
    }
    return xmlObj.child;
};
function $ffe42f7d6492ea5b$var$addChild(currentNode, childNode, jPath) {
    const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
    if (result === false) ;
    else if (typeof result === "string") {
        childNode.tagname = result;
        currentNode.addChild(childNode);
    } else currentNode.addChild(childNode);
}
const $ffe42f7d6492ea5b$var$replaceEntitiesValue = function(val) {
    if (this.options.processEntities) {
        for(let entityName in this.docTypeEntities){
            const entity = this.docTypeEntities[entityName];
            val = val.replace(entity.regx, entity.val);
        }
        for(let entityName in this.lastEntities){
            const entity = this.lastEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        if (this.options.htmlEntities) for(let entityName in this.htmlEntities){
            const entity = this.htmlEntities[entityName];
            val = val.replace(entity.regex, entity.val);
        }
        val = val.replace(this.ampEntity.regex, this.ampEntity.val);
    }
    return val;
};
function $ffe42f7d6492ea5b$var$saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
    if (textData) {
        if (isLeafNode === undefined) isLeafNode = Object.keys(currentNode.child).length === 0;
        textData = this.parseTextData(textData, currentNode.tagname, jPath, false, currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false, isLeafNode);
        if (textData !== undefined && textData !== "") currentNode.add(this.options.textNodeName, textData);
        textData = "";
    }
    return textData;
}
//TODO: use jPath to simplify the logic
/**
 * 
 * @param {string[]} stopNodes 
 * @param {string} jPath
 * @param {string} currentTagName 
 */ function $ffe42f7d6492ea5b$var$isItStopNode(stopNodes, jPath, currentTagName) {
    const allNodesExp = "*." + currentTagName;
    for(const stopNodePath in stopNodes){
        const stopNodeExp = stopNodes[stopNodePath];
        if (allNodesExp === stopNodeExp || jPath === stopNodeExp) return true;
    }
    return false;
}
/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */ function $ffe42f7d6492ea5b$var$tagExpWithClosingIndex(xmlData, i, closingChar = ">") {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < xmlData.length; index++){
        let ch = xmlData[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === closingChar[0]) {
            if (closingChar[1]) {
                if (xmlData[index + 1] === closingChar[1]) return {
                    data: tagExp,
                    index: index
                };
            } else return {
                data: tagExp,
                index: index
            };
        } else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
function $ffe42f7d6492ea5b$var$readTagExp(xmlData, i, removeNSPrefix, closingChar = ">") {
    const result = $ffe42f7d6492ea5b$var$tagExpWithClosingIndex(xmlData, i + 1, closingChar);
    if (!result) return;
    let tagExp = result.data;
    const closeIndex = result.index;
    const separatorIndex = tagExp.search(/\s/);
    let tagName = tagExp;
    let attrExpPresent = true;
    if (separatorIndex !== -1) {
        tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, '');
        tagExp = tagExp.substr(separatorIndex + 1);
    }
    if (removeNSPrefix) {
        const colonIndex = tagName.indexOf(":");
        if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
            attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
        }
    }
    return {
        tagName: tagName,
        tagExp: tagExp,
        closeIndex: closeIndex,
        attrExpPresent: attrExpPresent
    };
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */ function $ffe42f7d6492ea5b$var$readStopNodeData(xmlData, tagName, i) {
    const startIndex = i;
    // Starting at 1 since we already have an open tag
    let openTagCount = 1;
    for(; i < xmlData.length; i++)if (xmlData[i] === "<") {
        if (xmlData[i + 1] === "/") {
            const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
            let closeTagName = xmlData.substring(i + 2, closeIndex).trim();
            if (closeTagName === tagName) {
                openTagCount--;
                if (openTagCount === 0) return {
                    tagContent: xmlData.substring(startIndex, i),
                    i: closeIndex
                };
            }
            i = closeIndex;
        } else if (xmlData[i + 1] === '?') {
            const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 3) === '!--') {
            const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 2) === '![') {
            const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
            i = closeIndex;
        } else {
            const tagData = $ffe42f7d6492ea5b$var$readTagExp(xmlData, i, '>');
            if (tagData) {
                const openTagName = tagData && tagData.tagName;
                if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") openTagCount++;
                i = tagData.closeIndex;
            }
        }
    }
     //end for loop
}
function $ffe42f7d6492ea5b$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $b7a28001cd116d9a$exports(val, options);
    } else {
        if ($f62ff286a4f745fa$export$a5edf3f35b6dd392(val)) return val;
        else return '';
    }
}
$ffe42f7d6492ea5b$exports = $ffe42f7d6492ea5b$var$OrderedObjParser;


var $8806e7cb340781c4$export$1b80ed980367b7c1;
'use strict';
/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */ function $8806e7cb340781c4$var$prettify(node, options) {
    return $8806e7cb340781c4$var$compress(node, options);
}
/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */ function $8806e7cb340781c4$var$compress(arr, options, jPath) {
    let text;
    const compressedObj = {};
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const property = $8806e7cb340781c4$var$propName(tagObj);
        let newJpath = "";
        if (jPath === undefined) newJpath = property;
        else newJpath = jPath + "." + property;
        if (property === options.textNodeName) {
            if (text === undefined) text = tagObj[property];
            else text += "" + tagObj[property];
        } else if (property === undefined) continue;
        else if (tagObj[property]) {
            let val = $8806e7cb340781c4$var$compress(tagObj[property], options, newJpath);
            const isLeaf = $8806e7cb340781c4$var$isLeafTag(val, options);
            if (tagObj[":@"]) $8806e7cb340781c4$var$assignAttributes(val, tagObj[":@"], newJpath, options);
            else if (Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) val = val[options.textNodeName];
            else if (Object.keys(val).length === 0) {
                if (options.alwaysCreateTextNode) val[options.textNodeName] = "";
                else val = "";
            }
            if (compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
                if (!Array.isArray(compressedObj[property])) compressedObj[property] = [
                    compressedObj[property]
                ];
                compressedObj[property].push(val);
            } else //TODO: if a node is not an array, then check if it should be an array
            //also determine if it is a leaf node
            if (options.isArray(property, newJpath, isLeaf)) compressedObj[property] = [
                val
            ];
            else compressedObj[property] = val;
        }
    }
    // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
    if (typeof text === "string") {
        if (text.length > 0) compressedObj[options.textNodeName] = text;
    } else if (text !== undefined) compressedObj[options.textNodeName] = text;
    return compressedObj;
}
function $8806e7cb340781c4$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key !== ":@") return key;
    }
}
function $8806e7cb340781c4$var$assignAttributes(obj, attrMap, jpath, options) {
    if (attrMap) {
        const keys = Object.keys(attrMap);
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++){
            const atrrName = keys[i];
            if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) obj[atrrName] = [
                attrMap[atrrName]
            ];
            else obj[atrrName] = attrMap[atrrName];
        }
    }
}
function $8806e7cb340781c4$var$isLeafTag(obj, options) {
    const { textNodeName: textNodeName } = options;
    const propCount = Object.keys(obj).length;
    if (propCount === 0) return true;
    if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) return true;
    return false;
}
$8806e7cb340781c4$export$1b80ed980367b7c1 = $8806e7cb340781c4$var$prettify;


var $fc10b5bda729ad87$require$prettify = $8806e7cb340781c4$export$1b80ed980367b7c1;

class $fc10b5bda729ad87$var$XMLParser {
    constructor(options){
        this.externalEntities = {};
        this.options = $fc10b5bda729ad87$require$buildOptions(options);
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */ parse(xmlData, validationOption) {
        if (typeof xmlData === "string") ;
        else if (xmlData.toString) xmlData = xmlData.toString();
        else throw new Error("XML data is accepted in String or Bytes[] form.");
        if (validationOption) {
            if (validationOption === true) validationOption = {}; //validate with default options
            const result = $e6697f46f4a0942a$export$a22775fa5e2eebd9(xmlData, validationOption);
            if (result !== true) throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
        }
        const orderedObjParser = new $ffe42f7d6492ea5b$exports(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return $fc10b5bda729ad87$require$prettify(orderedResult, this.options);
    }
    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */ addEntity(key, value) {
        if (value.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        else if (value === "&") throw new Error("An entity with value '&' is not permitted");
        else this.externalEntities[key] = value;
    }
}
$fc10b5bda729ad87$exports = $fc10b5bda729ad87$var$XMLParser;


var $f07d0849a7dcedd5$exports = {};
'use strict';
var $7a9dd9537815f4b0$exports = {};
const $7a9dd9537815f4b0$var$EOL = "\n";
/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */ function $7a9dd9537815f4b0$var$toXml(jArray, options) {
    let indentation = "";
    if (options.format && options.indentBy.length > 0) indentation = $7a9dd9537815f4b0$var$EOL;
    return $7a9dd9537815f4b0$var$arrToStr(jArray, options, "", indentation);
}
function $7a9dd9537815f4b0$var$arrToStr(arr, options, jPath, indentation) {
    let xmlStr = "";
    let isPreviousElementTag = false;
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const tagName = $7a9dd9537815f4b0$var$propName(tagObj);
        let newJPath = "";
        if (jPath.length === 0) newJPath = tagName;
        else newJPath = `${jPath}.${tagName}`;
        if (tagName === options.textNodeName) {
            let tagText = tagObj[tagName];
            if (!$7a9dd9537815f4b0$var$isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = $7a9dd9537815f4b0$var$replaceEntitiesValue(tagText, options);
            }
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += tagText;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.cdataPropName) {
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.commentPropName) {
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            isPreviousElementTag = true;
            continue;
        } else if (tagName[0] === "?") {
            const attStr = $7a9dd9537815f4b0$var$attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            isPreviousElementTag = true;
            continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") newIdentation += options.indentBy;
        const attStr = $7a9dd9537815f4b0$var$attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = $7a9dd9537815f4b0$var$arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
            if (options.suppressUnpairedNode) xmlStr += tagStart + ">";
            else xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) xmlStr += tagStart + "/>";
        else if (tagValue && tagValue.endsWith(">")) xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        else {
            xmlStr += tagStart + ">";
            if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) xmlStr += indentation + options.indentBy + tagValue + indentation;
            else xmlStr += tagValue;
            xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
    }
    return xmlStr;
}
function $7a9dd9537815f4b0$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key !== ":@") return key;
    }
}
function $7a9dd9537815f4b0$var$attr_to_str(attrMap, options) {
    let attrStr = "";
    if (attrMap && !options.ignoreAttributes) for(let attr in attrMap){
        let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
        attrVal = $7a9dd9537815f4b0$var$replaceEntitiesValue(attrVal, options);
        if (attrVal === true && options.suppressBooleanAttributes) attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
        else attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
    }
    return attrStr;
}
function $7a9dd9537815f4b0$var$isStopNode(jPath, options) {
    jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for(let index in options.stopNodes){
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
    }
    return false;
}
function $7a9dd9537815f4b0$var$replaceEntitiesValue(textValue, options) {
    if (textValue && textValue.length > 0 && options.processEntities) for(let i = 0; i < options.entities.length; i++){
        const entity = options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
}
$7a9dd9537815f4b0$exports = $7a9dd9537815f4b0$var$toXml;


const $f07d0849a7dcedd5$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataPropName: false,
    format: false,
    indentBy: '  ',
    suppressEmptyNode: false,
    suppressUnpairedNode: true,
    suppressBooleanAttributes: true,
    tagValueProcessor: function(key, a) {
        return a;
    },
    attributeValueProcessor: function(attrName, a) {
        return a;
    },
    preserveOrder: false,
    commentPropName: false,
    unpairedTags: [],
    entities: [
        {
            regex: new RegExp("&", "g"),
            val: "&amp;"
        },
        {
            regex: new RegExp(">", "g"),
            val: "&gt;"
        },
        {
            regex: new RegExp("<", "g"),
            val: "&lt;"
        },
        {
            regex: new RegExp("\'", "g"),
            val: "&apos;"
        },
        {
            regex: new RegExp("\"", "g"),
            val: "&quot;"
        }
    ],
    processEntities: true,
    stopNodes: [],
    // transformTagName: false,
    // transformAttributeName: false,
    oneListGroup: false
};
function $f07d0849a7dcedd5$var$Builder(options) {
    this.options = Object.assign({}, $f07d0849a7dcedd5$var$defaultOptions, options);
    if (this.options.ignoreAttributes || this.options.attributesGroupName) this.isAttribute = function() {
        return false;
    };
    else {
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $f07d0849a7dcedd5$var$isAttribute;
    }
    this.processTextOrObjNode = $f07d0849a7dcedd5$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $f07d0849a7dcedd5$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
}
$f07d0849a7dcedd5$var$Builder.prototype.build = function(jObj) {
    if (this.options.preserveOrder) return $7a9dd9537815f4b0$exports(jObj, this.options);
    else {
        if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) jObj = {
            [this.options.arrayNodeName]: jObj
        };
        return this.j2x(jObj, 0).val;
    }
};
$f07d0849a7dcedd5$var$Builder.prototype.j2x = function(jObj, level) {
    let attrStr = '';
    let val = '';
    for(let key in jObj){
        if (typeof jObj[key] === 'undefined') ;
        else if (jObj[key] === null) {
            if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
            else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (jObj[key] instanceof Date) val += this.buildTextValNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr) attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
            else //tag value
            if (key === this.options.textNodeName) {
                let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
                val += this.replaceEntitiesValue(newval);
            } else val += this.buildTextValNode(jObj[key], key, '', level);
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            const arrLen = jObj[key].length;
            let listTagVal = "";
            for(let j = 0; j < arrLen; j++){
                const item = jObj[key][j];
                if (typeof item === 'undefined') ;
                else if (item === null) {
                    if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
                    else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                } else if (typeof item === 'object') {
                    if (this.options.oneListGroup) listTagVal += this.j2x(item, level + 1).val;
                    else listTagVal += this.processTextOrObjNode(item, key, level);
                } else listTagVal += this.buildTextValNode(item, key, '', level);
            }
            if (this.options.oneListGroup) listTagVal = this.buildObjectNode(listTagVal, key, '', level);
            val += listTagVal;
        } else //nested node
        if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        } else val += this.processTextOrObjNode(jObj[key], key, level);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
$f07d0849a7dcedd5$var$Builder.prototype.buildAttrPairStr = function(attrName, val) {
    val = this.options.attributeValueProcessor(attrName, '' + val);
    val = this.replaceEntitiesValue(val);
    if (this.options.suppressBooleanAttributes && val === "true") return ' ' + attrName;
    else return ' ' + attrName + '="' + val + '"';
};
function $f07d0849a7dcedd5$var$processTextOrObjNode(object, key, level) {
    const result = this.j2x(object, level + 1);
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
    else return this.buildObjectNode(result.val, key, result.attrStr, level);
}
$f07d0849a7dcedd5$var$Builder.prototype.buildObjectNode = function(val, key, attrStr, level) {
    if (val === "") {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    } else {
        let tagEndExp = '</' + key + this.tagEndChar;
        let piClosingChar = "";
        if (key[0] === "?") {
            piClosingChar = "?";
            tagEndExp = "";
        }
        if (attrStr && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + piClosingChar + '>' + val + tagEndExp;
        else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) return this.indentate(level) + `<!--${val}-->` + this.newLine;
        else return this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
    }
};
$f07d0849a7dcedd5$var$Builder.prototype.closeTag = function(key) {
    let closeTag = "";
    if (this.options.unpairedTags.indexOf(key) !== -1) {
        if (!this.options.suppressUnpairedNode) closeTag = "/";
    } else if (this.options.suppressEmptyNode) closeTag = "/";
    else closeTag = `></${key}`;
    return closeTag;
};
function $f07d0849a7dcedd5$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
    }
}
$f07d0849a7dcedd5$var$Builder.prototype.buildTextValNode = function(val, key, attrStr, level) {
    if (this.options.cdataPropName !== false && key === this.options.cdataPropName) return this.indentate(level) + `<![CDATA[${val}]]>` + this.newLine;
    else if (this.options.commentPropName !== false && key === this.options.commentPropName) return this.indentate(level) + `<!--${val}-->` + this.newLine;
    else if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
    else {
        let textValue = this.options.tagValueProcessor(key, val);
        textValue = this.replaceEntitiesValue(textValue);
        if (textValue === '') return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '>' + textValue + '</' + key + this.tagEndChar;
    }
};
$f07d0849a7dcedd5$var$Builder.prototype.replaceEntitiesValue = function(textValue) {
    if (textValue && textValue.length > 0 && this.options.processEntities) for(let i = 0; i < this.options.entities.length; i++){
        const entity = this.options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
};
function $f07d0849a7dcedd5$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $f07d0849a7dcedd5$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix)) return name.substr(this.attrPrefixLen);
    else return false;
}
$f07d0849a7dcedd5$exports = $f07d0849a7dcedd5$var$Builder;


$2b87ce1df293278b$exports = {
    XMLParser: $fc10b5bda729ad87$exports,
    XMLValidator: $e6697f46f4a0942a$exports,
    XMLBuilder: $f07d0849a7dcedd5$exports
};




class $1c0ac447e2dd7670$export$a53c51960b14a8e5 extends (0, $f4d6e6bcf25435f5$export$29647f3b4097d3c0) {
    constructor(options){
        super(options);
        Object.setPrototypeOf(this, $1c0ac447e2dd7670$export$a53c51960b14a8e5.prototype);
    }
}


const $581888fd928d8ba4$export$2088a1c61866b42f = {
    requester: "requester"
};
const $581888fd928d8ba4$export$fb013b91cfe9631c = {
    requester: "requester"
};
class $581888fd928d8ba4$export$1de06065cff890a8 extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "NoSuchUpload",
            $fault: "client",
            ...opts
        });
        this.name = "NoSuchUpload";
        this.$fault = "client";
        Object.setPrototypeOf(this, $581888fd928d8ba4$export$1de06065cff890a8.prototype);
    }
}
const $581888fd928d8ba4$export$461a4b9cc44c53a4 = {
    Enabled: "Enabled",
    Suspended: "Suspended"
};
const $581888fd928d8ba4$export$92738401e1603719 = {
    AmazonCustomerByEmail: "AmazonCustomerByEmail",
    CanonicalUser: "CanonicalUser",
    Group: "Group"
};
const $581888fd928d8ba4$export$a461eaf23bef603e = {
    FULL_CONTROL: "FULL_CONTROL",
    READ: "READ",
    READ_ACP: "READ_ACP",
    WRITE: "WRITE",
    WRITE_ACP: "WRITE_ACP"
};
const $581888fd928d8ba4$export$bb669a85cf08a23d = {
    Destination: "Destination"
};
const $581888fd928d8ba4$export$7114a33237015736 = {
    AES256: "AES256",
    aws_kms: "aws:kms",
    aws_kms_dsse: "aws:kms:dsse"
};
const $581888fd928d8ba4$export$2bc4ff953c9f8de4 = {
    authenticated_read: "authenticated-read",
    aws_exec_read: "aws-exec-read",
    bucket_owner_full_control: "bucket-owner-full-control",
    bucket_owner_read: "bucket-owner-read",
    private: "private",
    public_read: "public-read",
    public_read_write: "public-read-write"
};
const $581888fd928d8ba4$export$578faf5500e50907 = {
    CRC32: "CRC32",
    CRC32C: "CRC32C",
    SHA1: "SHA1",
    SHA256: "SHA256"
};
const $581888fd928d8ba4$export$62964424255eeec4 = {
    COPY: "COPY",
    REPLACE: "REPLACE"
};
const $581888fd928d8ba4$export$a107d1c72844e898 = {
    OFF: "OFF",
    ON: "ON"
};
const $581888fd928d8ba4$export$b06b63840ce459d4 = {
    COMPLIANCE: "COMPLIANCE",
    GOVERNANCE: "GOVERNANCE"
};
const $581888fd928d8ba4$export$c9f3e7046503c180 = {
    DEEP_ARCHIVE: "DEEP_ARCHIVE",
    GLACIER: "GLACIER",
    GLACIER_IR: "GLACIER_IR",
    INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
    ONEZONE_IA: "ONEZONE_IA",
    OUTPOSTS: "OUTPOSTS",
    REDUCED_REDUNDANCY: "REDUCED_REDUNDANCY",
    SNOW: "SNOW",
    STANDARD: "STANDARD",
    STANDARD_IA: "STANDARD_IA"
};
const $581888fd928d8ba4$export$9ee8cb617ddaf4c2 = {
    COPY: "COPY",
    REPLACE: "REPLACE"
};
class $581888fd928d8ba4$export$77615b2f7cde9dd7 extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "ObjectNotInActiveTierError",
            $fault: "client",
            ...opts
        });
        this.name = "ObjectNotInActiveTierError";
        this.$fault = "client";
        Object.setPrototypeOf(this, $581888fd928d8ba4$export$77615b2f7cde9dd7.prototype);
    }
}
class $581888fd928d8ba4$export$b6b374c2bfd60422 extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "BucketAlreadyExists",
            $fault: "client",
            ...opts
        });
        this.name = "BucketAlreadyExists";
        this.$fault = "client";
        Object.setPrototypeOf(this, $581888fd928d8ba4$export$b6b374c2bfd60422.prototype);
    }
}
class $581888fd928d8ba4$export$3d44152d602e5b07 extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "BucketAlreadyOwnedByYou",
            $fault: "client",
            ...opts
        });
        this.name = "BucketAlreadyOwnedByYou";
        this.$fault = "client";
        Object.setPrototypeOf(this, $581888fd928d8ba4$export$3d44152d602e5b07.prototype);
    }
}
const $581888fd928d8ba4$export$c6537723816e271b = {
    authenticated_read: "authenticated-read",
    private: "private",
    public_read: "public-read",
    public_read_write: "public-read-write"
};
const $581888fd928d8ba4$export$bb93eee3fe586aa6 = {
    EU: "EU",
    af_south_1: "af-south-1",
    ap_east_1: "ap-east-1",
    ap_northeast_1: "ap-northeast-1",
    ap_northeast_2: "ap-northeast-2",
    ap_northeast_3: "ap-northeast-3",
    ap_south_1: "ap-south-1",
    ap_south_2: "ap-south-2",
    ap_southeast_1: "ap-southeast-1",
    ap_southeast_2: "ap-southeast-2",
    ap_southeast_3: "ap-southeast-3",
    ca_central_1: "ca-central-1",
    cn_north_1: "cn-north-1",
    cn_northwest_1: "cn-northwest-1",
    eu_central_1: "eu-central-1",
    eu_north_1: "eu-north-1",
    eu_south_1: "eu-south-1",
    eu_south_2: "eu-south-2",
    eu_west_1: "eu-west-1",
    eu_west_2: "eu-west-2",
    eu_west_3: "eu-west-3",
    me_south_1: "me-south-1",
    sa_east_1: "sa-east-1",
    us_east_2: "us-east-2",
    us_gov_east_1: "us-gov-east-1",
    us_gov_west_1: "us-gov-west-1",
    us_west_1: "us-west-1",
    us_west_2: "us-west-2"
};
const $581888fd928d8ba4$export$78011c6a3f9ac7bc = {
    BucketOwnerEnforced: "BucketOwnerEnforced",
    BucketOwnerPreferred: "BucketOwnerPreferred",
    ObjectWriter: "ObjectWriter"
};
var $581888fd928d8ba4$export$c9ec61557dcb764a;
(function(AnalyticsFilter) {
    AnalyticsFilter.visit = (value, visitor)=>{
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($581888fd928d8ba4$export$c9ec61557dcb764a || ($581888fd928d8ba4$export$c9ec61557dcb764a = {}));
const $581888fd928d8ba4$export$29fe27c41c8a8938 = {
    CSV: "CSV"
};
const $581888fd928d8ba4$export$80e034a7f289c3e4 = {
    V_1: "V_1"
};
const $581888fd928d8ba4$export$7f9a2082b392326e = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$678658c19f924e51 = {
    ARCHIVE_ACCESS: "ARCHIVE_ACCESS",
    DEEP_ARCHIVE_ACCESS: "DEEP_ARCHIVE_ACCESS"
};
const $581888fd928d8ba4$export$191f65f0cb1052dc = {
    CSV: "CSV",
    ORC: "ORC",
    Parquet: "Parquet"
};
const $581888fd928d8ba4$export$9e2ee342c395e0e0 = {
    All: "All",
    Current: "Current"
};
const $581888fd928d8ba4$export$1a6ee719036d2ac6 = {
    BucketKeyStatus: "BucketKeyStatus",
    ChecksumAlgorithm: "ChecksumAlgorithm",
    ETag: "ETag",
    EncryptionStatus: "EncryptionStatus",
    IntelligentTieringAccessTier: "IntelligentTieringAccessTier",
    IsMultipartUploaded: "IsMultipartUploaded",
    LastModifiedDate: "LastModifiedDate",
    ObjectAccessControlList: "ObjectAccessControlList",
    ObjectLockLegalHoldStatus: "ObjectLockLegalHoldStatus",
    ObjectLockMode: "ObjectLockMode",
    ObjectLockRetainUntilDate: "ObjectLockRetainUntilDate",
    ObjectOwner: "ObjectOwner",
    ReplicationStatus: "ReplicationStatus",
    Size: "Size",
    StorageClass: "StorageClass"
};
const $581888fd928d8ba4$export$4e4cd66dff7403f3 = {
    Daily: "Daily",
    Weekly: "Weekly"
};
var $581888fd928d8ba4$export$4338dba1e93ddaf4;
(function(LifecycleRuleFilter) {
    LifecycleRuleFilter.visit = (value, visitor)=>{
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.ObjectSizeGreaterThan !== undefined) return visitor.ObjectSizeGreaterThan(value.ObjectSizeGreaterThan);
        if (value.ObjectSizeLessThan !== undefined) return visitor.ObjectSizeLessThan(value.ObjectSizeLessThan);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($581888fd928d8ba4$export$4338dba1e93ddaf4 || ($581888fd928d8ba4$export$4338dba1e93ddaf4 = {}));
const $581888fd928d8ba4$export$c5e045ed304f0693 = {
    DEEP_ARCHIVE: "DEEP_ARCHIVE",
    GLACIER: "GLACIER",
    GLACIER_IR: "GLACIER_IR",
    INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
    ONEZONE_IA: "ONEZONE_IA",
    STANDARD_IA: "STANDARD_IA"
};
const $581888fd928d8ba4$export$e07001eef35cce48 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$f61526eb707ec4e5 = {
    FULL_CONTROL: "FULL_CONTROL",
    READ: "READ",
    WRITE: "WRITE"
};
var $581888fd928d8ba4$export$564a1f9c338cae45;
(function(MetricsFilter) {
    MetricsFilter.visit = (value, visitor)=>{
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.AccessPointArn !== undefined) return visitor.AccessPointArn(value.AccessPointArn);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($581888fd928d8ba4$export$564a1f9c338cae45 || ($581888fd928d8ba4$export$564a1f9c338cae45 = {}));
const $581888fd928d8ba4$export$d61e24a684f9e51 = {
    s3_IntelligentTiering: "s3:IntelligentTiering",
    s3_LifecycleExpiration_: "s3:LifecycleExpiration:*",
    s3_LifecycleExpiration_Delete: "s3:LifecycleExpiration:Delete",
    s3_LifecycleExpiration_DeleteMarkerCreated: "s3:LifecycleExpiration:DeleteMarkerCreated",
    s3_LifecycleTransition: "s3:LifecycleTransition",
    s3_ObjectAcl_Put: "s3:ObjectAcl:Put",
    s3_ObjectCreated_: "s3:ObjectCreated:*",
    s3_ObjectCreated_CompleteMultipartUpload: "s3:ObjectCreated:CompleteMultipartUpload",
    s3_ObjectCreated_Copy: "s3:ObjectCreated:Copy",
    s3_ObjectCreated_Post: "s3:ObjectCreated:Post",
    s3_ObjectCreated_Put: "s3:ObjectCreated:Put",
    s3_ObjectRemoved_: "s3:ObjectRemoved:*",
    s3_ObjectRemoved_Delete: "s3:ObjectRemoved:Delete",
    s3_ObjectRemoved_DeleteMarkerCreated: "s3:ObjectRemoved:DeleteMarkerCreated",
    s3_ObjectRestore_: "s3:ObjectRestore:*",
    s3_ObjectRestore_Completed: "s3:ObjectRestore:Completed",
    s3_ObjectRestore_Delete: "s3:ObjectRestore:Delete",
    s3_ObjectRestore_Post: "s3:ObjectRestore:Post",
    s3_ObjectTagging_: "s3:ObjectTagging:*",
    s3_ObjectTagging_Delete: "s3:ObjectTagging:Delete",
    s3_ObjectTagging_Put: "s3:ObjectTagging:Put",
    s3_ReducedRedundancyLostObject: "s3:ReducedRedundancyLostObject",
    s3_Replication_: "s3:Replication:*",
    s3_Replication_OperationFailedReplication: "s3:Replication:OperationFailedReplication",
    s3_Replication_OperationMissedThreshold: "s3:Replication:OperationMissedThreshold",
    s3_Replication_OperationNotTracked: "s3:Replication:OperationNotTracked",
    s3_Replication_OperationReplicatedAfterThreshold: "s3:Replication:OperationReplicatedAfterThreshold"
};
const $581888fd928d8ba4$export$8910525d2927db4a = {
    prefix: "prefix",
    suffix: "suffix"
};
const $581888fd928d8ba4$export$a30282025632e486 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$57c6aac8453e0326 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$ad9a9bcf96805340 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$7450743f85207a6f = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
var $581888fd928d8ba4$export$c5652b893758d9eb;
(function(ReplicationRuleFilter) {
    ReplicationRuleFilter.visit = (value, visitor)=>{
        if (value.Prefix !== undefined) return visitor.Prefix(value.Prefix);
        if (value.Tag !== undefined) return visitor.Tag(value.Tag);
        if (value.And !== undefined) return visitor.And(value.And);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($581888fd928d8ba4$export$c5652b893758d9eb || ($581888fd928d8ba4$export$c5652b893758d9eb = {}));
const $581888fd928d8ba4$export$37ed8894bf15c7cc = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$6769a00a1513ac8d = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$463cbeba2ee6e701 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$a0c454341dc6c9b6 = {
    BucketOwner: "BucketOwner",
    Requester: "Requester"
};
const $581888fd928d8ba4$export$3eb97608f0094ca = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$53eb802876329b9c = {
    Enabled: "Enabled",
    Suspended: "Suspended"
};
const $581888fd928d8ba4$export$377bbedb5576dfa8 = {
    http: "http",
    https: "https"
};
const $581888fd928d8ba4$export$e94cd17a87edcf61 = {
    COMPLETE: "COMPLETE",
    FAILED: "FAILED",
    PENDING: "PENDING",
    REPLICA: "REPLICA"
};
const $581888fd928d8ba4$export$12fb0f2ce043ea4d = {
    ENABLED: "ENABLED"
};
class $581888fd928d8ba4$export$6424f05126e7daf8 extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "InvalidObjectState",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidObjectState";
        this.$fault = "client";
        Object.setPrototypeOf(this, $581888fd928d8ba4$export$6424f05126e7daf8.prototype);
        this.StorageClass = opts.StorageClass;
        this.AccessTier = opts.AccessTier;
    }
}
class $581888fd928d8ba4$export$1f6f8c73c651f3ca extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "NoSuchKey",
            $fault: "client",
            ...opts
        });
        this.name = "NoSuchKey";
        this.$fault = "client";
        Object.setPrototypeOf(this, $581888fd928d8ba4$export$1f6f8c73c651f3ca.prototype);
    }
}
const $581888fd928d8ba4$export$98ca292af92c3ca7 = {
    CHECKSUM: "Checksum",
    ETAG: "ETag",
    OBJECT_PARTS: "ObjectParts",
    OBJECT_SIZE: "ObjectSize",
    STORAGE_CLASS: "StorageClass"
};
const $581888fd928d8ba4$export$7a910e7bcb8a9f5 = {
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$8d22b7763fab892d = {
    COMPLIANCE: "COMPLIANCE",
    GOVERNANCE: "GOVERNANCE"
};
class $581888fd928d8ba4$export$271f9f08425019c7 extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "NotFound",
            $fault: "client",
            ...opts
        });
        this.name = "NotFound";
        this.$fault = "client";
        Object.setPrototypeOf(this, $581888fd928d8ba4$export$271f9f08425019c7.prototype);
    }
}
const $581888fd928d8ba4$export$ca079fdb822b790f = {
    ARCHIVE_ACCESS: "ARCHIVE_ACCESS",
    DEEP_ARCHIVE_ACCESS: "DEEP_ARCHIVE_ACCESS"
};
const $581888fd928d8ba4$export$456871da275f7922 = {
    url: "url"
};
const $581888fd928d8ba4$export$d195d5551132983 = {
    DEEP_ARCHIVE: "DEEP_ARCHIVE",
    GLACIER: "GLACIER",
    GLACIER_IR: "GLACIER_IR",
    INTELLIGENT_TIERING: "INTELLIGENT_TIERING",
    ONEZONE_IA: "ONEZONE_IA",
    OUTPOSTS: "OUTPOSTS",
    REDUCED_REDUNDANCY: "REDUCED_REDUNDANCY",
    SNOW: "SNOW",
    STANDARD: "STANDARD",
    STANDARD_IA: "STANDARD_IA"
};
const $581888fd928d8ba4$export$dca8e7037d29022 = {
    RESTORE_STATUS: "RestoreStatus"
};
class $581888fd928d8ba4$export$bbe89283205bd874 extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "NoSuchBucket",
            $fault: "client",
            ...opts
        });
        this.name = "NoSuchBucket";
        this.$fault = "client";
        Object.setPrototypeOf(this, $581888fd928d8ba4$export$bbe89283205bd874.prototype);
    }
}
const $581888fd928d8ba4$export$38f3da1761c0e0d9 = {
    STANDARD: "STANDARD"
};
const $581888fd928d8ba4$export$d651da0d36c71698 = {
    Disabled: "Disabled",
    Enabled: "Enabled"
};
const $581888fd928d8ba4$export$ee980f22bb30c0b1 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$eb8e420b7cfdd234 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$fb8699876f0673e1 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$a0f30ec69261ee40 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$5abe7f3ae720ef5a = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$a7b934ef912ebf62 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$a7e93a6b579d53af = (obj)=>({
        ...obj,
        ...obj.KMSMasterKeyID && {
            KMSMasterKeyID: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$b765ce8faf930a02 = (obj)=>({
        ...obj,
        ...obj.ApplyServerSideEncryptionByDefault && {
            ApplyServerSideEncryptionByDefault: $581888fd928d8ba4$export$a7e93a6b579d53af(obj.ApplyServerSideEncryptionByDefault)
        }
    });
const $581888fd928d8ba4$export$53d539a6eea5b6ca = (obj)=>({
        ...obj,
        ...obj.Rules && {
            Rules: obj.Rules.map((item)=>$581888fd928d8ba4$export$b765ce8faf930a02(item))
        }
    });
const $581888fd928d8ba4$export$d7df4bcb0241f9e2 = (obj)=>({
        ...obj,
        ...obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $581888fd928d8ba4$export$53d539a6eea5b6ca(obj.ServerSideEncryptionConfiguration)
        }
    });
const $581888fd928d8ba4$export$cb892ee53d79e488 = (obj)=>({
        ...obj,
        ...obj.KeyId && {
            KeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$f16a5b3cef976950 = (obj)=>({
        ...obj,
        ...obj.SSEKMS && {
            SSEKMS: $581888fd928d8ba4$export$cb892ee53d79e488(obj.SSEKMS)
        }
    });
const $581888fd928d8ba4$export$a1f0f98e9204134c = (obj)=>({
        ...obj,
        ...obj.Encryption && {
            Encryption: $581888fd928d8ba4$export$f16a5b3cef976950(obj.Encryption)
        }
    });
const $581888fd928d8ba4$export$e212d4bb36570081 = (obj)=>({
        ...obj,
        ...obj.S3BucketDestination && {
            S3BucketDestination: $581888fd928d8ba4$export$a1f0f98e9204134c(obj.S3BucketDestination)
        }
    });
const $581888fd928d8ba4$export$42cfce9f712db38f = (obj)=>({
        ...obj,
        ...obj.Destination && {
            Destination: $581888fd928d8ba4$export$e212d4bb36570081(obj.Destination)
        }
    });
const $581888fd928d8ba4$export$770e533990455861 = (obj)=>({
        ...obj,
        ...obj.InventoryConfiguration && {
            InventoryConfiguration: $581888fd928d8ba4$export$42cfce9f712db38f(obj.InventoryConfiguration)
        }
    });
const $581888fd928d8ba4$export$5a075da6fc07a9a8 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$19e9479fe773d432 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$6e2d787d30f344ce = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$271fb34028c0c6e7 = (obj)=>({
        ...obj
    });
const $581888fd928d8ba4$export$af4af8d2ddf19d2e = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$f8e32741b8b3f8f5 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$5af58b20282a23ee = (obj)=>({
        ...obj,
        ...obj.InventoryConfigurationList && {
            InventoryConfigurationList: obj.InventoryConfigurationList.map((item)=>$581888fd928d8ba4$export$42cfce9f712db38f(item))
        }
    });
const $581888fd928d8ba4$export$4441acdd50048efe = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$92539c3978f21568 = (obj)=>({
        ...obj,
        ...obj.ServerSideEncryptionConfiguration && {
            ServerSideEncryptionConfiguration: $581888fd928d8ba4$export$53d539a6eea5b6ca(obj.ServerSideEncryptionConfiguration)
        }
    });
const $581888fd928d8ba4$export$51164d1b54fc6c9a = (obj)=>({
        ...obj,
        ...obj.InventoryConfiguration && {
            InventoryConfiguration: $581888fd928d8ba4$export$42cfce9f712db38f(obj.InventoryConfiguration)
        }
    });
const $581888fd928d8ba4$export$4532cbbab0d00c4f = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $581888fd928d8ba4$export$35f8aea70e7bdcca = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.SSEKMSEncryptionContext && {
            SSEKMSEncryptionContext: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });




class $1b94a343f91115e4$export$a97e3c65be291319 extends (0, $1c0ac447e2dd7670$export$a53c51960b14a8e5) {
    constructor(opts){
        super({
            name: "ObjectAlreadyInActiveTierError",
            $fault: "client",
            ...opts
        });
        this.name = "ObjectAlreadyInActiveTierError";
        this.$fault = "client";
        Object.setPrototypeOf(this, $1b94a343f91115e4$export$a97e3c65be291319.prototype);
    }
}
const $1b94a343f91115e4$export$b5ec6150a6c2000b = {
    Bulk: "Bulk",
    Expedited: "Expedited",
    Standard: "Standard"
};
const $1b94a343f91115e4$export$32402a1a71d3ed97 = {
    SQL: "SQL"
};
const $1b94a343f91115e4$export$cf7621ba1f62c1fb = {
    BZIP2: "BZIP2",
    GZIP: "GZIP",
    NONE: "NONE"
};
const $1b94a343f91115e4$export$e0a8b40ee8e7958f = {
    IGNORE: "IGNORE",
    NONE: "NONE",
    USE: "USE"
};
const $1b94a343f91115e4$export$b8d04dd3765058e2 = {
    DOCUMENT: "DOCUMENT",
    LINES: "LINES"
};
const $1b94a343f91115e4$export$b4890521754421ba = {
    ALWAYS: "ALWAYS",
    ASNEEDED: "ASNEEDED"
};
const $1b94a343f91115e4$export$ee855080cc4fa5a8 = {
    SELECT: "SELECT"
};
var $1b94a343f91115e4$export$4c951f3462fad8ac;
(function(SelectObjectContentEventStream) {
    SelectObjectContentEventStream.visit = (value, visitor)=>{
        if (value.Records !== undefined) return visitor.Records(value.Records);
        if (value.Stats !== undefined) return visitor.Stats(value.Stats);
        if (value.Progress !== undefined) return visitor.Progress(value.Progress);
        if (value.Cont !== undefined) return visitor.Cont(value.Cont);
        if (value.End !== undefined) return visitor.End(value.End);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})($1b94a343f91115e4$export$4c951f3462fad8ac || ($1b94a343f91115e4$export$4c951f3462fad8ac = {}));
const $1b94a343f91115e4$export$37ef1918e28a982e = (obj)=>({
        ...obj,
        ...obj.KMSKeyId && {
            KMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $1b94a343f91115e4$export$83a69b3e9aa40aca = (obj)=>({
        ...obj,
        ...obj.Encryption && {
            Encryption: $1b94a343f91115e4$export$37ef1918e28a982e(obj.Encryption)
        }
    });
const $1b94a343f91115e4$export$a655f667672eabb6 = (obj)=>({
        ...obj,
        ...obj.S3 && {
            S3: $1b94a343f91115e4$export$83a69b3e9aa40aca(obj.S3)
        }
    });
const $1b94a343f91115e4$export$4488eace7b3ecf8a = (obj)=>({
        ...obj,
        ...obj.OutputLocation && {
            OutputLocation: $1b94a343f91115e4$export$a655f667672eabb6(obj.OutputLocation)
        }
    });
const $1b94a343f91115e4$export$6b86ebfab0a812dd = (obj)=>({
        ...obj,
        ...obj.RestoreRequest && {
            RestoreRequest: $1b94a343f91115e4$export$4488eace7b3ecf8a(obj.RestoreRequest)
        }
    });
const $1b94a343f91115e4$export$b33d770effc8305b = (obj)=>{
    if (obj.Records !== undefined) return {
        Records: obj.Records
    };
    if (obj.Stats !== undefined) return {
        Stats: obj.Stats
    };
    if (obj.Progress !== undefined) return {
        Progress: obj.Progress
    };
    if (obj.Cont !== undefined) return {
        Cont: obj.Cont
    };
    if (obj.End !== undefined) return {
        End: obj.End
    };
    if (obj.$unknown !== undefined) return {
        [obj.$unknown[0]]: "UNKNOWN"
    };
};
const $1b94a343f91115e4$export$f672474f32fab0f0 = (obj)=>({
        ...obj,
        ...obj.Payload && {
            Payload: "STREAMING_CONTENT"
        }
    });
const $1b94a343f91115e4$export$375c9835f190a59b = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $1b94a343f91115e4$export$16e90045ae9e0c88 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $1b94a343f91115e4$export$d8157ceb4def2c93 = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $1b94a343f91115e4$export$f6814a8c31592894 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $1b94a343f91115e4$export$250bf831eb24996d = (obj)=>({
        ...obj,
        ...obj.SSECustomerKey && {
            SSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        },
        ...obj.CopySourceSSECustomerKey && {
            CopySourceSSECustomerKey: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });
const $1b94a343f91115e4$export$a8eca9afe1025803 = (obj)=>({
        ...obj,
        ...obj.SSEKMSKeyId && {
            SSEKMSKeyId: (0, $8922e83afabc5012$export$17127055dc9ac067)
        }
    });



const $695e66930879143f$export$10d13acf81981e5c = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "AbortMultipartUpload"
        ],
        uploadId: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.UploadId, `UploadId`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$c0d6594d5a007c93 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-checksum-crc32": input.ChecksumCRC32,
        "x-amz-checksum-crc32c": input.ChecksumCRC32C,
        "x-amz-checksum-sha1": input.ChecksumSHA1,
        "x-amz-checksum-sha256": input.ChecksumSHA256,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "CompleteMultipartUpload"
        ],
        uploadId: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.UploadId, `UploadId`)
        ]
    });
    let body;
    if (input.MultipartUpload !== undefined) body = $695e66930879143f$var$se_CompletedMultipartUpload(input.MultipartUpload, context);
    let contents;
    if (input.MultipartUpload !== undefined) {
        contents = $695e66930879143f$var$se_CompletedMultipartUpload(input.MultipartUpload, context);
        contents = contents.withName("CompleteMultipartUpload");
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "POST",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$a4a7e31ebbed0a91 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-acl": input.ACL,
        "cache-control": input.CacheControl,
        "x-amz-checksum-algorithm": input.ChecksumAlgorithm,
        "content-disposition": input.ContentDisposition,
        "content-encoding": input.ContentEncoding,
        "content-language": input.ContentLanguage,
        "content-type": input.ContentType,
        "x-amz-copy-source": input.CopySource,
        "x-amz-copy-source-if-match": input.CopySourceIfMatch,
        "x-amz-copy-source-if-modified-since": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.CopySourceIfModifiedSince).toString()
        ],
        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch,
        "x-amz-copy-source-if-unmodified-since": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.CopySourceIfUnmodifiedSince).toString()
        ],
        expires: [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.Expires),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.Expires).toString()
        ],
        "x-amz-grant-full-control": input.GrantFullControl,
        "x-amz-grant-read": input.GrantRead,
        "x-amz-grant-read-acp": input.GrantReadACP,
        "x-amz-grant-write-acp": input.GrantWriteACP,
        "x-amz-metadata-directive": input.MetadataDirective,
        "x-amz-tagging-directive": input.TaggingDirective,
        "x-amz-server-side-encryption": input.ServerSideEncryption,
        "x-amz-storage-class": input.StorageClass,
        "x-amz-website-redirect-location": input.WebsiteRedirectLocation,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId,
        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext,
        "x-amz-server-side-encryption-bucket-key-enabled": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.BucketKeyEnabled),
            ()=>input.BucketKeyEnabled.toString()
        ],
        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm,
        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey,
        "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-tagging": input.Tagging,
        "x-amz-object-lock-mode": input.ObjectLockMode,
        "x-amz-object-lock-retain-until-date": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate),
            ()=>(input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
        ],
        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner,
        ...input.Metadata !== undefined && Object.keys(input.Metadata).reduce((acc, suffix)=>{
            acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
            return acc;
        }, {})
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "CopyObject"
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$c8f40844147ea2e3 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-acl": input.ACL,
        "x-amz-grant-full-control": input.GrantFullControl,
        "x-amz-grant-read": input.GrantRead,
        "x-amz-grant-read-acp": input.GrantReadACP,
        "x-amz-grant-write": input.GrantWrite,
        "x-amz-grant-write-acp": input.GrantWriteACP,
        "x-amz-bucket-object-lock-enabled": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ObjectLockEnabledForBucket),
            ()=>input.ObjectLockEnabledForBucket.toString()
        ],
        "x-amz-object-ownership": input.ObjectOwnership
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    let body;
    if (input.CreateBucketConfiguration !== undefined) body = $695e66930879143f$var$se_CreateBucketConfiguration(input.CreateBucketConfiguration, context);
    let contents;
    if (input.CreateBucketConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_CreateBucketConfiguration(input.CreateBucketConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        body: body
    });
};
const $695e66930879143f$export$3cc910d56b5ba1fa = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-acl": input.ACL,
        "cache-control": input.CacheControl,
        "content-disposition": input.ContentDisposition,
        "content-encoding": input.ContentEncoding,
        "content-language": input.ContentLanguage,
        "content-type": input.ContentType,
        expires: [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.Expires),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.Expires).toString()
        ],
        "x-amz-grant-full-control": input.GrantFullControl,
        "x-amz-grant-read": input.GrantRead,
        "x-amz-grant-read-acp": input.GrantReadACP,
        "x-amz-grant-write-acp": input.GrantWriteACP,
        "x-amz-server-side-encryption": input.ServerSideEncryption,
        "x-amz-storage-class": input.StorageClass,
        "x-amz-website-redirect-location": input.WebsiteRedirectLocation,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId,
        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext,
        "x-amz-server-side-encryption-bucket-key-enabled": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.BucketKeyEnabled),
            ()=>input.BucketKeyEnabled.toString()
        ],
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-tagging": input.Tagging,
        "x-amz-object-lock-mode": input.ObjectLockMode,
        "x-amz-object-lock-retain-until-date": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate),
            ()=>(input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
        ],
        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-checksum-algorithm": input.ChecksumAlgorithm,
        ...input.Metadata !== undefined && Object.keys(input.Metadata).reduce((acc, suffix)=>{
            acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
            return acc;
        }, {})
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        uploads: [
            ,
            ""
        ],
        "x-id": [
            ,
            "CreateMultipartUpload"
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "POST",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$c510bfd07b726d28 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        body: body
    });
};
const $695e66930879143f$export$751c46c05d301c2b = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        analytics: [
            ,
            ""
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$a68151826c0ba2c4 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        cors: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$b0173c5abecf1f23 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        encryption: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$413c02a033f96fb4 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "intelligent-tiering": [
            ,
            ""
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$d830094fff00a099 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        inventory: [
            ,
            ""
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$f91c22f123caef4e = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        lifecycle: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$12a370f261e5c0dd = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        metrics: [
            ,
            ""
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$332be06b7bac51c2 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        ownershipControls: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$6ea2dcb93818c52b = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        policy: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$865c6fe92c9b85ca = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        replication: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$78d1db3f85a7cb49 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        tagging: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$75fd93177c73ffd5 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        website: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$ce8b91db00a48a2d = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-mfa": input.MFA,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-bypass-governance-retention": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.BypassGovernanceRetention),
            ()=>input.BypassGovernanceRetention.toString()
        ],
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "DeleteObject"
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$e4e156dbf32c5986 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-mfa": input.MFA,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-bypass-governance-retention": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.BypassGovernanceRetention),
            ()=>input.BypassGovernanceRetention.toString()
        ],
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        delete: [
            ,
            ""
        ],
        "x-id": [
            ,
            "DeleteObjects"
        ]
    });
    let body;
    if (input.Delete !== undefined) body = $695e66930879143f$var$se_Delete(input.Delete, context);
    let contents;
    if (input.Delete !== undefined) {
        contents = $695e66930879143f$var$se_Delete(input.Delete, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "POST",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$4b7dd6da3e7aa857 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        tagging: [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$943ebe732e7b80de = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        publicAccessBlock: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "DELETE",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$933b5eeb53ef70ac = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-request-payer": input.RequestPayer
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        accelerate: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$a4414c6c1a2fc819 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        acl: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$8982e062abbeffcb = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        analytics: [
            ,
            ""
        ],
        "x-id": [
            ,
            "GetBucketAnalyticsConfiguration"
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$37d228a94687306a = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        cors: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$72940b3db9c1b61b = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        encryption: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$be20b5bea56546ee = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "intelligent-tiering": [
            ,
            ""
        ],
        "x-id": [
            ,
            "GetBucketIntelligentTieringConfiguration"
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$94863c04fbc3cc82 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        inventory: [
            ,
            ""
        ],
        "x-id": [
            ,
            "GetBucketInventoryConfiguration"
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$9a62f47185385e78 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        lifecycle: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$e7f73d80f954412c = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        location: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$f718c2932b08adb4 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        logging: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$1d3d4c44931f2a0d = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        metrics: [
            ,
            ""
        ],
        "x-id": [
            ,
            "GetBucketMetricsConfiguration"
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$fdabf990f1e6a37d = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        notification: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$3928fd24ca8807cc = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        ownershipControls: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$43bfb515ecc1108 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        policy: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$1fb3135e372980ae = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        policyStatus: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$d719dfb5c8f69272 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        replication: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$4fcc412a9b229a66 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        requestPayment: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$97966bb80376c08b = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        tagging: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$78ef1242631d0fad = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        versioning: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$bbe0f964a7cdfbdc = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        website: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$d47bb2874555749d = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "if-match": input.IfMatch,
        "if-modified-since": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.IfModifiedSince),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.IfModifiedSince).toString()
        ],
        "if-none-match": input.IfNoneMatch,
        "if-unmodified-since": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.IfUnmodifiedSince),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.IfUnmodifiedSince).toString()
        ],
        range: input.Range,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-checksum-mode": input.ChecksumMode
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "GetObject"
        ],
        "response-cache-control": [
            ,
            input.ResponseCacheControl
        ],
        "response-content-disposition": [
            ,
            input.ResponseContentDisposition
        ],
        "response-content-encoding": [
            ,
            input.ResponseContentEncoding
        ],
        "response-content-language": [
            ,
            input.ResponseContentLanguage
        ],
        "response-content-type": [
            ,
            input.ResponseContentType
        ],
        "response-expires": [
            ()=>input.ResponseExpires !== void 0,
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.ResponseExpires).toString()
        ],
        versionId: [
            ,
            input.VersionId
        ],
        partNumber: [
            ()=>input.PartNumber !== void 0,
            ()=>input.PartNumber.toString()
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$2eb7a1046962dc4 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        acl: [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$6095dc65b65c7ada = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-max-parts": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.MaxParts),
            ()=>input.MaxParts.toString()
        ],
        "x-amz-part-number-marker": input.PartNumberMarker,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-object-attributes": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ObjectAttributes),
            ()=>(input.ObjectAttributes || []).map((_entry)=>_entry).join(", ")
        ]
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        attributes: [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$a8215207fe34efb = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "legal-hold": [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$f5a321dcfb8c99ef = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "object-lock": [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$c416bbaad1be2464 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        retention: [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$5687757f6416f974 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-request-payer": input.RequestPayer
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        tagging: [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$501bfef18f069d5d = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        torrent: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$653de371a253cce1 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        publicAccessBlock: [
            ,
            ""
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$12b7e7cf521a0b4 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "HEAD",
        headers: headers,
        path: resolvedPath,
        body: body
    });
};
const $695e66930879143f$export$89ef241b7cc6b282 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "if-match": input.IfMatch,
        "if-modified-since": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.IfModifiedSince),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.IfModifiedSince).toString()
        ],
        "if-none-match": input.IfNoneMatch,
        "if-unmodified-since": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.IfUnmodifiedSince),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.IfUnmodifiedSince).toString()
        ],
        range: input.Range,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-checksum-mode": input.ChecksumMode
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        versionId: [
            ,
            input.VersionId
        ],
        partNumber: [
            ()=>input.PartNumber !== void 0,
            ()=>input.PartNumber.toString()
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "HEAD",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$bac987ae75e1b7b3 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        analytics: [
            ,
            ""
        ],
        "x-id": [
            ,
            "ListBucketAnalyticsConfigurations"
        ],
        "continuation-token": [
            ,
            input.ContinuationToken
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$463b553148d5eb2c = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "intelligent-tiering": [
            ,
            ""
        ],
        "x-id": [
            ,
            "ListBucketIntelligentTieringConfigurations"
        ],
        "continuation-token": [
            ,
            input.ContinuationToken
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$91f705f8f090fa7a = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        inventory: [
            ,
            ""
        ],
        "x-id": [
            ,
            "ListBucketInventoryConfigurations"
        ],
        "continuation-token": [
            ,
            input.ContinuationToken
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$db6c7914f5cab208 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        metrics: [
            ,
            ""
        ],
        "x-id": [
            ,
            "ListBucketMetricsConfigurations"
        ],
        "continuation-token": [
            ,
            input.ContinuationToken
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$e3d06ab48ef1f8dd = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/xml"
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    let body;
    body = "";
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        body: body
    });
};
const $695e66930879143f$export$3cffb625572e4e48 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-request-payer": input.RequestPayer
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        uploads: [
            ,
            ""
        ],
        delimiter: [
            ,
            input.Delimiter
        ],
        "encoding-type": [
            ,
            input.EncodingType
        ],
        "key-marker": [
            ,
            input.KeyMarker
        ],
        "max-uploads": [
            ()=>input.MaxUploads !== void 0,
            ()=>input.MaxUploads.toString()
        ],
        prefix: [
            ,
            input.Prefix
        ],
        "upload-id-marker": [
            ,
            input.UploadIdMarker
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$6180c0473e7f5c88 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-optional-object-attributes": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.OptionalObjectAttributes),
            ()=>(input.OptionalObjectAttributes || []).map((_entry)=>_entry).join(", ")
        ]
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        delimiter: [
            ,
            input.Delimiter
        ],
        "encoding-type": [
            ,
            input.EncodingType
        ],
        marker: [
            ,
            input.Marker
        ],
        "max-keys": [
            ()=>input.MaxKeys !== void 0,
            ()=>input.MaxKeys.toString()
        ],
        prefix: [
            ,
            input.Prefix
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$da301345d3ee143 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-optional-object-attributes": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.OptionalObjectAttributes),
            ()=>(input.OptionalObjectAttributes || []).map((_entry)=>_entry).join(", ")
        ]
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "list-type": [
            ,
            "2"
        ],
        delimiter: [
            ,
            input.Delimiter
        ],
        "encoding-type": [
            ,
            input.EncodingType
        ],
        "max-keys": [
            ()=>input.MaxKeys !== void 0,
            ()=>input.MaxKeys.toString()
        ],
        prefix: [
            ,
            input.Prefix
        ],
        "continuation-token": [
            ,
            input.ContinuationToken
        ],
        "fetch-owner": [
            ()=>input.FetchOwner !== void 0,
            ()=>input.FetchOwner.toString()
        ],
        "start-after": [
            ,
            input.StartAfter
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$d2331614a12bddc8 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-optional-object-attributes": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.OptionalObjectAttributes),
            ()=>(input.OptionalObjectAttributes || []).map((_entry)=>_entry).join(", ")
        ]
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        versions: [
            ,
            ""
        ],
        delimiter: [
            ,
            input.Delimiter
        ],
        "encoding-type": [
            ,
            input.EncodingType
        ],
        "key-marker": [
            ,
            input.KeyMarker
        ],
        "max-keys": [
            ()=>input.MaxKeys !== void 0,
            ()=>input.MaxKeys.toString()
        ],
        prefix: [
            ,
            input.Prefix
        ],
        "version-id-marker": [
            ,
            input.VersionIdMarker
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$9af1da1eab1701a6 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "ListParts"
        ],
        "max-parts": [
            ()=>input.MaxParts !== void 0,
            ()=>input.MaxParts.toString()
        ],
        "part-number-marker": [
            ,
            input.PartNumberMarker
        ],
        uploadId: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.UploadId, `UploadId`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "GET",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$3f6fdbe302658691 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        accelerate: [
            ,
            ""
        ]
    });
    let body;
    if (input.AccelerateConfiguration !== undefined) body = $695e66930879143f$var$se_AccelerateConfiguration(input.AccelerateConfiguration, context);
    let contents;
    if (input.AccelerateConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_AccelerateConfiguration(input.AccelerateConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$54a4ba734de35851 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-acl": input.ACL,
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-grant-full-control": input.GrantFullControl,
        "x-amz-grant-read": input.GrantRead,
        "x-amz-grant-read-acp": input.GrantReadACP,
        "x-amz-grant-write": input.GrantWrite,
        "x-amz-grant-write-acp": input.GrantWriteACP,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        acl: [
            ,
            ""
        ]
    });
    let body;
    if (input.AccessControlPolicy !== undefined) body = $695e66930879143f$var$se_AccessControlPolicy(input.AccessControlPolicy, context);
    let contents;
    if (input.AccessControlPolicy !== undefined) {
        contents = $695e66930879143f$var$se_AccessControlPolicy(input.AccessControlPolicy, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$94d9bfa60902369 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        analytics: [
            ,
            ""
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    if (input.AnalyticsConfiguration !== undefined) body = $695e66930879143f$var$se_AnalyticsConfiguration(input.AnalyticsConfiguration, context);
    let contents;
    if (input.AnalyticsConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_AnalyticsConfiguration(input.AnalyticsConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$f8235149762cf3fe = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        cors: [
            ,
            ""
        ]
    });
    let body;
    if (input.CORSConfiguration !== undefined) body = $695e66930879143f$var$se_CORSConfiguration(input.CORSConfiguration, context);
    let contents;
    if (input.CORSConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_CORSConfiguration(input.CORSConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$321a9e23524a5161 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        encryption: [
            ,
            ""
        ]
    });
    let body;
    if (input.ServerSideEncryptionConfiguration !== undefined) body = $695e66930879143f$var$se_ServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
    let contents;
    if (input.ServerSideEncryptionConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_ServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$c6f0b8805cfde2aa = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/xml"
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "intelligent-tiering": [
            ,
            ""
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    if (input.IntelligentTieringConfiguration !== undefined) body = $695e66930879143f$var$se_IntelligentTieringConfiguration(input.IntelligentTieringConfiguration, context);
    let contents;
    if (input.IntelligentTieringConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_IntelligentTieringConfiguration(input.IntelligentTieringConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$bbfc84d93fe571ef = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        inventory: [
            ,
            ""
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    if (input.InventoryConfiguration !== undefined) body = $695e66930879143f$var$se_InventoryConfiguration(input.InventoryConfiguration, context);
    let contents;
    if (input.InventoryConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_InventoryConfiguration(input.InventoryConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$84c94e18c9eb3457 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        lifecycle: [
            ,
            ""
        ]
    });
    let body;
    if (input.LifecycleConfiguration !== undefined) body = $695e66930879143f$var$se_BucketLifecycleConfiguration(input.LifecycleConfiguration, context);
    let contents;
    if (input.LifecycleConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_BucketLifecycleConfiguration(input.LifecycleConfiguration, context);
        contents = contents.withName("LifecycleConfiguration");
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$1ffabe3d765e71ea = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        logging: [
            ,
            ""
        ]
    });
    let body;
    if (input.BucketLoggingStatus !== undefined) body = $695e66930879143f$var$se_BucketLoggingStatus(input.BucketLoggingStatus, context);
    let contents;
    if (input.BucketLoggingStatus !== undefined) {
        contents = $695e66930879143f$var$se_BucketLoggingStatus(input.BucketLoggingStatus, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$27715d7c7e0e5e44 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        metrics: [
            ,
            ""
        ],
        id: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.Id, `Id`)
        ]
    });
    let body;
    if (input.MetricsConfiguration !== undefined) body = $695e66930879143f$var$se_MetricsConfiguration(input.MetricsConfiguration, context);
    let contents;
    if (input.MetricsConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_MetricsConfiguration(input.MetricsConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$82a3c9e036067c97 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-skip-destination-validation": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.SkipDestinationValidation),
            ()=>input.SkipDestinationValidation.toString()
        ]
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        notification: [
            ,
            ""
        ]
    });
    let body;
    if (input.NotificationConfiguration !== undefined) body = $695e66930879143f$var$se_NotificationConfiguration(input.NotificationConfiguration, context);
    let contents;
    if (input.NotificationConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_NotificationConfiguration(input.NotificationConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$611be6edb4640fcc = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        ownershipControls: [
            ,
            ""
        ]
    });
    let body;
    if (input.OwnershipControls !== undefined) body = $695e66930879143f$var$se_OwnershipControls(input.OwnershipControls, context);
    let contents;
    if (input.OwnershipControls !== undefined) {
        contents = $695e66930879143f$var$se_OwnershipControls(input.OwnershipControls, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$e9a0e1c53a9ac9e5 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "text/plain",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-confirm-remove-self-bucket-access": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ConfirmRemoveSelfBucketAccess),
            ()=>input.ConfirmRemoveSelfBucketAccess.toString()
        ],
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        policy: [
            ,
            ""
        ]
    });
    let body;
    if (input.Policy !== undefined) body = input.Policy;
    let contents;
    if (input.Policy !== undefined) {
        contents = input.Policy;
        body = contents;
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$243a83db339eb017 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-bucket-object-lock-token": input.Token,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        replication: [
            ,
            ""
        ]
    });
    let body;
    if (input.ReplicationConfiguration !== undefined) body = $695e66930879143f$var$se_ReplicationConfiguration(input.ReplicationConfiguration, context);
    let contents;
    if (input.ReplicationConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_ReplicationConfiguration(input.ReplicationConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$9c20a21af6ed0bc6 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        requestPayment: [
            ,
            ""
        ]
    });
    let body;
    if (input.RequestPaymentConfiguration !== undefined) body = $695e66930879143f$var$se_RequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
    let contents;
    if (input.RequestPaymentConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_RequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$e7a67f9de630d095 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        tagging: [
            ,
            ""
        ]
    });
    let body;
    if (input.Tagging !== undefined) body = $695e66930879143f$var$se_Tagging(input.Tagging, context);
    let contents;
    if (input.Tagging !== undefined) {
        contents = $695e66930879143f$var$se_Tagging(input.Tagging, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$b4a6e0bf6c649497 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-mfa": input.MFA,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        versioning: [
            ,
            ""
        ]
    });
    let body;
    if (input.VersioningConfiguration !== undefined) body = $695e66930879143f$var$se_VersioningConfiguration(input.VersioningConfiguration, context);
    let contents;
    if (input.VersioningConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_VersioningConfiguration(input.VersioningConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$16c3ea57a0ba6053 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        website: [
            ,
            ""
        ]
    });
    let body;
    if (input.WebsiteConfiguration !== undefined) body = $695e66930879143f$var$se_WebsiteConfiguration(input.WebsiteConfiguration, context);
    let contents;
    if (input.WebsiteConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_WebsiteConfiguration(input.WebsiteConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$80b592020f8ee8b7 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": input.ContentType || "application/octet-stream",
        "x-amz-acl": input.ACL,
        "cache-control": input.CacheControl,
        "content-disposition": input.ContentDisposition,
        "content-encoding": input.ContentEncoding,
        "content-language": input.ContentLanguage,
        "content-length": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ContentLength),
            ()=>input.ContentLength.toString()
        ],
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-checksum-crc32": input.ChecksumCRC32,
        "x-amz-checksum-crc32c": input.ChecksumCRC32C,
        "x-amz-checksum-sha1": input.ChecksumSHA1,
        "x-amz-checksum-sha256": input.ChecksumSHA256,
        expires: [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.Expires),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.Expires).toString()
        ],
        "x-amz-grant-full-control": input.GrantFullControl,
        "x-amz-grant-read": input.GrantRead,
        "x-amz-grant-read-acp": input.GrantReadACP,
        "x-amz-grant-write-acp": input.GrantWriteACP,
        "x-amz-server-side-encryption": input.ServerSideEncryption,
        "x-amz-storage-class": input.StorageClass,
        "x-amz-website-redirect-location": input.WebsiteRedirectLocation,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId,
        "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext,
        "x-amz-server-side-encryption-bucket-key-enabled": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.BucketKeyEnabled),
            ()=>input.BucketKeyEnabled.toString()
        ],
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-tagging": input.Tagging,
        "x-amz-object-lock-mode": input.ObjectLockMode,
        "x-amz-object-lock-retain-until-date": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate),
            ()=>(input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
        ],
        "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        ...input.Metadata !== undefined && Object.keys(input.Metadata).reduce((acc, suffix)=>{
            acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
            return acc;
        }, {})
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "PutObject"
        ]
    });
    let body;
    if (input.Body !== undefined) body = input.Body;
    let contents;
    if (input.Body !== undefined) {
        contents = input.Body;
        body = contents;
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$9966f17a0fff323b = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-acl": input.ACL,
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-grant-full-control": input.GrantFullControl,
        "x-amz-grant-read": input.GrantRead,
        "x-amz-grant-read-acp": input.GrantReadACP,
        "x-amz-grant-write": input.GrantWrite,
        "x-amz-grant-write-acp": input.GrantWriteACP,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        acl: [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    if (input.AccessControlPolicy !== undefined) body = $695e66930879143f$var$se_AccessControlPolicy(input.AccessControlPolicy, context);
    let contents;
    if (input.AccessControlPolicy !== undefined) {
        contents = $695e66930879143f$var$se_AccessControlPolicy(input.AccessControlPolicy, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$e406d8702bc54811 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-request-payer": input.RequestPayer,
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "legal-hold": [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    if (input.LegalHold !== undefined) body = $695e66930879143f$var$se_ObjectLockLegalHold(input.LegalHold, context);
    let contents;
    if (input.LegalHold !== undefined) {
        contents = $695e66930879143f$var$se_ObjectLockLegalHold(input.LegalHold, context);
        contents = contents.withName("LegalHold");
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$ef8c4e74dbf262ca = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-bucket-object-lock-token": input.Token,
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "object-lock": [
            ,
            ""
        ]
    });
    let body;
    if (input.ObjectLockConfiguration !== undefined) body = $695e66930879143f$var$se_ObjectLockConfiguration(input.ObjectLockConfiguration, context);
    let contents;
    if (input.ObjectLockConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_ObjectLockConfiguration(input.ObjectLockConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$b805daaf3fbf99bf = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-bypass-governance-retention": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.BypassGovernanceRetention),
            ()=>input.BypassGovernanceRetention.toString()
        ],
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        retention: [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    if (input.Retention !== undefined) body = $695e66930879143f$var$se_ObjectLockRetention(input.Retention, context);
    let contents;
    if (input.Retention !== undefined) {
        contents = $695e66930879143f$var$se_ObjectLockRetention(input.Retention, context);
        contents = contents.withName("Retention");
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$ecc70053eace4832 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-request-payer": input.RequestPayer
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        tagging: [
            ,
            ""
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    if (input.Tagging !== undefined) body = $695e66930879143f$var$se_Tagging(input.Tagging, context);
    let contents;
    if (input.Tagging !== undefined) {
        contents = $695e66930879143f$var$se_Tagging(input.Tagging, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$b2b09e9f8ccb7800 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        publicAccessBlock: [
            ,
            ""
        ]
    });
    let body;
    if (input.PublicAccessBlockConfiguration !== undefined) body = $695e66930879143f$var$se_PublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
    let contents;
    if (input.PublicAccessBlockConfiguration !== undefined) {
        contents = $695e66930879143f$var$se_PublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$2ea69c74e54da740 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        restore: [
            ,
            ""
        ],
        "x-id": [
            ,
            "RestoreObject"
        ],
        versionId: [
            ,
            input.VersionId
        ]
    });
    let body;
    if (input.RestoreRequest !== undefined) body = $695e66930879143f$var$se_RestoreRequest(input.RestoreRequest, context);
    let contents;
    if (input.RestoreRequest !== undefined) {
        contents = $695e66930879143f$var$se_RestoreRequest(input.RestoreRequest, context);
        body = '<?xml version="1.0" encoding="UTF-8"?>';
        contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
        body += contents.toString();
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "POST",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$6fd8ebeb11534574 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/xml",
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        select: [
            ,
            ""
        ],
        "select-type": [
            ,
            "2"
        ],
        "x-id": [
            ,
            "SelectObjectContent"
        ]
    });
    let body;
    body = '<?xml version="1.0" encoding="UTF-8"?>';
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("SelectObjectContentRequest");
    bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
    if (input.Expression !== undefined) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Expression", input.Expression).withName("Expression");
        bodyNode.addChildNode(node);
    }
    if (input.ExpressionType !== undefined) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ExpressionType", input.ExpressionType).withName("ExpressionType");
        bodyNode.addChildNode(node);
    }
    if (input.InputSerialization !== undefined) {
        const node = $695e66930879143f$var$se_InputSerialization(input.InputSerialization, context).withName("InputSerialization");
        bodyNode.addChildNode(node);
    }
    if (input.OutputSerialization !== undefined) {
        const node = $695e66930879143f$var$se_OutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
        bodyNode.addChildNode(node);
    }
    if (input.RequestProgress !== undefined) {
        const node = $695e66930879143f$var$se_RequestProgress(input.RequestProgress, context).withName("RequestProgress");
        bodyNode.addChildNode(node);
    }
    if (input.ScanRange !== undefined) {
        const node = $695e66930879143f$var$se_ScanRange(input.ScanRange, context).withName("ScanRange");
        bodyNode.addChildNode(node);
    }
    body += bodyNode.toString();
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "POST",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$83a6b460ef4fd1f8 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "content-type": "application/octet-stream",
        "content-length": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ContentLength),
            ()=>input.ContentLength.toString()
        ],
        "content-md5": input.ContentMD5,
        "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
        "x-amz-checksum-crc32": input.ChecksumCRC32,
        "x-amz-checksum-crc32c": input.ChecksumCRC32C,
        "x-amz-checksum-sha1": input.ChecksumSHA1,
        "x-amz-checksum-sha256": input.ChecksumSHA256,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "UploadPart"
        ],
        partNumber: [
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.PartNumber, `PartNumber`) != null,
            ()=>input.PartNumber.toString()
        ],
        uploadId: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.UploadId, `UploadId`)
        ]
    });
    let body;
    if (input.Body !== undefined) body = input.Body;
    let contents;
    if (input.Body !== undefined) {
        contents = input.Body;
        body = contents;
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$d78018a5b1b8367c = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-copy-source": input.CopySource,
        "x-amz-copy-source-if-match": input.CopySourceIfMatch,
        "x-amz-copy-source-if-modified-since": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.CopySourceIfModifiedSince),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.CopySourceIfModifiedSince).toString()
        ],
        "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch,
        "x-amz-copy-source-if-unmodified-since": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.CopySourceIfUnmodifiedSince).toString()
        ],
        "x-amz-copy-source-range": input.CopySourceRange,
        "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
        "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm,
        "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey,
        "x-amz-copy-source-server-side-encryption-customer-key-md5": input.CopySourceSSECustomerKeyMD5,
        "x-amz-request-payer": input.RequestPayer,
        "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
        "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
    });
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/{Key+}";
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Bucket", ()=>input.Bucket, "{Bucket}", false);
    resolvedPath = (0, $70dbc58951792150$export$405ac9a9ce1cbd80)(resolvedPath, input, "Key", ()=>input.Key, "{Key+}", true);
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "UploadPartCopy"
        ],
        partNumber: [
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.PartNumber, `PartNumber`) != null,
            ()=>input.PartNumber.toString()
        ],
        uploadId: [
            ,
            (0, $f10fb2b359b91940$export$8413a63dbe548a49)(input.UploadId, `UploadId`)
        ]
    });
    let body;
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: hostname,
        port: port,
        method: "PUT",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$a026a0f9b1f48587 = async (input, context)=>{
    const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await context.endpoint();
    const headers = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({}, $695e66930879143f$var$isSerializableHeaderValue, {
        "x-amz-content-sha256": "UNSIGNED-PAYLOAD",
        "content-type": "application/octet-stream",
        "x-amz-request-route": input.RequestRoute,
        "x-amz-request-token": input.RequestToken,
        "x-amz-fwd-status": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.StatusCode),
            ()=>input.StatusCode.toString()
        ],
        "x-amz-fwd-error-code": input.ErrorCode,
        "x-amz-fwd-error-message": input.ErrorMessage,
        "x-amz-fwd-header-accept-ranges": input.AcceptRanges,
        "x-amz-fwd-header-cache-control": input.CacheControl,
        "x-amz-fwd-header-content-disposition": input.ContentDisposition,
        "x-amz-fwd-header-content-encoding": input.ContentEncoding,
        "x-amz-fwd-header-content-language": input.ContentLanguage,
        "content-length": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ContentLength),
            ()=>input.ContentLength.toString()
        ],
        "x-amz-fwd-header-content-range": input.ContentRange,
        "x-amz-fwd-header-content-type": input.ContentType,
        "x-amz-fwd-header-x-amz-checksum-crc32": input.ChecksumCRC32,
        "x-amz-fwd-header-x-amz-checksum-crc32c": input.ChecksumCRC32C,
        "x-amz-fwd-header-x-amz-checksum-sha1": input.ChecksumSHA1,
        "x-amz-fwd-header-x-amz-checksum-sha256": input.ChecksumSHA256,
        "x-amz-fwd-header-x-amz-delete-marker": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.DeleteMarker),
            ()=>input.DeleteMarker.toString()
        ],
        "x-amz-fwd-header-etag": input.ETag,
        "x-amz-fwd-header-expires": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.Expires),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.Expires).toString()
        ],
        "x-amz-fwd-header-x-amz-expiration": input.Expiration,
        "x-amz-fwd-header-last-modified": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.LastModified),
            ()=>(0, $d519855744bca7a8$export$5b50865171ed23a9)(input.LastModified).toString()
        ],
        "x-amz-fwd-header-x-amz-missing-meta": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.MissingMeta),
            ()=>input.MissingMeta.toString()
        ],
        "x-amz-fwd-header-x-amz-object-lock-mode": input.ObjectLockMode,
        "x-amz-fwd-header-x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus,
        "x-amz-fwd-header-x-amz-object-lock-retain-until-date": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.ObjectLockRetainUntilDate),
            ()=>(input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
        ],
        "x-amz-fwd-header-x-amz-mp-parts-count": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.PartsCount),
            ()=>input.PartsCount.toString()
        ],
        "x-amz-fwd-header-x-amz-replication-status": input.ReplicationStatus,
        "x-amz-fwd-header-x-amz-request-charged": input.RequestCharged,
        "x-amz-fwd-header-x-amz-restore": input.Restore,
        "x-amz-fwd-header-x-amz-server-side-encryption": input.ServerSideEncryption,
        "x-amz-fwd-header-x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
        "x-amz-fwd-header-x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId,
        "x-amz-fwd-header-x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
        "x-amz-fwd-header-x-amz-storage-class": input.StorageClass,
        "x-amz-fwd-header-x-amz-tagging-count": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.TagCount),
            ()=>input.TagCount.toString()
        ],
        "x-amz-fwd-header-x-amz-version-id": input.VersionId,
        "x-amz-fwd-header-x-amz-server-side-encryption-bucket-key-enabled": [
            ()=>$695e66930879143f$var$isSerializableHeaderValue(input.BucketKeyEnabled),
            ()=>input.BucketKeyEnabled.toString()
        ],
        ...input.Metadata !== undefined && Object.keys(input.Metadata).reduce((acc, suffix)=>{
            acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
            return acc;
        }, {})
    });
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/WriteGetObjectResponse";
    const query = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        "x-id": [
            ,
            "WriteGetObjectResponse"
        ]
    });
    let body;
    if (input.Body !== undefined) body = input.Body;
    let contents;
    if (input.Body !== undefined) {
        contents = input.Body;
        body = contents;
    }
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "{RequestRoute}." + resolvedHostname;
        if (input.RequestRoute === undefined) throw new Error("Empty value provided for input host prefix: RequestRoute.");
        resolvedHostname = resolvedHostname.replace("{RequestRoute}", input.RequestRoute);
        if (!(0, $d7aef99e0ec8cee0$export$e024c793399bdd01)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    return new (0, $76db987a884ad8a2$export$7587955500404ec3)({
        protocol: protocol,
        hostname: resolvedHostname,
        port: port,
        method: "POST",
        headers: headers,
        path: resolvedPath,
        query: query,
        body: body
    });
};
const $695e66930879143f$export$584ab52a599445fc = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_AbortMultipartUploadCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_AbortMultipartUploadCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "NoSuchUpload":
        case "com.amazonaws.s3#NoSuchUpload":
            throw await $695e66930879143f$var$de_NoSuchUploadRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$c515ac7dad03483f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_CompleteMultipartUploadCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        Expiration: [
            ,
            output.headers["x-amz-expiration"]
        ],
        ServerSideEncryption: [
            ,
            output.headers["x-amz-server-side-encryption"]
        ],
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ],
        SSEKMSKeyId: [
            ,
            output.headers["x-amz-server-side-encryption-aws-kms-key-id"]
        ],
        BucketKeyEnabled: [
            ()=>void 0 !== output.headers["x-amz-server-side-encryption-bucket-key-enabled"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-server-side-encryption-bucket-key-enabled"])
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["Bucket"] !== undefined) contents.Bucket = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Bucket"]);
    if (data["ChecksumCRC32"] !== undefined) contents.ChecksumCRC32 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ChecksumCRC32"]);
    if (data["ChecksumCRC32C"] !== undefined) contents.ChecksumCRC32C = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ChecksumCRC32C"]);
    if (data["ChecksumSHA1"] !== undefined) contents.ChecksumSHA1 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ChecksumSHA1"]);
    if (data["ChecksumSHA256"] !== undefined) contents.ChecksumSHA256 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ChecksumSHA256"]);
    if (data["ETag"] !== undefined) contents.ETag = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ETag"]);
    if (data["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Key"]);
    if (data["Location"] !== undefined) contents.Location = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Location"]);
    return contents;
};
const $695e66930879143f$var$de_CompleteMultipartUploadCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$8caa46faae53e879 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_CopyObjectCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        Expiration: [
            ,
            output.headers["x-amz-expiration"]
        ],
        CopySourceVersionId: [
            ,
            output.headers["x-amz-copy-source-version-id"]
        ],
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ],
        ServerSideEncryption: [
            ,
            output.headers["x-amz-server-side-encryption"]
        ],
        SSECustomerAlgorithm: [
            ,
            output.headers["x-amz-server-side-encryption-customer-algorithm"]
        ],
        SSECustomerKeyMD5: [
            ,
            output.headers["x-amz-server-side-encryption-customer-key-md5"]
        ],
        SSEKMSKeyId: [
            ,
            output.headers["x-amz-server-side-encryption-aws-kms-key-id"]
        ],
        SSEKMSEncryptionContext: [
            ,
            output.headers["x-amz-server-side-encryption-context"]
        ],
        BucketKeyEnabled: [
            ()=>void 0 !== output.headers["x-amz-server-side-encryption-bucket-key-enabled"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-server-side-encryption-bucket-key-enabled"])
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.CopyObjectResult = $695e66930879143f$var$de_CopyObjectResult(data, context);
    return contents;
};
const $695e66930879143f$var$de_CopyObjectCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "ObjectNotInActiveTierError":
        case "com.amazonaws.s3#ObjectNotInActiveTierError":
            throw await $695e66930879143f$var$de_ObjectNotInActiveTierErrorRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$5faed19c2239746d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_CreateBucketCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        Location: [
            ,
            output.headers["location"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_CreateBucketCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "BucketAlreadyExists":
        case "com.amazonaws.s3#BucketAlreadyExists":
            throw await $695e66930879143f$var$de_BucketAlreadyExistsRes(parsedOutput, context);
        case "BucketAlreadyOwnedByYou":
        case "com.amazonaws.s3#BucketAlreadyOwnedByYou":
            throw await $695e66930879143f$var$de_BucketAlreadyOwnedByYouRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$26ee6d662365d0aa = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_CreateMultipartUploadCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        AbortDate: [
            ()=>void 0 !== output.headers["x-amz-abort-date"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$cf3a566289648a1e)(output.headers["x-amz-abort-date"]))
        ],
        AbortRuleId: [
            ,
            output.headers["x-amz-abort-rule-id"]
        ],
        ServerSideEncryption: [
            ,
            output.headers["x-amz-server-side-encryption"]
        ],
        SSECustomerAlgorithm: [
            ,
            output.headers["x-amz-server-side-encryption-customer-algorithm"]
        ],
        SSECustomerKeyMD5: [
            ,
            output.headers["x-amz-server-side-encryption-customer-key-md5"]
        ],
        SSEKMSKeyId: [
            ,
            output.headers["x-amz-server-side-encryption-aws-kms-key-id"]
        ],
        SSEKMSEncryptionContext: [
            ,
            output.headers["x-amz-server-side-encryption-context"]
        ],
        BucketKeyEnabled: [
            ()=>void 0 !== output.headers["x-amz-server-side-encryption-bucket-key-enabled"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-server-side-encryption-bucket-key-enabled"])
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ],
        ChecksumAlgorithm: [
            ,
            output.headers["x-amz-checksum-algorithm"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["Bucket"] !== undefined) contents.Bucket = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Bucket"]);
    if (data["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Key"]);
    if (data["UploadId"] !== undefined) contents.UploadId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["UploadId"]);
    return contents;
};
const $695e66930879143f$var$de_CreateMultipartUploadCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$679c7ef3d4347002 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$80d2762c2a3c51e = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketAnalyticsConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketAnalyticsConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$ea45039ce950a575 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketCorsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketCorsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$324d6f24b808da3f = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketEncryptionCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketEncryptionCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$d025149d0740c2bc = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketIntelligentTieringConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketIntelligentTieringConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$f814210bbf0bdc72 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketInventoryConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketInventoryConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$5133d32b6041d7d7 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketLifecycleCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketLifecycleCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$2989b776dea46795 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketMetricsConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketMetricsConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$c37a7332a9c03010 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketOwnershipControlsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketOwnershipControlsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$82b7954983c2ced5 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketPolicyCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketPolicyCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$15f22b651e448e49 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketReplicationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketReplicationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$b0d18a657e86fd9a = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketTaggingCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketTaggingCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$ad0a40c1d52ed647 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteBucketWebsiteCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteBucketWebsiteCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$e2f802b89379cb1b = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteObjectCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        DeleteMarker: [
            ()=>void 0 !== output.headers["x-amz-delete-marker"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-delete-marker"])
        ],
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteObjectCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$439fb3ac4907d2dc = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteObjectsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.Deleted === "") contents.Deleted = [];
    else if (data["Deleted"] !== undefined) contents.Deleted = $695e66930879143f$var$de_DeletedObjects((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Deleted"]), context);
    if (data.Error === "") contents.Errors = [];
    else if (data["Error"] !== undefined) contents.Errors = $695e66930879143f$var$de_Errors((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Error"]), context);
    return contents;
};
const $695e66930879143f$var$de_DeleteObjectsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$4c6ead8dac914c87 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeleteObjectTaggingCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeleteObjectTaggingCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$50e0d8aa45013173 = async (output, context)=>{
    if (output.statusCode !== 204 && output.statusCode >= 300) return $695e66930879143f$var$de_DeletePublicAccessBlockCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_DeletePublicAccessBlockCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$4a09c85c1de79ed5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketAccelerateConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Status"]);
    return contents;
};
const $695e66930879143f$var$de_GetBucketAccelerateConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$64385380d83d3aa = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketAclCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.AccessControlList === "") contents.Grants = [];
    else if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $695e66930879143f$var$de_Grants((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["AccessControlList"]["Grant"]), context);
    if (data["Owner"] !== undefined) contents.Owner = $695e66930879143f$var$de_Owner(data["Owner"], context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketAclCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$a0a71690cdbea2b3 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketAnalyticsConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.AnalyticsConfiguration = $695e66930879143f$var$de_AnalyticsConfiguration(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketAnalyticsConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$a08671b31e44c28a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketCorsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.CORSRule === "") contents.CORSRules = [];
    else if (data["CORSRule"] !== undefined) contents.CORSRules = $695e66930879143f$var$de_CORSRules((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["CORSRule"]), context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketCorsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$57205eb10636c925 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketEncryptionCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.ServerSideEncryptionConfiguration = $695e66930879143f$var$de_ServerSideEncryptionConfiguration(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketEncryptionCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$1cef593fbdeaf31e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketIntelligentTieringConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.IntelligentTieringConfiguration = $695e66930879143f$var$de_IntelligentTieringConfiguration(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketIntelligentTieringConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$82b23f98d76bbdfc = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketInventoryConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.InventoryConfiguration = $695e66930879143f$var$de_InventoryConfiguration(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketInventoryConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$c752ccb684cd7849 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketLifecycleConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.Rule === "") contents.Rules = [];
    else if (data["Rule"] !== undefined) contents.Rules = $695e66930879143f$var$de_LifecycleRules((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Rule"]), context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketLifecycleConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$c9074fcef001d65b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketLocationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["LocationConstraint"] !== undefined) contents.LocationConstraint = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["LocationConstraint"]);
    return contents;
};
const $695e66930879143f$var$de_GetBucketLocationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$b730a9f24f72747 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketLoggingCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["LoggingEnabled"] !== undefined) contents.LoggingEnabled = $695e66930879143f$var$de_LoggingEnabled(data["LoggingEnabled"], context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketLoggingCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$62d97f122a985ee2 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketMetricsConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.MetricsConfiguration = $695e66930879143f$var$de_MetricsConfiguration(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketMetricsConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$34ec0d820b7b6a02 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketNotificationConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["EventBridgeConfiguration"] !== undefined) contents.EventBridgeConfiguration = $695e66930879143f$var$de_EventBridgeConfiguration(data["EventBridgeConfiguration"], context);
    if (data.CloudFunctionConfiguration === "") contents.LambdaFunctionConfigurations = [];
    else if (data["CloudFunctionConfiguration"] !== undefined) contents.LambdaFunctionConfigurations = $695e66930879143f$var$de_LambdaFunctionConfigurationList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["CloudFunctionConfiguration"]), context);
    if (data.QueueConfiguration === "") contents.QueueConfigurations = [];
    else if (data["QueueConfiguration"] !== undefined) contents.QueueConfigurations = $695e66930879143f$var$de_QueueConfigurationList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["QueueConfiguration"]), context);
    if (data.TopicConfiguration === "") contents.TopicConfigurations = [];
    else if (data["TopicConfiguration"] !== undefined) contents.TopicConfigurations = $695e66930879143f$var$de_TopicConfigurationList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["TopicConfiguration"]), context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketNotificationConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$d8cd2601fb507ba = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketOwnershipControlsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.OwnershipControls = $695e66930879143f$var$de_OwnershipControls(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketOwnershipControlsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$462280d554ad64e0 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketPolicyCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = await $695e66930879143f$var$collectBodyString(output.body, context);
    contents.Policy = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data);
    return contents;
};
const $695e66930879143f$var$de_GetBucketPolicyCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$5db9869d862d5dba = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketPolicyStatusCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.PolicyStatus = $695e66930879143f$var$de_PolicyStatus(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketPolicyStatusCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$f0add93faececff5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketReplicationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.ReplicationConfiguration = $695e66930879143f$var$de_ReplicationConfiguration(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketReplicationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$bbbfb17284d74c03 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketRequestPaymentCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["Payer"] !== undefined) contents.Payer = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Payer"]);
    return contents;
};
const $695e66930879143f$var$de_GetBucketRequestPaymentCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$15bd4014a4e6ab66 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketTaggingCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.TagSet === "") contents.TagSet = [];
    else if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $695e66930879143f$var$de_TagSet((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["TagSet"]["Tag"]), context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketTaggingCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$cbc21f30de233f33 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketVersioningCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["MfaDelete"] !== undefined) contents.MFADelete = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["MfaDelete"]);
    if (data["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Status"]);
    return contents;
};
const $695e66930879143f$var$de_GetBucketVersioningCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$324b37c649cb6a1f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetBucketWebsiteCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["ErrorDocument"] !== undefined) contents.ErrorDocument = $695e66930879143f$var$de_ErrorDocument(data["ErrorDocument"], context);
    if (data["IndexDocument"] !== undefined) contents.IndexDocument = $695e66930879143f$var$de_IndexDocument(data["IndexDocument"], context);
    if (data["RedirectAllRequestsTo"] !== undefined) contents.RedirectAllRequestsTo = $695e66930879143f$var$de_RedirectAllRequestsTo(data["RedirectAllRequestsTo"], context);
    if (data.RoutingRules === "") contents.RoutingRules = [];
    else if (data["RoutingRules"] !== undefined && data["RoutingRules"]["RoutingRule"] !== undefined) contents.RoutingRules = $695e66930879143f$var$de_RoutingRules((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["RoutingRules"]["RoutingRule"]), context);
    return contents;
};
const $695e66930879143f$var$de_GetBucketWebsiteCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$ce97779f2225a8a8 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetObjectCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        DeleteMarker: [
            ()=>void 0 !== output.headers["x-amz-delete-marker"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-delete-marker"])
        ],
        AcceptRanges: [
            ,
            output.headers["accept-ranges"]
        ],
        Expiration: [
            ,
            output.headers["x-amz-expiration"]
        ],
        Restore: [
            ,
            output.headers["x-amz-restore"]
        ],
        LastModified: [
            ()=>void 0 !== output.headers["last-modified"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$cf3a566289648a1e)(output.headers["last-modified"]))
        ],
        ContentLength: [
            ()=>void 0 !== output.headers["content-length"],
            ()=>(0, $f10fb2b359b91940$export$f90617f39a736d36)(output.headers["content-length"])
        ],
        ETag: [
            ,
            output.headers["etag"]
        ],
        ChecksumCRC32: [
            ,
            output.headers["x-amz-checksum-crc32"]
        ],
        ChecksumCRC32C: [
            ,
            output.headers["x-amz-checksum-crc32c"]
        ],
        ChecksumSHA1: [
            ,
            output.headers["x-amz-checksum-sha1"]
        ],
        ChecksumSHA256: [
            ,
            output.headers["x-amz-checksum-sha256"]
        ],
        MissingMeta: [
            ()=>void 0 !== output.headers["x-amz-missing-meta"],
            ()=>(0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output.headers["x-amz-missing-meta"])
        ],
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ],
        CacheControl: [
            ,
            output.headers["cache-control"]
        ],
        ContentDisposition: [
            ,
            output.headers["content-disposition"]
        ],
        ContentEncoding: [
            ,
            output.headers["content-encoding"]
        ],
        ContentLanguage: [
            ,
            output.headers["content-language"]
        ],
        ContentRange: [
            ,
            output.headers["content-range"]
        ],
        ContentType: [
            ,
            output.headers["content-type"]
        ],
        Expires: [
            ()=>void 0 !== output.headers["expires"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$cf3a566289648a1e)(output.headers["expires"]))
        ],
        WebsiteRedirectLocation: [
            ,
            output.headers["x-amz-website-redirect-location"]
        ],
        ServerSideEncryption: [
            ,
            output.headers["x-amz-server-side-encryption"]
        ],
        SSECustomerAlgorithm: [
            ,
            output.headers["x-amz-server-side-encryption-customer-algorithm"]
        ],
        SSECustomerKeyMD5: [
            ,
            output.headers["x-amz-server-side-encryption-customer-key-md5"]
        ],
        SSEKMSKeyId: [
            ,
            output.headers["x-amz-server-side-encryption-aws-kms-key-id"]
        ],
        BucketKeyEnabled: [
            ()=>void 0 !== output.headers["x-amz-server-side-encryption-bucket-key-enabled"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-server-side-encryption-bucket-key-enabled"])
        ],
        StorageClass: [
            ,
            output.headers["x-amz-storage-class"]
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ],
        ReplicationStatus: [
            ,
            output.headers["x-amz-replication-status"]
        ],
        PartsCount: [
            ()=>void 0 !== output.headers["x-amz-mp-parts-count"],
            ()=>(0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output.headers["x-amz-mp-parts-count"])
        ],
        TagCount: [
            ()=>void 0 !== output.headers["x-amz-tagging-count"],
            ()=>(0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output.headers["x-amz-tagging-count"])
        ],
        ObjectLockMode: [
            ,
            output.headers["x-amz-object-lock-mode"]
        ],
        ObjectLockRetainUntilDate: [
            ()=>void 0 !== output.headers["x-amz-object-lock-retain-until-date"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output.headers["x-amz-object-lock-retain-until-date"]))
        ],
        ObjectLockLegalHoldStatus: [
            ,
            output.headers["x-amz-object-lock-legal-hold"]
        ],
        Metadata: [
            ,
            Object.keys(output.headers).filter((header)=>header.startsWith("x-amz-meta-")).reduce((acc, header)=>{
                acc[header.substring(11)] = output.headers[header];
                return acc;
            }, {})
        ]
    });
    const data = output.body;
    context.sdkStreamMixin(data);
    contents.Body = data;
    return contents;
};
const $695e66930879143f$var$de_GetObjectCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "InvalidObjectState":
        case "com.amazonaws.s3#InvalidObjectState":
            throw await $695e66930879143f$var$de_InvalidObjectStateRes(parsedOutput, context);
        case "NoSuchKey":
        case "com.amazonaws.s3#NoSuchKey":
            throw await $695e66930879143f$var$de_NoSuchKeyRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$9983385d19b8a38d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetObjectAclCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.AccessControlList === "") contents.Grants = [];
    else if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) contents.Grants = $695e66930879143f$var$de_Grants((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["AccessControlList"]["Grant"]), context);
    if (data["Owner"] !== undefined) contents.Owner = $695e66930879143f$var$de_Owner(data["Owner"], context);
    return contents;
};
const $695e66930879143f$var$de_GetObjectAclCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "NoSuchKey":
        case "com.amazonaws.s3#NoSuchKey":
            throw await $695e66930879143f$var$de_NoSuchKeyRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$1a4cc865f2990fe = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetObjectAttributesCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        DeleteMarker: [
            ()=>void 0 !== output.headers["x-amz-delete-marker"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-delete-marker"])
        ],
        LastModified: [
            ()=>void 0 !== output.headers["last-modified"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$cf3a566289648a1e)(output.headers["last-modified"]))
        ],
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["Checksum"] !== undefined) contents.Checksum = $695e66930879143f$var$de_Checksum(data["Checksum"], context);
    if (data["ETag"] !== undefined) contents.ETag = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ETag"]);
    if (data["ObjectParts"] !== undefined) contents.ObjectParts = $695e66930879143f$var$de_GetObjectAttributesParts(data["ObjectParts"], context);
    if (data["ObjectSize"] !== undefined) contents.ObjectSize = (0, $f10fb2b359b91940$export$f90617f39a736d36)(data["ObjectSize"]);
    if (data["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["StorageClass"]);
    return contents;
};
const $695e66930879143f$var$de_GetObjectAttributesCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "NoSuchKey":
        case "com.amazonaws.s3#NoSuchKey":
            throw await $695e66930879143f$var$de_NoSuchKeyRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$7c10231615fda34b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetObjectLegalHoldCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.LegalHold = $695e66930879143f$var$de_ObjectLockLegalHold(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetObjectLegalHoldCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$aa261c4e9daf9d4a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetObjectLockConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.ObjectLockConfiguration = $695e66930879143f$var$de_ObjectLockConfiguration(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetObjectLockConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$430c0fcdeec89b5a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetObjectRetentionCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.Retention = $695e66930879143f$var$de_ObjectLockRetention(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetObjectRetentionCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$1626c75542346cdd = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetObjectTaggingCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.TagSet === "") contents.TagSet = [];
    else if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) contents.TagSet = $695e66930879143f$var$de_TagSet((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["TagSet"]["Tag"]), context);
    return contents;
};
const $695e66930879143f$var$de_GetObjectTaggingCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$b51a5621ff8a39ba = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetObjectTorrentCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = output.body;
    context.sdkStreamMixin(data);
    contents.Body = data;
    return contents;
};
const $695e66930879143f$var$de_GetObjectTorrentCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$3e244a0093a8d58d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_GetPublicAccessBlockCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.PublicAccessBlockConfiguration = $695e66930879143f$var$de_PublicAccessBlockConfiguration(data, context);
    return contents;
};
const $695e66930879143f$var$de_GetPublicAccessBlockCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$f3775d528a4c31b5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_HeadBucketCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_HeadBucketCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "NotFound":
        case "com.amazonaws.s3#NotFound":
            throw await $695e66930879143f$var$de_NotFoundRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$c65459f3f5e48f4e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_HeadObjectCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        DeleteMarker: [
            ()=>void 0 !== output.headers["x-amz-delete-marker"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-delete-marker"])
        ],
        AcceptRanges: [
            ,
            output.headers["accept-ranges"]
        ],
        Expiration: [
            ,
            output.headers["x-amz-expiration"]
        ],
        Restore: [
            ,
            output.headers["x-amz-restore"]
        ],
        ArchiveStatus: [
            ,
            output.headers["x-amz-archive-status"]
        ],
        LastModified: [
            ()=>void 0 !== output.headers["last-modified"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$cf3a566289648a1e)(output.headers["last-modified"]))
        ],
        ContentLength: [
            ()=>void 0 !== output.headers["content-length"],
            ()=>(0, $f10fb2b359b91940$export$f90617f39a736d36)(output.headers["content-length"])
        ],
        ChecksumCRC32: [
            ,
            output.headers["x-amz-checksum-crc32"]
        ],
        ChecksumCRC32C: [
            ,
            output.headers["x-amz-checksum-crc32c"]
        ],
        ChecksumSHA1: [
            ,
            output.headers["x-amz-checksum-sha1"]
        ],
        ChecksumSHA256: [
            ,
            output.headers["x-amz-checksum-sha256"]
        ],
        ETag: [
            ,
            output.headers["etag"]
        ],
        MissingMeta: [
            ()=>void 0 !== output.headers["x-amz-missing-meta"],
            ()=>(0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output.headers["x-amz-missing-meta"])
        ],
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ],
        CacheControl: [
            ,
            output.headers["cache-control"]
        ],
        ContentDisposition: [
            ,
            output.headers["content-disposition"]
        ],
        ContentEncoding: [
            ,
            output.headers["content-encoding"]
        ],
        ContentLanguage: [
            ,
            output.headers["content-language"]
        ],
        ContentType: [
            ,
            output.headers["content-type"]
        ],
        Expires: [
            ()=>void 0 !== output.headers["expires"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$cf3a566289648a1e)(output.headers["expires"]))
        ],
        WebsiteRedirectLocation: [
            ,
            output.headers["x-amz-website-redirect-location"]
        ],
        ServerSideEncryption: [
            ,
            output.headers["x-amz-server-side-encryption"]
        ],
        SSECustomerAlgorithm: [
            ,
            output.headers["x-amz-server-side-encryption-customer-algorithm"]
        ],
        SSECustomerKeyMD5: [
            ,
            output.headers["x-amz-server-side-encryption-customer-key-md5"]
        ],
        SSEKMSKeyId: [
            ,
            output.headers["x-amz-server-side-encryption-aws-kms-key-id"]
        ],
        BucketKeyEnabled: [
            ()=>void 0 !== output.headers["x-amz-server-side-encryption-bucket-key-enabled"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-server-side-encryption-bucket-key-enabled"])
        ],
        StorageClass: [
            ,
            output.headers["x-amz-storage-class"]
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ],
        ReplicationStatus: [
            ,
            output.headers["x-amz-replication-status"]
        ],
        PartsCount: [
            ()=>void 0 !== output.headers["x-amz-mp-parts-count"],
            ()=>(0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output.headers["x-amz-mp-parts-count"])
        ],
        ObjectLockMode: [
            ,
            output.headers["x-amz-object-lock-mode"]
        ],
        ObjectLockRetainUntilDate: [
            ()=>void 0 !== output.headers["x-amz-object-lock-retain-until-date"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output.headers["x-amz-object-lock-retain-until-date"]))
        ],
        ObjectLockLegalHoldStatus: [
            ,
            output.headers["x-amz-object-lock-legal-hold"]
        ],
        Metadata: [
            ,
            Object.keys(output.headers).filter((header)=>header.startsWith("x-amz-meta-")).reduce((acc, header)=>{
                acc[header.substring(11)] = output.headers[header];
                return acc;
            }, {})
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_HeadObjectCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "NotFound":
        case "com.amazonaws.s3#NotFound":
            throw await $695e66930879143f$var$de_NotFoundRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$4a580d6152559b0a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListBucketAnalyticsConfigurationsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.AnalyticsConfiguration === "") contents.AnalyticsConfigurationList = [];
    else if (data["AnalyticsConfiguration"] !== undefined) contents.AnalyticsConfigurationList = $695e66930879143f$var$de_AnalyticsConfigurationList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["AnalyticsConfiguration"]), context);
    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ContinuationToken"]);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextContinuationToken"]);
    return contents;
};
const $695e66930879143f$var$de_ListBucketAnalyticsConfigurationsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$fb8e43a59b26e374 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListBucketIntelligentTieringConfigurationsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ContinuationToken"]);
    if (data.IntelligentTieringConfiguration === "") contents.IntelligentTieringConfigurationList = [];
    else if (data["IntelligentTieringConfiguration"] !== undefined) contents.IntelligentTieringConfigurationList = $695e66930879143f$var$de_IntelligentTieringConfigurationList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["IntelligentTieringConfiguration"]), context);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextContinuationToken"]);
    return contents;
};
const $695e66930879143f$var$de_ListBucketIntelligentTieringConfigurationsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$6b4533e13b7e300f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListBucketInventoryConfigurationsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ContinuationToken"]);
    if (data.InventoryConfiguration === "") contents.InventoryConfigurationList = [];
    else if (data["InventoryConfiguration"] !== undefined) contents.InventoryConfigurationList = $695e66930879143f$var$de_InventoryConfigurationList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["InventoryConfiguration"]), context);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextContinuationToken"]);
    return contents;
};
const $695e66930879143f$var$de_ListBucketInventoryConfigurationsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$129d146e4f043f73 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListBucketMetricsConfigurationsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ContinuationToken"]);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data.MetricsConfiguration === "") contents.MetricsConfigurationList = [];
    else if (data["MetricsConfiguration"] !== undefined) contents.MetricsConfigurationList = $695e66930879143f$var$de_MetricsConfigurationList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["MetricsConfiguration"]), context);
    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextContinuationToken"]);
    return contents;
};
const $695e66930879143f$var$de_ListBucketMetricsConfigurationsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$e054f59953b787ee = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListBucketsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.Buckets === "") contents.Buckets = [];
    else if (data["Buckets"] !== undefined && data["Buckets"]["Bucket"] !== undefined) contents.Buckets = $695e66930879143f$var$de_Buckets((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Buckets"]["Bucket"]), context);
    if (data["Owner"] !== undefined) contents.Owner = $695e66930879143f$var$de_Owner(data["Owner"], context);
    return contents;
};
const $695e66930879143f$var$de_ListBucketsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$202c2be1cea3d836 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListMultipartUploadsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["Bucket"] !== undefined) contents.Bucket = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Bucket"]);
    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
    else if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $695e66930879143f$var$de_CommonPrefixList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["CommonPrefixes"]), context);
    if (data["Delimiter"] !== undefined) contents.Delimiter = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Delimiter"]);
    if (data["EncodingType"] !== undefined) contents.EncodingType = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["EncodingType"]);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data["KeyMarker"] !== undefined) contents.KeyMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["KeyMarker"]);
    if (data["MaxUploads"] !== undefined) contents.MaxUploads = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(data["MaxUploads"]);
    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextKeyMarker"]);
    if (data["NextUploadIdMarker"] !== undefined) contents.NextUploadIdMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextUploadIdMarker"]);
    if (data["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Prefix"]);
    if (data["UploadIdMarker"] !== undefined) contents.UploadIdMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["UploadIdMarker"]);
    if (data.Upload === "") contents.Uploads = [];
    else if (data["Upload"] !== undefined) contents.Uploads = $695e66930879143f$var$de_MultipartUploadList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Upload"]), context);
    return contents;
};
const $695e66930879143f$var$de_ListMultipartUploadsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$60c32fef378932a4 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListObjectsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
    else if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $695e66930879143f$var$de_CommonPrefixList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["CommonPrefixes"]), context);
    if (data.Contents === "") contents.Contents = [];
    else if (data["Contents"] !== undefined) contents.Contents = $695e66930879143f$var$de_ObjectList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Contents"]), context);
    if (data["Delimiter"] !== undefined) contents.Delimiter = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Delimiter"]);
    if (data["EncodingType"] !== undefined) contents.EncodingType = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["EncodingType"]);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data["Marker"] !== undefined) contents.Marker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Marker"]);
    if (data["MaxKeys"] !== undefined) contents.MaxKeys = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(data["MaxKeys"]);
    if (data["Name"] !== undefined) contents.Name = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Name"]);
    if (data["NextMarker"] !== undefined) contents.NextMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextMarker"]);
    if (data["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Prefix"]);
    return contents;
};
const $695e66930879143f$var$de_ListObjectsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "NoSuchBucket":
        case "com.amazonaws.s3#NoSuchBucket":
            throw await $695e66930879143f$var$de_NoSuchBucketRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$feeeb96d3aa8311b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListObjectsV2CommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
    else if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $695e66930879143f$var$de_CommonPrefixList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["CommonPrefixes"]), context);
    if (data.Contents === "") contents.Contents = [];
    else if (data["Contents"] !== undefined) contents.Contents = $695e66930879143f$var$de_ObjectList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Contents"]), context);
    if (data["ContinuationToken"] !== undefined) contents.ContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ContinuationToken"]);
    if (data["Delimiter"] !== undefined) contents.Delimiter = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Delimiter"]);
    if (data["EncodingType"] !== undefined) contents.EncodingType = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["EncodingType"]);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data["KeyCount"] !== undefined) contents.KeyCount = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(data["KeyCount"]);
    if (data["MaxKeys"] !== undefined) contents.MaxKeys = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(data["MaxKeys"]);
    if (data["Name"] !== undefined) contents.Name = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Name"]);
    if (data["NextContinuationToken"] !== undefined) contents.NextContinuationToken = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextContinuationToken"]);
    if (data["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Prefix"]);
    if (data["StartAfter"] !== undefined) contents.StartAfter = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["StartAfter"]);
    return contents;
};
const $695e66930879143f$var$de_ListObjectsV2CommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "NoSuchBucket":
        case "com.amazonaws.s3#NoSuchBucket":
            throw await $695e66930879143f$var$de_NoSuchBucketRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$d416390b9e326b20 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListObjectVersionsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data.CommonPrefixes === "") contents.CommonPrefixes = [];
    else if (data["CommonPrefixes"] !== undefined) contents.CommonPrefixes = $695e66930879143f$var$de_CommonPrefixList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["CommonPrefixes"]), context);
    if (data.DeleteMarker === "") contents.DeleteMarkers = [];
    else if (data["DeleteMarker"] !== undefined) contents.DeleteMarkers = $695e66930879143f$var$de_DeleteMarkers((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["DeleteMarker"]), context);
    if (data["Delimiter"] !== undefined) contents.Delimiter = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Delimiter"]);
    if (data["EncodingType"] !== undefined) contents.EncodingType = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["EncodingType"]);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data["KeyMarker"] !== undefined) contents.KeyMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["KeyMarker"]);
    if (data["MaxKeys"] !== undefined) contents.MaxKeys = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(data["MaxKeys"]);
    if (data["Name"] !== undefined) contents.Name = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Name"]);
    if (data["NextKeyMarker"] !== undefined) contents.NextKeyMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextKeyMarker"]);
    if (data["NextVersionIdMarker"] !== undefined) contents.NextVersionIdMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextVersionIdMarker"]);
    if (data["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Prefix"]);
    if (data["VersionIdMarker"] !== undefined) contents.VersionIdMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["VersionIdMarker"]);
    if (data.Version === "") contents.Versions = [];
    else if (data["Version"] !== undefined) contents.Versions = $695e66930879143f$var$de_ObjectVersionList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Version"]), context);
    return contents;
};
const $695e66930879143f$var$de_ListObjectVersionsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$889118d85a8eede7 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_ListPartsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        AbortDate: [
            ()=>void 0 !== output.headers["x-amz-abort-date"],
            ()=>(0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$cf3a566289648a1e)(output.headers["x-amz-abort-date"]))
        ],
        AbortRuleId: [
            ,
            output.headers["x-amz-abort-rule-id"]
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context)), "body");
    if (data["Bucket"] !== undefined) contents.Bucket = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Bucket"]);
    if (data["ChecksumAlgorithm"] !== undefined) contents.ChecksumAlgorithm = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["ChecksumAlgorithm"]);
    if (data["Initiator"] !== undefined) contents.Initiator = $695e66930879143f$var$de_Initiator(data["Initiator"], context);
    if (data["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(data["IsTruncated"]);
    if (data["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["Key"]);
    if (data["MaxParts"] !== undefined) contents.MaxParts = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(data["MaxParts"]);
    if (data["NextPartNumberMarker"] !== undefined) contents.NextPartNumberMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["NextPartNumberMarker"]);
    if (data["Owner"] !== undefined) contents.Owner = $695e66930879143f$var$de_Owner(data["Owner"], context);
    if (data["PartNumberMarker"] !== undefined) contents.PartNumberMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["PartNumberMarker"]);
    if (data.Part === "") contents.Parts = [];
    else if (data["Part"] !== undefined) contents.Parts = $695e66930879143f$var$de_Parts((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(data["Part"]), context);
    if (data["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["StorageClass"]);
    if (data["UploadId"] !== undefined) contents.UploadId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["UploadId"]);
    return contents;
};
const $695e66930879143f$var$de_ListPartsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$d2a736b57650c456 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketAccelerateConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketAccelerateConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$75e6a99b1c339917 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketAclCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketAclCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$854cdce50005e56a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketAnalyticsConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketAnalyticsConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$c0c66a8837f2d4b7 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketCorsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketCorsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$e7db3ad9c672fd4f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketEncryptionCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketEncryptionCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$59e017c5bb66929d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketIntelligentTieringConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketIntelligentTieringConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$f255d6249684469e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketInventoryConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketInventoryConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$c202de193d98138f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketLifecycleConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketLifecycleConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$449100442e3176cf = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketLoggingCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketLoggingCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$25022097f277800e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketMetricsConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketMetricsConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$440e091cf54e6cab = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketNotificationConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketNotificationConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$32aa15f0afe296ab = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketOwnershipControlsCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketOwnershipControlsCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$b58e3d261138954b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketPolicyCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketPolicyCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$9391691c9783a112 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketReplicationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketReplicationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$419f306f268e3e00 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketRequestPaymentCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketRequestPaymentCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$95aca8e80cc02bb4 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketTaggingCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketTaggingCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$5f7f53ae9422ba4c = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketVersioningCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketVersioningCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$d80cda07dc7d9c8 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutBucketWebsiteCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutBucketWebsiteCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$7b5fb371239d4b24 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutObjectCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        Expiration: [
            ,
            output.headers["x-amz-expiration"]
        ],
        ETag: [
            ,
            output.headers["etag"]
        ],
        ChecksumCRC32: [
            ,
            output.headers["x-amz-checksum-crc32"]
        ],
        ChecksumCRC32C: [
            ,
            output.headers["x-amz-checksum-crc32c"]
        ],
        ChecksumSHA1: [
            ,
            output.headers["x-amz-checksum-sha1"]
        ],
        ChecksumSHA256: [
            ,
            output.headers["x-amz-checksum-sha256"]
        ],
        ServerSideEncryption: [
            ,
            output.headers["x-amz-server-side-encryption"]
        ],
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ],
        SSECustomerAlgorithm: [
            ,
            output.headers["x-amz-server-side-encryption-customer-algorithm"]
        ],
        SSECustomerKeyMD5: [
            ,
            output.headers["x-amz-server-side-encryption-customer-key-md5"]
        ],
        SSEKMSKeyId: [
            ,
            output.headers["x-amz-server-side-encryption-aws-kms-key-id"]
        ],
        SSEKMSEncryptionContext: [
            ,
            output.headers["x-amz-server-side-encryption-context"]
        ],
        BucketKeyEnabled: [
            ()=>void 0 !== output.headers["x-amz-server-side-encryption-bucket-key-enabled"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-server-side-encryption-bucket-key-enabled"])
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutObjectCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$bf11fd5d155581b3 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutObjectAclCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutObjectAclCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "NoSuchKey":
        case "com.amazonaws.s3#NoSuchKey":
            throw await $695e66930879143f$var$de_NoSuchKeyRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$4b6d1543afbb074f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutObjectLegalHoldCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutObjectLegalHoldCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$90f68ac8a7a0e24 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutObjectLockConfigurationCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutObjectLockConfigurationCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$b26d670522bae7cd = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutObjectRetentionCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutObjectRetentionCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$8409a6520dd6d338 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutObjectTaggingCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        VersionId: [
            ,
            output.headers["x-amz-version-id"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutObjectTaggingCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$ca8f3e913af12de5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_PutPublicAccessBlockCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_PutPublicAccessBlockCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$aaca0f50a468a078 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_RestoreObjectCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ],
        RestoreOutputPath: [
            ,
            output.headers["x-amz-restore-output-path"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_RestoreObjectCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    switch(errorCode){
        case "ObjectAlreadyInActiveTierError":
        case "com.amazonaws.s3#ObjectAlreadyInActiveTierError":
            throw await $695e66930879143f$var$de_ObjectAlreadyInActiveTierErrorRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $695e66930879143f$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $695e66930879143f$export$b9e872a6d39a299d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_SelectObjectContentCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    const data = output.body;
    contents.Payload = $695e66930879143f$var$de_SelectObjectContentEventStream(data, context);
    return contents;
};
const $695e66930879143f$var$de_SelectObjectContentCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$c970fb418cbd6bb1 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_UploadPartCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        ServerSideEncryption: [
            ,
            output.headers["x-amz-server-side-encryption"]
        ],
        ETag: [
            ,
            output.headers["etag"]
        ],
        ChecksumCRC32: [
            ,
            output.headers["x-amz-checksum-crc32"]
        ],
        ChecksumCRC32C: [
            ,
            output.headers["x-amz-checksum-crc32c"]
        ],
        ChecksumSHA1: [
            ,
            output.headers["x-amz-checksum-sha1"]
        ],
        ChecksumSHA256: [
            ,
            output.headers["x-amz-checksum-sha256"]
        ],
        SSECustomerAlgorithm: [
            ,
            output.headers["x-amz-server-side-encryption-customer-algorithm"]
        ],
        SSECustomerKeyMD5: [
            ,
            output.headers["x-amz-server-side-encryption-customer-key-md5"]
        ],
        SSEKMSKeyId: [
            ,
            output.headers["x-amz-server-side-encryption-aws-kms-key-id"]
        ],
        BucketKeyEnabled: [
            ()=>void 0 !== output.headers["x-amz-server-side-encryption-bucket-key-enabled"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-server-side-encryption-bucket-key-enabled"])
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_UploadPartCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$c431a3723512099a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_UploadPartCopyCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output),
        CopySourceVersionId: [
            ,
            output.headers["x-amz-copy-source-version-id"]
        ],
        ServerSideEncryption: [
            ,
            output.headers["x-amz-server-side-encryption"]
        ],
        SSECustomerAlgorithm: [
            ,
            output.headers["x-amz-server-side-encryption-customer-algorithm"]
        ],
        SSECustomerKeyMD5: [
            ,
            output.headers["x-amz-server-side-encryption-customer-key-md5"]
        ],
        SSEKMSKeyId: [
            ,
            output.headers["x-amz-server-side-encryption-aws-kms-key-id"]
        ],
        BucketKeyEnabled: [
            ()=>void 0 !== output.headers["x-amz-server-side-encryption-bucket-key-enabled"],
            ()=>(0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output.headers["x-amz-server-side-encryption-bucket-key-enabled"])
        ],
        RequestCharged: [
            ,
            output.headers["x-amz-request-charged"]
        ]
    });
    const data = (0, $f10fb2b359b91940$export$cf825aadce530e7e)(await $695e66930879143f$var$parseBody(output.body, context));
    contents.CopyPartResult = $695e66930879143f$var$de_CopyPartResult(data, context);
    return contents;
};
const $695e66930879143f$var$de_UploadPartCopyCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$export$7c898350df913e04 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $695e66930879143f$var$de_WriteGetObjectResponseCommandError(output, context);
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({
        $metadata: $695e66930879143f$var$deserializeMetadata(output)
    });
    await (0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(output.body, context);
    return contents;
};
const $695e66930879143f$var$de_WriteGetObjectResponseCommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await $695e66930879143f$var$parseErrorBody(output.body, context)
    };
    const errorCode = $695e66930879143f$var$loadRestXmlErrorCode(output, parsedOutput.body);
    const parsedBody = parsedOutput.body;
    return $695e66930879143f$var$throwDefaultError({
        output: output,
        parsedBody: parsedBody,
        errorCode: errorCode
    });
};
const $695e66930879143f$var$throwDefaultError = (0, $7890e3748e9b15a4$export$62ac8acba1748a85)((0, $1c0ac447e2dd7670$export$a53c51960b14a8e5));
const $695e66930879143f$var$de_BucketAlreadyExistsRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $581888fd928d8ba4$export$b6b374c2bfd60422)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_BucketAlreadyOwnedByYouRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $581888fd928d8ba4$export$3d44152d602e5b07)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_InvalidObjectStateRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    if (data["AccessTier"] !== undefined) contents.AccessTier = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["AccessTier"]);
    if (data["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(data["StorageClass"]);
    const exception = new (0, $581888fd928d8ba4$export$6424f05126e7daf8)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_NoSuchBucketRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $581888fd928d8ba4$export$bbe89283205bd874)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_NoSuchKeyRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $581888fd928d8ba4$export$1f6f8c73c651f3ca)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_NoSuchUploadRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $581888fd928d8ba4$export$1de06065cff890a8)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_NotFoundRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $581888fd928d8ba4$export$271f9f08425019c7)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_ObjectAlreadyInActiveTierErrorRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $1b94a343f91115e4$export$a97e3c65be291319)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_ObjectNotInActiveTierErrorRes = async (parsedOutput, context)=>{
    const contents = (0, $c5dd53748caa092b$export$871de8747c9eaa88)({});
    const data = parsedOutput.body;
    const exception = new (0, $581888fd928d8ba4$export$77615b2f7cde9dd7)({
        $metadata: $695e66930879143f$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $f4d6e6bcf25435f5$export$db01f0c43e877a50)(exception, parsedOutput.body);
};
const $695e66930879143f$var$de_SelectObjectContentEventStream = (output, context)=>{
    return context.eventStreamMarshaller.deserialize(output, async (event)=>{
        if (event["Records"] != null) return {
            Records: await $695e66930879143f$var$de_RecordsEvent_event(event["Records"], context)
        };
        if (event["Stats"] != null) return {
            Stats: await $695e66930879143f$var$de_StatsEvent_event(event["Stats"], context)
        };
        if (event["Progress"] != null) return {
            Progress: await $695e66930879143f$var$de_ProgressEvent_event(event["Progress"], context)
        };
        if (event["Cont"] != null) return {
            Cont: await $695e66930879143f$var$de_ContinuationEvent_event(event["Cont"], context)
        };
        if (event["End"] != null) return {
            End: await $695e66930879143f$var$de_EndEvent_event(event["End"], context)
        };
        return {
            $unknown: output
        };
    });
};
const $695e66930879143f$var$de_ContinuationEvent_event = async (output, context)=>{
    const contents = {};
    const data = await $695e66930879143f$var$parseBody(output.body, context);
    Object.assign(contents, $695e66930879143f$var$de_ContinuationEvent(data, context));
    return contents;
};
const $695e66930879143f$var$de_EndEvent_event = async (output, context)=>{
    const contents = {};
    const data = await $695e66930879143f$var$parseBody(output.body, context);
    Object.assign(contents, $695e66930879143f$var$de_EndEvent(data, context));
    return contents;
};
const $695e66930879143f$var$de_ProgressEvent_event = async (output, context)=>{
    const contents = {};
    const data = await $695e66930879143f$var$parseBody(output.body, context);
    contents.Details = $695e66930879143f$var$de_Progress(data, context);
    return contents;
};
const $695e66930879143f$var$de_RecordsEvent_event = async (output, context)=>{
    const contents = {};
    contents.Payload = output.body;
    return contents;
};
const $695e66930879143f$var$de_StatsEvent_event = async (output, context)=>{
    const contents = {};
    const data = await $695e66930879143f$var$parseBody(output.body, context);
    contents.Details = $695e66930879143f$var$de_Stats(data, context);
    return contents;
};
const $695e66930879143f$var$se_AbortIncompleteMultipartUpload = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AbortIncompleteMultipartUpload");
    if (input.DaysAfterInitiation != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("DaysAfterInitiation", String(input.DaysAfterInitiation)).withName("DaysAfterInitiation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_AccelerateConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AccelerateConfiguration");
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketAccelerateStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_AccessControlPolicy = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AccessControlPolicy");
    if (input.Grants != null) {
        const nodes = $695e66930879143f$var$se_Grants(input.Grants, context);
        const containerNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AccessControlList");
        nodes.map((node)=>{
            containerNode.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode);
    }
    if (input.Owner != null) {
        const node = $695e66930879143f$var$se_Owner(input.Owner, context).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_AccessControlTranslation = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AccessControlTranslation");
    if (input.Owner != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("OwnerOverride", input.Owner).withName("Owner");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_AllowedHeaders = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AllowedHeader", entry);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_AllowedMethods = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AllowedMethod", entry);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_AllowedOrigins = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AllowedOrigin", entry);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_AnalyticsAndOperator = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AnalyticsAndOperator");
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags != null) {
        const nodes = $695e66930879143f$var$se_TagSet(input.Tags, context);
        nodes.map((node)=>{
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_AnalyticsConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AnalyticsConfiguration");
    if (input.Id != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AnalyticsId", input.Id).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_AnalyticsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClassAnalysis != null) {
        const node = $695e66930879143f$var$se_StorageClassAnalysis(input.StorageClassAnalysis, context).withName("StorageClassAnalysis");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_AnalyticsExportDestination = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AnalyticsExportDestination");
    if (input.S3BucketDestination != null) {
        const node = $695e66930879143f$var$se_AnalyticsS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_AnalyticsFilter = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AnalyticsFilter");
    (0, $581888fd928d8ba4$export$c9ec61557dcb764a).visit(input, {
        Prefix: (value)=>{
            const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", value).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: (value)=>{
            const node = $695e66930879143f$var$se_Tag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: (value)=>{
            const node = $695e66930879143f$var$se_AnalyticsAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: (name, value)=>{
            if (!(value instanceof (0, $e5feeac9197fd5d3$export$e775a15d806cbddc) || value instanceof (0, $74950727763df02e$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
const $695e66930879143f$var$se_AnalyticsS3BucketDestination = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AnalyticsS3BucketDestination");
    if (input.Format != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AnalyticsS3ExportFileFormat", input.Format).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.BucketAccountId != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AccountId", input.BucketAccountId).withName("BucketAccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketName", input.Bucket).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_BucketLifecycleConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("BucketLifecycleConfiguration");
    if (input.Rules != null) {
        const nodes = $695e66930879143f$var$se_LifecycleRules(input.Rules, context);
        nodes.map((node)=>{
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_BucketLoggingStatus = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("BucketLoggingStatus");
    if (input.LoggingEnabled != null) {
        const node = $695e66930879143f$var$se_LoggingEnabled(input.LoggingEnabled, context).withName("LoggingEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_CompletedMultipartUpload = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("CompletedMultipartUpload");
    if (input.Parts != null) {
        const nodes = $695e66930879143f$var$se_CompletedPartList(input.Parts, context);
        nodes.map((node)=>{
            node = node.withName("Part");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_CompletedPart = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("CompletedPart");
    if (input.ETag != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ETag", input.ETag).withName("ETag");
        bodyNode.addChildNode(node);
    }
    if (input.ChecksumCRC32 != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ChecksumCRC32", input.ChecksumCRC32).withName("ChecksumCRC32");
        bodyNode.addChildNode(node);
    }
    if (input.ChecksumCRC32C != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ChecksumCRC32C", input.ChecksumCRC32C).withName("ChecksumCRC32C");
        bodyNode.addChildNode(node);
    }
    if (input.ChecksumSHA1 != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ChecksumSHA1", input.ChecksumSHA1).withName("ChecksumSHA1");
        bodyNode.addChildNode(node);
    }
    if (input.ChecksumSHA256 != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ChecksumSHA256", input.ChecksumSHA256).withName("ChecksumSHA256");
        bodyNode.addChildNode(node);
    }
    if (input.PartNumber != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("PartNumber", String(input.PartNumber)).withName("PartNumber");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_CompletedPartList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_CompletedPart(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_Condition = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Condition");
    if (input.HttpErrorCodeReturnedEquals != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("HttpErrorCodeReturnedEquals", input.HttpErrorCodeReturnedEquals).withName("HttpErrorCodeReturnedEquals");
        bodyNode.addChildNode(node);
    }
    if (input.KeyPrefixEquals != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("KeyPrefixEquals", input.KeyPrefixEquals).withName("KeyPrefixEquals");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_CORSConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("CORSConfiguration");
    if (input.CORSRules != null) {
        const nodes = $695e66930879143f$var$se_CORSRules(input.CORSRules, context);
        nodes.map((node)=>{
            node = node.withName("CORSRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_CORSRule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("CORSRule");
    if (input.ID != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ID", input.ID).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.AllowedHeaders != null) {
        const nodes = $695e66930879143f$var$se_AllowedHeaders(input.AllowedHeaders, context);
        nodes.map((node)=>{
            node = node.withName("AllowedHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedMethods != null) {
        const nodes = $695e66930879143f$var$se_AllowedMethods(input.AllowedMethods, context);
        nodes.map((node)=>{
            node = node.withName("AllowedMethod");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AllowedOrigins != null) {
        const nodes = $695e66930879143f$var$se_AllowedOrigins(input.AllowedOrigins, context);
        nodes.map((node)=>{
            node = node.withName("AllowedOrigin");
            bodyNode.addChildNode(node);
        });
    }
    if (input.ExposeHeaders != null) {
        const nodes = $695e66930879143f$var$se_ExposeHeaders(input.ExposeHeaders, context);
        nodes.map((node)=>{
            node = node.withName("ExposeHeader");
            bodyNode.addChildNode(node);
        });
    }
    if (input.MaxAgeSeconds != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("MaxAgeSeconds", String(input.MaxAgeSeconds)).withName("MaxAgeSeconds");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_CORSRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_CORSRule(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_CreateBucketConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("CreateBucketConfiguration");
    if (input.LocationConstraint != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketLocationConstraint", input.LocationConstraint).withName("LocationConstraint");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_CSVInput = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("CSVInput");
    if (input.FileHeaderInfo != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("FileHeaderInfo", input.FileHeaderInfo).withName("FileHeaderInfo");
        bodyNode.addChildNode(node);
    }
    if (input.Comments != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Comments", input.Comments).withName("Comments");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("QuoteEscapeCharacter", input.QuoteEscapeCharacter).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("RecordDelimiter", input.RecordDelimiter).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FieldDelimiter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("FieldDelimiter", input.FieldDelimiter).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("QuoteCharacter", input.QuoteCharacter).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.AllowQuotedRecordDelimiter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AllowQuotedRecordDelimiter", String(input.AllowQuotedRecordDelimiter)).withName("AllowQuotedRecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_CSVOutput = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("CSVOutput");
    if (input.QuoteFields != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("QuoteFields", input.QuoteFields).withName("QuoteFields");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteEscapeCharacter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("QuoteEscapeCharacter", input.QuoteEscapeCharacter).withName("QuoteEscapeCharacter");
        bodyNode.addChildNode(node);
    }
    if (input.RecordDelimiter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("RecordDelimiter", input.RecordDelimiter).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.FieldDelimiter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("FieldDelimiter", input.FieldDelimiter).withName("FieldDelimiter");
        bodyNode.addChildNode(node);
    }
    if (input.QuoteCharacter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("QuoteCharacter", input.QuoteCharacter).withName("QuoteCharacter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_DefaultRetention = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("DefaultRetention");
    if (input.Mode != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectLockRetentionMode", input.Mode).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.Days != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Days", String(input.Days)).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.Years != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Years", String(input.Years)).withName("Years");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Delete = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Delete");
    if (input.Objects != null) {
        const nodes = $695e66930879143f$var$se_ObjectIdentifierList(input.Objects, context);
        nodes.map((node)=>{
            node = node.withName("Object");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Quiet != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Quiet", String(input.Quiet)).withName("Quiet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_DeleteMarkerReplication = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("DeleteMarkerReplication");
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("DeleteMarkerReplicationStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Destination = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Destination");
    if (input.Bucket != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketName", input.Bucket).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Account != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AccountId", input.Account).withName("Account");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("StorageClass", input.StorageClass).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlTranslation != null) {
        const node = $695e66930879143f$var$se_AccessControlTranslation(input.AccessControlTranslation, context).withName("AccessControlTranslation");
        bodyNode.addChildNode(node);
    }
    if (input.EncryptionConfiguration != null) {
        const node = $695e66930879143f$var$se_EncryptionConfiguration(input.EncryptionConfiguration, context).withName("EncryptionConfiguration");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicationTime != null) {
        const node = $695e66930879143f$var$se_ReplicationTime(input.ReplicationTime, context).withName("ReplicationTime");
        bodyNode.addChildNode(node);
    }
    if (input.Metrics != null) {
        const node = $695e66930879143f$var$se_Metrics(input.Metrics, context).withName("Metrics");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Encryption = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Encryption");
    if (input.EncryptionType != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ServerSideEncryption", input.EncryptionType).withName("EncryptionType");
        bodyNode.addChildNode(node);
    }
    if (input.KMSKeyId != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("SSEKMSKeyId", input.KMSKeyId).withName("KMSKeyId");
        bodyNode.addChildNode(node);
    }
    if (input.KMSContext != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("KMSContext", input.KMSContext).withName("KMSContext");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_EncryptionConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("EncryptionConfiguration");
    if (input.ReplicaKmsKeyID != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ReplicaKmsKeyID", input.ReplicaKmsKeyID).withName("ReplicaKmsKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ErrorDocument = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ErrorDocument");
    if (input.Key != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectKey", input.Key).withName("Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_EventBridgeConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("EventBridgeConfiguration");
    return bodyNode;
};
const $695e66930879143f$var$se_EventList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Event", entry);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_ExistingObjectReplication = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ExistingObjectReplication");
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ExistingObjectReplicationStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ExposeHeaders = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ExposeHeader", entry);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_FilterRule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("FilterRule");
    if (input.Name != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("FilterRuleName", input.Name).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("FilterRuleValue", input.Value).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_FilterRuleList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_FilterRule(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_GlacierJobParameters = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("GlacierJobParameters");
    if (input.Tier != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Tier", input.Tier).withName("Tier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Grant = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Grant");
    if (input.Grantee != null) {
        const node = $695e66930879143f$var$se_Grantee(input.Grantee, context).withName("Grantee");
        node.addAttribute("xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
        bodyNode.addChildNode(node);
    }
    if (input.Permission != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Permission", input.Permission).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Grantee = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Grantee");
    if (input.DisplayName != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("DisplayName", input.DisplayName).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.EmailAddress != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("EmailAddress", input.EmailAddress).withName("EmailAddress");
        bodyNode.addChildNode(node);
    }
    if (input.ID != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ID", input.ID).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.URI != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("URI", input.URI).withName("URI");
        bodyNode.addChildNode(node);
    }
    if (input.Type != null) bodyNode.addAttribute("xsi:type", input.Type);
    return bodyNode;
};
const $695e66930879143f$var$se_Grants = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_Grant(entry, context);
        return node.withName("Grant");
    });
};
const $695e66930879143f$var$se_IndexDocument = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("IndexDocument");
    if (input.Suffix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Suffix", input.Suffix).withName("Suffix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_InputSerialization = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("InputSerialization");
    if (input.CSV != null) {
        const node = $695e66930879143f$var$se_CSVInput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    if (input.CompressionType != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("CompressionType", input.CompressionType).withName("CompressionType");
        bodyNode.addChildNode(node);
    }
    if (input.JSON != null) {
        const node = $695e66930879143f$var$se_JSONInput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    if (input.Parquet != null) {
        const node = $695e66930879143f$var$se_ParquetInput(input.Parquet, context).withName("Parquet");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_IntelligentTieringAndOperator = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("IntelligentTieringAndOperator");
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags != null) {
        const nodes = $695e66930879143f$var$se_TagSet(input.Tags, context);
        nodes.map((node)=>{
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_IntelligentTieringConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("IntelligentTieringConfiguration");
    if (input.Id != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("IntelligentTieringId", input.Id).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_IntelligentTieringFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("IntelligentTieringStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Tierings != null) {
        const nodes = $695e66930879143f$var$se_TieringList(input.Tierings, context);
        nodes.map((node)=>{
            node = node.withName("Tiering");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_IntelligentTieringFilter = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("IntelligentTieringFilter");
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tag != null) {
        const node = $695e66930879143f$var$se_Tag(input.Tag, context).withName("Tag");
        bodyNode.addChildNode(node);
    }
    if (input.And != null) {
        const node = $695e66930879143f$var$se_IntelligentTieringAndOperator(input.And, context).withName("And");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_InventoryConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("InventoryConfiguration");
    if (input.Destination != null) {
        const node = $695e66930879143f$var$se_InventoryDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.IsEnabled != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("IsEnabled", String(input.IsEnabled)).withName("IsEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_InventoryFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Id != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("InventoryId", input.Id).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.IncludedObjectVersions != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("InventoryIncludedObjectVersions", input.IncludedObjectVersions).withName("IncludedObjectVersions");
        bodyNode.addChildNode(node);
    }
    if (input.OptionalFields != null) {
        const nodes = $695e66930879143f$var$se_InventoryOptionalFields(input.OptionalFields, context);
        const containerNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("OptionalFields");
        nodes.map((node)=>{
            containerNode.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode);
    }
    if (input.Schedule != null) {
        const node = $695e66930879143f$var$se_InventorySchedule(input.Schedule, context).withName("Schedule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_InventoryDestination = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("InventoryDestination");
    if (input.S3BucketDestination != null) {
        const node = $695e66930879143f$var$se_InventoryS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_InventoryEncryption = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("InventoryEncryption");
    if (input.SSES3 != null) {
        const node = $695e66930879143f$var$se_SSES3(input.SSES3, context).withName("SSE-S3");
        bodyNode.addChildNode(node);
    }
    if (input.SSEKMS != null) {
        const node = $695e66930879143f$var$se_SSEKMS(input.SSEKMS, context).withName("SSE-KMS");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_InventoryFilter = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("InventoryFilter");
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_InventoryOptionalFields = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("InventoryOptionalField", entry);
        return node.withName("Field");
    });
};
const $695e66930879143f$var$se_InventoryS3BucketDestination = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("InventoryS3BucketDestination");
    if (input.AccountId != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AccountId", input.AccountId).withName("AccountId");
        bodyNode.addChildNode(node);
    }
    if (input.Bucket != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketName", input.Bucket).withName("Bucket");
        bodyNode.addChildNode(node);
    }
    if (input.Format != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("InventoryFormat", input.Format).withName("Format");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption != null) {
        const node = $695e66930879143f$var$se_InventoryEncryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_InventorySchedule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("InventorySchedule");
    if (input.Frequency != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("InventoryFrequency", input.Frequency).withName("Frequency");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_JSONInput = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("JSONInput");
    if (input.Type != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("JSONType", input.Type).withName("Type");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_JSONOutput = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("JSONOutput");
    if (input.RecordDelimiter != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("RecordDelimiter", input.RecordDelimiter).withName("RecordDelimiter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_LambdaFunctionConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("LambdaFunctionConfiguration");
    if (input.Id != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("NotificationId", input.Id).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.LambdaFunctionArn != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("LambdaFunctionArn", input.LambdaFunctionArn).withName("CloudFunction");
        bodyNode.addChildNode(node);
    }
    if (input.Events != null) {
        const nodes = $695e66930879143f$var$se_EventList(input.Events, context);
        nodes.map((node)=>{
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_NotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_LambdaFunctionConfigurationList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_LambdaFunctionConfiguration(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_LifecycleExpiration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("LifecycleExpiration");
    if (input.Date != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Date", (input.Date.toISOString().split(".")[0] + "Z").toString()).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.Days != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Days", String(input.Days)).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.ExpiredObjectDeleteMarker != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ExpiredObjectDeleteMarker", String(input.ExpiredObjectDeleteMarker)).withName("ExpiredObjectDeleteMarker");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_LifecycleRule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("LifecycleRule");
    if (input.Expiration != null) {
        const node = $695e66930879143f$var$se_LifecycleExpiration(input.Expiration, context).withName("Expiration");
        bodyNode.addChildNode(node);
    }
    if (input.ID != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ID", input.ID).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_LifecycleRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ExpirationStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Transitions != null) {
        const nodes = $695e66930879143f$var$se_TransitionList(input.Transitions, context);
        nodes.map((node)=>{
            node = node.withName("Transition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.NoncurrentVersionTransitions != null) {
        const nodes = $695e66930879143f$var$se_NoncurrentVersionTransitionList(input.NoncurrentVersionTransitions, context);
        nodes.map((node)=>{
            node = node.withName("NoncurrentVersionTransition");
            bodyNode.addChildNode(node);
        });
    }
    if (input.NoncurrentVersionExpiration != null) {
        const node = $695e66930879143f$var$se_NoncurrentVersionExpiration(input.NoncurrentVersionExpiration, context).withName("NoncurrentVersionExpiration");
        bodyNode.addChildNode(node);
    }
    if (input.AbortIncompleteMultipartUpload != null) {
        const node = $695e66930879143f$var$se_AbortIncompleteMultipartUpload(input.AbortIncompleteMultipartUpload, context).withName("AbortIncompleteMultipartUpload");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_LifecycleRuleAndOperator = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("LifecycleRuleAndOperator");
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags != null) {
        const nodes = $695e66930879143f$var$se_TagSet(input.Tags, context);
        nodes.map((node)=>{
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    if (input.ObjectSizeGreaterThan != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectSizeGreaterThanBytes", String(input.ObjectSizeGreaterThan)).withName("ObjectSizeGreaterThan");
        bodyNode.addChildNode(node);
    }
    if (input.ObjectSizeLessThan != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectSizeLessThanBytes", String(input.ObjectSizeLessThan)).withName("ObjectSizeLessThan");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_LifecycleRuleFilter = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("LifecycleRuleFilter");
    (0, $581888fd928d8ba4$export$4338dba1e93ddaf4).visit(input, {
        Prefix: (value)=>{
            const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", value).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: (value)=>{
            const node = $695e66930879143f$var$se_Tag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        ObjectSizeGreaterThan: (value)=>{
            const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectSizeGreaterThanBytes", String(value)).withName("ObjectSizeGreaterThan");
            bodyNode.addChildNode(node);
        },
        ObjectSizeLessThan: (value)=>{
            const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectSizeLessThanBytes", String(value)).withName("ObjectSizeLessThan");
            bodyNode.addChildNode(node);
        },
        And: (value)=>{
            const node = $695e66930879143f$var$se_LifecycleRuleAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: (name, value)=>{
            if (!(value instanceof (0, $e5feeac9197fd5d3$export$e775a15d806cbddc) || value instanceof (0, $74950727763df02e$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
const $695e66930879143f$var$se_LifecycleRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_LifecycleRule(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_LoggingEnabled = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("LoggingEnabled");
    if (input.TargetBucket != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("TargetBucket", input.TargetBucket).withName("TargetBucket");
        bodyNode.addChildNode(node);
    }
    if (input.TargetGrants != null) {
        const nodes = $695e66930879143f$var$se_TargetGrants(input.TargetGrants, context);
        const containerNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("TargetGrants");
        nodes.map((node)=>{
            containerNode.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode);
    }
    if (input.TargetPrefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("TargetPrefix", input.TargetPrefix).withName("TargetPrefix");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_MetadataEntry = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("MetadataEntry");
    if (input.Name != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("MetadataKey", input.Name).withName("Name");
        bodyNode.addChildNode(node);
    }
    if (input.Value != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("MetadataValue", input.Value).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Metrics = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Metrics");
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("MetricsStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.EventThreshold != null) {
        const node = $695e66930879143f$var$se_ReplicationTimeValue(input.EventThreshold, context).withName("EventThreshold");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_MetricsAndOperator = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("MetricsAndOperator");
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags != null) {
        const nodes = $695e66930879143f$var$se_TagSet(input.Tags, context);
        nodes.map((node)=>{
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    if (input.AccessPointArn != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AccessPointArn", input.AccessPointArn).withName("AccessPointArn");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_MetricsConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("MetricsConfiguration");
    if (input.Id != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("MetricsId", input.Id).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_MetricsFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_MetricsFilter = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("MetricsFilter");
    (0, $581888fd928d8ba4$export$564a1f9c338cae45).visit(input, {
        Prefix: (value)=>{
            const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", value).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: (value)=>{
            const node = $695e66930879143f$var$se_Tag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        AccessPointArn: (value)=>{
            const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("AccessPointArn", value).withName("AccessPointArn");
            bodyNode.addChildNode(node);
        },
        And: (value)=>{
            const node = $695e66930879143f$var$se_MetricsAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: (name, value)=>{
            if (!(value instanceof (0, $e5feeac9197fd5d3$export$e775a15d806cbddc) || value instanceof (0, $74950727763df02e$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
const $695e66930879143f$var$se_NoncurrentVersionExpiration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("NoncurrentVersionExpiration");
    if (input.NoncurrentDays != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Days", String(input.NoncurrentDays)).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    if (input.NewerNoncurrentVersions != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("VersionCount", String(input.NewerNoncurrentVersions)).withName("NewerNoncurrentVersions");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_NoncurrentVersionTransition = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("NoncurrentVersionTransition");
    if (input.NoncurrentDays != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Days", String(input.NoncurrentDays)).withName("NoncurrentDays");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("TransitionStorageClass", input.StorageClass).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    if (input.NewerNoncurrentVersions != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("VersionCount", String(input.NewerNoncurrentVersions)).withName("NewerNoncurrentVersions");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_NoncurrentVersionTransitionList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_NoncurrentVersionTransition(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_NotificationConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("NotificationConfiguration");
    if (input.TopicConfigurations != null) {
        const nodes = $695e66930879143f$var$se_TopicConfigurationList(input.TopicConfigurations, context);
        nodes.map((node)=>{
            node = node.withName("TopicConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.QueueConfigurations != null) {
        const nodes = $695e66930879143f$var$se_QueueConfigurationList(input.QueueConfigurations, context);
        nodes.map((node)=>{
            node = node.withName("QueueConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.LambdaFunctionConfigurations != null) {
        const nodes = $695e66930879143f$var$se_LambdaFunctionConfigurationList(input.LambdaFunctionConfigurations, context);
        nodes.map((node)=>{
            node = node.withName("CloudFunctionConfiguration");
            bodyNode.addChildNode(node);
        });
    }
    if (input.EventBridgeConfiguration != null) {
        const node = $695e66930879143f$var$se_EventBridgeConfiguration(input.EventBridgeConfiguration, context).withName("EventBridgeConfiguration");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_NotificationConfigurationFilter = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("NotificationConfigurationFilter");
    if (input.Key != null) {
        const node = $695e66930879143f$var$se_S3KeyFilter(input.Key, context).withName("S3Key");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ObjectIdentifier = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ObjectIdentifier");
    if (input.Key != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectKey", input.Key).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.VersionId != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectVersionId", input.VersionId).withName("VersionId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ObjectIdentifierList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_ObjectIdentifier(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_ObjectLockConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ObjectLockConfiguration");
    if (input.ObjectLockEnabled != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectLockEnabled", input.ObjectLockEnabled).withName("ObjectLockEnabled");
        bodyNode.addChildNode(node);
    }
    if (input.Rule != null) {
        const node = $695e66930879143f$var$se_ObjectLockRule(input.Rule, context).withName("Rule");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ObjectLockLegalHold = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ObjectLockLegalHold");
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectLockLegalHoldStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ObjectLockRetention = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ObjectLockRetention");
    if (input.Mode != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectLockRetentionMode", input.Mode).withName("Mode");
        bodyNode.addChildNode(node);
    }
    if (input.RetainUntilDate != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Date", (input.RetainUntilDate.toISOString().split(".")[0] + "Z").toString()).withName("RetainUntilDate");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ObjectLockRule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ObjectLockRule");
    if (input.DefaultRetention != null) {
        const node = $695e66930879143f$var$se_DefaultRetention(input.DefaultRetention, context).withName("DefaultRetention");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_OutputLocation = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("OutputLocation");
    if (input.S3 != null) {
        const node = $695e66930879143f$var$se_S3Location(input.S3, context).withName("S3");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_OutputSerialization = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("OutputSerialization");
    if (input.CSV != null) {
        const node = $695e66930879143f$var$se_CSVOutput(input.CSV, context).withName("CSV");
        bodyNode.addChildNode(node);
    }
    if (input.JSON != null) {
        const node = $695e66930879143f$var$se_JSONOutput(input.JSON, context).withName("JSON");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Owner = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Owner");
    if (input.DisplayName != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("DisplayName", input.DisplayName).withName("DisplayName");
        bodyNode.addChildNode(node);
    }
    if (input.ID != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ID", input.ID).withName("ID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_OwnershipControls = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("OwnershipControls");
    if (input.Rules != null) {
        const nodes = $695e66930879143f$var$se_OwnershipControlsRules(input.Rules, context);
        nodes.map((node)=>{
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_OwnershipControlsRule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("OwnershipControlsRule");
    if (input.ObjectOwnership != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectOwnership", input.ObjectOwnership).withName("ObjectOwnership");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_OwnershipControlsRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_OwnershipControlsRule(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_ParquetInput = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ParquetInput");
    return bodyNode;
};
const $695e66930879143f$var$se_PublicAccessBlockConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("PublicAccessBlockConfiguration");
    if (input.BlockPublicAcls != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Setting", String(input.BlockPublicAcls)).withName("BlockPublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.IgnorePublicAcls != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Setting", String(input.IgnorePublicAcls)).withName("IgnorePublicAcls");
        bodyNode.addChildNode(node);
    }
    if (input.BlockPublicPolicy != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Setting", String(input.BlockPublicPolicy)).withName("BlockPublicPolicy");
        bodyNode.addChildNode(node);
    }
    if (input.RestrictPublicBuckets != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Setting", String(input.RestrictPublicBuckets)).withName("RestrictPublicBuckets");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_QueueConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("QueueConfiguration");
    if (input.Id != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("NotificationId", input.Id).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.QueueArn != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("QueueArn", input.QueueArn).withName("Queue");
        bodyNode.addChildNode(node);
    }
    if (input.Events != null) {
        const nodes = $695e66930879143f$var$se_EventList(input.Events, context);
        nodes.map((node)=>{
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_NotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_QueueConfigurationList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_QueueConfiguration(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_Redirect = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Redirect");
    if (input.HostName != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("HostName", input.HostName).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.HttpRedirectCode != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("HttpRedirectCode", input.HttpRedirectCode).withName("HttpRedirectCode");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Protocol", input.Protocol).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyPrefixWith != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ReplaceKeyPrefixWith", input.ReplaceKeyPrefixWith).withName("ReplaceKeyPrefixWith");
        bodyNode.addChildNode(node);
    }
    if (input.ReplaceKeyWith != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ReplaceKeyWith", input.ReplaceKeyWith).withName("ReplaceKeyWith");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_RedirectAllRequestsTo = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("RedirectAllRequestsTo");
    if (input.HostName != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("HostName", input.HostName).withName("HostName");
        bodyNode.addChildNode(node);
    }
    if (input.Protocol != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Protocol", input.Protocol).withName("Protocol");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ReplicaModifications = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ReplicaModifications");
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ReplicaModificationsStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ReplicationConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ReplicationConfiguration");
    if (input.Role != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Role", input.Role).withName("Role");
        bodyNode.addChildNode(node);
    }
    if (input.Rules != null) {
        const nodes = $695e66930879143f$var$se_ReplicationRules(input.Rules, context);
        nodes.map((node)=>{
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ReplicationRule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ReplicationRule");
    if (input.ID != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ID", input.ID).withName("ID");
        bodyNode.addChildNode(node);
    }
    if (input.Priority != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Priority", String(input.Priority)).withName("Priority");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_ReplicationRuleFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ReplicationRuleStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.SourceSelectionCriteria != null) {
        const node = $695e66930879143f$var$se_SourceSelectionCriteria(input.SourceSelectionCriteria, context).withName("SourceSelectionCriteria");
        bodyNode.addChildNode(node);
    }
    if (input.ExistingObjectReplication != null) {
        const node = $695e66930879143f$var$se_ExistingObjectReplication(input.ExistingObjectReplication, context).withName("ExistingObjectReplication");
        bodyNode.addChildNode(node);
    }
    if (input.Destination != null) {
        const node = $695e66930879143f$var$se_Destination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    if (input.DeleteMarkerReplication != null) {
        const node = $695e66930879143f$var$se_DeleteMarkerReplication(input.DeleteMarkerReplication, context).withName("DeleteMarkerReplication");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ReplicationRuleAndOperator = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ReplicationRuleAndOperator");
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Tags != null) {
        const nodes = $695e66930879143f$var$se_TagSet(input.Tags, context);
        nodes.map((node)=>{
            node = node.withName("Tag");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ReplicationRuleFilter = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ReplicationRuleFilter");
    (0, $581888fd928d8ba4$export$c5652b893758d9eb).visit(input, {
        Prefix: (value)=>{
            const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Prefix", value).withName("Prefix");
            bodyNode.addChildNode(node);
        },
        Tag: (value)=>{
            const node = $695e66930879143f$var$se_Tag(value, context).withName("Tag");
            bodyNode.addChildNode(node);
        },
        And: (value)=>{
            const node = $695e66930879143f$var$se_ReplicationRuleAndOperator(value, context).withName("And");
            bodyNode.addChildNode(node);
        },
        _: (name, value)=>{
            if (!(value instanceof (0, $e5feeac9197fd5d3$export$e775a15d806cbddc) || value instanceof (0, $74950727763df02e$export$b35b8f45887823df))) throw new Error("Unable to serialize unknown union members in XML.");
            bodyNode.addChildNode(new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)(name).addChildNode(value));
        }
    });
    return bodyNode;
};
const $695e66930879143f$var$se_ReplicationRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_ReplicationRule(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_ReplicationTime = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ReplicationTime");
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ReplicationTimeStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    if (input.Time != null) {
        const node = $695e66930879143f$var$se_ReplicationTimeValue(input.Time, context).withName("Time");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ReplicationTimeValue = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ReplicationTimeValue");
    if (input.Minutes != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Minutes", String(input.Minutes)).withName("Minutes");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_RequestPaymentConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("RequestPaymentConfiguration");
    if (input.Payer != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Payer", input.Payer).withName("Payer");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_RequestProgress = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("RequestProgress");
    if (input.Enabled != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("EnableRequestProgress", String(input.Enabled)).withName("Enabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_RestoreRequest = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("RestoreRequest");
    if (input.Days != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Days", String(input.Days)).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.GlacierJobParameters != null) {
        const node = $695e66930879143f$var$se_GlacierJobParameters(input.GlacierJobParameters, context).withName("GlacierJobParameters");
        bodyNode.addChildNode(node);
    }
    if (input.Type != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("RestoreRequestType", input.Type).withName("Type");
        bodyNode.addChildNode(node);
    }
    if (input.Tier != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Tier", input.Tier).withName("Tier");
        bodyNode.addChildNode(node);
    }
    if (input.Description != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Description", input.Description).withName("Description");
        bodyNode.addChildNode(node);
    }
    if (input.SelectParameters != null) {
        const node = $695e66930879143f$var$se_SelectParameters(input.SelectParameters, context).withName("SelectParameters");
        bodyNode.addChildNode(node);
    }
    if (input.OutputLocation != null) {
        const node = $695e66930879143f$var$se_OutputLocation(input.OutputLocation, context).withName("OutputLocation");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_RoutingRule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("RoutingRule");
    if (input.Condition != null) {
        const node = $695e66930879143f$var$se_Condition(input.Condition, context).withName("Condition");
        bodyNode.addChildNode(node);
    }
    if (input.Redirect != null) {
        const node = $695e66930879143f$var$se_Redirect(input.Redirect, context).withName("Redirect");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_RoutingRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_RoutingRule(entry, context);
        return node.withName("RoutingRule");
    });
};
const $695e66930879143f$var$se_S3KeyFilter = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("S3KeyFilter");
    if (input.FilterRules != null) {
        const nodes = $695e66930879143f$var$se_FilterRuleList(input.FilterRules, context);
        nodes.map((node)=>{
            node = node.withName("FilterRule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_S3Location = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("S3Location");
    if (input.BucketName != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketName", input.BucketName).withName("BucketName");
        bodyNode.addChildNode(node);
    }
    if (input.Prefix != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("LocationPrefix", input.Prefix).withName("Prefix");
        bodyNode.addChildNode(node);
    }
    if (input.Encryption != null) {
        const node = $695e66930879143f$var$se_Encryption(input.Encryption, context).withName("Encryption");
        bodyNode.addChildNode(node);
    }
    if (input.CannedACL != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectCannedACL", input.CannedACL).withName("CannedACL");
        bodyNode.addChildNode(node);
    }
    if (input.AccessControlList != null) {
        const nodes = $695e66930879143f$var$se_Grants(input.AccessControlList, context);
        const containerNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("AccessControlList");
        nodes.map((node)=>{
            containerNode.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode);
    }
    if (input.Tagging != null) {
        const node = $695e66930879143f$var$se_Tagging(input.Tagging, context).withName("Tagging");
        bodyNode.addChildNode(node);
    }
    if (input.UserMetadata != null) {
        const nodes = $695e66930879143f$var$se_UserMetadata(input.UserMetadata, context);
        const containerNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("UserMetadata");
        nodes.map((node)=>{
            containerNode.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode);
    }
    if (input.StorageClass != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("StorageClass", input.StorageClass).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ScanRange = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ScanRange");
    if (input.Start != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Start", String(input.Start)).withName("Start");
        bodyNode.addChildNode(node);
    }
    if (input.End != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("End", String(input.End)).withName("End");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_SelectParameters = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("SelectParameters");
    if (input.InputSerialization != null) {
        const node = $695e66930879143f$var$se_InputSerialization(input.InputSerialization, context).withName("InputSerialization");
        bodyNode.addChildNode(node);
    }
    if (input.ExpressionType != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ExpressionType", input.ExpressionType).withName("ExpressionType");
        bodyNode.addChildNode(node);
    }
    if (input.Expression != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Expression", input.Expression).withName("Expression");
        bodyNode.addChildNode(node);
    }
    if (input.OutputSerialization != null) {
        const node = $695e66930879143f$var$se_OutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ServerSideEncryptionByDefault = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ServerSideEncryptionByDefault");
    if (input.SSEAlgorithm != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ServerSideEncryption", input.SSEAlgorithm).withName("SSEAlgorithm");
        bodyNode.addChildNode(node);
    }
    if (input.KMSMasterKeyID != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("SSEKMSKeyId", input.KMSMasterKeyID).withName("KMSMasterKeyID");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ServerSideEncryptionConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ServerSideEncryptionConfiguration");
    if (input.Rules != null) {
        const nodes = $695e66930879143f$var$se_ServerSideEncryptionRules(input.Rules, context);
        nodes.map((node)=>{
            node = node.withName("Rule");
            bodyNode.addChildNode(node);
        });
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ServerSideEncryptionRule = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("ServerSideEncryptionRule");
    if (input.ApplyServerSideEncryptionByDefault != null) {
        const node = $695e66930879143f$var$se_ServerSideEncryptionByDefault(input.ApplyServerSideEncryptionByDefault, context).withName("ApplyServerSideEncryptionByDefault");
        bodyNode.addChildNode(node);
    }
    if (input.BucketKeyEnabled != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketKeyEnabled", String(input.BucketKeyEnabled)).withName("BucketKeyEnabled");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_ServerSideEncryptionRules = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_ServerSideEncryptionRule(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_SourceSelectionCriteria = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("SourceSelectionCriteria");
    if (input.SseKmsEncryptedObjects != null) {
        const node = $695e66930879143f$var$se_SseKmsEncryptedObjects(input.SseKmsEncryptedObjects, context).withName("SseKmsEncryptedObjects");
        bodyNode.addChildNode(node);
    }
    if (input.ReplicaModifications != null) {
        const node = $695e66930879143f$var$se_ReplicaModifications(input.ReplicaModifications, context).withName("ReplicaModifications");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_SSEKMS = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("SSE-KMS");
    if (input.KeyId != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("SSEKMSKeyId", input.KeyId).withName("KeyId");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_SseKmsEncryptedObjects = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("SseKmsEncryptedObjects");
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("SseKmsEncryptedObjectsStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_SSES3 = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("SSE-S3");
    return bodyNode;
};
const $695e66930879143f$var$se_StorageClassAnalysis = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("StorageClassAnalysis");
    if (input.DataExport != null) {
        const node = $695e66930879143f$var$se_StorageClassAnalysisDataExport(input.DataExport, context).withName("DataExport");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_StorageClassAnalysisDataExport = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("StorageClassAnalysisDataExport");
    if (input.OutputSchemaVersion != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("StorageClassAnalysisSchemaVersion", input.OutputSchemaVersion).withName("OutputSchemaVersion");
        bodyNode.addChildNode(node);
    }
    if (input.Destination != null) {
        const node = $695e66930879143f$var$se_AnalyticsExportDestination(input.Destination, context).withName("Destination");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Tag = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Tag");
    if (input.Key != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("ObjectKey", input.Key).withName("Key");
        bodyNode.addChildNode(node);
    }
    if (input.Value != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Value", input.Value).withName("Value");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_Tagging = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Tagging");
    if (input.TagSet != null) {
        const nodes = $695e66930879143f$var$se_TagSet(input.TagSet, context);
        const containerNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("TagSet");
        nodes.map((node)=>{
            containerNode.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_TagSet = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_Tag(entry, context);
        return node.withName("Tag");
    });
};
const $695e66930879143f$var$se_TargetGrant = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("TargetGrant");
    if (input.Grantee != null) {
        const node = $695e66930879143f$var$se_Grantee(input.Grantee, context).withName("Grantee");
        node.addAttribute("xmlns:xsi", "http://www.w3.org/2001/XMLSchema-instance");
        bodyNode.addChildNode(node);
    }
    if (input.Permission != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketLogsPermission", input.Permission).withName("Permission");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_TargetGrants = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_TargetGrant(entry, context);
        return node.withName("Grant");
    });
};
const $695e66930879143f$var$se_Tiering = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Tiering");
    if (input.Days != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("IntelligentTieringDays", String(input.Days)).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.AccessTier != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("IntelligentTieringAccessTier", input.AccessTier).withName("AccessTier");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_TieringList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_Tiering(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_TopicConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("TopicConfiguration");
    if (input.Id != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("NotificationId", input.Id).withName("Id");
        bodyNode.addChildNode(node);
    }
    if (input.TopicArn != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("TopicArn", input.TopicArn).withName("Topic");
        bodyNode.addChildNode(node);
    }
    if (input.Events != null) {
        const nodes = $695e66930879143f$var$se_EventList(input.Events, context);
        nodes.map((node)=>{
            node = node.withName("Event");
            bodyNode.addChildNode(node);
        });
    }
    if (input.Filter != null) {
        const node = $695e66930879143f$var$se_NotificationConfigurationFilter(input.Filter, context).withName("Filter");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_TopicConfigurationList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_TopicConfiguration(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_Transition = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("Transition");
    if (input.Date != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Date", (input.Date.toISOString().split(".")[0] + "Z").toString()).withName("Date");
        bodyNode.addChildNode(node);
    }
    if (input.Days != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("Days", String(input.Days)).withName("Days");
        bodyNode.addChildNode(node);
    }
    if (input.StorageClass != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("TransitionStorageClass", input.StorageClass).withName("StorageClass");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_TransitionList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_Transition(entry, context);
        return node.withName("member");
    });
};
const $695e66930879143f$var$se_UserMetadata = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        const node = $695e66930879143f$var$se_MetadataEntry(entry, context);
        return node.withName("MetadataEntry");
    });
};
const $695e66930879143f$var$se_VersioningConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("VersioningConfiguration");
    if (input.MFADelete != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("MFADelete", input.MFADelete).withName("MfaDelete");
        bodyNode.addChildNode(node);
    }
    if (input.Status != null) {
        const node = (0, $e5feeac9197fd5d3$export$e775a15d806cbddc).of("BucketVersioningStatus", input.Status).withName("Status");
        bodyNode.addChildNode(node);
    }
    return bodyNode;
};
const $695e66930879143f$var$se_WebsiteConfiguration = (input, context)=>{
    const bodyNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("WebsiteConfiguration");
    if (input.ErrorDocument != null) {
        const node = $695e66930879143f$var$se_ErrorDocument(input.ErrorDocument, context).withName("ErrorDocument");
        bodyNode.addChildNode(node);
    }
    if (input.IndexDocument != null) {
        const node = $695e66930879143f$var$se_IndexDocument(input.IndexDocument, context).withName("IndexDocument");
        bodyNode.addChildNode(node);
    }
    if (input.RedirectAllRequestsTo != null) {
        const node = $695e66930879143f$var$se_RedirectAllRequestsTo(input.RedirectAllRequestsTo, context).withName("RedirectAllRequestsTo");
        bodyNode.addChildNode(node);
    }
    if (input.RoutingRules != null) {
        const nodes = $695e66930879143f$var$se_RoutingRules(input.RoutingRules, context);
        const containerNode = new (0, $e5feeac9197fd5d3$export$e775a15d806cbddc)("RoutingRules");
        nodes.map((node)=>{
            containerNode.addChildNode(node);
        });
        bodyNode.addChildNode(containerNode);
    }
    return bodyNode;
};
const $695e66930879143f$var$de_AbortIncompleteMultipartUpload = (output, context)=>{
    const contents = {};
    if (output["DaysAfterInitiation"] !== undefined) contents.DaysAfterInitiation = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["DaysAfterInitiation"]);
    return contents;
};
const $695e66930879143f$var$de_AccessControlTranslation = (output, context)=>{
    const contents = {};
    if (output["Owner"] !== undefined) contents.Owner = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Owner"]);
    return contents;
};
const $695e66930879143f$var$de_AllowedHeaders = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $f10fb2b359b91940$export$7ed80f53fe336639)(entry);
    });
};
const $695e66930879143f$var$de_AllowedMethods = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $f10fb2b359b91940$export$7ed80f53fe336639)(entry);
    });
};
const $695e66930879143f$var$de_AllowedOrigins = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $f10fb2b359b91940$export$7ed80f53fe336639)(entry);
    });
};
const $695e66930879143f$var$de_AnalyticsAndOperator = (output, context)=>{
    const contents = {};
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output.Tag === "") contents.Tags = [];
    else if (output["Tag"] !== undefined) contents.Tags = $695e66930879143f$var$de_TagSet((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
const $695e66930879143f$var$de_AnalyticsConfiguration = (output, context)=>{
    const contents = {};
    if (output["Id"] !== undefined) contents.Id = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Id"]);
    if (output.Filter === "") ;
    else if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_AnalyticsFilter((0, $f10fb2b359b91940$export$9ef77073e45b6301)(output["Filter"]), context);
    if (output["StorageClassAnalysis"] !== undefined) contents.StorageClassAnalysis = $695e66930879143f$var$de_StorageClassAnalysis(output["StorageClassAnalysis"], context);
    return contents;
};
const $695e66930879143f$var$de_AnalyticsConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_AnalyticsConfiguration(entry, context);
    });
};
const $695e66930879143f$var$de_AnalyticsExportDestination = (output, context)=>{
    const contents = {};
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $695e66930879143f$var$de_AnalyticsS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
const $695e66930879143f$var$de_AnalyticsFilter = (output, context)=>{
    if (output["Prefix"] !== undefined) return {
        Prefix: (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"])
    };
    if (output["Tag"] !== undefined) return {
        Tag: $695e66930879143f$var$de_Tag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $695e66930879143f$var$de_AnalyticsAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $695e66930879143f$var$de_AnalyticsS3BucketDestination = (output, context)=>{
    const contents = {};
    if (output["Format"] !== undefined) contents.Format = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Format"]);
    if (output["BucketAccountId"] !== undefined) contents.BucketAccountId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["BucketAccountId"]);
    if (output["Bucket"] !== undefined) contents.Bucket = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Bucket"]);
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    return contents;
};
const $695e66930879143f$var$de_Bucket = (output, context)=>{
    const contents = {};
    if (output["Name"] !== undefined) contents.Name = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Name"]);
    if (output["CreationDate"] !== undefined) contents.CreationDate = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["CreationDate"]));
    return contents;
};
const $695e66930879143f$var$de_Buckets = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_Bucket(entry, context);
    });
};
const $695e66930879143f$var$de_Checksum = (output, context)=>{
    const contents = {};
    if (output["ChecksumCRC32"] !== undefined) contents.ChecksumCRC32 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32"]);
    if (output["ChecksumCRC32C"] !== undefined) contents.ChecksumCRC32C = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32C"]);
    if (output["ChecksumSHA1"] !== undefined) contents.ChecksumSHA1 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA1"]);
    if (output["ChecksumSHA256"] !== undefined) contents.ChecksumSHA256 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA256"]);
    return contents;
};
const $695e66930879143f$var$de_ChecksumAlgorithmList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $f10fb2b359b91940$export$7ed80f53fe336639)(entry);
    });
};
const $695e66930879143f$var$de_CommonPrefix = (output, context)=>{
    const contents = {};
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    return contents;
};
const $695e66930879143f$var$de_CommonPrefixList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_CommonPrefix(entry, context);
    });
};
const $695e66930879143f$var$de_Condition = (output, context)=>{
    const contents = {};
    if (output["HttpErrorCodeReturnedEquals"] !== undefined) contents.HttpErrorCodeReturnedEquals = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["HttpErrorCodeReturnedEquals"]);
    if (output["KeyPrefixEquals"] !== undefined) contents.KeyPrefixEquals = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["KeyPrefixEquals"]);
    return contents;
};
const $695e66930879143f$var$de_ContinuationEvent = (output, context)=>{
    const contents = {};
    return contents;
};
const $695e66930879143f$var$de_CopyObjectResult = (output, context)=>{
    const contents = {};
    if (output["ETag"] !== undefined) contents.ETag = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ETag"]);
    if (output["LastModified"] !== undefined) contents.LastModified = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["LastModified"]));
    if (output["ChecksumCRC32"] !== undefined) contents.ChecksumCRC32 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32"]);
    if (output["ChecksumCRC32C"] !== undefined) contents.ChecksumCRC32C = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32C"]);
    if (output["ChecksumSHA1"] !== undefined) contents.ChecksumSHA1 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA1"]);
    if (output["ChecksumSHA256"] !== undefined) contents.ChecksumSHA256 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA256"]);
    return contents;
};
const $695e66930879143f$var$de_CopyPartResult = (output, context)=>{
    const contents = {};
    if (output["ETag"] !== undefined) contents.ETag = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ETag"]);
    if (output["LastModified"] !== undefined) contents.LastModified = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["LastModified"]));
    if (output["ChecksumCRC32"] !== undefined) contents.ChecksumCRC32 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32"]);
    if (output["ChecksumCRC32C"] !== undefined) contents.ChecksumCRC32C = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32C"]);
    if (output["ChecksumSHA1"] !== undefined) contents.ChecksumSHA1 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA1"]);
    if (output["ChecksumSHA256"] !== undefined) contents.ChecksumSHA256 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA256"]);
    return contents;
};
const $695e66930879143f$var$de_CORSRule = (output, context)=>{
    const contents = {};
    if (output["ID"] !== undefined) contents.ID = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ID"]);
    if (output.AllowedHeader === "") contents.AllowedHeaders = [];
    else if (output["AllowedHeader"] !== undefined) contents.AllowedHeaders = $695e66930879143f$var$de_AllowedHeaders((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["AllowedHeader"]), context);
    if (output.AllowedMethod === "") contents.AllowedMethods = [];
    else if (output["AllowedMethod"] !== undefined) contents.AllowedMethods = $695e66930879143f$var$de_AllowedMethods((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["AllowedMethod"]), context);
    if (output.AllowedOrigin === "") contents.AllowedOrigins = [];
    else if (output["AllowedOrigin"] !== undefined) contents.AllowedOrigins = $695e66930879143f$var$de_AllowedOrigins((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["AllowedOrigin"]), context);
    if (output.ExposeHeader === "") contents.ExposeHeaders = [];
    else if (output["ExposeHeader"] !== undefined) contents.ExposeHeaders = $695e66930879143f$var$de_ExposeHeaders((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["ExposeHeader"]), context);
    if (output["MaxAgeSeconds"] !== undefined) contents.MaxAgeSeconds = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["MaxAgeSeconds"]);
    return contents;
};
const $695e66930879143f$var$de_CORSRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_CORSRule(entry, context);
    });
};
const $695e66930879143f$var$de_DefaultRetention = (output, context)=>{
    const contents = {};
    if (output["Mode"] !== undefined) contents.Mode = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Mode"]);
    if (output["Days"] !== undefined) contents.Days = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["Days"]);
    if (output["Years"] !== undefined) contents.Years = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["Years"]);
    return contents;
};
const $695e66930879143f$var$de_DeletedObject = (output, context)=>{
    const contents = {};
    if (output["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Key"]);
    if (output["VersionId"] !== undefined) contents.VersionId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["VersionId"]);
    if (output["DeleteMarker"] !== undefined) contents.DeleteMarker = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["DeleteMarker"]);
    if (output["DeleteMarkerVersionId"] !== undefined) contents.DeleteMarkerVersionId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["DeleteMarkerVersionId"]);
    return contents;
};
const $695e66930879143f$var$de_DeletedObjects = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_DeletedObject(entry, context);
    });
};
const $695e66930879143f$var$de_DeleteMarkerEntry = (output, context)=>{
    const contents = {};
    if (output["Owner"] !== undefined) contents.Owner = $695e66930879143f$var$de_Owner(output["Owner"], context);
    if (output["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Key"]);
    if (output["VersionId"] !== undefined) contents.VersionId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["VersionId"]);
    if (output["IsLatest"] !== undefined) contents.IsLatest = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["IsLatest"]);
    if (output["LastModified"] !== undefined) contents.LastModified = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["LastModified"]));
    return contents;
};
const $695e66930879143f$var$de_DeleteMarkerReplication = (output, context)=>{
    const contents = {};
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    return contents;
};
const $695e66930879143f$var$de_DeleteMarkers = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_DeleteMarkerEntry(entry, context);
    });
};
const $695e66930879143f$var$de_Destination = (output, context)=>{
    const contents = {};
    if (output["Bucket"] !== undefined) contents.Bucket = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Bucket"]);
    if (output["Account"] !== undefined) contents.Account = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Account"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["StorageClass"]);
    if (output["AccessControlTranslation"] !== undefined) contents.AccessControlTranslation = $695e66930879143f$var$de_AccessControlTranslation(output["AccessControlTranslation"], context);
    if (output["EncryptionConfiguration"] !== undefined) contents.EncryptionConfiguration = $695e66930879143f$var$de_EncryptionConfiguration(output["EncryptionConfiguration"], context);
    if (output["ReplicationTime"] !== undefined) contents.ReplicationTime = $695e66930879143f$var$de_ReplicationTime(output["ReplicationTime"], context);
    if (output["Metrics"] !== undefined) contents.Metrics = $695e66930879143f$var$de_Metrics(output["Metrics"], context);
    return contents;
};
const $695e66930879143f$var$de_EncryptionConfiguration = (output, context)=>{
    const contents = {};
    if (output["ReplicaKmsKeyID"] !== undefined) contents.ReplicaKmsKeyID = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ReplicaKmsKeyID"]);
    return contents;
};
const $695e66930879143f$var$de_EndEvent = (output, context)=>{
    const contents = {};
    return contents;
};
const $695e66930879143f$var$de__Error = (output, context)=>{
    const contents = {};
    if (output["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Key"]);
    if (output["VersionId"] !== undefined) contents.VersionId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["VersionId"]);
    if (output["Code"] !== undefined) contents.Code = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Code"]);
    if (output["Message"] !== undefined) contents.Message = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Message"]);
    return contents;
};
const $695e66930879143f$var$de_ErrorDocument = (output, context)=>{
    const contents = {};
    if (output["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Key"]);
    return contents;
};
const $695e66930879143f$var$de_Errors = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de__Error(entry, context);
    });
};
const $695e66930879143f$var$de_EventBridgeConfiguration = (output, context)=>{
    const contents = {};
    return contents;
};
const $695e66930879143f$var$de_EventList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $f10fb2b359b91940$export$7ed80f53fe336639)(entry);
    });
};
const $695e66930879143f$var$de_ExistingObjectReplication = (output, context)=>{
    const contents = {};
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    return contents;
};
const $695e66930879143f$var$de_ExposeHeaders = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $f10fb2b359b91940$export$7ed80f53fe336639)(entry);
    });
};
const $695e66930879143f$var$de_FilterRule = (output, context)=>{
    const contents = {};
    if (output["Name"] !== undefined) contents.Name = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Name"]);
    if (output["Value"] !== undefined) contents.Value = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Value"]);
    return contents;
};
const $695e66930879143f$var$de_FilterRuleList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_FilterRule(entry, context);
    });
};
const $695e66930879143f$var$de_GetObjectAttributesParts = (output, context)=>{
    const contents = {};
    if (output["PartsCount"] !== undefined) contents.TotalPartsCount = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["PartsCount"]);
    if (output["PartNumberMarker"] !== undefined) contents.PartNumberMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["PartNumberMarker"]);
    if (output["NextPartNumberMarker"] !== undefined) contents.NextPartNumberMarker = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["NextPartNumberMarker"]);
    if (output["MaxParts"] !== undefined) contents.MaxParts = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["MaxParts"]);
    if (output["IsTruncated"] !== undefined) contents.IsTruncated = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["IsTruncated"]);
    if (output.Part === "") contents.Parts = [];
    else if (output["Part"] !== undefined) contents.Parts = $695e66930879143f$var$de_PartsList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Part"]), context);
    return contents;
};
const $695e66930879143f$var$de_Grant = (output, context)=>{
    const contents = {};
    if (output["Grantee"] !== undefined) contents.Grantee = $695e66930879143f$var$de_Grantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Permission"]);
    return contents;
};
const $695e66930879143f$var$de_Grantee = (output, context)=>{
    const contents = {};
    if (output["DisplayName"] !== undefined) contents.DisplayName = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["DisplayName"]);
    if (output["EmailAddress"] !== undefined) contents.EmailAddress = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["EmailAddress"]);
    if (output["ID"] !== undefined) contents.ID = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ID"]);
    if (output["URI"] !== undefined) contents.URI = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["URI"]);
    if (output["xsi:type"] !== undefined) contents.Type = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["xsi:type"]);
    return contents;
};
const $695e66930879143f$var$de_Grants = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_Grant(entry, context);
    });
};
const $695e66930879143f$var$de_IndexDocument = (output, context)=>{
    const contents = {};
    if (output["Suffix"] !== undefined) contents.Suffix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Suffix"]);
    return contents;
};
const $695e66930879143f$var$de_Initiator = (output, context)=>{
    const contents = {};
    if (output["ID"] !== undefined) contents.ID = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ID"]);
    if (output["DisplayName"] !== undefined) contents.DisplayName = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["DisplayName"]);
    return contents;
};
const $695e66930879143f$var$de_IntelligentTieringAndOperator = (output, context)=>{
    const contents = {};
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output.Tag === "") contents.Tags = [];
    else if (output["Tag"] !== undefined) contents.Tags = $695e66930879143f$var$de_TagSet((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
const $695e66930879143f$var$de_IntelligentTieringConfiguration = (output, context)=>{
    const contents = {};
    if (output["Id"] !== undefined) contents.Id = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Id"]);
    if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_IntelligentTieringFilter(output["Filter"], context);
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    if (output.Tiering === "") contents.Tierings = [];
    else if (output["Tiering"] !== undefined) contents.Tierings = $695e66930879143f$var$de_TieringList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Tiering"]), context);
    return contents;
};
const $695e66930879143f$var$de_IntelligentTieringConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_IntelligentTieringConfiguration(entry, context);
    });
};
const $695e66930879143f$var$de_IntelligentTieringFilter = (output, context)=>{
    const contents = {};
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output["Tag"] !== undefined) contents.Tag = $695e66930879143f$var$de_Tag(output["Tag"], context);
    if (output["And"] !== undefined) contents.And = $695e66930879143f$var$de_IntelligentTieringAndOperator(output["And"], context);
    return contents;
};
const $695e66930879143f$var$de_InventoryConfiguration = (output, context)=>{
    const contents = {};
    if (output["Destination"] !== undefined) contents.Destination = $695e66930879143f$var$de_InventoryDestination(output["Destination"], context);
    if (output["IsEnabled"] !== undefined) contents.IsEnabled = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["IsEnabled"]);
    if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_InventoryFilter(output["Filter"], context);
    if (output["Id"] !== undefined) contents.Id = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Id"]);
    if (output["IncludedObjectVersions"] !== undefined) contents.IncludedObjectVersions = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["IncludedObjectVersions"]);
    if (output.OptionalFields === "") contents.OptionalFields = [];
    else if (output["OptionalFields"] !== undefined && output["OptionalFields"]["Field"] !== undefined) contents.OptionalFields = $695e66930879143f$var$de_InventoryOptionalFields((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["OptionalFields"]["Field"]), context);
    if (output["Schedule"] !== undefined) contents.Schedule = $695e66930879143f$var$de_InventorySchedule(output["Schedule"], context);
    return contents;
};
const $695e66930879143f$var$de_InventoryConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_InventoryConfiguration(entry, context);
    });
};
const $695e66930879143f$var$de_InventoryDestination = (output, context)=>{
    const contents = {};
    if (output["S3BucketDestination"] !== undefined) contents.S3BucketDestination = $695e66930879143f$var$de_InventoryS3BucketDestination(output["S3BucketDestination"], context);
    return contents;
};
const $695e66930879143f$var$de_InventoryEncryption = (output, context)=>{
    const contents = {};
    if (output["SSE-S3"] !== undefined) contents.SSES3 = $695e66930879143f$var$de_SSES3(output["SSE-S3"], context);
    if (output["SSE-KMS"] !== undefined) contents.SSEKMS = $695e66930879143f$var$de_SSEKMS(output["SSE-KMS"], context);
    return contents;
};
const $695e66930879143f$var$de_InventoryFilter = (output, context)=>{
    const contents = {};
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    return contents;
};
const $695e66930879143f$var$de_InventoryOptionalFields = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $f10fb2b359b91940$export$7ed80f53fe336639)(entry);
    });
};
const $695e66930879143f$var$de_InventoryS3BucketDestination = (output, context)=>{
    const contents = {};
    if (output["AccountId"] !== undefined) contents.AccountId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["AccountId"]);
    if (output["Bucket"] !== undefined) contents.Bucket = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Bucket"]);
    if (output["Format"] !== undefined) contents.Format = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Format"]);
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output["Encryption"] !== undefined) contents.Encryption = $695e66930879143f$var$de_InventoryEncryption(output["Encryption"], context);
    return contents;
};
const $695e66930879143f$var$de_InventorySchedule = (output, context)=>{
    const contents = {};
    if (output["Frequency"] !== undefined) contents.Frequency = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Frequency"]);
    return contents;
};
const $695e66930879143f$var$de_LambdaFunctionConfiguration = (output, context)=>{
    const contents = {};
    if (output["Id"] !== undefined) contents.Id = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Id"]);
    if (output["CloudFunction"] !== undefined) contents.LambdaFunctionArn = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["CloudFunction"]);
    if (output.Event === "") contents.Events = [];
    else if (output["Event"] !== undefined) contents.Events = $695e66930879143f$var$de_EventList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_NotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
const $695e66930879143f$var$de_LambdaFunctionConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_LambdaFunctionConfiguration(entry, context);
    });
};
const $695e66930879143f$var$de_LifecycleExpiration = (output, context)=>{
    const contents = {};
    if (output["Date"] !== undefined) contents.Date = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["Date"]));
    if (output["Days"] !== undefined) contents.Days = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["Days"]);
    if (output["ExpiredObjectDeleteMarker"] !== undefined) contents.ExpiredObjectDeleteMarker = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["ExpiredObjectDeleteMarker"]);
    return contents;
};
const $695e66930879143f$var$de_LifecycleRule = (output, context)=>{
    const contents = {};
    if (output["Expiration"] !== undefined) contents.Expiration = $695e66930879143f$var$de_LifecycleExpiration(output["Expiration"], context);
    if (output["ID"] !== undefined) contents.ID = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ID"]);
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output.Filter === "") ;
    else if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_LifecycleRuleFilter((0, $f10fb2b359b91940$export$9ef77073e45b6301)(output["Filter"]), context);
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    if (output.Transition === "") contents.Transitions = [];
    else if (output["Transition"] !== undefined) contents.Transitions = $695e66930879143f$var$de_TransitionList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Transition"]), context);
    if (output.NoncurrentVersionTransition === "") contents.NoncurrentVersionTransitions = [];
    else if (output["NoncurrentVersionTransition"] !== undefined) contents.NoncurrentVersionTransitions = $695e66930879143f$var$de_NoncurrentVersionTransitionList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["NoncurrentVersionTransition"]), context);
    if (output["NoncurrentVersionExpiration"] !== undefined) contents.NoncurrentVersionExpiration = $695e66930879143f$var$de_NoncurrentVersionExpiration(output["NoncurrentVersionExpiration"], context);
    if (output["AbortIncompleteMultipartUpload"] !== undefined) contents.AbortIncompleteMultipartUpload = $695e66930879143f$var$de_AbortIncompleteMultipartUpload(output["AbortIncompleteMultipartUpload"], context);
    return contents;
};
const $695e66930879143f$var$de_LifecycleRuleAndOperator = (output, context)=>{
    const contents = {};
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output.Tag === "") contents.Tags = [];
    else if (output["Tag"] !== undefined) contents.Tags = $695e66930879143f$var$de_TagSet((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Tag"]), context);
    if (output["ObjectSizeGreaterThan"] !== undefined) contents.ObjectSizeGreaterThan = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["ObjectSizeGreaterThan"]);
    if (output["ObjectSizeLessThan"] !== undefined) contents.ObjectSizeLessThan = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["ObjectSizeLessThan"]);
    return contents;
};
const $695e66930879143f$var$de_LifecycleRuleFilter = (output, context)=>{
    if (output["Prefix"] !== undefined) return {
        Prefix: (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"])
    };
    if (output["Tag"] !== undefined) return {
        Tag: $695e66930879143f$var$de_Tag(output["Tag"], context)
    };
    if (output["ObjectSizeGreaterThan"] !== undefined) return {
        ObjectSizeGreaterThan: (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["ObjectSizeGreaterThan"])
    };
    if (output["ObjectSizeLessThan"] !== undefined) return {
        ObjectSizeLessThan: (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["ObjectSizeLessThan"])
    };
    if (output["And"] !== undefined) return {
        And: $695e66930879143f$var$de_LifecycleRuleAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $695e66930879143f$var$de_LifecycleRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_LifecycleRule(entry, context);
    });
};
const $695e66930879143f$var$de_LoggingEnabled = (output, context)=>{
    const contents = {};
    if (output["TargetBucket"] !== undefined) contents.TargetBucket = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["TargetBucket"]);
    if (output.TargetGrants === "") contents.TargetGrants = [];
    else if (output["TargetGrants"] !== undefined && output["TargetGrants"]["Grant"] !== undefined) contents.TargetGrants = $695e66930879143f$var$de_TargetGrants((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["TargetGrants"]["Grant"]), context);
    if (output["TargetPrefix"] !== undefined) contents.TargetPrefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["TargetPrefix"]);
    return contents;
};
const $695e66930879143f$var$de_Metrics = (output, context)=>{
    const contents = {};
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    if (output["EventThreshold"] !== undefined) contents.EventThreshold = $695e66930879143f$var$de_ReplicationTimeValue(output["EventThreshold"], context);
    return contents;
};
const $695e66930879143f$var$de_MetricsAndOperator = (output, context)=>{
    const contents = {};
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output.Tag === "") contents.Tags = [];
    else if (output["Tag"] !== undefined) contents.Tags = $695e66930879143f$var$de_TagSet((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Tag"]), context);
    if (output["AccessPointArn"] !== undefined) contents.AccessPointArn = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["AccessPointArn"]);
    return contents;
};
const $695e66930879143f$var$de_MetricsConfiguration = (output, context)=>{
    const contents = {};
    if (output["Id"] !== undefined) contents.Id = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Id"]);
    if (output.Filter === "") ;
    else if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_MetricsFilter((0, $f10fb2b359b91940$export$9ef77073e45b6301)(output["Filter"]), context);
    return contents;
};
const $695e66930879143f$var$de_MetricsConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_MetricsConfiguration(entry, context);
    });
};
const $695e66930879143f$var$de_MetricsFilter = (output, context)=>{
    if (output["Prefix"] !== undefined) return {
        Prefix: (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"])
    };
    if (output["Tag"] !== undefined) return {
        Tag: $695e66930879143f$var$de_Tag(output["Tag"], context)
    };
    if (output["AccessPointArn"] !== undefined) return {
        AccessPointArn: (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["AccessPointArn"])
    };
    if (output["And"] !== undefined) return {
        And: $695e66930879143f$var$de_MetricsAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $695e66930879143f$var$de_MultipartUpload = (output, context)=>{
    const contents = {};
    if (output["UploadId"] !== undefined) contents.UploadId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["UploadId"]);
    if (output["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Key"]);
    if (output["Initiated"] !== undefined) contents.Initiated = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["Initiated"]));
    if (output["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["StorageClass"]);
    if (output["Owner"] !== undefined) contents.Owner = $695e66930879143f$var$de_Owner(output["Owner"], context);
    if (output["Initiator"] !== undefined) contents.Initiator = $695e66930879143f$var$de_Initiator(output["Initiator"], context);
    if (output["ChecksumAlgorithm"] !== undefined) contents.ChecksumAlgorithm = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumAlgorithm"]);
    return contents;
};
const $695e66930879143f$var$de_MultipartUploadList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_MultipartUpload(entry, context);
    });
};
const $695e66930879143f$var$de_NoncurrentVersionExpiration = (output, context)=>{
    const contents = {};
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["NoncurrentDays"]);
    if (output["NewerNoncurrentVersions"] !== undefined) contents.NewerNoncurrentVersions = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["NewerNoncurrentVersions"]);
    return contents;
};
const $695e66930879143f$var$de_NoncurrentVersionTransition = (output, context)=>{
    const contents = {};
    if (output["NoncurrentDays"] !== undefined) contents.NoncurrentDays = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["NoncurrentDays"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["StorageClass"]);
    if (output["NewerNoncurrentVersions"] !== undefined) contents.NewerNoncurrentVersions = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["NewerNoncurrentVersions"]);
    return contents;
};
const $695e66930879143f$var$de_NoncurrentVersionTransitionList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_NoncurrentVersionTransition(entry, context);
    });
};
const $695e66930879143f$var$de_NotificationConfigurationFilter = (output, context)=>{
    const contents = {};
    if (output["S3Key"] !== undefined) contents.Key = $695e66930879143f$var$de_S3KeyFilter(output["S3Key"], context);
    return contents;
};
const $695e66930879143f$var$de__Object = (output, context)=>{
    const contents = {};
    if (output["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Key"]);
    if (output["LastModified"] !== undefined) contents.LastModified = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["LastModified"]));
    if (output["ETag"] !== undefined) contents.ETag = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ETag"]);
    if (output.ChecksumAlgorithm === "") contents.ChecksumAlgorithm = [];
    else if (output["ChecksumAlgorithm"] !== undefined) contents.ChecksumAlgorithm = $695e66930879143f$var$de_ChecksumAlgorithmList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["ChecksumAlgorithm"]), context);
    if (output["Size"] !== undefined) contents.Size = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["Size"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["StorageClass"]);
    if (output["Owner"] !== undefined) contents.Owner = $695e66930879143f$var$de_Owner(output["Owner"], context);
    if (output["RestoreStatus"] !== undefined) contents.RestoreStatus = $695e66930879143f$var$de_RestoreStatus(output["RestoreStatus"], context);
    return contents;
};
const $695e66930879143f$var$de_ObjectList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de__Object(entry, context);
    });
};
const $695e66930879143f$var$de_ObjectLockConfiguration = (output, context)=>{
    const contents = {};
    if (output["ObjectLockEnabled"] !== undefined) contents.ObjectLockEnabled = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ObjectLockEnabled"]);
    if (output["Rule"] !== undefined) contents.Rule = $695e66930879143f$var$de_ObjectLockRule(output["Rule"], context);
    return contents;
};
const $695e66930879143f$var$de_ObjectLockLegalHold = (output, context)=>{
    const contents = {};
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    return contents;
};
const $695e66930879143f$var$de_ObjectLockRetention = (output, context)=>{
    const contents = {};
    if (output["Mode"] !== undefined) contents.Mode = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Mode"]);
    if (output["RetainUntilDate"] !== undefined) contents.RetainUntilDate = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["RetainUntilDate"]));
    return contents;
};
const $695e66930879143f$var$de_ObjectLockRule = (output, context)=>{
    const contents = {};
    if (output["DefaultRetention"] !== undefined) contents.DefaultRetention = $695e66930879143f$var$de_DefaultRetention(output["DefaultRetention"], context);
    return contents;
};
const $695e66930879143f$var$de_ObjectPart = (output, context)=>{
    const contents = {};
    if (output["PartNumber"] !== undefined) contents.PartNumber = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["PartNumber"]);
    if (output["Size"] !== undefined) contents.Size = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["Size"]);
    if (output["ChecksumCRC32"] !== undefined) contents.ChecksumCRC32 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32"]);
    if (output["ChecksumCRC32C"] !== undefined) contents.ChecksumCRC32C = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32C"]);
    if (output["ChecksumSHA1"] !== undefined) contents.ChecksumSHA1 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA1"]);
    if (output["ChecksumSHA256"] !== undefined) contents.ChecksumSHA256 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA256"]);
    return contents;
};
const $695e66930879143f$var$de_ObjectVersion = (output, context)=>{
    const contents = {};
    if (output["ETag"] !== undefined) contents.ETag = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ETag"]);
    if (output.ChecksumAlgorithm === "") contents.ChecksumAlgorithm = [];
    else if (output["ChecksumAlgorithm"] !== undefined) contents.ChecksumAlgorithm = $695e66930879143f$var$de_ChecksumAlgorithmList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["ChecksumAlgorithm"]), context);
    if (output["Size"] !== undefined) contents.Size = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["Size"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["StorageClass"]);
    if (output["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Key"]);
    if (output["VersionId"] !== undefined) contents.VersionId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["VersionId"]);
    if (output["IsLatest"] !== undefined) contents.IsLatest = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["IsLatest"]);
    if (output["LastModified"] !== undefined) contents.LastModified = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["LastModified"]));
    if (output["Owner"] !== undefined) contents.Owner = $695e66930879143f$var$de_Owner(output["Owner"], context);
    if (output["RestoreStatus"] !== undefined) contents.RestoreStatus = $695e66930879143f$var$de_RestoreStatus(output["RestoreStatus"], context);
    return contents;
};
const $695e66930879143f$var$de_ObjectVersionList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_ObjectVersion(entry, context);
    });
};
const $695e66930879143f$var$de_Owner = (output, context)=>{
    const contents = {};
    if (output["DisplayName"] !== undefined) contents.DisplayName = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["DisplayName"]);
    if (output["ID"] !== undefined) contents.ID = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ID"]);
    return contents;
};
const $695e66930879143f$var$de_OwnershipControls = (output, context)=>{
    const contents = {};
    if (output.Rule === "") contents.Rules = [];
    else if (output["Rule"] !== undefined) contents.Rules = $695e66930879143f$var$de_OwnershipControlsRules((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
const $695e66930879143f$var$de_OwnershipControlsRule = (output, context)=>{
    const contents = {};
    if (output["ObjectOwnership"] !== undefined) contents.ObjectOwnership = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ObjectOwnership"]);
    return contents;
};
const $695e66930879143f$var$de_OwnershipControlsRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_OwnershipControlsRule(entry, context);
    });
};
const $695e66930879143f$var$de_Part = (output, context)=>{
    const contents = {};
    if (output["PartNumber"] !== undefined) contents.PartNumber = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["PartNumber"]);
    if (output["LastModified"] !== undefined) contents.LastModified = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["LastModified"]));
    if (output["ETag"] !== undefined) contents.ETag = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ETag"]);
    if (output["Size"] !== undefined) contents.Size = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["Size"]);
    if (output["ChecksumCRC32"] !== undefined) contents.ChecksumCRC32 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32"]);
    if (output["ChecksumCRC32C"] !== undefined) contents.ChecksumCRC32C = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumCRC32C"]);
    if (output["ChecksumSHA1"] !== undefined) contents.ChecksumSHA1 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA1"]);
    if (output["ChecksumSHA256"] !== undefined) contents.ChecksumSHA256 = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ChecksumSHA256"]);
    return contents;
};
const $695e66930879143f$var$de_Parts = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_Part(entry, context);
    });
};
const $695e66930879143f$var$de_PartsList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_ObjectPart(entry, context);
    });
};
const $695e66930879143f$var$de_PolicyStatus = (output, context)=>{
    const contents = {};
    if (output["IsPublic"] !== undefined) contents.IsPublic = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["IsPublic"]);
    return contents;
};
const $695e66930879143f$var$de_Progress = (output, context)=>{
    const contents = {};
    if (output["BytesScanned"] !== undefined) contents.BytesScanned = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["BytesScanned"]);
    if (output["BytesProcessed"] !== undefined) contents.BytesProcessed = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["BytesProcessed"]);
    if (output["BytesReturned"] !== undefined) contents.BytesReturned = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["BytesReturned"]);
    return contents;
};
const $695e66930879143f$var$de_PublicAccessBlockConfiguration = (output, context)=>{
    const contents = {};
    if (output["BlockPublicAcls"] !== undefined) contents.BlockPublicAcls = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["BlockPublicAcls"]);
    if (output["IgnorePublicAcls"] !== undefined) contents.IgnorePublicAcls = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["IgnorePublicAcls"]);
    if (output["BlockPublicPolicy"] !== undefined) contents.BlockPublicPolicy = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["BlockPublicPolicy"]);
    if (output["RestrictPublicBuckets"] !== undefined) contents.RestrictPublicBuckets = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["RestrictPublicBuckets"]);
    return contents;
};
const $695e66930879143f$var$de_QueueConfiguration = (output, context)=>{
    const contents = {};
    if (output["Id"] !== undefined) contents.Id = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Id"]);
    if (output["Queue"] !== undefined) contents.QueueArn = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Queue"]);
    if (output.Event === "") contents.Events = [];
    else if (output["Event"] !== undefined) contents.Events = $695e66930879143f$var$de_EventList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_NotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
const $695e66930879143f$var$de_QueueConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_QueueConfiguration(entry, context);
    });
};
const $695e66930879143f$var$de_Redirect = (output, context)=>{
    const contents = {};
    if (output["HostName"] !== undefined) contents.HostName = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["HostName"]);
    if (output["HttpRedirectCode"] !== undefined) contents.HttpRedirectCode = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["HttpRedirectCode"]);
    if (output["Protocol"] !== undefined) contents.Protocol = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Protocol"]);
    if (output["ReplaceKeyPrefixWith"] !== undefined) contents.ReplaceKeyPrefixWith = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ReplaceKeyPrefixWith"]);
    if (output["ReplaceKeyWith"] !== undefined) contents.ReplaceKeyWith = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ReplaceKeyWith"]);
    return contents;
};
const $695e66930879143f$var$de_RedirectAllRequestsTo = (output, context)=>{
    const contents = {};
    if (output["HostName"] !== undefined) contents.HostName = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["HostName"]);
    if (output["Protocol"] !== undefined) contents.Protocol = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Protocol"]);
    return contents;
};
const $695e66930879143f$var$de_ReplicaModifications = (output, context)=>{
    const contents = {};
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    return contents;
};
const $695e66930879143f$var$de_ReplicationConfiguration = (output, context)=>{
    const contents = {};
    if (output["Role"] !== undefined) contents.Role = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Role"]);
    if (output.Rule === "") contents.Rules = [];
    else if (output["Rule"] !== undefined) contents.Rules = $695e66930879143f$var$de_ReplicationRules((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
const $695e66930879143f$var$de_ReplicationRule = (output, context)=>{
    const contents = {};
    if (output["ID"] !== undefined) contents.ID = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["ID"]);
    if (output["Priority"] !== undefined) contents.Priority = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["Priority"]);
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output.Filter === "") ;
    else if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_ReplicationRuleFilter((0, $f10fb2b359b91940$export$9ef77073e45b6301)(output["Filter"]), context);
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    if (output["SourceSelectionCriteria"] !== undefined) contents.SourceSelectionCriteria = $695e66930879143f$var$de_SourceSelectionCriteria(output["SourceSelectionCriteria"], context);
    if (output["ExistingObjectReplication"] !== undefined) contents.ExistingObjectReplication = $695e66930879143f$var$de_ExistingObjectReplication(output["ExistingObjectReplication"], context);
    if (output["Destination"] !== undefined) contents.Destination = $695e66930879143f$var$de_Destination(output["Destination"], context);
    if (output["DeleteMarkerReplication"] !== undefined) contents.DeleteMarkerReplication = $695e66930879143f$var$de_DeleteMarkerReplication(output["DeleteMarkerReplication"], context);
    return contents;
};
const $695e66930879143f$var$de_ReplicationRuleAndOperator = (output, context)=>{
    const contents = {};
    if (output["Prefix"] !== undefined) contents.Prefix = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"]);
    if (output.Tag === "") contents.Tags = [];
    else if (output["Tag"] !== undefined) contents.Tags = $695e66930879143f$var$de_TagSet((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Tag"]), context);
    return contents;
};
const $695e66930879143f$var$de_ReplicationRuleFilter = (output, context)=>{
    if (output["Prefix"] !== undefined) return {
        Prefix: (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Prefix"])
    };
    if (output["Tag"] !== undefined) return {
        Tag: $695e66930879143f$var$de_Tag(output["Tag"], context)
    };
    if (output["And"] !== undefined) return {
        And: $695e66930879143f$var$de_ReplicationRuleAndOperator(output["And"], context)
    };
    return {
        $unknown: Object.entries(output)[0]
    };
};
const $695e66930879143f$var$de_ReplicationRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_ReplicationRule(entry, context);
    });
};
const $695e66930879143f$var$de_ReplicationTime = (output, context)=>{
    const contents = {};
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    if (output["Time"] !== undefined) contents.Time = $695e66930879143f$var$de_ReplicationTimeValue(output["Time"], context);
    return contents;
};
const $695e66930879143f$var$de_ReplicationTimeValue = (output, context)=>{
    const contents = {};
    if (output["Minutes"] !== undefined) contents.Minutes = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["Minutes"]);
    return contents;
};
const $695e66930879143f$var$de_RestoreStatus = (output, context)=>{
    const contents = {};
    if (output["IsRestoreInProgress"] !== undefined) contents.IsRestoreInProgress = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["IsRestoreInProgress"]);
    if (output["RestoreExpiryDate"] !== undefined) contents.RestoreExpiryDate = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["RestoreExpiryDate"]));
    return contents;
};
const $695e66930879143f$var$de_RoutingRule = (output, context)=>{
    const contents = {};
    if (output["Condition"] !== undefined) contents.Condition = $695e66930879143f$var$de_Condition(output["Condition"], context);
    if (output["Redirect"] !== undefined) contents.Redirect = $695e66930879143f$var$de_Redirect(output["Redirect"], context);
    return contents;
};
const $695e66930879143f$var$de_RoutingRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_RoutingRule(entry, context);
    });
};
const $695e66930879143f$var$de_S3KeyFilter = (output, context)=>{
    const contents = {};
    if (output.FilterRule === "") contents.FilterRules = [];
    else if (output["FilterRule"] !== undefined) contents.FilterRules = $695e66930879143f$var$de_FilterRuleList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["FilterRule"]), context);
    return contents;
};
const $695e66930879143f$var$de_ServerSideEncryptionByDefault = (output, context)=>{
    const contents = {};
    if (output["SSEAlgorithm"] !== undefined) contents.SSEAlgorithm = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["SSEAlgorithm"]);
    if (output["KMSMasterKeyID"] !== undefined) contents.KMSMasterKeyID = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["KMSMasterKeyID"]);
    return contents;
};
const $695e66930879143f$var$de_ServerSideEncryptionConfiguration = (output, context)=>{
    const contents = {};
    if (output.Rule === "") contents.Rules = [];
    else if (output["Rule"] !== undefined) contents.Rules = $695e66930879143f$var$de_ServerSideEncryptionRules((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Rule"]), context);
    return contents;
};
const $695e66930879143f$var$de_ServerSideEncryptionRule = (output, context)=>{
    const contents = {};
    if (output["ApplyServerSideEncryptionByDefault"] !== undefined) contents.ApplyServerSideEncryptionByDefault = $695e66930879143f$var$de_ServerSideEncryptionByDefault(output["ApplyServerSideEncryptionByDefault"], context);
    if (output["BucketKeyEnabled"] !== undefined) contents.BucketKeyEnabled = (0, $f10fb2b359b91940$export$3fb54149990fb5b5)(output["BucketKeyEnabled"]);
    return contents;
};
const $695e66930879143f$var$de_ServerSideEncryptionRules = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_ServerSideEncryptionRule(entry, context);
    });
};
const $695e66930879143f$var$de_SourceSelectionCriteria = (output, context)=>{
    const contents = {};
    if (output["SseKmsEncryptedObjects"] !== undefined) contents.SseKmsEncryptedObjects = $695e66930879143f$var$de_SseKmsEncryptedObjects(output["SseKmsEncryptedObjects"], context);
    if (output["ReplicaModifications"] !== undefined) contents.ReplicaModifications = $695e66930879143f$var$de_ReplicaModifications(output["ReplicaModifications"], context);
    return contents;
};
const $695e66930879143f$var$de_SSEKMS = (output, context)=>{
    const contents = {};
    if (output["KeyId"] !== undefined) contents.KeyId = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["KeyId"]);
    return contents;
};
const $695e66930879143f$var$de_SseKmsEncryptedObjects = (output, context)=>{
    const contents = {};
    if (output["Status"] !== undefined) contents.Status = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Status"]);
    return contents;
};
const $695e66930879143f$var$de_SSES3 = (output, context)=>{
    const contents = {};
    return contents;
};
const $695e66930879143f$var$de_Stats = (output, context)=>{
    const contents = {};
    if (output["BytesScanned"] !== undefined) contents.BytesScanned = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["BytesScanned"]);
    if (output["BytesProcessed"] !== undefined) contents.BytesProcessed = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["BytesProcessed"]);
    if (output["BytesReturned"] !== undefined) contents.BytesReturned = (0, $f10fb2b359b91940$export$f90617f39a736d36)(output["BytesReturned"]);
    return contents;
};
const $695e66930879143f$var$de_StorageClassAnalysis = (output, context)=>{
    const contents = {};
    if (output["DataExport"] !== undefined) contents.DataExport = $695e66930879143f$var$de_StorageClassAnalysisDataExport(output["DataExport"], context);
    return contents;
};
const $695e66930879143f$var$de_StorageClassAnalysisDataExport = (output, context)=>{
    const contents = {};
    if (output["OutputSchemaVersion"] !== undefined) contents.OutputSchemaVersion = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["OutputSchemaVersion"]);
    if (output["Destination"] !== undefined) contents.Destination = $695e66930879143f$var$de_AnalyticsExportDestination(output["Destination"], context);
    return contents;
};
const $695e66930879143f$var$de_Tag = (output, context)=>{
    const contents = {};
    if (output["Key"] !== undefined) contents.Key = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Key"]);
    if (output["Value"] !== undefined) contents.Value = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Value"]);
    return contents;
};
const $695e66930879143f$var$de_TagSet = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_Tag(entry, context);
    });
};
const $695e66930879143f$var$de_TargetGrant = (output, context)=>{
    const contents = {};
    if (output["Grantee"] !== undefined) contents.Grantee = $695e66930879143f$var$de_Grantee(output["Grantee"], context);
    if (output["Permission"] !== undefined) contents.Permission = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Permission"]);
    return contents;
};
const $695e66930879143f$var$de_TargetGrants = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_TargetGrant(entry, context);
    });
};
const $695e66930879143f$var$de_Tiering = (output, context)=>{
    const contents = {};
    if (output["Days"] !== undefined) contents.Days = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["Days"]);
    if (output["AccessTier"] !== undefined) contents.AccessTier = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["AccessTier"]);
    return contents;
};
const $695e66930879143f$var$de_TieringList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_Tiering(entry, context);
    });
};
const $695e66930879143f$var$de_TopicConfiguration = (output, context)=>{
    const contents = {};
    if (output["Id"] !== undefined) contents.Id = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Id"]);
    if (output["Topic"] !== undefined) contents.TopicArn = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["Topic"]);
    if (output.Event === "") contents.Events = [];
    else if (output["Event"] !== undefined) contents.Events = $695e66930879143f$var$de_EventList((0, $7e6ebdfaa9b33533$export$52272e038712c64e)(output["Event"]), context);
    if (output["Filter"] !== undefined) contents.Filter = $695e66930879143f$var$de_NotificationConfigurationFilter(output["Filter"], context);
    return contents;
};
const $695e66930879143f$var$de_TopicConfigurationList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_TopicConfiguration(entry, context);
    });
};
const $695e66930879143f$var$de_Transition = (output, context)=>{
    const contents = {};
    if (output["Date"] !== undefined) contents.Date = (0, $f10fb2b359b91940$export$8413a63dbe548a49)((0, $d519855744bca7a8$export$3cb821e2875b4b7d)(output["Date"]));
    if (output["Days"] !== undefined) contents.Days = (0, $f10fb2b359b91940$export$c3c2f00b115709e6)(output["Days"]);
    if (output["StorageClass"] !== undefined) contents.StorageClass = (0, $f10fb2b359b91940$export$7ed80f53fe336639)(output["StorageClass"]);
    return contents;
};
const $695e66930879143f$var$de_TransitionList = (output, context)=>{
    return (output || []).filter((e)=>e != null).map((entry)=>{
        return $695e66930879143f$var$de_Transition(entry, context);
    });
};
const $695e66930879143f$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });
const $695e66930879143f$var$collectBodyString = (streamBody, context)=>(0, $cd8fb6f0bc5d10ec$export$3392bcddb824e5ca)(streamBody, context).then((body)=>context.utf8Encoder(body));
const $695e66930879143f$var$isSerializableHeaderValue = (value)=>value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
const $695e66930879143f$var$parseBody = (streamBody, context)=>$695e66930879143f$var$collectBodyString(streamBody, context).then((encoded)=>{
        if (encoded.length) {
            const parser = new (0, $2b87ce1df293278b$exports.XMLParser)({
                attributeNamePrefix: "",
                htmlEntities: true,
                ignoreAttributes: false,
                ignoreDeclaration: true,
                parseTagValue: false,
                trimValues: false,
                tagValueProcessor: (_, val)=>val.trim() === "" && val.includes("\n") ? "" : undefined
            });
            parser.addEntity("#xD", "\r");
            parser.addEntity("#10", "\n");
            const parsedObj = parser.parse(encoded);
            const textNodeName = "#text";
            const key = Object.keys(parsedObj)[0];
            const parsedObjToReturn = parsedObj[key];
            if (parsedObjToReturn[textNodeName]) {
                parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
                delete parsedObjToReturn[textNodeName];
            }
            return (0, $85f1f2fc8f60827c$export$113d90026b452881)(parsedObjToReturn);
        }
        return {};
    });
const $695e66930879143f$var$parseErrorBody = async (errorBody, context)=>{
    const value = await $695e66930879143f$var$parseBody(errorBody, context);
    if (value.Error) value.Error.message = value.Error.message ?? value.Error.Message;
    return value;
};
const $695e66930879143f$var$loadRestXmlErrorCode = (output, data)=>{
    if (data?.Code !== undefined) return data.Code;
    if (output.statusCode == 404) return "NotFound";
};


class $4321cea269e1a859$export$87d2388f8662d995 extends (0, $9b91565ddaedd0f1$export$cc7e12c76513e857) {
    static getEndpointParameterInstructions() {
        return {
            Bucket: {
                type: "contextParams",
                name: "Bucket"
            },
            ForcePathStyle: {
                type: "clientContextParams",
                name: "forcePathStyle"
            },
            UseArnRegion: {
                type: "clientContextParams",
                name: "useArnRegion"
            },
            DisableMultiRegionAccessPoints: {
                type: "clientContextParams",
                name: "disableMultiregionAccessPoints"
            },
            Accelerate: {
                type: "clientContextParams",
                name: "useAccelerateEndpoint"
            },
            UseGlobalEndpoint: {
                type: "builtInParams",
                name: "useGlobalEndpoint"
            },
            UseFIPS: {
                type: "builtInParams",
                name: "useFipsEndpoint"
            },
            Endpoint: {
                type: "builtInParams",
                name: "endpoint"
            },
            Region: {
                type: "builtInParams",
                name: "region"
            },
            UseDualStack: {
                type: "builtInParams",
                name: "useDualstackEndpoint"
            }
        };
    }
    constructor(input){
        super();
        this.input = input;
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7b67ff6108e5be33$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $e3a5472d351bf15f$export$946c80457b765eab)(configuration, $4321cea269e1a859$export$87d2388f8662d995.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const clientName = "S3Client";
        const commandName = "AbortMultipartUploadCommand";
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (_)=>_,
            outputFilterSensitiveLog: (_)=>_
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return (0, $695e66930879143f$export$10d13acf81981e5c)(input, context);
    }
    deserialize(output, context) {
        return (0, $695e66930879143f$export$584ab52a599445fc)(output, context);
    }
}


const $c7a4919c2d4dda92$var$CONTENT_LENGTH_HEADER = "content-length";
function $c7a4919c2d4dda92$export$ef1b67e0faf37c57() {
    return (next, context)=>async (args)=>{
            const { request: request } = args;
            if ((0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request)) {
                if (!request.headers[$c7a4919c2d4dda92$var$CONTENT_LENGTH_HEADER]) {
                    const message = `Are you using a Stream of unknown length as the Body of a PutObject request? Consider using Upload instead from @aws-sdk/lib-storage.`;
                    if (typeof context?.logger?.warn === "function") context.logger.warn(message);
                    else console.warn(message);
                }
            }
            return next({
                ...args
            });
        };
}
const $c7a4919c2d4dda92$export$cf4a6daea5f975c7 = {
    step: "finalizeRequest",
    tags: [
        "CHECK_CONTENT_LENGTH_HEADER"
    ],
    name: "getCheckContentLengthHeaderPlugin",
    override: true
};
const $c7a4919c2d4dda92$export$9cab92d587daac23 = (unused)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($c7a4919c2d4dda92$export$ef1b67e0faf37c57(), $c7a4919c2d4dda92$export$cf4a6daea5f975c7);
        }
    });


const $c69f352e0da94b39$export$9acff03461140bb6 = (input)=>({
        ...input,
        forcePathStyle: input.forcePathStyle ?? false,
        useAccelerateEndpoint: input.useAccelerateEndpoint ?? false,
        disableMultiregionAccessPoints: input.disableMultiregionAccessPoints ?? false
    });



const $8bc6b8c148710a81$export$61d7988259be6660 = (config)=>(next)=>async (args)=>{
            const result = await next(args);
            const { response: response } = result;
            if (!(0, $2c63d34427c28f98$export$1d94dfe0d9d1f1e7).isInstance(response)) return result;
            const { statusCode: statusCode, body: body } = response;
            if (statusCode < 200 || statusCode >= 300) return result;
            const bodyBytes = await $8bc6b8c148710a81$var$collectBody(body, config);
            const bodyString = await $8bc6b8c148710a81$var$collectBodyString(bodyBytes, config);
            if (bodyBytes.length === 0) {
                const err = new Error("S3 aborted request");
                err.name = "InternalError";
                throw err;
            }
            if (bodyString && bodyString.match("<Error>")) response.statusCode = 400;
            response.body = bodyBytes;
            return result;
        };
const $8bc6b8c148710a81$var$collectBody = (streamBody = new Uint8Array(), context)=>{
    if (streamBody instanceof Uint8Array) return Promise.resolve(streamBody);
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
const $8bc6b8c148710a81$var$collectBodyString = (streamBody, context)=>$8bc6b8c148710a81$var$collectBody(streamBody, context).then((body)=>context.utf8Encoder(body));
const $8bc6b8c148710a81$export$ea0247469da1888 = {
    relation: "after",
    toMiddleware: "deserializerMiddleware",
    tags: [
        "THROW_200_EXCEPTIONS",
        "S3"
    ],
    name: "throw200ExceptionsMiddleware",
    override: true
};
const $8bc6b8c148710a81$export$97cbbd0d754f3189 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($8bc6b8c148710a81$export$61d7988259be6660(config), $8bc6b8c148710a81$export$ea0247469da1888);
        }
    });


const $aa29b5a91f4b5323$export$a22775fa5e2eebd9 = (str)=>typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
const $aa29b5a91f4b5323$export$98e6a39c04603d36 = (arn)=>{
    const segments = arn.split(":");
    if (segments.length < 6 || segments[0] !== "arn") throw new Error("Malformed ARN");
    const [, partition, service, region, accountId, ...resource] = segments;
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resource: resource.join(":")
    };
};
const $aa29b5a91f4b5323$export$3f8fe6489e95757d = (arnObject)=>{
    const { partition: partition = "aws", service: service, region: region, accountId: accountId, resource: resource } = arnObject;
    if ([
        service,
        region,
        accountId,
        resource
    ].some((segment)=>typeof segment !== "string")) throw new Error("Input ARN object is invalid");
    return `arn:${partition}:${service}:${region}:${accountId}:${resource}`;
};


function $0268e8cb6b99ca31$export$97e70cdcaaace32a() {
    return (next)=>async (args)=>{
            const { input: { Bucket: Bucket } } = args;
            if (typeof Bucket === "string" && !(0, $aa29b5a91f4b5323$export$a22775fa5e2eebd9)(Bucket) && Bucket.indexOf("/") >= 0) {
                const err = new Error(`Bucket name shouldn't contain '/', received '${Bucket}'`);
                err.name = "InvalidBucketName";
                throw err;
            }
            return next({
                ...args
            });
        };
}
const $0268e8cb6b99ca31$export$db8005617bec77bd = {
    step: "initialize",
    tags: [
        "VALIDATE_BUCKET_NAME"
    ],
    name: "validateBucketNameMiddleware",
    override: true
};
const $0268e8cb6b99ca31$export$c30d61978fbb3ad8 = (unused)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($0268e8cb6b99ca31$export$97e70cdcaaace32a(), $0268e8cb6b99ca31$export$db8005617bec77bd);
        }
    });




function $f373a583c4de1c5c$export$16515ae394ee1bc8(options) {
    return (next)=>async (args)=>{
            let input = {
                ...args.input
            };
            const properties = [
                {
                    target: "SSECustomerKey",
                    hash: "SSECustomerKeyMD5"
                },
                {
                    target: "CopySourceSSECustomerKey",
                    hash: "CopySourceSSECustomerKeyMD5"
                }
            ];
            for (const prop of properties){
                const value = input[prop.target];
                if (value) {
                    const valueView = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : typeof value === "string" ? options.utf8Decoder(value) : new Uint8Array(value);
                    const encoded = options.base64Encoder(valueView);
                    const hash = new options.md5();
                    hash.update(valueView);
                    input = {
                        ...input,
                        [prop.target]: encoded,
                        [prop.hash]: options.base64Encoder(await hash.digest())
                    };
                }
            }
            return next({
                ...args,
                input: input
            });
        };
}
const $f373a583c4de1c5c$export$bd3ed071b8ca05b3 = {
    name: "ssecMiddleware",
    step: "initialize",
    tags: [
        "SSE"
    ],
    override: true
};
const $f373a583c4de1c5c$export$baf25e0187b0946b = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($f373a583c4de1c5c$export$16515ae394ee1bc8(config), $f373a583c4de1c5c$export$bd3ed071b8ca05b3);
        }
    });







class $d61edaf1bc0c0a33$export$f827ea0301b4eeff extends (0, $9b91565ddaedd0f1$export$cc7e12c76513e857) {
    static getEndpointParameterInstructions() {
        return {
            Bucket: {
                type: "contextParams",
                name: "Bucket"
            },
            ForcePathStyle: {
                type: "clientContextParams",
                name: "forcePathStyle"
            },
            UseArnRegion: {
                type: "clientContextParams",
                name: "useArnRegion"
            },
            DisableMultiRegionAccessPoints: {
                type: "clientContextParams",
                name: "disableMultiregionAccessPoints"
            },
            Accelerate: {
                type: "clientContextParams",
                name: "useAccelerateEndpoint"
            },
            UseGlobalEndpoint: {
                type: "builtInParams",
                name: "useGlobalEndpoint"
            },
            UseFIPS: {
                type: "builtInParams",
                name: "useFipsEndpoint"
            },
            Endpoint: {
                type: "builtInParams",
                name: "endpoint"
            },
            Region: {
                type: "builtInParams",
                name: "region"
            },
            UseDualStack: {
                type: "builtInParams",
                name: "useDualstackEndpoint"
            }
        };
    }
    constructor(input){
        super();
        this.input = input;
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7b67ff6108e5be33$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $e3a5472d351bf15f$export$946c80457b765eab)(configuration, $d61edaf1bc0c0a33$export$f827ea0301b4eeff.getEndpointParameterInstructions()));
        this.middlewareStack.use((0, $8bc6b8c148710a81$export$97cbbd0d754f3189)(configuration));
        this.middlewareStack.use((0, $f373a583c4de1c5c$export$baf25e0187b0946b)(configuration));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const clientName = "S3Client";
        const commandName = "CompleteMultipartUploadCommand";
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $581888fd928d8ba4$export$eb8e420b7cfdd234),
            outputFilterSensitiveLog: (0, $581888fd928d8ba4$export$ee980f22bb30c0b1)
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return (0, $695e66930879143f$export$c0d6594d5a007c93)(input, context);
    }
    deserialize(output, context) {
        return (0, $695e66930879143f$export$c515ac7dad03483f)(output, context);
    }
}







class $bd5a45fbaa7b2945$export$76155123c96043b8 extends (0, $9b91565ddaedd0f1$export$cc7e12c76513e857) {
    static getEndpointParameterInstructions() {
        return {
            Bucket: {
                type: "contextParams",
                name: "Bucket"
            },
            ForcePathStyle: {
                type: "clientContextParams",
                name: "forcePathStyle"
            },
            UseArnRegion: {
                type: "clientContextParams",
                name: "useArnRegion"
            },
            DisableMultiRegionAccessPoints: {
                type: "clientContextParams",
                name: "disableMultiregionAccessPoints"
            },
            Accelerate: {
                type: "clientContextParams",
                name: "useAccelerateEndpoint"
            },
            UseGlobalEndpoint: {
                type: "builtInParams",
                name: "useGlobalEndpoint"
            },
            UseFIPS: {
                type: "builtInParams",
                name: "useFipsEndpoint"
            },
            Endpoint: {
                type: "builtInParams",
                name: "endpoint"
            },
            Region: {
                type: "builtInParams",
                name: "region"
            },
            UseDualStack: {
                type: "builtInParams",
                name: "useDualstackEndpoint"
            }
        };
    }
    constructor(input){
        super();
        this.input = input;
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7b67ff6108e5be33$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $e3a5472d351bf15f$export$946c80457b765eab)(configuration, $bd5a45fbaa7b2945$export$76155123c96043b8.getEndpointParameterInstructions()));
        this.middlewareStack.use((0, $f373a583c4de1c5c$export$baf25e0187b0946b)(configuration));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const clientName = "S3Client";
        const commandName = "CreateMultipartUploadCommand";
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $581888fd928d8ba4$export$a7b934ef912ebf62),
            outputFilterSensitiveLog: (0, $581888fd928d8ba4$export$5abe7f3ae720ef5a)
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return (0, $695e66930879143f$export$3cc910d56b5ba1fa)(input, context);
    }
    deserialize(output, context) {
        return (0, $695e66930879143f$export$26ee6d662365d0aa)(output, context);
    }
}

var $7c4ec06688dd6e5f$export$578faf5500e50907;
(function(ChecksumAlgorithm) {
    ChecksumAlgorithm["MD5"] = "MD5";
    ChecksumAlgorithm["CRC32"] = "CRC32";
    ChecksumAlgorithm["CRC32C"] = "CRC32C";
    ChecksumAlgorithm["SHA1"] = "SHA1";
    ChecksumAlgorithm["SHA256"] = "SHA256";
})($7c4ec06688dd6e5f$export$578faf5500e50907 || ($7c4ec06688dd6e5f$export$578faf5500e50907 = {}));
var $7c4ec06688dd6e5f$export$6e71e3f58e94f6f3;
(function(ChecksumLocation) {
    ChecksumLocation["HEADER"] = "header";
    ChecksumLocation["TRAILER"] = "trailer";
})($7c4ec06688dd6e5f$export$6e71e3f58e94f6f3 || ($7c4ec06688dd6e5f$export$6e71e3f58e94f6f3 = {}));





const $be5af2e0765574aa$export$250d41e5cdcdba3f = [
    (0, $7c4ec06688dd6e5f$export$578faf5500e50907).CRC32,
    (0, $7c4ec06688dd6e5f$export$578faf5500e50907).CRC32C,
    (0, $7c4ec06688dd6e5f$export$578faf5500e50907).SHA1,
    (0, $7c4ec06688dd6e5f$export$578faf5500e50907).SHA256
];
const $be5af2e0765574aa$export$d72f0660fe536945 = [
    (0, $7c4ec06688dd6e5f$export$578faf5500e50907).CRC32,
    (0, $7c4ec06688dd6e5f$export$578faf5500e50907).CRC32C,
    (0, $7c4ec06688dd6e5f$export$578faf5500e50907).SHA1,
    (0, $7c4ec06688dd6e5f$export$578faf5500e50907).SHA256
];


const $5088df800641b2bc$export$3a8d03296046b4c = (input, { requestChecksumRequired: requestChecksumRequired, requestAlgorithmMember: requestAlgorithmMember })=>{
    if (!requestAlgorithmMember || !input[requestAlgorithmMember]) return requestChecksumRequired ? (0, $7c4ec06688dd6e5f$export$578faf5500e50907).MD5 : undefined;
    const checksumAlgorithm = input[requestAlgorithmMember];
    if (!(0, $be5af2e0765574aa$export$250d41e5cdcdba3f).includes(checksumAlgorithm)) throw new Error(`The checksum algorithm "${checksumAlgorithm}" is not supported by the client.` + ` Select one of ${0, $be5af2e0765574aa$export$250d41e5cdcdba3f}.`);
    return checksumAlgorithm;
};



const $afb72a0a2dae82af$export$f2b25cbe2b26f44a = (algorithm)=>algorithm === (0, $7c4ec06688dd6e5f$export$578faf5500e50907).MD5 ? "content-md5" : `x-amz-checksum-${algorithm.toLowerCase()}`;


const $8f05080568214f09$export$17944590be865217 = (header, headers)=>{
    const soughtHeader = header.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};


const $ac7e68f76bf33be3$export$9dd3754ae86f0017 = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";


const $8073f174eb36cf7c$export$cd8dd85fa30a5026 = (body)=>body !== undefined && typeof body !== "string" && !ArrayBuffer.isView(body) && !(0, $ac7e68f76bf33be3$export$9dd3754ae86f0017)(body);


var $850a55f0ba482479$exports = {};
"use strict";
Object.defineProperty($850a55f0ba482479$exports, "__esModule", {
    value: true
});
$850a55f0ba482479$exports.AwsCrc32 = $850a55f0ba482479$exports.Crc32 = $850a55f0ba482479$exports.crc32 = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $44c6a1cc8d629007$var$extendStatics = function(d, b) {
    $44c6a1cc8d629007$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $44c6a1cc8d629007$var$extendStatics(d, b);
};
function $44c6a1cc8d629007$export$a8ba968b8961cb8a(d, b) {
    $44c6a1cc8d629007$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $44c6a1cc8d629007$export$18ce0697a983be9b = function() {
    $44c6a1cc8d629007$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $44c6a1cc8d629007$export$18ce0697a983be9b.apply(this, arguments);
};
function $44c6a1cc8d629007$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $44c6a1cc8d629007$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $44c6a1cc8d629007$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $44c6a1cc8d629007$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $44c6a1cc8d629007$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $44c6a1cc8d629007$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $44c6a1cc8d629007$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $44c6a1cc8d629007$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $44c6a1cc8d629007$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $44c6a1cc8d629007$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $44c6a1cc8d629007$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($44c6a1cc8d629007$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $44c6a1cc8d629007$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $44c6a1cc8d629007$export$10c90e4f7922046c(v) {
    return this instanceof $44c6a1cc8d629007$export$10c90e4f7922046c ? (this.v = v, this) : new $44c6a1cc8d629007$export$10c90e4f7922046c(v);
}
function $44c6a1cc8d629007$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $44c6a1cc8d629007$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $44c6a1cc8d629007$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $44c6a1cc8d629007$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $44c6a1cc8d629007$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $44c6a1cc8d629007$export$19a8beecd37a4c45 === "function" ? $44c6a1cc8d629007$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $44c6a1cc8d629007$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $44c6a1cc8d629007$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $44c6a1cc8d629007$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $44c6a1cc8d629007$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $44c6a1cc8d629007$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $8XVZm = parcelRequire("8XVZm");
function $850a55f0ba482479$var$crc32(data) {
    return new $850a55f0ba482479$var$Crc32().update(data).digest();
}
$850a55f0ba482479$exports.crc32 = $850a55f0ba482479$var$crc32;
var $850a55f0ba482479$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = $44c6a1cc8d629007$export$19a8beecd37a4c45(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $850a55f0ba482479$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
$850a55f0ba482479$exports.Crc32 = $850a55f0ba482479$var$Crc32;
// prettier-ignore
var $850a55f0ba482479$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $850a55f0ba482479$var$lookupTable = (0, $8XVZm.uint32ArrayFrom)($850a55f0ba482479$var$a_lookUpTable);
var $0c53b9c20ef04cf6$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($0c53b9c20ef04cf6$exports, "__esModule", {
    value: true
});
$0c53b9c20ef04cf6$exports.AwsCrc32 = void 0;


var $8XVZm = parcelRequire("8XVZm");

var $0c53b9c20ef04cf6$var$AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new $850a55f0ba482479$exports.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $8XVZm.isEmptyData)(toHash)) return;
        this.crc32.update((0, $8XVZm.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return $44c6a1cc8d629007$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $44c6a1cc8d629007$export$67ebef60e6f28a6(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $8XVZm.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    AwsCrc32.prototype.reset = function() {
        this.crc32 = new $850a55f0ba482479$exports.Crc32();
    };
    return AwsCrc32;
}();
$0c53b9c20ef04cf6$exports.AwsCrc32 = $0c53b9c20ef04cf6$var$AwsCrc32;


Object.defineProperty($850a55f0ba482479$exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return $0c53b9c20ef04cf6$exports.AwsCrc32;
    }
});


var $ad304a1db9668409$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($ad304a1db9668409$exports, "__esModule", {
    value: true
});
$ad304a1db9668409$exports.AwsCrc32c = $ad304a1db9668409$exports.Crc32c = $ad304a1db9668409$exports.crc32c = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ecd72203d4a265b4$var$extendStatics = function(d, b) {
    $ecd72203d4a265b4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ecd72203d4a265b4$var$extendStatics(d, b);
};
function $ecd72203d4a265b4$export$a8ba968b8961cb8a(d, b) {
    $ecd72203d4a265b4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ecd72203d4a265b4$export$18ce0697a983be9b = function() {
    $ecd72203d4a265b4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ecd72203d4a265b4$export$18ce0697a983be9b.apply(this, arguments);
};
function $ecd72203d4a265b4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ecd72203d4a265b4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ecd72203d4a265b4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ecd72203d4a265b4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ecd72203d4a265b4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ecd72203d4a265b4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ecd72203d4a265b4$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ecd72203d4a265b4$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ecd72203d4a265b4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ecd72203d4a265b4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ecd72203d4a265b4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ecd72203d4a265b4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ecd72203d4a265b4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ecd72203d4a265b4$export$10c90e4f7922046c(v) {
    return this instanceof $ecd72203d4a265b4$export$10c90e4f7922046c ? (this.v = v, this) : new $ecd72203d4a265b4$export$10c90e4f7922046c(v);
}
function $ecd72203d4a265b4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ecd72203d4a265b4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ecd72203d4a265b4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ecd72203d4a265b4$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ecd72203d4a265b4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ecd72203d4a265b4$export$19a8beecd37a4c45 === "function" ? $ecd72203d4a265b4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ecd72203d4a265b4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ecd72203d4a265b4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ecd72203d4a265b4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ecd72203d4a265b4$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ecd72203d4a265b4$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $8XVZm = parcelRequire("8XVZm");
function $ad304a1db9668409$var$crc32c(data) {
    return new $ad304a1db9668409$var$Crc32c().update(data).digest();
}
$ad304a1db9668409$exports.crc32c = $ad304a1db9668409$var$crc32c;
var $ad304a1db9668409$var$Crc32c = /** @class */ function() {
    function Crc32c() {
        this.checksum = 0xffffffff;
    }
    Crc32c.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = $ecd72203d4a265b4$export$19a8beecd37a4c45(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $ad304a1db9668409$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32c.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32c;
}();
$ad304a1db9668409$exports.Crc32c = $ad304a1db9668409$var$Crc32c;
// prettier-ignore
var $ad304a1db9668409$var$a_lookupTable = [
    0x00000000,
    0xF26B8303,
    0xE13B70F7,
    0x1350F3F4,
    0xC79A971F,
    0x35F1141C,
    0x26A1E7E8,
    0xD4CA64EB,
    0x8AD958CF,
    0x78B2DBCC,
    0x6BE22838,
    0x9989AB3B,
    0x4D43CFD0,
    0xBF284CD3,
    0xAC78BF27,
    0x5E133C24,
    0x105EC76F,
    0xE235446C,
    0xF165B798,
    0x030E349B,
    0xD7C45070,
    0x25AFD373,
    0x36FF2087,
    0xC494A384,
    0x9A879FA0,
    0x68EC1CA3,
    0x7BBCEF57,
    0x89D76C54,
    0x5D1D08BF,
    0xAF768BBC,
    0xBC267848,
    0x4E4DFB4B,
    0x20BD8EDE,
    0xD2D60DDD,
    0xC186FE29,
    0x33ED7D2A,
    0xE72719C1,
    0x154C9AC2,
    0x061C6936,
    0xF477EA35,
    0xAA64D611,
    0x580F5512,
    0x4B5FA6E6,
    0xB93425E5,
    0x6DFE410E,
    0x9F95C20D,
    0x8CC531F9,
    0x7EAEB2FA,
    0x30E349B1,
    0xC288CAB2,
    0xD1D83946,
    0x23B3BA45,
    0xF779DEAE,
    0x05125DAD,
    0x1642AE59,
    0xE4292D5A,
    0xBA3A117E,
    0x4851927D,
    0x5B016189,
    0xA96AE28A,
    0x7DA08661,
    0x8FCB0562,
    0x9C9BF696,
    0x6EF07595,
    0x417B1DBC,
    0xB3109EBF,
    0xA0406D4B,
    0x522BEE48,
    0x86E18AA3,
    0x748A09A0,
    0x67DAFA54,
    0x95B17957,
    0xCBA24573,
    0x39C9C670,
    0x2A993584,
    0xD8F2B687,
    0x0C38D26C,
    0xFE53516F,
    0xED03A29B,
    0x1F682198,
    0x5125DAD3,
    0xA34E59D0,
    0xB01EAA24,
    0x42752927,
    0x96BF4DCC,
    0x64D4CECF,
    0x77843D3B,
    0x85EFBE38,
    0xDBFC821C,
    0x2997011F,
    0x3AC7F2EB,
    0xC8AC71E8,
    0x1C661503,
    0xEE0D9600,
    0xFD5D65F4,
    0x0F36E6F7,
    0x61C69362,
    0x93AD1061,
    0x80FDE395,
    0x72966096,
    0xA65C047D,
    0x5437877E,
    0x4767748A,
    0xB50CF789,
    0xEB1FCBAD,
    0x197448AE,
    0x0A24BB5A,
    0xF84F3859,
    0x2C855CB2,
    0xDEEEDFB1,
    0xCDBE2C45,
    0x3FD5AF46,
    0x7198540D,
    0x83F3D70E,
    0x90A324FA,
    0x62C8A7F9,
    0xB602C312,
    0x44694011,
    0x5739B3E5,
    0xA55230E6,
    0xFB410CC2,
    0x092A8FC1,
    0x1A7A7C35,
    0xE811FF36,
    0x3CDB9BDD,
    0xCEB018DE,
    0xDDE0EB2A,
    0x2F8B6829,
    0x82F63B78,
    0x709DB87B,
    0x63CD4B8F,
    0x91A6C88C,
    0x456CAC67,
    0xB7072F64,
    0xA457DC90,
    0x563C5F93,
    0x082F63B7,
    0xFA44E0B4,
    0xE9141340,
    0x1B7F9043,
    0xCFB5F4A8,
    0x3DDE77AB,
    0x2E8E845F,
    0xDCE5075C,
    0x92A8FC17,
    0x60C37F14,
    0x73938CE0,
    0x81F80FE3,
    0x55326B08,
    0xA759E80B,
    0xB4091BFF,
    0x466298FC,
    0x1871A4D8,
    0xEA1A27DB,
    0xF94AD42F,
    0x0B21572C,
    0xDFEB33C7,
    0x2D80B0C4,
    0x3ED04330,
    0xCCBBC033,
    0xA24BB5A6,
    0x502036A5,
    0x4370C551,
    0xB11B4652,
    0x65D122B9,
    0x97BAA1BA,
    0x84EA524E,
    0x7681D14D,
    0x2892ED69,
    0xDAF96E6A,
    0xC9A99D9E,
    0x3BC21E9D,
    0xEF087A76,
    0x1D63F975,
    0x0E330A81,
    0xFC588982,
    0xB21572C9,
    0x407EF1CA,
    0x532E023E,
    0xA145813D,
    0x758FE5D6,
    0x87E466D5,
    0x94B49521,
    0x66DF1622,
    0x38CC2A06,
    0xCAA7A905,
    0xD9F75AF1,
    0x2B9CD9F2,
    0xFF56BD19,
    0x0D3D3E1A,
    0x1E6DCDEE,
    0xEC064EED,
    0xC38D26C4,
    0x31E6A5C7,
    0x22B65633,
    0xD0DDD530,
    0x0417B1DB,
    0xF67C32D8,
    0xE52CC12C,
    0x1747422F,
    0x49547E0B,
    0xBB3FFD08,
    0xA86F0EFC,
    0x5A048DFF,
    0x8ECEE914,
    0x7CA56A17,
    0x6FF599E3,
    0x9D9E1AE0,
    0xD3D3E1AB,
    0x21B862A8,
    0x32E8915C,
    0xC083125F,
    0x144976B4,
    0xE622F5B7,
    0xF5720643,
    0x07198540,
    0x590AB964,
    0xAB613A67,
    0xB831C993,
    0x4A5A4A90,
    0x9E902E7B,
    0x6CFBAD78,
    0x7FAB5E8C,
    0x8DC0DD8F,
    0xE330A81A,
    0x115B2B19,
    0x020BD8ED,
    0xF0605BEE,
    0x24AA3F05,
    0xD6C1BC06,
    0xC5914FF2,
    0x37FACCF1,
    0x69E9F0D5,
    0x9B8273D6,
    0x88D28022,
    0x7AB90321,
    0xAE7367CA,
    0x5C18E4C9,
    0x4F48173D,
    0xBD23943E,
    0xF36E6F75,
    0x0105EC76,
    0x12551F82,
    0xE03E9C81,
    0x34F4F86A,
    0xC69F7B69,
    0xD5CF889D,
    0x27A40B9E,
    0x79B737BA,
    0x8BDCB4B9,
    0x988C474D,
    0x6AE7C44E,
    0xBE2DA0A5,
    0x4C4623A6,
    0x5F16D052,
    0xAD7D5351
];
var $ad304a1db9668409$var$lookupTable = (0, $8XVZm.uint32ArrayFrom)($ad304a1db9668409$var$a_lookupTable);
var $818032b084f9e497$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($818032b084f9e497$exports, "__esModule", {
    value: true
});
$818032b084f9e497$exports.AwsCrc32c = void 0;


var $8XVZm = parcelRequire("8XVZm");

var $818032b084f9e497$var$AwsCrc32c = /** @class */ function() {
    function AwsCrc32c() {
        this.crc32c = new $ad304a1db9668409$exports.Crc32c();
    }
    AwsCrc32c.prototype.update = function(toHash) {
        if ((0, $8XVZm.isEmptyData)(toHash)) return;
        this.crc32c.update((0, $8XVZm.convertToBuffer)(toHash));
    };
    AwsCrc32c.prototype.digest = function() {
        return $ecd72203d4a265b4$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $ecd72203d4a265b4$export$67ebef60e6f28a6(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $8XVZm.numToUint8)(this.crc32c.digest())
                ];
            });
        });
    };
    AwsCrc32c.prototype.reset = function() {
        this.crc32c = new $ad304a1db9668409$exports.Crc32c();
    };
    return AwsCrc32c;
}();
$818032b084f9e497$exports.AwsCrc32c = $818032b084f9e497$var$AwsCrc32c;


Object.defineProperty($ad304a1db9668409$exports, "AwsCrc32c", {
    enumerable: true,
    get: function() {
        return $818032b084f9e497$exports.AwsCrc32c;
    }
});



const $d29fa2ed13731081$export$d3ce400302f6a9a2 = (checksumAlgorithm, config)=>({
        [(0, $7c4ec06688dd6e5f$export$578faf5500e50907).MD5]: config.md5,
        [(0, $7c4ec06688dd6e5f$export$578faf5500e50907).CRC32]: (0, $850a55f0ba482479$exports.AwsCrc32),
        [(0, $7c4ec06688dd6e5f$export$578faf5500e50907).CRC32C]: (0, $ad304a1db9668409$exports.AwsCrc32c),
        [(0, $7c4ec06688dd6e5f$export$578faf5500e50907).SHA1]: config.sha1,
        [(0, $7c4ec06688dd6e5f$export$578faf5500e50907).SHA256]: config.sha256
    })[checksumAlgorithm];



const $93bdfb3d366686dc$export$f83388b67aa49343 = (checksumAlgorithmFn, body)=>{
    const hash = new checksumAlgorithmFn();
    hash.update((0, $e548b91235db5cfc$export$73470fd2221e6aef)(body || ""));
    return hash.digest();
};




const $9a8d16b8f8e94262$export$5278aa44d35662c5 = async (body, { streamHasher: streamHasher, checksumAlgorithmFn: checksumAlgorithmFn, base64Encoder: base64Encoder })=>{
    const digest = (0, $8073f174eb36cf7c$export$cd8dd85fa30a5026)(body) ? streamHasher(checksumAlgorithmFn, body) : (0, $93bdfb3d366686dc$export$f83388b67aa49343)(checksumAlgorithmFn, body);
    return base64Encoder(await digest);
};



const $612f15ac2444bc01$export$bd7e95f266f35d51 = (responseAlgorithms = [])=>{
    const validChecksumAlgorithms = [];
    for (const algorithm of (0, $be5af2e0765574aa$export$d72f0660fe536945)){
        if (!responseAlgorithms.includes(algorithm) || !(0, $be5af2e0765574aa$export$250d41e5cdcdba3f).includes(algorithm)) continue;
        validChecksumAlgorithms.push(algorithm);
    }
    return validChecksumAlgorithms;
};




const $d2f1c80559516657$export$562693a02c991a20 = async (response, { config: config, responseAlgorithms: responseAlgorithms })=>{
    const checksumAlgorithms = (0, $612f15ac2444bc01$export$bd7e95f266f35d51)(responseAlgorithms);
    const { body: responseBody, headers: responseHeaders } = response;
    for (const algorithm of checksumAlgorithms){
        const responseHeader = (0, $afb72a0a2dae82af$export$f2b25cbe2b26f44a)(algorithm);
        const checksumFromResponse = responseHeaders[responseHeader];
        if (checksumFromResponse) {
            const checksumAlgorithmFn = (0, $d29fa2ed13731081$export$d3ce400302f6a9a2)(algorithm, config);
            const { streamHasher: streamHasher, base64Encoder: base64Encoder } = config;
            const checksum = await (0, $9a8d16b8f8e94262$export$5278aa44d35662c5)(responseBody, {
                streamHasher: streamHasher,
                checksumAlgorithmFn: checksumAlgorithmFn,
                base64Encoder: base64Encoder
            });
            if (checksum === checksumFromResponse) break;
            throw new Error(`Checksum mismatch: expected "${checksum}" but received "${checksumFromResponse}"` + ` in response header "${responseHeader}".`);
        }
    }
};


const $b259067196f4c3b7$export$30415c4d5829592d = (config, middlewareConfig)=>(next)=>async (args)=>{
            if (!(0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const { request: request } = args;
            const { body: requestBody, headers: headers } = request;
            const { base64Encoder: base64Encoder, streamHasher: streamHasher } = config;
            const { input: input, requestChecksumRequired: requestChecksumRequired, requestAlgorithmMember: requestAlgorithmMember } = middlewareConfig;
            const checksumAlgorithm = (0, $5088df800641b2bc$export$3a8d03296046b4c)(input, {
                requestChecksumRequired: requestChecksumRequired,
                requestAlgorithmMember: requestAlgorithmMember
            });
            let updatedBody = requestBody;
            let updatedHeaders = headers;
            if (checksumAlgorithm) {
                const checksumLocationName = (0, $afb72a0a2dae82af$export$f2b25cbe2b26f44a)(checksumAlgorithm);
                const checksumAlgorithmFn = (0, $d29fa2ed13731081$export$d3ce400302f6a9a2)(checksumAlgorithm, config);
                if ((0, $8073f174eb36cf7c$export$cd8dd85fa30a5026)(requestBody)) {
                    const { getAwsChunkedEncodingStream: getAwsChunkedEncodingStream, bodyLengthChecker: bodyLengthChecker } = config;
                    updatedBody = getAwsChunkedEncodingStream(requestBody, {
                        base64Encoder: base64Encoder,
                        bodyLengthChecker: bodyLengthChecker,
                        checksumLocationName: checksumLocationName,
                        checksumAlgorithmFn: checksumAlgorithmFn,
                        streamHasher: streamHasher
                    });
                    updatedHeaders = {
                        ...headers,
                        "content-encoding": headers["content-encoding"] ? `${headers["content-encoding"]},aws-chunked` : "aws-chunked",
                        "transfer-encoding": "chunked",
                        "x-amz-decoded-content-length": headers["content-length"],
                        "x-amz-content-sha256": "STREAMING-UNSIGNED-PAYLOAD-TRAILER",
                        "x-amz-trailer": checksumLocationName
                    };
                    delete updatedHeaders["content-length"];
                } else if (!(0, $8f05080568214f09$export$17944590be865217)(checksumLocationName, headers)) {
                    const rawChecksum = await (0, $93bdfb3d366686dc$export$f83388b67aa49343)(checksumAlgorithmFn, requestBody);
                    updatedHeaders = {
                        ...headers,
                        [checksumLocationName]: base64Encoder(rawChecksum)
                    };
                }
            }
            const result = await next({
                ...args,
                request: {
                    ...request,
                    headers: updatedHeaders,
                    body: updatedBody
                }
            });
            const { requestValidationModeMember: requestValidationModeMember, responseAlgorithms: responseAlgorithms } = middlewareConfig;
            if (requestValidationModeMember && input[requestValidationModeMember] === "ENABLED") await (0, $d2f1c80559516657$export$562693a02c991a20)(result.response, {
                config: config,
                responseAlgorithms: responseAlgorithms
            });
            return result;
        };



const $3894f853c046795a$export$e97fa0bb5e52c630 = {
    name: "flexibleChecksumsMiddleware",
    step: "build",
    tags: [
        "BODY_CHECKSUM"
    ],
    override: true
};
const $3894f853c046795a$export$b3c55b56128dbf17 = (config, middlewareConfig)=>({
        applyToStack: (clientStack)=>{
            clientStack.add((0, $b259067196f4c3b7$export$30415c4d5829592d)(config, middlewareConfig), $3894f853c046795a$export$e97fa0bb5e52c630);
        }
    });










class $2de2536a47252ea3$export$25364b3fa12a4666 extends (0, $9b91565ddaedd0f1$export$cc7e12c76513e857) {
    static getEndpointParameterInstructions() {
        return {
            Bucket: {
                type: "contextParams",
                name: "Bucket"
            },
            ForcePathStyle: {
                type: "clientContextParams",
                name: "forcePathStyle"
            },
            UseArnRegion: {
                type: "clientContextParams",
                name: "useArnRegion"
            },
            DisableMultiRegionAccessPoints: {
                type: "clientContextParams",
                name: "disableMultiregionAccessPoints"
            },
            Accelerate: {
                type: "clientContextParams",
                name: "useAccelerateEndpoint"
            },
            UseGlobalEndpoint: {
                type: "builtInParams",
                name: "useGlobalEndpoint"
            },
            UseFIPS: {
                type: "builtInParams",
                name: "useFipsEndpoint"
            },
            Endpoint: {
                type: "builtInParams",
                name: "endpoint"
            },
            Region: {
                type: "builtInParams",
                name: "region"
            },
            UseDualStack: {
                type: "builtInParams",
                name: "useDualstackEndpoint"
            }
        };
    }
    constructor(input){
        super();
        this.input = input;
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7b67ff6108e5be33$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $e3a5472d351bf15f$export$946c80457b765eab)(configuration, $2de2536a47252ea3$export$25364b3fa12a4666.getEndpointParameterInstructions()));
        this.middlewareStack.use((0, $f373a583c4de1c5c$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $3894f853c046795a$export$b3c55b56128dbf17)(configuration, {
            input: this.input,
            requestChecksumRequired: false,
            requestValidationModeMember: "ChecksumMode",
            responseAlgorithms: [
                "CRC32",
                "CRC32C",
                "SHA256",
                "SHA1"
            ]
        }));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const clientName = "S3Client";
        const commandName = "GetObjectCommand";
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $581888fd928d8ba4$export$19e9479fe773d432),
            outputFilterSensitiveLog: (0, $581888fd928d8ba4$export$5a075da6fc07a9a8)
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return (0, $695e66930879143f$export$d47bb2874555749d)(input, context);
    }
    deserialize(output, context) {
        return (0, $695e66930879143f$export$ce97779f2225a8a8)(output, context);
    }
}







class $6f263ee8fed03a95$export$ce09a87958bd6882 extends (0, $9b91565ddaedd0f1$export$cc7e12c76513e857) {
    static getEndpointParameterInstructions() {
        return {
            Bucket: {
                type: "contextParams",
                name: "Bucket"
            },
            ForcePathStyle: {
                type: "clientContextParams",
                name: "forcePathStyle"
            },
            UseArnRegion: {
                type: "clientContextParams",
                name: "useArnRegion"
            },
            DisableMultiRegionAccessPoints: {
                type: "clientContextParams",
                name: "disableMultiregionAccessPoints"
            },
            Accelerate: {
                type: "clientContextParams",
                name: "useAccelerateEndpoint"
            },
            UseGlobalEndpoint: {
                type: "builtInParams",
                name: "useGlobalEndpoint"
            },
            UseFIPS: {
                type: "builtInParams",
                name: "useFipsEndpoint"
            },
            Endpoint: {
                type: "builtInParams",
                name: "endpoint"
            },
            Region: {
                type: "builtInParams",
                name: "region"
            },
            UseDualStack: {
                type: "builtInParams",
                name: "useDualstackEndpoint"
            }
        };
    }
    constructor(input){
        super();
        this.input = input;
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7b67ff6108e5be33$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $e3a5472d351bf15f$export$946c80457b765eab)(configuration, $6f263ee8fed03a95$export$ce09a87958bd6882.getEndpointParameterInstructions()));
        this.middlewareStack.use((0, $f373a583c4de1c5c$export$baf25e0187b0946b)(configuration));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const clientName = "S3Client";
        const commandName = "HeadObjectCommand";
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $581888fd928d8ba4$export$f8e32741b8b3f8f5),
            outputFilterSensitiveLog: (0, $581888fd928d8ba4$export$af4af8d2ddf19d2e)
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return (0, $695e66930879143f$export$89ef241b7cc6b282)(input, context);
    }
    deserialize(output, context) {
        return (0, $695e66930879143f$export$c65459f3f5e48f4e)(output, context);
    }
}









class $6c1c275f9407a048$export$4afa2352f8871c26 extends (0, $9b91565ddaedd0f1$export$cc7e12c76513e857) {
    static getEndpointParameterInstructions() {
        return {
            Bucket: {
                type: "contextParams",
                name: "Bucket"
            },
            ForcePathStyle: {
                type: "clientContextParams",
                name: "forcePathStyle"
            },
            UseArnRegion: {
                type: "clientContextParams",
                name: "useArnRegion"
            },
            DisableMultiRegionAccessPoints: {
                type: "clientContextParams",
                name: "disableMultiregionAccessPoints"
            },
            Accelerate: {
                type: "clientContextParams",
                name: "useAccelerateEndpoint"
            },
            UseGlobalEndpoint: {
                type: "builtInParams",
                name: "useGlobalEndpoint"
            },
            UseFIPS: {
                type: "builtInParams",
                name: "useFipsEndpoint"
            },
            Endpoint: {
                type: "builtInParams",
                name: "endpoint"
            },
            Region: {
                type: "builtInParams",
                name: "region"
            },
            UseDualStack: {
                type: "builtInParams",
                name: "useDualstackEndpoint"
            }
        };
    }
    constructor(input){
        super();
        this.input = input;
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7b67ff6108e5be33$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $e3a5472d351bf15f$export$946c80457b765eab)(configuration, $6c1c275f9407a048$export$4afa2352f8871c26.getEndpointParameterInstructions()));
        this.middlewareStack.use((0, $c7a4919c2d4dda92$export$9cab92d587daac23)(configuration));
        this.middlewareStack.use((0, $f373a583c4de1c5c$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $3894f853c046795a$export$b3c55b56128dbf17)(configuration, {
            input: this.input,
            requestAlgorithmMember: "ChecksumAlgorithm",
            requestChecksumRequired: false
        }));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const clientName = "S3Client";
        const commandName = "PutObjectCommand";
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $581888fd928d8ba4$export$35f8aea70e7bdcca),
            outputFilterSensitiveLog: (0, $581888fd928d8ba4$export$4532cbbab0d00c4f)
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return (0, $695e66930879143f$export$80b592020f8ee8b7)(input, context);
    }
    deserialize(output, context) {
        return (0, $695e66930879143f$export$7b5fb371239d4b24)(output, context);
    }
}


function $b93203295d94535b$export$ea55ca13ab589d75(options) {
    return (next)=>async (args)=>{
            const { request: request } = args;
            if ((0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request) && request.body && options.runtime === "node") request.headers = {
                ...request.headers,
                Expect: "100-continue"
            };
            return next({
                ...args,
                request: request
            });
        };
}
const $b93203295d94535b$export$582010bfa3126ad3 = {
    step: "build",
    tags: [
        "SET_EXPECT_HEADER",
        "EXPECT_HEADER"
    ],
    name: "addExpectContinueMiddleware",
    override: true
};
const $b93203295d94535b$export$7692e5e7214e5cd1 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($b93203295d94535b$export$ea55ca13ab589d75(options), $b93203295d94535b$export$582010bfa3126ad3);
        }
    });



function $88d2ee7e36f5c90f$export$c1625bf0b32b4481(input) {
    return input;
}
const $88d2ee7e36f5c90f$export$858685d7aeef192d = (options)=>(next)=>async (args)=>{
            if (!(0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const { request: request } = args;
            const { handlerProtocol: handlerProtocol = "" } = options.requestHandler.metadata || {};
            if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                delete request.headers["host"];
                request.headers[":authority"] = "";
            } else if (!request.headers["host"]) {
                let host = request.hostname;
                if (request.port != null) host += `:${request.port}`;
                request.headers["host"] = host;
            }
            return next(args);
        };
const $88d2ee7e36f5c90f$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
const $88d2ee7e36f5c90f$export$23d3b647211be53a = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($88d2ee7e36f5c90f$export$858685d7aeef192d(options), $88d2ee7e36f5c90f$export$696d244ba96181e8);
        }
    });


const $8add791fe0d5d356$export$fe0e777ee4f58cde = ()=>(next, context)=>async (args)=>{
            try {
                const response = await next(args);
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog: overrideOutputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                const outputFilterSensitiveLog = overrideOutputFilterSensitiveLog ?? context.outputFilterSensitiveLog;
                const { $metadata: $metadata, ...outputWithoutMetadata } = response.output;
                logger?.info?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                    metadata: $metadata
                });
                return response;
            } catch (error) {
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                logger?.error?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    error: error,
                    metadata: error.$metadata
                });
                throw error;
            }
        };
const $8add791fe0d5d356$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
const $8add791fe0d5d356$export$f6ef65d7766fc255 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($8add791fe0d5d356$export$fe0e777ee4f58cde(), $8add791fe0d5d356$export$877c148ab4ad0722);
        }
    });






const $60c3e4d6205418db$var$TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
const $60c3e4d6205418db$var$ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
const $60c3e4d6205418db$var$ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
const $60c3e4d6205418db$export$d12885408d4c0634 = (options)=>(next)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty($60c3e4d6205418db$var$TRACE_ID_HEADER_NAME)) return next(args);
            const functionName = $cfae44f0dfdf62c0$exports.env[$60c3e4d6205418db$var$ENV_LAMBDA_FUNCTION_NAME];
            const traceId = $cfae44f0dfdf62c0$exports.env[$60c3e4d6205418db$var$ENV_TRACE_ID];
            const nonEmptyString = (str)=>typeof str === "string" && str.length > 0;
            if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[$60c3e4d6205418db$var$TRACE_ID_HEADER_NAME] = traceId;
            return next({
                ...args,
                request: request
            });
        };
const $60c3e4d6205418db$export$1f1705db3faed8f3 = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
const $60c3e4d6205418db$export$11d0b9345788bd5 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($60c3e4d6205418db$export$d12885408d4c0634(options), $60c3e4d6205418db$export$1f1705db3faed8f3);
        }
    });



class $66e74fa52ad76d5e$export$478ec1fdae99aa79 extends Error {
    constructor(message, tryNextLink = true){
        super(message);
        this.tryNextLink = tryNextLink;
        this.name = "ProviderError";
        Object.setPrototypeOf(this, $66e74fa52ad76d5e$export$478ec1fdae99aa79.prototype);
    }
    static from(error, tryNextLink = true) {
        return Object.assign(new this(error.message, tryNextLink), error);
    }
}


class $22edbf5d928b139b$export$921076535eff0df5 extends (0, $66e74fa52ad76d5e$export$478ec1fdae99aa79) {
    constructor(message, tryNextLink = true){
        super(message, tryNextLink);
        this.tryNextLink = tryNextLink;
        this.name = "CredentialsProviderError";
        Object.setPrototypeOf(this, $22edbf5d928b139b$export$921076535eff0df5.prototype);
    }
}




class $418f3eea319677b1$export$5c605c2f83e2f56b extends (0, $66e74fa52ad76d5e$export$478ec1fdae99aa79) {
    constructor(message, tryNextLink = true){
        super(message, tryNextLink);
        this.tryNextLink = tryNextLink;
        this.name = "TokenProviderError";
        Object.setPrototypeOf(this, $418f3eea319677b1$export$5c605c2f83e2f56b.prototype);
    }
}



function $dc259544a3c72aeb$export$e08e3b67e392101e(...providers) {
    return ()=>{
        let promise = Promise.reject(new (0, $66e74fa52ad76d5e$export$478ec1fdae99aa79)("No providers in chain"));
        for (const provider of providers)promise = promise.catch((err)=>{
            if (err?.tryNextLink) return provider();
            throw err;
        });
        return promise;
    };
}


const $245c310c414c4e05$export$294ab423a8f4a426 = (staticValue)=>()=>Promise.resolve(staticValue);


const $4ee178ba25e8e3b7$export$fc10aeed3a532e2a = (provider, isExpired, requiresRefresh)=>{
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async ()=>{
        if (!pending) pending = provider();
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        if (isConstant) return resolved;
        if (requiresRefresh && !requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider();
            return resolved;
        }
        return resolved;
    };
};







class $6dbba239f0acbd88$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $6dbba239f0acbd88$var$negate(bytes);
        return new $6dbba239f0acbd88$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $6dbba239f0acbd88$var$negate(bytes);
        return parseInt((0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $6dbba239f0acbd88$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


class $affcb535cdea111e$export$74fd41a85c5dcec9 {
    constructor(toUtf8, fromUtf8){
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = this.fromUtf8(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = this.fromUtf8(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set((0, $6dbba239f0acbd88$export$8a5e19712a0a5deb).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$affcb535cdea111e$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $ff463032e6a14a0a$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
    parse(headers) {
        const out = {};
        let position = 0;
        while(position < headers.byteLength){
            const nameLength = headers.getUint8(position++);
            const name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0:
                    out[name] = {
                        type: $affcb535cdea111e$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1:
                    out[name] = {
                        type: $affcb535cdea111e$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2:
                    out[name] = {
                        type: $affcb535cdea111e$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3:
                    out[name] = {
                        type: $affcb535cdea111e$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4:
                    out[name] = {
                        type: $affcb535cdea111e$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5:
                    out[name] = {
                        type: $affcb535cdea111e$var$LONG_TAG,
                        value: new (0, $6dbba239f0acbd88$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6:
                    const binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $affcb535cdea111e$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7:
                    const stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $affcb535cdea111e$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8:
                    out[name] = {
                        type: $affcb535cdea111e$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $6dbba239f0acbd88$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9:
                    const uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $affcb535cdea111e$var$UUID_TAG,
                        value: `${(0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(uuidBytes.subarray(0, 4))}-${(0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(uuidBytes.subarray(4, 6))}-${(0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(uuidBytes.subarray(6, 8))}-${(0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(uuidBytes.subarray(8, 10))}-${(0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(uuidBytes.subarray(10))}`
                    };
                    break;
                default:
                    throw new Error(`Unrecognized header type tag`);
            }
        }
        return out;
    }
}
var $affcb535cdea111e$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($affcb535cdea111e$var$HEADER_VALUE_TYPE || ($affcb535cdea111e$var$HEADER_VALUE_TYPE = {}));
const $affcb535cdea111e$var$BOOLEAN_TAG = "boolean";
const $affcb535cdea111e$var$BYTE_TAG = "byte";
const $affcb535cdea111e$var$SHORT_TAG = "short";
const $affcb535cdea111e$var$INT_TAG = "integer";
const $affcb535cdea111e$var$LONG_TAG = "long";
const $affcb535cdea111e$var$BINARY_TAG = "binary";
const $affcb535cdea111e$var$STRING_TAG = "string";
const $affcb535cdea111e$var$TIMESTAMP_TAG = "timestamp";
const $affcb535cdea111e$var$UUID_TAG = "uuid";
const $affcb535cdea111e$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;



const $47f0018c8550b229$var$PRELUDE_MEMBER_LENGTH = 4;
const $47f0018c8550b229$var$PRELUDE_LENGTH = $47f0018c8550b229$var$PRELUDE_MEMBER_LENGTH * 2;
const $47f0018c8550b229$var$CHECKSUM_LENGTH = 4;
const $47f0018c8550b229$var$MINIMUM_MESSAGE_LENGTH = $47f0018c8550b229$var$PRELUDE_LENGTH + $47f0018c8550b229$var$CHECKSUM_LENGTH * 2;
function $47f0018c8550b229$export$546b6bc432bd9a53({ byteLength: byteLength, byteOffset: byteOffset, buffer: buffer }) {
    if (byteLength < $47f0018c8550b229$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    const view = new DataView(buffer, byteOffset, byteLength);
    const messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    const headerLength = view.getUint32($47f0018c8550b229$var$PRELUDE_MEMBER_LENGTH, false);
    const expectedPreludeChecksum = view.getUint32($47f0018c8550b229$var$PRELUDE_LENGTH, false);
    const expectedMessageChecksum = view.getUint32(byteLength - $47f0018c8550b229$var$CHECKSUM_LENGTH, false);
    const checksummer = new (0, $850a55f0ba482479$exports.Crc32)().update(new Uint8Array(buffer, byteOffset, $47f0018c8550b229$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error(`The prelude checksum specified in the message (${expectedPreludeChecksum}) does not match the calculated CRC32 checksum (${checksummer.digest()})`);
    checksummer.update(new Uint8Array(buffer, byteOffset + $47f0018c8550b229$var$PRELUDE_LENGTH, byteLength - ($47f0018c8550b229$var$PRELUDE_LENGTH + $47f0018c8550b229$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error(`The message checksum (${checksummer.digest()}) did not match the expected value of ${expectedMessageChecksum}`);
    return {
        headers: new DataView(buffer, byteOffset + $47f0018c8550b229$var$PRELUDE_LENGTH + $47f0018c8550b229$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $47f0018c8550b229$var$PRELUDE_LENGTH + $47f0018c8550b229$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($47f0018c8550b229$var$PRELUDE_LENGTH + $47f0018c8550b229$var$CHECKSUM_LENGTH + $47f0018c8550b229$var$CHECKSUM_LENGTH))
    };
}


class $971d27a5548b3be2$export$60e2ad0c77b6bab {
    constructor(toUtf8, fromUtf8){
        this.headerMarshaller = new (0, $affcb535cdea111e$export$74fd41a85c5dcec9)(toUtf8, fromUtf8);
        this.messageBuffer = [];
        this.isEndOfStream = false;
    }
    feed(message) {
        this.messageBuffer.push(this.decode(message));
    }
    endOfStream() {
        this.isEndOfStream = true;
    }
    getMessage() {
        const message = this.messageBuffer.pop();
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessage () {
                return message;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    getAvailableMessages() {
        const messages = this.messageBuffer;
        this.messageBuffer = [];
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessages () {
                return messages;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    encode({ headers: rawHeaders, body: body }) {
        const headers = this.headerMarshaller.format(rawHeaders);
        const length = headers.byteLength + body.byteLength + 16;
        const out = new Uint8Array(length);
        const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        const checksum = new (0, $850a55f0ba482479$exports.Crc32)();
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    }
    decode(message) {
        const { headers: headers, body: body } = (0, $47f0018c8550b229$export$546b6bc432bd9a53)(message);
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    }
    formatHeaders(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    }
}






class $fbc75239fe6580e5$export$4ffe73dc7dfe29dd {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const bytes of this.options.inputStream){
            const decoded = this.options.decoder.decode(bytes);
            yield decoded;
        }
    }
}


class $430fdc8a7f5897c3$export$1204278c33e35f1b {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const msg of this.options.messageStream){
            const encoded = this.options.encoder.encode(msg);
            yield encoded;
        }
        if (this.options.includeEndFrame) yield new Uint8Array(0);
    }
}


class $57bed3f14ed14353$export$c78403d78d3ee8a {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const message of this.options.messageStream){
            const deserialized = await this.options.deserializer(message);
            if (deserialized === undefined) continue;
            yield deserialized;
        }
    }
}


class $e30bf2e44d4a3f27$export$96361fe9dd919a8e {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const chunk of this.options.inputStream){
            const payloadBuf = this.options.serializer(chunk);
            yield payloadBuf;
        }
    }
}







const $a1657dd5dbbba947$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $a1657dd5dbbba947$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $a1657dd5dbbba947$export$6e114beec37430d7 = "X-Amz-Date";
const $a1657dd5dbbba947$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $a1657dd5dbbba947$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $a1657dd5dbbba947$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $a1657dd5dbbba947$export$8e1383b7eea7bee = "X-Amz-Security-Token";
const $a1657dd5dbbba947$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $a1657dd5dbbba947$export$9924a64a4b8b0d58 = "authorization";
const $a1657dd5dbbba947$export$acf4b8bdf24aab34 = $a1657dd5dbbba947$export$6e114beec37430d7.toLowerCase();
const $a1657dd5dbbba947$export$c65c8c9f514da472 = "date";
const $a1657dd5dbbba947$export$20d6a73fd0b10982 = [
    $a1657dd5dbbba947$export$9924a64a4b8b0d58,
    $a1657dd5dbbba947$export$acf4b8bdf24aab34,
    $a1657dd5dbbba947$export$c65c8c9f514da472
];
const $a1657dd5dbbba947$export$29961f34c719157e = $a1657dd5dbbba947$export$41ae838dc1e0f082.toLowerCase();
const $a1657dd5dbbba947$export$eaef12179141669a = "x-amz-content-sha256";
const $a1657dd5dbbba947$export$fdc81b663012a8d2 = $a1657dd5dbbba947$export$8e1383b7eea7bee.toLowerCase();
const $a1657dd5dbbba947$export$96307741595055fc = "host";
const $a1657dd5dbbba947$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
const $a1657dd5dbbba947$export$8085db98abbe0597 = /^proxy-/;
const $a1657dd5dbbba947$export$758380400526c39 = /^sec-/;
const $a1657dd5dbbba947$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
const $a1657dd5dbbba947$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
const $a1657dd5dbbba947$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
const $a1657dd5dbbba947$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
const $a1657dd5dbbba947$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
const $a1657dd5dbbba947$export$bf665777b4a1722f = 50;
const $a1657dd5dbbba947$export$c4bf0942098f6bb = "aws4_request";
const $a1657dd5dbbba947$export$274df788bdcca184 = 604800;





const $2b9ee0fe71097206$var$signingKeyCache = {};
const $2b9ee0fe71097206$var$cacheQueue = [];
const $2b9ee0fe71097206$export$41a9651decfe2bde = (shortDate, region, service)=>`${shortDate}/${region}/${service}/${0, $a1657dd5dbbba947$export$c4bf0942098f6bb}`;
const $2b9ee0fe71097206$export$8b95a069d16dd783 = async (sha256Constructor, credentials, shortDate, region, service)=>{
    const credsHash = await $2b9ee0fe71097206$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${(0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in $2b9ee0fe71097206$var$signingKeyCache) return $2b9ee0fe71097206$var$signingKeyCache[cacheKey];
    $2b9ee0fe71097206$var$cacheQueue.push(cacheKey);
    while($2b9ee0fe71097206$var$cacheQueue.length > (0, $a1657dd5dbbba947$export$bf665777b4a1722f))delete $2b9ee0fe71097206$var$signingKeyCache[$2b9ee0fe71097206$var$cacheQueue.shift()];
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [
        shortDate,
        region,
        service,
        (0, $a1657dd5dbbba947$export$c4bf0942098f6bb)
    ])key = await $2b9ee0fe71097206$var$hmac(sha256Constructor, key, signable);
    return $2b9ee0fe71097206$var$signingKeyCache[cacheKey] = key;
};
const $2b9ee0fe71097206$export$a31b95746ea0a30a = ()=>{
    $2b9ee0fe71097206$var$cacheQueue.length = 0;
    Object.keys($2b9ee0fe71097206$var$signingKeyCache).forEach((cacheKey)=>{
        delete $2b9ee0fe71097206$var$signingKeyCache[cacheKey];
    });
};
const $2b9ee0fe71097206$var$hmac = (ctor, secret, data)=>{
    const hash = new ctor(secret);
    hash.update((0, $e548b91235db5cfc$export$73470fd2221e6aef)(data));
    return hash.digest();
};



const $3711235d8e5015ee$export$859d7f1bb55e2914 = ({ headers: headers }, unsignableHeaders, signableHeaders)=>{
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()){
        if (headers[headerName] == undefined) continue;
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in (0, $a1657dd5dbbba947$export$8ffdcd58c4092560) || unsignableHeaders?.has(canonicalHeaderName) || (0, $a1657dd5dbbba947$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $a1657dd5dbbba947$export$758380400526c39).test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};




const $6d4725dbc7ca19cd$export$8fea7e63ecd1ddbb = ({ query: query = {} })=>{
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query).sort()){
        if (key.toLowerCase() === (0, $a1657dd5dbbba947$export$29961f34c719157e)) continue;
        keys.push(key);
        const value = query[key];
        if (typeof value === "string") serialized[key] = `${(0, $44b4089172bbcee0$export$c3b4775ad75a73db)(key)}=${(0, $44b4089172bbcee0$export$c3b4775ad75a73db)(value)}`;
        else if (Array.isArray(value)) serialized[key] = value.slice(0).reduce((encoded, value)=>encoded.concat([
                `${(0, $44b4089172bbcee0$export$c3b4775ad75a73db)(key)}=${(0, $44b4089172bbcee0$export$c3b4775ad75a73db)(value)}`
            ]), []).sort().join("&");
    }
    return keys.map((key)=>serialized[key]).filter((serialized)=>serialized).join("&");
};






const $05e6a90e0ea94a56$export$a46a74202b0efd71 = async ({ headers: headers, body: body }, hashConstructor)=>{
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === (0, $a1657dd5dbbba947$export$eaef12179141669a)) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || (0, $ac7e68f76bf33be3$export$9dd3754ae86f0017)(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update((0, $e548b91235db5cfc$export$73470fd2221e6aef)(body));
        return (0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(await hashCtor.digest());
    }
    return 0, $a1657dd5dbbba947$export$91f7321b40d9fd07;
};


const $1d6316486d1b2b5d$export$17944590be865217 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};
const $1d6316486d1b2b5d$export$149b1181d497cd = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
    }
    return undefined;
};
const $1d6316486d1b2b5d$export$d3408eaf94074c90 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers))if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
};


const $8fe4db7fb1d2f441$export$d043aa0bf7223286 = ({ headers: headers, query: query, ...rest })=>({
        ...rest,
        headers: {
            ...headers
        },
        query: query ? $8fe4db7fb1d2f441$export$4923819f93729b21(query) : undefined
    });
const $8fe4db7fb1d2f441$export$4923819f93729b21 = (query)=>Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});


const $5fb2c4f9ab02391c$export$bfc08a76d4bd60f6 = (request, options = {})=>{
    const { headers: headers, query: query = {} } = typeof request.clone === "function" ? request.clone() : (0, $8fe4db7fb1d2f441$export$d043aa0bf7223286)(request);
    for (const name of Object.keys(headers)){
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !options.unhoistableHeaders?.has(lname)) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return {
        ...request,
        headers: headers,
        query: query
    };
};




const $716b1f50de7e844c$export$a7cfe9131aa06be4 = (request)=>{
    request = typeof request.clone === "function" ? request.clone() : (0, $8fe4db7fb1d2f441$export$d043aa0bf7223286)(request);
    for (const headerName of Object.keys(request.headers))if ((0, $a1657dd5dbbba947$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    return request;
};


const $6a9f233137451648$export$b65d57190c224ef2 = (time)=>$6a9f233137451648$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
const $6a9f233137451648$export$e67a095c620b86fe = (time)=>{
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};


class $332513fcfabd50ca$export$20baf4d3f65eb30c {
    constructor({ applyChecksum: applyChecksum, credentials: credentials, region: region, service: service, sha256: sha256, uriEscapePath: uriEscapePath = true }){
        this.headerMarshaller = new (0, $affcb535cdea111e$export$74fd41a85c5dcec9)((0, $2554f7a5fe934436$export$b4b216764bb846eb), (0, $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc));
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $184c4781feb1f814$export$b1276c07738d6325)(region);
        this.credentialProvider = (0, $184c4781feb1f814$export$b1276c07738d6325)(credentials);
    }
    async presign(originalRequest, options = {}) {
        const { signingDate: signingDate = new Date(), expiresIn: expiresIn = 3600, unsignableHeaders: unsignableHeaders, unhoistableHeaders: unhoistableHeaders, signableHeaders: signableHeaders, signingRegion: signingRegion, signingService: signingService } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { longDate: longDate, shortDate: shortDate } = $332513fcfabd50ca$var$formatDate(signingDate);
        if (expiresIn > (0, $a1657dd5dbbba947$export$274df788bdcca184)) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = (0, $2b9ee0fe71097206$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        const request = (0, $5fb2c4f9ab02391c$export$bfc08a76d4bd60f6)((0, $716b1f50de7e844c$export$a7cfe9131aa06be4)(originalRequest), {
            unhoistableHeaders: unhoistableHeaders
        });
        if (credentials.sessionToken) request.query[0, $a1657dd5dbbba947$export$8e1383b7eea7bee] = credentials.sessionToken;
        request.query[0, $a1657dd5dbbba947$export$186cd8495ba0377d] = (0, $a1657dd5dbbba947$export$863a63fba5b2ddf5);
        request.query[0, $a1657dd5dbbba947$export$5c8e6dd7758f59d6] = `${credentials.accessKeyId}/${scope}`;
        request.query[0, $a1657dd5dbbba947$export$6e114beec37430d7] = longDate;
        request.query[0, $a1657dd5dbbba947$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
        const canonicalHeaders = (0, $3711235d8e5015ee$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
        request.query[0, $a1657dd5dbbba947$export$2dcbb254f883c238] = $332513fcfabd50ca$var$getCanonicalHeaderList(canonicalHeaders);
        request.query[0, $a1657dd5dbbba947$export$41ae838dc1e0f082] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await (0, $05e6a90e0ea94a56$export$a46a74202b0efd71)(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") return this.signString(toSign, options);
        else if (toSign.headers && toSign.payload) return this.signEvent(toSign, options);
        else if (toSign.message) return this.signMessage(toSign, options);
        else return this.signRequest(toSign, options);
    }
    async signEvent({ headers: headers, payload: payload }, { signingDate: signingDate = new Date(), priorSignature: priorSignature, signingRegion: signingRegion, signingService: signingService }) {
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate, longDate: longDate } = $332513fcfabd50ca$var$formatDate(signingDate);
        const scope = (0, $2b9ee0fe71097206$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        const hashedPayload = await (0, $05e6a90e0ea94a56$export$a46a74202b0efd71)({
            headers: {},
            body: payload
        }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = (0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(await hash.digest());
        const stringToSign = [
            (0, $a1657dd5dbbba947$export$9a1f6cf06ac56167),
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload
        ].join("\n");
        return this.signString(stringToSign, {
            signingDate: signingDate,
            signingRegion: region,
            signingService: signingService
        });
    }
    async signMessage(signableMessage, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService }) {
        const promise = this.signEvent({
            headers: this.headerMarshaller.format(signableMessage.message.headers),
            payload: signableMessage.message.body
        }, {
            signingDate: signingDate,
            signingRegion: signingRegion,
            signingService: signingService,
            priorSignature: signableMessage.priorSignature
        });
        return promise.then((signature)=>{
            return {
                message: signableMessage.message,
                signature: signature
            };
        });
    }
    async signString(stringToSign, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate } = $332513fcfabd50ca$var$formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update((0, $e548b91235db5cfc$export$73470fd2221e6aef)(stringToSign));
        return (0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate: signingDate = new Date(), signableHeaders: signableHeaders, unsignableHeaders: unsignableHeaders, signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const request = (0, $716b1f50de7e844c$export$a7cfe9131aa06be4)(requestToSign);
        const { longDate: longDate, shortDate: shortDate } = $332513fcfabd50ca$var$formatDate(signingDate);
        const scope = (0, $2b9ee0fe71097206$export$41a9651decfe2bde)(shortDate, region, signingService ?? this.service);
        request.headers[0, $a1657dd5dbbba947$export$acf4b8bdf24aab34] = longDate;
        if (credentials.sessionToken) request.headers[0, $a1657dd5dbbba947$export$fdc81b663012a8d2] = credentials.sessionToken;
        const payloadHash = await (0, $05e6a90e0ea94a56$export$a46a74202b0efd71)(request, this.sha256);
        if (!(0, $1d6316486d1b2b5d$export$17944590be865217)((0, $a1657dd5dbbba947$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $a1657dd5dbbba947$export$eaef12179141669a] = payloadHash;
        const canonicalHeaders = (0, $3711235d8e5015ee$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[0, $a1657dd5dbbba947$export$9924a64a4b8b0d58] = `${0, $a1657dd5dbbba947$export$863a63fba5b2ddf5} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${$332513fcfabd50ca$var$getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${(0, $6d4725dbc7ca19cd$export$8fea7e63ecd1ddbb)(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update((0, $e548b91235db5cfc$export$73470fd2221e6aef)(canonicalRequest));
        const hashedRequest = await hash.digest();
        return `${0, $a1657dd5dbbba947$export$863a63fba5b2ddf5}
${longDate}
${credentialScope}
${(0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(hashedRequest)}`;
    }
    getCanonicalPath({ path: path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")){
                if (pathSegment?.length === 0) continue;
                if (pathSegment === ".") continue;
                if (pathSegment === "..") normalizedPathSegments.pop();
                else normalizedPathSegments.push(pathSegment);
            }
            const normalizedPath = `${path?.startsWith("/") ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && path?.endsWith("/") ? "/" : ""}`;
            const doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update((0, $e548b91235db5cfc$export$73470fd2221e6aef)(stringToSign));
        return (0, $ff463032e6a14a0a$export$7ea66e3774a60b67)(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return (0, $2b9ee0fe71097206$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    }
}
const $332513fcfabd50ca$var$formatDate = (now)=>{
    const longDate = (0, $6a9f233137451648$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
const $332513fcfabd50ca$var$getCanonicalHeaderList = (headers)=>Object.keys(headers).sort().join(";");











const $cbefa977fc2921db$var$CREDENTIAL_EXPIRE_WINDOW = 300000;
const $cbefa977fc2921db$export$1dd62920de1feabb = (input)=>{
    const normalizedCreds = input.credentials ? $cbefa977fc2921db$var$normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    const { signingEscapePath: signingEscapePath = true, systemClockOffset: systemClockOffset = input.systemClockOffset || 0, sha256: sha256 } = input;
    let signer;
    if (input.signer) signer = (0, $184c4781feb1f814$export$b1276c07738d6325)(input.signer);
    else if (input.regionInfoProvider) signer = ()=>(0, $184c4781feb1f814$export$b1276c07738d6325)(input.region)().then(async (region)=>[
                await input.regionInfoProvider(region, {
                    useFipsEndpoint: await input.useFipsEndpoint(),
                    useDualstackEndpoint: await input.useDualstackEndpoint()
                }) || {},
                region
            ]).then(([regionInfo, region])=>{
            const { signingRegion: signingRegion, signingService: signingService } = regionInfo;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            const params = {
                ...input,
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            };
            const SignerCtor = input.signerConstructor || (0, $332513fcfabd50ca$export$20baf4d3f65eb30c);
            return new SignerCtor(params);
        });
    else signer = async (authScheme)=>{
        authScheme = Object.assign({}, {
            name: "sigv4",
            signingName: input.signingName || input.defaultSigningName,
            signingRegion: await (0, $184c4781feb1f814$export$b1276c07738d6325)(input.region)(),
            properties: {}
        }, authScheme);
        const signingRegion = authScheme.signingRegion;
        const signingService = authScheme.signingName;
        input.signingRegion = input.signingRegion || signingRegion;
        input.signingName = input.signingName || signingService || input.serviceId;
        const params = {
            ...input,
            credentials: normalizedCreds,
            region: input.signingRegion,
            service: input.signingName,
            sha256: sha256,
            uriEscapePath: signingEscapePath
        };
        const SignerCtor = input.signerConstructor || (0, $332513fcfabd50ca$export$20baf4d3f65eb30c);
        return new SignerCtor(params);
    };
    return {
        ...input,
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    };
};
const $cbefa977fc2921db$export$578a43ebf7e4c675 = (input)=>{
    const normalizedCreds = input.credentials ? $cbefa977fc2921db$var$normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
    const { signingEscapePath: signingEscapePath = true, systemClockOffset: systemClockOffset = input.systemClockOffset || 0, sha256: sha256 } = input;
    let signer;
    if (input.signer) signer = (0, $184c4781feb1f814$export$b1276c07738d6325)(input.signer);
    else signer = (0, $184c4781feb1f814$export$b1276c07738d6325)(new (0, $332513fcfabd50ca$export$20baf4d3f65eb30c)({
        credentials: normalizedCreds,
        region: input.region,
        service: input.signingName,
        sha256: sha256,
        uriEscapePath: signingEscapePath
    }));
    return {
        ...input,
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    };
};
const $cbefa977fc2921db$var$normalizeCredentialProvider = (credentials)=>{
    if (typeof credentials === "function") return (0, $4ee178ba25e8e3b7$export$fc10aeed3a532e2a)(credentials, (credentials)=>credentials.expiration !== undefined && credentials.expiration.getTime() - Date.now() < $cbefa977fc2921db$var$CREDENTIAL_EXPIRE_WINDOW, (credentials)=>credentials.expiration !== undefined);
    return (0, $184c4781feb1f814$export$b1276c07738d6325)(credentials);
};



const $bc4de7f388f1dec3$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);



const $18d5f3a588bf1837$export$c162a01d4a03ea6f = (clockTime, systemClockOffset)=>Math.abs((0, $bc4de7f388f1dec3$export$86d5c90340985ada)(systemClockOffset).getTime() - clockTime) >= 300000;


const $3541a76fda0b82cb$export$1ed4d48b860b1348 = (clockTime, currentSystemClockOffset)=>{
    const clockTimeInMs = Date.parse(clockTime);
    if ((0, $18d5f3a588bf1837$export$c162a01d4a03ea6f)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};


const $88d408844032d892$export$78af9708f8cf3422 = (options)=>(next, context)=>async function(args) {
            if (!(0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(args.request)) return next(args);
            const authScheme = context.endpointV2?.properties?.authSchemes?.[0];
            const multiRegionOverride = authScheme?.name === "sigv4a" ? authScheme?.signingRegionSet?.join(",") : undefined;
            const signer = await options.signer(authScheme);
            const output = await next({
                ...args,
                request: await signer.sign(args.request, {
                    signingDate: (0, $bc4de7f388f1dec3$export$86d5c90340985ada)(options.systemClockOffset),
                    signingRegion: multiRegionOverride || context["signing_region"],
                    signingService: context["signing_service"]
                })
            }).catch((error)=>{
                const serverTime = error.ServerTime ?? $88d408844032d892$var$getDateHeader(error.$response);
                if (serverTime) options.systemClockOffset = (0, $3541a76fda0b82cb$export$1ed4d48b860b1348)(serverTime, options.systemClockOffset);
                throw error;
            });
            const dateHeader = $88d408844032d892$var$getDateHeader(output.response);
            if (dateHeader) options.systemClockOffset = (0, $3541a76fda0b82cb$export$1ed4d48b860b1348)(dateHeader, options.systemClockOffset);
            return output;
        };
const $88d408844032d892$var$getDateHeader = (response)=>(0, $2c63d34427c28f98$export$1d94dfe0d9d1f1e7).isInstance(response) ? response.headers?.date ?? response.headers?.Date : undefined;
const $88d408844032d892$export$29f4b3a6e94017d3 = {
    name: "awsAuthMiddleware",
    tags: [
        "SIGNATURE",
        "AWSAUTH"
    ],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true
};
const $88d408844032d892$export$59c2b7ad30ed4046 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($88d408844032d892$export$78af9708f8cf3422(options), $88d408844032d892$export$29f4b3a6e94017d3);
        }
    });
const $88d408844032d892$export$6255ccc0b84310b8 = $88d408844032d892$export$59c2b7ad30ed4046;




function $754475b8730b53d4$export$ec9a2d5663958cb(input) {
    return {
        ...input,
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    };
}


var $dc626a9d0b895939$exports = {};

$parcel$export($dc626a9d0b895939$exports, "partition", () => $dc626a9d0b895939$export$b29f828819edca8d);
$parcel$export($dc626a9d0b895939$exports, "setPartitionInfo", () => $dc626a9d0b895939$export$5b2daaf969a6da2e);
$parcel$export($dc626a9d0b895939$exports, "useDefaultPartitionInfo", () => $dc626a9d0b895939$export$1003c50da40cdce);
$parcel$export($dc626a9d0b895939$exports, "getUserAgentPrefix", () => $dc626a9d0b895939$export$c249da7071246380);
var $7b1e595046c17e5b$exports = {};
$7b1e595046c17e5b$exports = JSON.parse("{\"partitions\":[{\"id\":\"aws\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com\",\"dualStackDnsSuffix\":\"api.aws\",\"name\":\"aws\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^(us|eu|ap|sa|ca|me|af|il)\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"af-south-1\":{\"description\":\"Africa (Cape Town)\"},\"ap-east-1\":{\"description\":\"Asia Pacific (Hong Kong)\"},\"ap-northeast-1\":{\"description\":\"Asia Pacific (Tokyo)\"},\"ap-northeast-2\":{\"description\":\"Asia Pacific (Seoul)\"},\"ap-northeast-3\":{\"description\":\"Asia Pacific (Osaka)\"},\"ap-south-1\":{\"description\":\"Asia Pacific (Mumbai)\"},\"ap-south-2\":{\"description\":\"Asia Pacific (Hyderabad)\"},\"ap-southeast-1\":{\"description\":\"Asia Pacific (Singapore)\"},\"ap-southeast-2\":{\"description\":\"Asia Pacific (Sydney)\"},\"ap-southeast-3\":{\"description\":\"Asia Pacific (Jakarta)\"},\"ap-southeast-4\":{\"description\":\"Asia Pacific (Melbourne)\"},\"aws-global\":{\"description\":\"AWS Standard global region\"},\"ca-central-1\":{\"description\":\"Canada (Central)\"},\"eu-central-1\":{\"description\":\"Europe (Frankfurt)\"},\"eu-central-2\":{\"description\":\"Europe (Zurich)\"},\"eu-north-1\":{\"description\":\"Europe (Stockholm)\"},\"eu-south-1\":{\"description\":\"Europe (Milan)\"},\"eu-south-2\":{\"description\":\"Europe (Spain)\"},\"eu-west-1\":{\"description\":\"Europe (Ireland)\"},\"eu-west-2\":{\"description\":\"Europe (London)\"},\"eu-west-3\":{\"description\":\"Europe (Paris)\"},\"il-central-1\":{\"description\":\"Israel (Tel Aviv)\"},\"me-central-1\":{\"description\":\"Middle East (UAE)\"},\"me-south-1\":{\"description\":\"Middle East (Bahrain)\"},\"sa-east-1\":{\"description\":\"South America (Sao Paulo)\"},\"us-east-1\":{\"description\":\"US East (N. Virginia)\"},\"us-east-2\":{\"description\":\"US East (Ohio)\"},\"us-west-1\":{\"description\":\"US West (N. California)\"},\"us-west-2\":{\"description\":\"US West (Oregon)\"}}},{\"id\":\"aws-cn\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com.cn\",\"dualStackDnsSuffix\":\"api.amazonwebservices.com.cn\",\"name\":\"aws-cn\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^cn\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-cn-global\":{\"description\":\"AWS China global region\"},\"cn-north-1\":{\"description\":\"China (Beijing)\"},\"cn-northwest-1\":{\"description\":\"China (Ningxia)\"}}},{\"id\":\"aws-us-gov\",\"outputs\":{\"dnsSuffix\":\"amazonaws.com\",\"dualStackDnsSuffix\":\"api.aws\",\"name\":\"aws-us-gov\",\"supportsDualStack\":true,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-gov\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-us-gov-global\":{\"description\":\"AWS GovCloud (US) global region\"},\"us-gov-east-1\":{\"description\":\"AWS GovCloud (US-East)\"},\"us-gov-west-1\":{\"description\":\"AWS GovCloud (US-West)\"}}},{\"id\":\"aws-iso\",\"outputs\":{\"dnsSuffix\":\"c2s.ic.gov\",\"dualStackDnsSuffix\":\"c2s.ic.gov\",\"name\":\"aws-iso\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-iso\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-global\":{\"description\":\"AWS ISO (US) global region\"},\"us-iso-east-1\":{\"description\":\"US ISO East\"},\"us-iso-west-1\":{\"description\":\"US ISO WEST\"}}},{\"id\":\"aws-iso-b\",\"outputs\":{\"dnsSuffix\":\"sc2s.sgov.gov\",\"dualStackDnsSuffix\":\"sc2s.sgov.gov\",\"name\":\"aws-iso-b\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-isob\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{\"aws-iso-b-global\":{\"description\":\"AWS ISOB (US) global region\"},\"us-isob-east-1\":{\"description\":\"US ISOB East (Ohio)\"}}},{\"id\":\"aws-iso-e\",\"outputs\":{\"dnsSuffix\":\"cloud.adc-e.uk\",\"dualStackDnsSuffix\":\"cloud.adc-e.uk\",\"name\":\"aws-iso-e\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^eu\\\\-isoe\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{}},{\"id\":\"aws-iso-f\",\"outputs\":{\"dnsSuffix\":\"csp.hci.ic.gov\",\"dualStackDnsSuffix\":\"csp.hci.ic.gov\",\"name\":\"aws-iso-f\",\"supportsDualStack\":false,\"supportsFIPS\":true},\"regionRegex\":\"^us\\\\-isof\\\\-\\\\w+\\\\-\\\\d+$\",\"regions\":{}}],\"version\":\"1.1\"}");


let $dc626a9d0b895939$var$selectedPartitionsInfo = (0, (/*@__PURE__*/$parcel$interopDefault($7b1e595046c17e5b$exports)));
let $dc626a9d0b895939$var$selectedUserAgentPrefix = "";
const $dc626a9d0b895939$export$b29f828819edca8d = (value)=>{
    const { partitions: partitions } = $dc626a9d0b895939$var$selectedPartitionsInfo;
    for (const partition of partitions){
        const { regions: regions, outputs: outputs } = partition;
        for (const [region, regionData] of Object.entries(regions)){
            if (region === value) return {
                ...outputs,
                ...regionData
            };
        }
    }
    for (const partition of partitions){
        const { regionRegex: regionRegex, outputs: outputs } = partition;
        if (new RegExp(regionRegex).test(value)) return {
            ...outputs
        };
    }
    const DEFAULT_PARTITION = partitions.find((partition)=>partition.id === "aws");
    if (!DEFAULT_PARTITION) throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
    return {
        ...DEFAULT_PARTITION.outputs
    };
};
const $dc626a9d0b895939$export$5b2daaf969a6da2e = (partitionsInfo, userAgentPrefix = "")=>{
    $dc626a9d0b895939$var$selectedPartitionsInfo = partitionsInfo;
    $dc626a9d0b895939$var$selectedUserAgentPrefix = userAgentPrefix;
};
const $dc626a9d0b895939$export$1003c50da40cdce = ()=>{
    $dc626a9d0b895939$export$5b2daaf969a6da2e((0, (/*@__PURE__*/$parcel$interopDefault($7b1e595046c17e5b$exports))), "");
};
const $dc626a9d0b895939$export$c249da7071246380 = ()=>$dc626a9d0b895939$var$selectedUserAgentPrefix;


const $4065d69388554ce4$var$IP_V4_REGEX = new RegExp(`^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$`);
const $4065d69388554ce4$export$2c835f0fe38d2e0e = (value)=>$4065d69388554ce4$var$IP_V4_REGEX.test(value) || value.startsWith("[") && value.endsWith("]");


const $5b695a7ea91ed44b$export$2a09d6727e5ecede = "endpoints";


function $df34d0e77d2d4c7b$export$7b48b8905f46d631(input) {
    if (typeof input !== "object" || input == null) return input;
    if ("ref" in input) return `$${$df34d0e77d2d4c7b$export$7b48b8905f46d631(input.ref)}`;
    if ("fn" in input) return `${input.fn}(${(input.argv || []).map($df34d0e77d2d4c7b$export$7b48b8905f46d631).join(", ")})`;
    return JSON.stringify(input, null, 2);
}




class $0ce0b9aadce7061c$export$603f31e9980bccaf extends Error {
    constructor(message){
        super(message);
        this.name = "EndpointError";
    }
}



















var $301206997a00575d$exports = {};

$parcel$export($301206997a00575d$exports, "aws", () => $d7ec38fe8e2f7a6a$exports);
var $d7ec38fe8e2f7a6a$exports = {};
var $30b3b9a5722908f3$exports = {};

$parcel$export($30b3b9a5722908f3$exports, "isVirtualHostableS3Bucket", () => $30b3b9a5722908f3$export$6b6a3f4e857868ec);

var $a44faa70b797f995$exports = {};

$parcel$export($a44faa70b797f995$exports, "isValidHostLabel", () => $a44faa70b797f995$export$8a024457acd8bb49);
const $a44faa70b797f995$var$VALID_HOST_LABEL_REGEX = new RegExp(`^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$`);
const $a44faa70b797f995$export$8a024457acd8bb49 = (value, allowSubDomains = false)=>{
    if (!allowSubDomains) return $a44faa70b797f995$var$VALID_HOST_LABEL_REGEX.test(value);
    const labels = value.split(".");
    for (const label of labels){
        if (!$a44faa70b797f995$export$8a024457acd8bb49(label)) return false;
    }
    return true;
};


const $30b3b9a5722908f3$export$6b6a3f4e857868ec = (value, allowSubDomains = false)=>{
    if (allowSubDomains) {
        for (const label of value.split(".")){
            if (!$30b3b9a5722908f3$export$6b6a3f4e857868ec(label)) return false;
        }
        return true;
    }
    if (!(0, $a44faa70b797f995$export$8a024457acd8bb49)(value)) return false;
    if (value.length < 3 || value.length > 63) return false;
    if (value !== value.toLowerCase()) return false;
    if ((0, $4065d69388554ce4$export$2c835f0fe38d2e0e)(value)) return false;
    return true;
};


var $8ab4d9d9e20a654f$exports = {};

$parcel$export($8ab4d9d9e20a654f$exports, "parseArn", () => $8ab4d9d9e20a654f$export$ec6a98ce8737fc2c);
const $8ab4d9d9e20a654f$export$ec6a98ce8737fc2c = (value)=>{
    const segments = value.split(":");
    if (segments.length < 6) return null;
    const [arn, partition, service, region, accountId, ...resourceId] = segments;
    if (arn !== "arn" || partition === "" || service === "" || resourceId[0] === "") return null;
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resourceId: resourceId[0].includes("/") ? resourceId[0].split("/") : resourceId
    };
};



$parcel$exportWildcard($d7ec38fe8e2f7a6a$exports, $30b3b9a5722908f3$exports);
$parcel$exportWildcard($d7ec38fe8e2f7a6a$exports, $8ab4d9d9e20a654f$exports);
$parcel$exportWildcard($d7ec38fe8e2f7a6a$exports, $dc626a9d0b895939$exports);


var $7f219f00e0888916$exports = {};

$parcel$export($7f219f00e0888916$exports, "booleanEquals", () => $7f219f00e0888916$export$6608cbdc537206b3);
const $7f219f00e0888916$export$6608cbdc537206b3 = (value1, value2)=>value1 === value2;


var $93a8823e235bf805$exports = {};

$parcel$export($93a8823e235bf805$exports, "getAttr", () => $93a8823e235bf805$export$6a93fe6b2b4c71a0);


const $34b410a99c58edc3$export$e8fa1ee343c456a5 = (path)=>{
    const parts = path.split(".");
    const pathList = [];
    for (const part of parts){
        const squareBracketIndex = part.indexOf("[");
        if (squareBracketIndex !== -1) {
            if (part.indexOf("]") !== part.length - 1) throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Path: '${path}' does not end with ']'`);
            const arrayIndex = part.slice(squareBracketIndex + 1, -1);
            if (Number.isNaN(parseInt(arrayIndex))) throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Invalid array index: '${arrayIndex}' in path: '${path}'`);
            if (squareBracketIndex !== 0) pathList.push(part.slice(0, squareBracketIndex));
            pathList.push(arrayIndex);
        } else pathList.push(part);
    }
    return pathList;
};


const $93a8823e235bf805$export$6a93fe6b2b4c71a0 = (value, path)=>(0, $34b410a99c58edc3$export$e8fa1ee343c456a5)(path).reduce((acc, index)=>{
        if (typeof acc !== "object") throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Index '${index}' in '${path}' not found in '${JSON.stringify(value)}'`);
        else if (Array.isArray(acc)) return acc[parseInt(index)];
        return acc[index];
    }, value);


var $abec3ed5a545362f$exports = {};

$parcel$export($abec3ed5a545362f$exports, "isSet", () => $abec3ed5a545362f$export$6750766a7c7ec627);
const $abec3ed5a545362f$export$6750766a7c7ec627 = (value)=>value != null;



var $b6c8e153eccc4620$exports = {};

$parcel$export($b6c8e153eccc4620$exports, "not", () => $b6c8e153eccc4620$export$6003a5f097c73977);
const $b6c8e153eccc4620$export$6003a5f097c73977 = (value)=>!value;


var $f6b4696410beecd2$exports = {};

$parcel$export($f6b4696410beecd2$exports, "parseURL", () => $f6b4696410beecd2$export$4b3d9a5bae55976);



















var $4755d33108cef871$export$c62cb8f0251fe033;
(function(HostAddressType) {
    HostAddressType["AAAA"] = "AAAA";
    HostAddressType["A"] = "A";
})($4755d33108cef871$export$c62cb8f0251fe033 || ($4755d33108cef871$export$c62cb8f0251fe033 = {}));



























































const $f6b4696410beecd2$var$DEFAULT_PORTS = {
    [(0, $4dccccca93fbe3a1$export$b141d049add1dcb5).HTTP]: 80,
    [(0, $4dccccca93fbe3a1$export$b141d049add1dcb5).HTTPS]: 443
};
const $f6b4696410beecd2$export$4b3d9a5bae55976 = (value)=>{
    const whatwgURL = (()=>{
        try {
            if (value instanceof URL) return value;
            if (typeof value === "object" && "hostname" in value) {
                const { hostname: hostname, port: port, protocol: protocol = "", path: path = "", query: query = {} } = value;
                const url = new URL(`${protocol}//${hostname}${port ? `:${port}` : ""}${path}`);
                url.search = Object.entries(query).map(([k, v])=>`${k}=${v}`).join("&");
                return url;
            }
            return new URL(value);
        } catch (error) {
            return null;
        }
    })();
    if (!whatwgURL) {
        console.error(`Unable to parse ${JSON.stringify(value)} as a whatwg URL.`);
        return null;
    }
    const urlString = whatwgURL.href;
    const { host: host, hostname: hostname, pathname: pathname, protocol: protocol, search: search } = whatwgURL;
    if (search) return null;
    const scheme = protocol.slice(0, -1);
    if (!Object.values((0, $4dccccca93fbe3a1$export$b141d049add1dcb5)).includes(scheme)) return null;
    const isIp = (0, $4065d69388554ce4$export$2c835f0fe38d2e0e)(hostname);
    const inputContainsDefaultPort = urlString.includes(`${host}:${$f6b4696410beecd2$var$DEFAULT_PORTS[scheme]}`) || typeof value === "string" && value.includes(`${host}:${$f6b4696410beecd2$var$DEFAULT_PORTS[scheme]}`);
    const authority = `${host}${inputContainsDefaultPort ? `:${$f6b4696410beecd2$var$DEFAULT_PORTS[scheme]}` : ``}`;
    return {
        scheme: scheme,
        authority: authority,
        path: pathname,
        normalizedPath: pathname.endsWith("/") ? pathname : `${pathname}/`,
        isIp: isIp
    };
};


var $e8fa4d36809ae8eb$exports = {};

$parcel$export($e8fa4d36809ae8eb$exports, "stringEquals", () => $e8fa4d36809ae8eb$export$f8f73f238947765e);
const $e8fa4d36809ae8eb$export$f8f73f238947765e = (value1, value2)=>value1 === value2;


var $18912d86e803d3e9$exports = {};

$parcel$export($18912d86e803d3e9$exports, "substring", () => $18912d86e803d3e9$export$662d3818631fba36);
const $18912d86e803d3e9$export$662d3818631fba36 = (input, start, stop, reverse)=>{
    if (start >= stop || input.length < stop) return null;
    if (!reverse) return input.substring(start, stop);
    return input.substring(input.length - stop, input.length - start);
};


var $6c3361740f806587$exports = {};

$parcel$export($6c3361740f806587$exports, "uriEncode", () => $6c3361740f806587$export$1ea6cdab375898b5);
const $6c3361740f806587$export$1ea6cdab375898b5 = (value)=>encodeURIComponent(value).replace(/[!*'()]/g, (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`);


$parcel$exportWildcard($301206997a00575d$exports, $7f219f00e0888916$exports);
$parcel$exportWildcard($301206997a00575d$exports, $93a8823e235bf805$exports);
$parcel$exportWildcard($301206997a00575d$exports, $abec3ed5a545362f$exports);
$parcel$exportWildcard($301206997a00575d$exports, $a44faa70b797f995$exports);
$parcel$exportWildcard($301206997a00575d$exports, $b6c8e153eccc4620$exports);
$parcel$exportWildcard($301206997a00575d$exports, $f6b4696410beecd2$exports);
$parcel$exportWildcard($301206997a00575d$exports, $e8fa4d36809ae8eb$exports);
$parcel$exportWildcard($301206997a00575d$exports, $18912d86e803d3e9$exports);
$parcel$exportWildcard($301206997a00575d$exports, $6c3361740f806587$exports);





const $9e059044f55c72fb$export$c77ca0e5a2c5469c = (template, options)=>{
    const evaluatedTemplateArr = [];
    const templateContext = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    let currentIndex = 0;
    while(currentIndex < template.length){
        const openingBraceIndex = template.indexOf("{", currentIndex);
        if (openingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(currentIndex));
            break;
        }
        evaluatedTemplateArr.push(template.slice(currentIndex, openingBraceIndex));
        const closingBraceIndex = template.indexOf("}", openingBraceIndex);
        if (closingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex));
            break;
        }
        if (template[openingBraceIndex + 1] === "{" && template[closingBraceIndex + 1] === "}") {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex + 1, closingBraceIndex));
            currentIndex = closingBraceIndex + 2;
        }
        const parameterName = template.substring(openingBraceIndex + 1, closingBraceIndex);
        if (parameterName.includes("#")) {
            const [refName, attrName] = parameterName.split("#");
            evaluatedTemplateArr.push((0, $93a8823e235bf805$export$6a93fe6b2b4c71a0)(templateContext[refName], attrName));
        } else evaluatedTemplateArr.push(templateContext[parameterName]);
        currentIndex = closingBraceIndex + 1;
    }
    return evaluatedTemplateArr.join("");
};


const $484cdce71437b6a9$export$812bd59fe014e418 = ({ ref: ref }, options)=>{
    const referenceRecord = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    return referenceRecord[ref];
};


const $6388f44122f70c6d$export$3191fa0ae67b450c = (obj, keyName, options)=>{
    if (typeof obj === "string") return (0, $9e059044f55c72fb$export$c77ca0e5a2c5469c)(obj, options);
    else if (obj["fn"]) return (0, $3c491ae99c939527$export$d883fbf232f0d35a)(obj, options);
    else if (obj["ref"]) return (0, $484cdce71437b6a9$export$812bd59fe014e418)(obj, options);
    throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`'${keyName}': ${String(obj)} is not a string, function or reference.`);
};


const $3c491ae99c939527$export$d883fbf232f0d35a = ({ fn: fn, argv: argv }, options)=>{
    const evaluatedArgs = argv.map((arg)=>[
            "boolean",
            "number"
        ].includes(typeof arg) ? arg : (0, $6388f44122f70c6d$export$3191fa0ae67b450c)(arg, "arg", options));
    return fn.split(".").reduce((acc, key)=>acc[key], $301206997a00575d$exports)(...evaluatedArgs);
};


const $14dfd694629c6a2f$export$6695392473e235ae = ({ assign: assign, ...fnArgs }, options)=>{
    if (assign && assign in options.referenceRecord) throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`'${assign}' is already defined in Reference Record.`);
    const value = (0, $3c491ae99c939527$export$d883fbf232f0d35a)(fnArgs, options);
    options.logger?.debug?.((0, $5b695a7ea91ed44b$export$2a09d6727e5ecede), `evaluateCondition: ${(0, $df34d0e77d2d4c7b$export$7b48b8905f46d631)(fnArgs)} = ${(0, $df34d0e77d2d4c7b$export$7b48b8905f46d631)(value)}`);
    return {
        result: value === "" ? true : !!value,
        ...assign != null && {
            toAssign: {
                name: assign,
                value: value
            }
        }
    };
};


const $a2a6e0cbbd615fe8$export$bad219652748f1f3 = (conditions = [], options)=>{
    const conditionsReferenceRecord = {};
    for (const condition of conditions){
        const { result: result, toAssign: toAssign } = (0, $14dfd694629c6a2f$export$6695392473e235ae)(condition, {
            ...options,
            referenceRecord: {
                ...options.referenceRecord,
                ...conditionsReferenceRecord
            }
        });
        if (!result) return {
            result: result
        };
        if (toAssign) {
            conditionsReferenceRecord[toAssign.name] = toAssign.value;
            options.logger?.debug?.((0, $5b695a7ea91ed44b$export$2a09d6727e5ecede), `assign: ${toAssign.name} := ${(0, $df34d0e77d2d4c7b$export$7b48b8905f46d631)(toAssign.value)}`);
        }
    }
    return {
        result: true,
        referenceRecord: conditionsReferenceRecord
    };
};




const $cbab8a8d8e2f325a$export$479dec716600cbb = (headers, options)=>Object.entries(headers).reduce((acc, [headerKey, headerVal])=>({
            ...acc,
            [headerKey]: headerVal.map((headerValEntry)=>{
                const processedExpr = (0, $6388f44122f70c6d$export$3191fa0ae67b450c)(headerValEntry, "Header value entry", options);
                if (typeof processedExpr !== "string") throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Header '${headerKey}' value '${processedExpr}' is not a string`);
                return processedExpr;
            })
        }), {});





const $c42b02f5f9251afc$export$39bc8a0c7360c2f4 = (property, options)=>{
    if (Array.isArray(property)) return property.map((propertyEntry)=>$c42b02f5f9251afc$export$39bc8a0c7360c2f4(propertyEntry, options));
    switch(typeof property){
        case "string":
            return (0, $9e059044f55c72fb$export$c77ca0e5a2c5469c)(property, options);
        case "object":
            if (property === null) throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Unexpected endpoint property: ${property}`);
            return (0, $b894211462bfa3de$export$f7b44341c2929056)(property, options);
        case "boolean":
            return property;
        default:
            throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Unexpected endpoint property type: ${typeof property}`);
    }
};


const $b894211462bfa3de$export$f7b44341c2929056 = (properties, options)=>Object.entries(properties).reduce((acc, [propertyKey, propertyVal])=>({
            ...acc,
            [propertyKey]: (0, $c42b02f5f9251afc$export$39bc8a0c7360c2f4)(propertyVal, options)
        }), {});




const $b94289564b2fb82f$export$c54f5a49b5be9709 = (endpointUrl, options)=>{
    const expression = (0, $6388f44122f70c6d$export$3191fa0ae67b450c)(endpointUrl, "Endpoint URL", options);
    if (typeof expression === "string") try {
        return new URL(expression);
    } catch (error) {
        console.error(`Failed to construct URL with ${expression}`, error);
        throw error;
    }
    throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Endpoint URL must be a string, got ${typeof expression}`);
};


const $d5bcf73de96017ec$export$791799461674b1cb = (endpointRule, options)=>{
    const { conditions: conditions, endpoint: endpoint } = endpointRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $a2a6e0cbbd615fe8$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    const endpointRuleOptions = {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    };
    const { url: url, properties: properties, headers: headers } = endpoint;
    options.logger?.debug?.((0, $5b695a7ea91ed44b$export$2a09d6727e5ecede), `Resolving endpoint from template: ${(0, $df34d0e77d2d4c7b$export$7b48b8905f46d631)(endpoint)}`);
    return {
        ...headers != undefined && {
            headers: (0, $cbab8a8d8e2f325a$export$479dec716600cbb)(headers, endpointRuleOptions)
        },
        ...properties != undefined && {
            properties: (0, $b894211462bfa3de$export$f7b44341c2929056)(properties, endpointRuleOptions)
        },
        url: (0, $b94289564b2fb82f$export$c54f5a49b5be9709)(url, endpointRuleOptions)
    };
};





const $e2f9154ef4d1f36b$export$a36dfbc7e1fb8626 = (errorRule, options)=>{
    const { conditions: conditions, error: error } = errorRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $a2a6e0cbbd615fe8$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)((0, $6388f44122f70c6d$export$3191fa0ae67b450c)(error, "Error", {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    }));
};




const $1261e107c79b0f98$export$2e518b103c26ca79 = (treeRule, options)=>{
    const { conditions: conditions, rules: rules } = treeRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $a2a6e0cbbd615fe8$export$bad219652748f1f3)(conditions, options);
    if (!result) return;
    return (0, $00e6e5b62bb1ab56$export$cd6fa289eb934f12)(rules, {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    });
};


const $00e6e5b62bb1ab56$export$cd6fa289eb934f12 = (rules, options)=>{
    for (const rule of rules){
        if (rule.type === "endpoint") {
            const endpointOrUndefined = (0, $d5bcf73de96017ec$export$791799461674b1cb)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else if (rule.type === "error") (0, $e2f9154ef4d1f36b$export$a36dfbc7e1fb8626)(rule, options);
        else if (rule.type === "tree") {
            const endpointOrUndefined = (0, $1261e107c79b0f98$export$2e518b103c26ca79)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Unknown endpoint rule: ${rule}`);
    }
    throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Rules evaluation failed`);
};




const $5904fe9d0ba50fed$export$48b88e4e5ecac119 = (ruleSetObject, options)=>{
    const { endpointParams: endpointParams, logger: logger } = options;
    const { parameters: parameters, rules: rules } = ruleSetObject;
    options.logger?.debug?.(`${(0, $5b695a7ea91ed44b$export$2a09d6727e5ecede)} Initial EndpointParams: ${(0, $df34d0e77d2d4c7b$export$7b48b8905f46d631)(endpointParams)}`);
    const paramsWithDefault = Object.entries(parameters).filter(([, v])=>v.default != null).map(([k, v])=>[
            k,
            v.default
        ]);
    if (paramsWithDefault.length > 0) for (const [paramKey, paramDefaultValue] of paramsWithDefault)endpointParams[paramKey] = endpointParams[paramKey] ?? paramDefaultValue;
    const requiredParams = Object.entries(parameters).filter(([, v])=>v.required).map(([k])=>k);
    for (const requiredParam of requiredParams){
        if (endpointParams[requiredParam] == null) throw new (0, $0ce0b9aadce7061c$export$603f31e9980bccaf)(`Missing required parameter: '${requiredParam}'`);
    }
    const endpoint = (0, $00e6e5b62bb1ab56$export$cd6fa289eb934f12)(rules, {
        endpointParams: endpointParams,
        logger: logger,
        referenceRecord: {}
    });
    if (options.endpointParams?.Endpoint) try {
        const givenEndpoint = new URL(options.endpointParams.Endpoint);
        const { protocol: protocol, port: port } = givenEndpoint;
        endpoint.url.protocol = protocol;
        endpoint.url.port = port;
    } catch (e) {}
    options.logger?.debug?.(`${(0, $5b695a7ea91ed44b$export$2a09d6727e5ecede)} Resolved endpoint: ${(0, $df34d0e77d2d4c7b$export$7b48b8905f46d631)(endpoint)}`);
    return endpoint;
};






const $0784beb967af4490$export$97a08a1bb7ee0545 = "user-agent";
const $0784beb967af4490$export$e010e3d6246262a3 = "x-amz-user-agent";
const $0784beb967af4490$export$27b7b95a5fde2b31 = " ";
const $0784beb967af4490$export$43290ff793d1777d = "/";
const $0784beb967af4490$export$2d1b87b5b2a59af3 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
const $0784beb967af4490$export$84cb6e726944481 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w\#]/g;
const $0784beb967af4490$export$f810014d932f8c3e = "-";


const $7b3c99e5173f4767$export$62c460923941c0b0 = (options)=>(next, context)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request)) return next(args);
            const { headers: headers } = request;
            const userAgent = context?.userAgent?.map($7b3c99e5173f4767$var$escapeUserAgent) || [];
            const defaultUserAgent = (await options.defaultUserAgentProvider()).map($7b3c99e5173f4767$var$escapeUserAgent);
            const customUserAgent = options?.customUserAgent?.map($7b3c99e5173f4767$var$escapeUserAgent) || [];
            const prefix = (0, $dc626a9d0b895939$export$c249da7071246380)();
            const sdkUserAgentValue = (prefix ? [
                prefix
            ] : []).concat([
                ...defaultUserAgent,
                ...userAgent,
                ...customUserAgent
            ]).join((0, $0784beb967af4490$export$27b7b95a5fde2b31));
            const normalUAValue = [
                ...defaultUserAgent.filter((section)=>section.startsWith("aws-sdk-")),
                ...customUserAgent
            ].join((0, $0784beb967af4490$export$27b7b95a5fde2b31));
            if (options.runtime !== "browser") {
                if (normalUAValue) headers[0, $0784beb967af4490$export$e010e3d6246262a3] = headers[0, $0784beb967af4490$export$e010e3d6246262a3] ? `${headers[0, $0784beb967af4490$export$97a08a1bb7ee0545]} ${normalUAValue}` : normalUAValue;
                headers[0, $0784beb967af4490$export$97a08a1bb7ee0545] = sdkUserAgentValue;
            } else headers[0, $0784beb967af4490$export$e010e3d6246262a3] = sdkUserAgentValue;
            return next({
                ...args,
                request: request
            });
        };
const $7b3c99e5173f4767$var$escapeUserAgent = (userAgentPair)=>{
    const name = userAgentPair[0].split((0, $0784beb967af4490$export$43290ff793d1777d)).map((part)=>part.replace((0, $0784beb967af4490$export$2d1b87b5b2a59af3), (0, $0784beb967af4490$export$f810014d932f8c3e))).join((0, $0784beb967af4490$export$43290ff793d1777d));
    const version = userAgentPair[1]?.replace((0, $0784beb967af4490$export$84cb6e726944481), (0, $0784beb967af4490$export$f810014d932f8c3e));
    const prefixSeparatorIndex = name.indexOf((0, $0784beb967af4490$export$43290ff793d1777d));
    const prefix = name.substring(0, prefixSeparatorIndex);
    let uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter((item)=>item && item.length > 0).reduce((acc, item, index)=>{
        switch(index){
            case 0:
                return item;
            case 1:
                return `${acc}/${item}`;
            default:
                return `${acc}#${item}`;
        }
    }, "");
};
const $7b3c99e5173f4767$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
const $7b3c99e5173f4767$export$5393c0d2d7f4f5f0 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($7b3c99e5173f4767$export$62c460923941c0b0(config), $7b3c99e5173f4767$export$29eb04da6afef73f);
        }
    });




var $098bc0039cdbe194$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})($098bc0039cdbe194$export$4e8b093ec8dcab0d || ($098bc0039cdbe194$export$4e8b093ec8dcab0d = {}));
const $098bc0039cdbe194$export$f8c4049184e0ac3f = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error(`Cannot load ${type} "${key}". Expected "true" or "false", got ${obj[key]}.`);
};




const $d668a1f94de4394e$export$eacd91361c129033 = "AWS_USE_DUALSTACK_ENDPOINT";
const $d668a1f94de4394e$export$71f82540e79c63bf = "use_dualstack_endpoint";
const $d668a1f94de4394e$export$beb01fae7626c427 = false;
const $d668a1f94de4394e$export$522137fc0ae615ab = {
    environmentVariableSelector: (env)=>(0, $098bc0039cdbe194$export$f8c4049184e0ac3f)(env, $d668a1f94de4394e$export$eacd91361c129033, (0, $098bc0039cdbe194$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $098bc0039cdbe194$export$f8c4049184e0ac3f)(profile, $d668a1f94de4394e$export$71f82540e79c63bf, (0, $098bc0039cdbe194$export$4e8b093ec8dcab0d).CONFIG),
    default: false
};



const $c7e78c882a40b6b4$export$b7eebc18f98c6d7f = "AWS_USE_FIPS_ENDPOINT";
const $c7e78c882a40b6b4$export$30cf725f60d4be3e = "use_fips_endpoint";
const $c7e78c882a40b6b4$export$5555deeca435a10b = false;
const $c7e78c882a40b6b4$export$42f76cc8f259f4b8 = {
    environmentVariableSelector: (env)=>(0, $098bc0039cdbe194$export$f8c4049184e0ac3f)(env, $c7e78c882a40b6b4$export$b7eebc18f98c6d7f, (0, $098bc0039cdbe194$export$4e8b093ec8dcab0d).ENV),
    configFileSelector: (profile)=>(0, $098bc0039cdbe194$export$f8c4049184e0ac3f)(profile, $c7e78c882a40b6b4$export$30cf725f60d4be3e, (0, $098bc0039cdbe194$export$4e8b093ec8dcab0d).CONFIG),
    default: false
};



const $b911b4816d034755$export$6cd750975e36686c = (input)=>{
    const { endpoint: endpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: (0, $184c4781feb1f814$export$b1276c07738d6325)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, $184c4781feb1f814$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false)
    };
};



const $7437ac690d075132$export$c69bd155af41e6f1 = async (input)=>{
    const { tls: tls = true } = input;
    const region = await input.region();
    const dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
    const useDualstackEndpoint = await input.useDualstackEndpoint();
    const useFipsEndpoint = await input.useFipsEndpoint();
    const { hostname: hostname } = await input.regionInfoProvider(region, {
        useDualstackEndpoint: useDualstackEndpoint,
        useFipsEndpoint: useFipsEndpoint
    }) ?? {};
    if (!hostname) throw new Error("Cannot resolve hostname from client config");
    return input.urlParser(`${tls ? "https:" : "http:"}//${hostname}`);
};


const $d04e31b74ae931c5$export$24f352b1bd1e2f8b = (input)=>{
    const useDualstackEndpoint = (0, $184c4781feb1f814$export$b1276c07738d6325)(input.useDualstackEndpoint ?? false);
    const { endpoint: endpoint, useFipsEndpoint: useFipsEndpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: endpoint ? (0, $184c4781feb1f814$export$b1276c07738d6325)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : ()=>(0, $7437ac690d075132$export$c69bd155af41e6f1)({
                ...input,
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }),
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
};




const $608d8357e6f35ef9$export$26513716e2900bad = "AWS_REGION";
const $608d8357e6f35ef9$export$8afb1c306a7d01b = "region";
const $608d8357e6f35ef9$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$608d8357e6f35ef9$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$608d8357e6f35ef9$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $608d8357e6f35ef9$export$9a37503ca194454d = {
    preferredFile: "credentials"
};


const $64d4a625133a3952$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));


const $69e6bcc7a5eed993$export$ecbdf004a8547a7f = (region)=>(0, $64d4a625133a3952$export$cc893cb7e6a508dd)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;



const $237f0f9cb76337ce$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $69e6bcc7a5eed993$export$ecbdf004a8547a7f)(region);
            const providedRegion = await region();
            return (0, $69e6bcc7a5eed993$export$ecbdf004a8547a7f)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $64d4a625133a3952$export$cc893cb7e6a508dd)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};








const $7a53c960b810204a$export$75494cb913bf7ef6 = (variants = [], { useFipsEndpoint: useFipsEndpoint, useDualstackEndpoint: useDualstackEndpoint })=>variants.find(({ tags: tags })=>useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack"))?.hostname;


const $bd6bcc7ca8940bfc$export$d062b2a57a5d579b = (resolvedRegion, { regionHostname: regionHostname, partitionHostname: partitionHostname })=>regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;


const $899bcfe9a695cf02$export$2ba1c8e181ae49f8 = (region, { partitionHash: partitionHash })=>Object.keys(partitionHash || {}).find((key)=>partitionHash[key].regions.includes(region)) ?? "aws";


const $712203e3bf9fb371$export$be75b39beeb48b5c = (hostname, { signingRegion: signingRegion, regionRegex: regionRegex, useFipsEndpoint: useFipsEndpoint })=>{
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        const regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        const regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};


const $3d487d31922eb060$export$2b789d827caebed0 = (region, { useFipsEndpoint: useFipsEndpoint = false, useDualstackEndpoint: useDualstackEndpoint = false, signingService: signingService, regionHash: regionHash, partitionHash: partitionHash })=>{
    const partition = (0, $899bcfe9a695cf02$export$2ba1c8e181ae49f8)(region, {
        partitionHash: partitionHash
    });
    const resolvedRegion = region in regionHash ? region : partitionHash[partition]?.endpoint ?? region;
    const hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    const regionHostname = (0, $7a53c960b810204a$export$75494cb913bf7ef6)(regionHash[resolvedRegion]?.variants, hostnameOptions);
    const partitionHostname = (0, $7a53c960b810204a$export$75494cb913bf7ef6)(partitionHash[partition]?.variants, hostnameOptions);
    const hostname = (0, $bd6bcc7ca8940bfc$export$d062b2a57a5d579b)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error(`Endpoint resolution failed for: ${{
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }}`);
    const signingRegion = (0, $712203e3bf9fb371$export$be75b39beeb48b5c)(hostname, {
        signingRegion: regionHash[resolvedRegion]?.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return {
        partition: partition,
        signingService: signingService,
        hostname: hostname,
        ...signingRegion && {
            signingRegion: signingRegion
        },
        ...regionHash[resolvedRegion]?.signingService && {
            signingService: regionHash[resolvedRegion].signingService
        }
    };
};






const $907652720ee87f40$export$5e2ae00bf65442f0 = (input)=>({
        ...input,
        eventStreamMarshaller: input.eventStreamSerdeProvider(input)
    });





const $ec9f63e670cded24$var$CONTENT_LENGTH_HEADER = "content-length";
function $ec9f63e670cded24$export$940b29eb2788b975(bodyLengthChecker) {
    return (next)=>async (args)=>{
            const request = args.request;
            if ((0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request)) {
                const { body: body, headers: headers } = request;
                if (body && Object.keys(headers).map((str)=>str.toLowerCase()).indexOf($ec9f63e670cded24$var$CONTENT_LENGTH_HEADER) === -1) try {
                    const length = bodyLengthChecker(body);
                    request.headers = {
                        ...request.headers,
                        [$ec9f63e670cded24$var$CONTENT_LENGTH_HEADER]: String(length)
                    };
                } catch (error) {}
            }
            return next({
                ...args,
                request: request
            });
        };
}
const $ec9f63e670cded24$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
const $ec9f63e670cded24$export$7e6ddf9365a30fe9 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($ec9f63e670cded24$export$940b29eb2788b975(options.bodyLengthChecker), $ec9f63e670cded24$export$1f7816f8f350b2f5);
        }
    });



var $534adb1defad154b$export$6842199fccd474d3;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})($534adb1defad154b$export$6842199fccd474d3 || ($534adb1defad154b$export$6842199fccd474d3 = {}));
const $534adb1defad154b$export$2c7e51f38ba5a406 = 3;
const $534adb1defad154b$export$41315747b7c5d042 = $534adb1defad154b$export$6842199fccd474d3.STANDARD;


const $90043a5f28ccd58b$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
const $90043a5f28ccd58b$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
const $90043a5f28ccd58b$export$18bd3bfe89ded398 = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $90043a5f28ccd58b$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];
const $90043a5f28ccd58b$export$e4f761fe9d74ce41 = [
    "ECONNRESET",
    "ECONNREFUSED",
    "EPIPE",
    "ETIMEDOUT"
];


const $0e7fe54b0cea3a74$export$46428803f4bd8a0c = (error)=>error.$retryable !== undefined;
const $0e7fe54b0cea3a74$export$7b87435661177a94 = (error)=>(0, $90043a5f28ccd58b$export$9fde012b8b2a10ca).includes(error.name);
const $0e7fe54b0cea3a74$export$cbecb89f6256ccc8 = (error)=>error.$metadata?.httpStatusCode === 429 || (0, $90043a5f28ccd58b$export$89cd1b0ccfcb99d).includes(error.name) || error.$retryable?.throttling == true;
const $0e7fe54b0cea3a74$export$31778435da988512 = (error)=>(0, $90043a5f28ccd58b$export$18bd3bfe89ded398).includes(error.name) || (0, $90043a5f28ccd58b$export$e4f761fe9d74ce41).includes(error?.code || "") || (0, $90043a5f28ccd58b$export$38bf589d26009e4f).includes(error.$metadata?.httpStatusCode || 0);
const $0e7fe54b0cea3a74$export$a7cbe72d7c4012af = (error)=>{
    if (error.$metadata?.httpStatusCode !== undefined) {
        const statusCode = error.$metadata.httpStatusCode;
        if (500 <= statusCode && statusCode <= 599 && !$0e7fe54b0cea3a74$export$31778435da988512(error)) return true;
        return false;
    }
    return false;
};


class $791a7254310959c4$export$4d4bb1390e4746c4 {
    constructor(options){
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = options?.beta ?? 0.7;
        this.minCapacity = options?.minCapacity ?? 1;
        this.minFillRate = options?.minFillRate ?? 0.5;
        this.scaleConstant = options?.scaleConstant ?? 0.4;
        this.smooth = options?.smooth ?? 0.8;
        const currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    getCurrentTimeInSeconds() {
        return Date.now() / 1000;
    }
    async getSendToken() {
        return this.acquireTokenBucket(1);
    }
    async acquireTokenBucket(amount) {
        if (!this.enabled) return;
        this.refillTokenBucket();
        if (amount > this.currentCapacity) {
            const delay = (amount - this.currentCapacity) / this.fillRate * 1000;
            await new Promise((resolve)=>setTimeout(resolve, delay));
        }
        this.currentCapacity = this.currentCapacity - amount;
    }
    refillTokenBucket() {
        const timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        const fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    }
    updateClientSendingRate(response) {
        let calculatedRate;
        this.updateMeasuredRate();
        if ((0, $0e7fe54b0cea3a74$export$cbecb89f6256ccc8)(response)) {
            const rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        const newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    }
    calculateTimeWindow() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    }
    cubicThrottle(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    }
    cubicSuccess(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    }
    enableTokenBucket() {
        this.enabled = true;
    }
    updateTokenBucketRate(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    }
    updateMeasuredRate() {
        const t = this.getCurrentTimeInSeconds();
        const timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            const currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    }
    getPrecise(num) {
        return parseFloat(num.toFixed(8));
    }
}



const $c7c977bd0e69865b$export$7067ba90effbd789 = 100;
const $c7c977bd0e69865b$export$2412c80d04e902c6 = 20000;
const $c7c977bd0e69865b$export$4af31f8250b48e23 = 500;
const $c7c977bd0e69865b$export$f8c3d11675a1153 = 500;
const $c7c977bd0e69865b$export$797febae1136bc84 = 5;
const $c7c977bd0e69865b$export$b643545eaf9af837 = 10;
const $c7c977bd0e69865b$export$a25da3406dc148e4 = 1;
const $c7c977bd0e69865b$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
const $c7c977bd0e69865b$export$d4f764f0ec4f52f = "amz-sdk-request";



const $b1e7f763a905ab4a$export$fc672061560e1611 = ()=>{
    let delayBase = (0, $c7c977bd0e69865b$export$7067ba90effbd789);
    const computeNextBackoffDelay = (attempts)=>{
        return Math.floor(Math.min((0, $c7c977bd0e69865b$export$2412c80d04e902c6), Math.random() * 2 ** attempts * delayBase));
    };
    const setDelayBase = (delay)=>{
        delayBase = delay;
    };
    return {
        computeNextBackoffDelay: computeNextBackoffDelay,
        setDelayBase: setDelayBase
    };
};



const $b5f6cae3968bdcb0$export$330ec27afca1b9b = ({ retryDelay: retryDelay, retryCount: retryCount, retryCost: retryCost })=>{
    const getRetryCount = ()=>retryCount;
    const getRetryDelay = ()=>Math.min((0, $c7c977bd0e69865b$export$2412c80d04e902c6), retryDelay);
    const getRetryCost = ()=>retryCost;
    return {
        getRetryCount: getRetryCount,
        getRetryDelay: getRetryDelay,
        getRetryCost: getRetryCost
    };
};


class $81c097369ad908e6$export$64af437cce00eae8 {
    constructor(maxAttempts){
        this.maxAttempts = maxAttempts;
        this.mode = (0, $534adb1defad154b$export$6842199fccd474d3).STANDARD;
        this.capacity = (0, $c7c977bd0e69865b$export$f8c3d11675a1153);
        this.retryBackoffStrategy = (0, $b1e7f763a905ab4a$export$fc672061560e1611)();
        this.maxAttemptsProvider = typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts;
    }
    async acquireInitialRetryToken(retryTokenScope) {
        return (0, $b5f6cae3968bdcb0$export$330ec27afca1b9b)({
            retryDelay: (0, $c7c977bd0e69865b$export$7067ba90effbd789),
            retryCount: 0
        });
    }
    async refreshRetryTokenForRetry(token, errorInfo) {
        const maxAttempts = await this.getMaxAttempts();
        if (this.shouldRetry(token, errorInfo, maxAttempts)) {
            const errorType = errorInfo.errorType;
            this.retryBackoffStrategy.setDelayBase(errorType === "THROTTLING" ? (0, $c7c977bd0e69865b$export$4af31f8250b48e23) : (0, $c7c977bd0e69865b$export$7067ba90effbd789));
            const delayFromErrorType = this.retryBackoffStrategy.computeNextBackoffDelay(token.getRetryCount());
            const retryDelay = errorInfo.retryAfterHint ? Math.max(errorInfo.retryAfterHint.getTime() - Date.now() || 0, delayFromErrorType) : delayFromErrorType;
            const capacityCost = this.getCapacityCost(errorType);
            this.capacity -= capacityCost;
            return (0, $b5f6cae3968bdcb0$export$330ec27afca1b9b)({
                retryDelay: retryDelay,
                retryCount: token.getRetryCount() + 1,
                retryCost: capacityCost
            });
        }
        throw new Error("No retry token available");
    }
    recordSuccess(token) {
        this.capacity = Math.max((0, $c7c977bd0e69865b$export$f8c3d11675a1153), this.capacity + (token.getRetryCost() ?? (0, $c7c977bd0e69865b$export$a25da3406dc148e4)));
    }
    getCapacity() {
        return this.capacity;
    }
    async getMaxAttempts() {
        try {
            return await this.maxAttemptsProvider();
        } catch (error) {
            console.warn(`Max attempts provider could not resolve. Using default of ${(0, $534adb1defad154b$export$2c7e51f38ba5a406)}`);
            return 0, $534adb1defad154b$export$2c7e51f38ba5a406;
        }
    }
    shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
        const attempts = tokenToRenew.getRetryCount() + 1;
        return attempts < maxAttempts && this.capacity >= this.getCapacityCost(errorInfo.errorType) && this.isRetryableError(errorInfo.errorType);
    }
    getCapacityCost(errorType) {
        return errorType === "TRANSIENT" ? (0, $c7c977bd0e69865b$export$b643545eaf9af837) : (0, $c7c977bd0e69865b$export$797febae1136bc84);
    }
    isRetryableError(errorType) {
        return errorType === "THROTTLING" || errorType === "TRANSIENT";
    }
}


class $826a184038c7af0f$export$b6f3faf7501de8bc {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $534adb1defad154b$export$6842199fccd474d3).ADAPTIVE;
        const { rateLimiter: rateLimiter } = options ?? {};
        this.rateLimiter = rateLimiter ?? new (0, $791a7254310959c4$export$4d4bb1390e4746c4)();
        this.standardRetryStrategy = new (0, $81c097369ad908e6$export$64af437cce00eae8)(maxAttemptsProvider);
    }
    async acquireInitialRetryToken(retryTokenScope) {
        await this.rateLimiter.getSendToken();
        return this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope);
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        this.rateLimiter.updateClientSendingRate(errorInfo);
        return this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
    }
    recordSuccess(token) {
        this.rateLimiter.updateClientSendingRate({});
        this.standardRetryStrategy.recordSuccess(token);
    }
}




class $b3742896607db1e0$export$4d488d77e5dad28e extends (0, $81c097369ad908e6$export$64af437cce00eae8) {
    constructor(maxAttempts, computeNextBackoffDelay = (0, $c7c977bd0e69865b$export$7067ba90effbd789)){
        super(typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts);
        if (typeof computeNextBackoffDelay === "number") this.computeNextBackoffDelay = ()=>computeNextBackoffDelay;
        else this.computeNextBackoffDelay = computeNextBackoffDelay;
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        const token = await super.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
        token.getRetryDelay = ()=>this.computeNextBackoffDelay(token.getRetryCount());
        return token;
    }
}













// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $568f4ee4022ba00e$var$getRandomValues;
var $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1d0137947e8554ce$var$byteToHex = [];
for(var $1d0137947e8554ce$var$i = 0; $1d0137947e8554ce$var$i < 256; ++$1d0137947e8554ce$var$i)$1d0137947e8554ce$var$byteToHex.push(($1d0137947e8554ce$var$i + 0x100).toString(16).substr(1));
function $1d0137947e8554ce$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + '-' + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$2e2bcd8739ae039)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;



const $efbcdeeef1878a5a$export$2ebe7988802fc284 = (initialRetryTokens, options)=>{
    const MAX_CAPACITY = initialRetryTokens;
    const noRetryIncrement = options?.noRetryIncrement ?? (0, $c7c977bd0e69865b$export$a25da3406dc148e4);
    const retryCost = options?.retryCost ?? (0, $c7c977bd0e69865b$export$797febae1136bc84);
    const timeoutRetryCost = options?.timeoutRetryCost ?? (0, $c7c977bd0e69865b$export$b643545eaf9af837);
    let availableCapacity = initialRetryTokens;
    const getCapacityAmount = (error)=>error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    const hasRetryTokens = (error)=>getCapacityAmount(error) <= availableCapacity;
    const retrieveRetryTokens = (error)=>{
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        const capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    const releaseRetryTokens = (capacityReleaseAmount)=>{
        availableCapacity += capacityReleaseAmount ?? noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};



const $bb8a918551d0eac6$export$1cddd42598a3b1f6 = (delayBase, attempts)=>Math.floor(Math.min((0, $c7c977bd0e69865b$export$2412c80d04e902c6), Math.random() * 2 ** attempts * delayBase));



const $f6515c9b19754f41$export$3839fd261f89ec2 = (error)=>{
    if (!error) return false;
    return (0, $0e7fe54b0cea3a74$export$46428803f4bd8a0c)(error) || (0, $0e7fe54b0cea3a74$export$7b87435661177a94)(error) || (0, $0e7fe54b0cea3a74$export$cbecb89f6256ccc8)(error) || (0, $0e7fe54b0cea3a74$export$31778435da988512)(error);
};


const $343333d06ff290bf$export$c780f8210b6eca50 = (error)=>{
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error(`AWS SDK error wrapper for ${error}`);
};


class $a7f027275fe09b81$export$64af437cce00eae8 {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $534adb1defad154b$export$6842199fccd474d3).STANDARD;
        this.retryDecider = options?.retryDecider ?? (0, $f6515c9b19754f41$export$3839fd261f89ec2);
        this.delayDecider = options?.delayDecider ?? (0, $bb8a918551d0eac6$export$1cddd42598a3b1f6);
        this.retryQuota = options?.retryQuota ?? (0, $efbcdeeef1878a5a$export$2ebe7988802fc284)((0, $c7c977bd0e69865b$export$f8c3d11675a1153));
    }
    shouldRetry(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    }
    async getMaxAttempts() {
        let maxAttempts;
        try {
            maxAttempts = await this.maxAttemptsProvider();
        } catch (error) {
            maxAttempts = (0, $534adb1defad154b$export$2c7e51f38ba5a406);
        }
        return maxAttempts;
    }
    async retry(next, args, options) {
        let retryTokenAmount;
        let attempts = 0;
        let totalDelay = 0;
        const maxAttempts = await this.getMaxAttempts();
        const { request: request } = args;
        if ((0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request)) request.headers[0, $c7c977bd0e69865b$export$197fd517bf66ccb2] = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        while(true)try {
            if ((0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request)) request.headers[0, $c7c977bd0e69865b$export$d4f764f0ec4f52f] = `attempt=${attempts + 1}; max=${maxAttempts}`;
            if (options?.beforeRequest) await options.beforeRequest();
            const { response: response, output: output } = await next(args);
            if (options?.afterRequest) options.afterRequest(response);
            this.retryQuota.releaseRetryTokens(retryTokenAmount);
            output.$metadata.attempts = attempts + 1;
            output.$metadata.totalRetryDelay = totalDelay;
            return {
                response: response,
                output: output
            };
        } catch (e) {
            const err = (0, $343333d06ff290bf$export$c780f8210b6eca50)(e);
            attempts++;
            if (this.shouldRetry(err, attempts, maxAttempts)) {
                retryTokenAmount = this.retryQuota.retrieveRetryTokens(err);
                const delayFromDecider = this.delayDecider((0, $0e7fe54b0cea3a74$export$cbecb89f6256ccc8)(err) ? (0, $c7c977bd0e69865b$export$4af31f8250b48e23) : (0, $c7c977bd0e69865b$export$7067ba90effbd789), attempts);
                const delayFromResponse = $a7f027275fe09b81$var$getDelayFromRetryAfterHeader(err.$response);
                const delay = Math.max(delayFromResponse || 0, delayFromDecider);
                totalDelay += delay;
                await new Promise((resolve)=>setTimeout(resolve, delay));
                continue;
            }
            if (!err.$metadata) err.$metadata = {};
            err.$metadata.attempts = attempts;
            err.$metadata.totalRetryDelay = totalDelay;
            throw err;
        }
    }
}
const $a7f027275fe09b81$var$getDelayFromRetryAfterHeader = (response)=>{
    if (!(0, $2c63d34427c28f98$export$1d94dfe0d9d1f1e7).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};


class $389164393771d0af$export$b6f3faf7501de8bc extends (0, $a7f027275fe09b81$export$64af437cce00eae8) {
    constructor(maxAttemptsProvider, options){
        const { rateLimiter: rateLimiter, ...superOptions } = options ?? {};
        super(maxAttemptsProvider, superOptions);
        this.rateLimiter = rateLimiter ?? new (0, $791a7254310959c4$export$4d4bb1390e4746c4)();
        this.mode = (0, $534adb1defad154b$export$6842199fccd474d3).ADAPTIVE;
    }
    async retry(next, args) {
        return super.retry(next, args, {
            beforeRequest: async ()=>{
                return this.rateLimiter.getSendToken();
            },
            afterRequest: (response)=>{
                this.rateLimiter.updateClientSendingRate(response);
            }
        });
    }
}





const $13d2904175ea6339$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
const $13d2904175ea6339$export$9ae8a04532f798bc = "max_attempts";
const $13d2904175ea6339$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: (env)=>{
        const value = env[$13d2904175ea6339$export$a19952f9e421517c];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Environment variable ${$13d2904175ea6339$export$a19952f9e421517c} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    configFileSelector: (profile)=>{
        const value = profile[$13d2904175ea6339$export$9ae8a04532f798bc];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Shared config file entry ${$13d2904175ea6339$export$9ae8a04532f798bc} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    default: (0, $534adb1defad154b$export$2c7e51f38ba5a406)
};
const $13d2904175ea6339$export$ca7f6138f2c98476 = (input)=>{
    const { retryStrategy: retryStrategy } = input;
    const maxAttempts = (0, $184c4781feb1f814$export$b1276c07738d6325)(input.maxAttempts ?? (0, $534adb1defad154b$export$2c7e51f38ba5a406));
    return {
        ...input,
        maxAttempts: maxAttempts,
        retryStrategy: async ()=>{
            if (retryStrategy) return retryStrategy;
            const retryMode = await (0, $184c4781feb1f814$export$b1276c07738d6325)(input.retryMode)();
            if (retryMode === (0, $534adb1defad154b$export$6842199fccd474d3).ADAPTIVE) return new (0, $826a184038c7af0f$export$b6f3faf7501de8bc)(maxAttempts);
            return new (0, $81c097369ad908e6$export$64af437cce00eae8)(maxAttempts);
        }
    };
};
const $13d2904175ea6339$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
const $13d2904175ea6339$export$c5c0171a17765aea = "retry_mode";
const $13d2904175ea6339$export$972bf2bb01959ff5 = {
    environmentVariableSelector: (env)=>env[$13d2904175ea6339$export$4728af91ff39ef3b],
    configFileSelector: (profile)=>profile[$13d2904175ea6339$export$c5c0171a17765aea],
    default: (0, $534adb1defad154b$export$41315747b7c5d042)
};





const $b45774cbe4af775c$export$536b11ee0b9c4a95 = ()=>(next)=>async (args)=>{
            const { request: request } = args;
            if ((0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request)) {
                delete request.headers[0, $c7c977bd0e69865b$export$197fd517bf66ccb2];
                delete request.headers[0, $c7c977bd0e69865b$export$d4f764f0ec4f52f];
            }
            return next(args);
        };
const $b45774cbe4af775c$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
const $b45774cbe4af775c$export$fa165e6edc16c2a2 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($b45774cbe4af775c$export$536b11ee0b9c4a95(), $b45774cbe4af775c$export$3ec587d8f35e7a2c);
        }
    });








const $bd9ede8b9dd2c907$export$a3922aa5f87bae85 = (options)=>(next, context)=>async (args)=>{
            let retryStrategy = await options.retryStrategy();
            const maxAttempts = await options.maxAttempts();
            if ($bd9ede8b9dd2c907$var$isRetryStrategyV2(retryStrategy)) {
                retryStrategy;
                let retryToken = await retryStrategy.acquireInitialRetryToken(context["partition_id"]);
                let lastError = new Error();
                let attempts = 0;
                let totalRetryDelay = 0;
                const { request: request } = args;
                if ((0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request)) request.headers[0, $c7c977bd0e69865b$export$197fd517bf66ccb2] = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
                while(true)try {
                    if ((0, $76db987a884ad8a2$export$7587955500404ec3).isInstance(request)) request.headers[0, $c7c977bd0e69865b$export$d4f764f0ec4f52f] = `attempt=${attempts + 1}; max=${maxAttempts}`;
                    const { response: response, output: output } = await next(args);
                    retryStrategy.recordSuccess(retryToken);
                    output.$metadata.attempts = attempts + 1;
                    output.$metadata.totalRetryDelay = totalRetryDelay;
                    return {
                        response: response,
                        output: output
                    };
                } catch (e) {
                    const retryErrorInfo = $bd9ede8b9dd2c907$var$getRetryErrorInfo(e);
                    lastError = (0, $343333d06ff290bf$export$c780f8210b6eca50)(e);
                    try {
                        retryToken = await retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
                    } catch (refreshError) {
                        if (!lastError.$metadata) lastError.$metadata = {};
                        lastError.$metadata.attempts = attempts + 1;
                        lastError.$metadata.totalRetryDelay = totalRetryDelay;
                        throw lastError;
                    }
                    attempts = retryToken.getRetryCount();
                    const delay = retryToken.getRetryDelay();
                    totalRetryDelay += delay;
                    await new Promise((resolve)=>setTimeout(resolve, delay));
                }
            } else {
                retryStrategy;
                if (retryStrategy?.mode) context.userAgent = [
                    ...context.userAgent || [],
                    [
                        "cfg/retry-mode",
                        retryStrategy.mode
                    ]
                ];
                return retryStrategy.retry(next, args);
            }
        };
const $bd9ede8b9dd2c907$var$isRetryStrategyV2 = (retryStrategy)=>typeof retryStrategy.acquireInitialRetryToken !== "undefined" && typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" && typeof retryStrategy.recordSuccess !== "undefined";
const $bd9ede8b9dd2c907$var$getRetryErrorInfo = (error)=>{
    const errorInfo = {
        errorType: $bd9ede8b9dd2c907$var$getRetryErrorType(error)
    };
    const retryAfterHint = $bd9ede8b9dd2c907$export$8f45b27d98dcedff(error.$response);
    if (retryAfterHint) errorInfo.retryAfterHint = retryAfterHint;
    return errorInfo;
};
const $bd9ede8b9dd2c907$var$getRetryErrorType = (error)=>{
    if ((0, $0e7fe54b0cea3a74$export$cbecb89f6256ccc8)(error)) return "THROTTLING";
    if ((0, $0e7fe54b0cea3a74$export$31778435da988512)(error)) return "TRANSIENT";
    if ((0, $0e7fe54b0cea3a74$export$a7cbe72d7c4012af)(error)) return "SERVER_ERROR";
    return "CLIENT_ERROR";
};
const $bd9ede8b9dd2c907$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
const $bd9ede8b9dd2c907$export$c73199e2b1df9340 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($bd9ede8b9dd2c907$export$a3922aa5f87bae85(options), $bd9ede8b9dd2c907$export$44d3d03587957ce9);
        }
    });
const $bd9ede8b9dd2c907$export$8f45b27d98dcedff = (response)=>{
    if (!(0, $2c63d34427c28f98$export$1d94dfe0d9d1f1e7).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return new Date(retryAfterSeconds * 1000);
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate;
};





const $a66d5922af5b4baa$export$70b6341cd51750a8 = (options)=>{
    return {
        ...options,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        forcePathStyle: options.forcePathStyle ?? false,
        useAccelerateEndpoint: options.useAccelerateEndpoint ?? false,
        useGlobalEndpoint: options.useGlobalEndpoint ?? false,
        disableMultiregionAccessPoints: options.disableMultiregionAccessPoints ?? false,
        defaultSigningName: "s3"
    };
};


var $8bab7e469a6afe26$exports = {};
$8bab7e469a6afe26$exports = JSON.parse("{\"name\":\"@aws-sdk/client-s3\",\"description\":\"AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native\",\"version\":\"3.387.0\",\"scripts\":{\"build\":\"concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'\",\"build:cjs\":\"tsc -p tsconfig.cjs.json\",\"build:docs\":\"typedoc\",\"build:es\":\"tsc -p tsconfig.es.json\",\"build:include:deps\":\"lerna run --scope $npm_package_name --include-dependencies build\",\"build:types\":\"tsc -p tsconfig.types.json\",\"build:types:downlevel\":\"downlevel-dts dist-types dist-types/ts3.4\",\"clean\":\"rimraf ./dist-* && rimraf *.tsbuildinfo\",\"extract:docs\":\"api-extractor run --local\",\"generate:client\":\"node ../../scripts/generate-clients/single-service --solo s3\",\"test\":\"yarn test:unit\",\"test:e2e\":\"ts-mocha test/**/*.ispec.ts && karma start karma.conf.js\",\"test:unit\":\"ts-mocha test/**/*.spec.ts\"},\"main\":\"./dist-cjs/index.js\",\"types\":\"./dist-types/index.d.ts\",\"module\":\"./dist-es/index.js\",\"sideEffects\":false,\"dependencies\":{\"@aws-crypto/sha1-browser\":\"3.0.0\",\"@aws-crypto/sha256-browser\":\"3.0.0\",\"@aws-crypto/sha256-js\":\"3.0.0\",\"@aws-sdk/client-sts\":\"3.387.0\",\"@aws-sdk/credential-provider-node\":\"3.387.0\",\"@aws-sdk/middleware-bucket-endpoint\":\"3.387.0\",\"@aws-sdk/middleware-expect-continue\":\"3.387.0\",\"@aws-sdk/middleware-flexible-checksums\":\"3.387.0\",\"@aws-sdk/middleware-host-header\":\"3.387.0\",\"@aws-sdk/middleware-location-constraint\":\"3.387.0\",\"@aws-sdk/middleware-logger\":\"3.387.0\",\"@aws-sdk/middleware-recursion-detection\":\"3.387.0\",\"@aws-sdk/middleware-sdk-s3\":\"3.387.0\",\"@aws-sdk/middleware-signing\":\"3.387.0\",\"@aws-sdk/middleware-ssec\":\"3.387.0\",\"@aws-sdk/middleware-user-agent\":\"3.387.0\",\"@aws-sdk/signature-v4-multi-region\":\"3.387.0\",\"@aws-sdk/types\":\"3.387.0\",\"@aws-sdk/util-endpoints\":\"3.387.0\",\"@aws-sdk/util-user-agent-browser\":\"3.387.0\",\"@aws-sdk/util-user-agent-node\":\"3.387.0\",\"@aws-sdk/xml-builder\":\"3.310.0\",\"@smithy/config-resolver\":\"^2.0.2\",\"@smithy/eventstream-serde-browser\":\"^2.0.2\",\"@smithy/eventstream-serde-config-resolver\":\"^2.0.2\",\"@smithy/eventstream-serde-node\":\"^2.0.2\",\"@smithy/fetch-http-handler\":\"^2.0.2\",\"@smithy/hash-blob-browser\":\"^2.0.2\",\"@smithy/hash-node\":\"^2.0.2\",\"@smithy/hash-stream-node\":\"^2.0.2\",\"@smithy/invalid-dependency\":\"^2.0.2\",\"@smithy/md5-js\":\"^2.0.2\",\"@smithy/middleware-content-length\":\"^2.0.2\",\"@smithy/middleware-endpoint\":\"^2.0.2\",\"@smithy/middleware-retry\":\"^2.0.2\",\"@smithy/middleware-serde\":\"^2.0.2\",\"@smithy/middleware-stack\":\"^2.0.0\",\"@smithy/node-config-provider\":\"^2.0.2\",\"@smithy/node-http-handler\":\"^2.0.2\",\"@smithy/protocol-http\":\"^2.0.2\",\"@smithy/smithy-client\":\"^2.0.2\",\"@smithy/types\":\"^2.1.0\",\"@smithy/url-parser\":\"^2.0.2\",\"@smithy/util-base64\":\"^2.0.0\",\"@smithy/util-body-length-browser\":\"^2.0.0\",\"@smithy/util-body-length-node\":\"^2.0.0\",\"@smithy/util-defaults-mode-browser\":\"^2.0.2\",\"@smithy/util-defaults-mode-node\":\"^2.0.2\",\"@smithy/util-retry\":\"^2.0.0\",\"@smithy/util-stream\":\"^2.0.2\",\"@smithy/util-utf8\":\"^2.0.0\",\"@smithy/util-waiter\":\"^2.0.2\",\"fast-xml-parser\":\"4.2.5\",\"tslib\":\"^2.5.0\"},\"devDependencies\":{\"@smithy/service-client-documentation-generator\":\"^2.0.0\",\"@tsconfig/node14\":\"1.0.3\",\"@types/chai\":\"^4.2.11\",\"@types/mocha\":\"^8.0.4\",\"@types/node\":\"^14.14.31\",\"concurrently\":\"7.0.0\",\"downlevel-dts\":\"0.10.1\",\"rimraf\":\"3.0.2\",\"typedoc\":\"0.23.23\",\"typescript\":\"~4.9.5\"},\"engines\":{\"node\":\">=14.0.0\"},\"typesVersions\":{\"<4.0\":{\"dist-types/*\":[\"dist-types/ts3.4/*\"]}},\"files\":[\"dist-*/**\"],\"author\":{\"name\":\"AWS SDK for JavaScript Team\",\"url\":\"https://aws.amazon.com/javascript/\"},\"license\":\"Apache-2.0\",\"browser\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.browser\"},\"react-native\":{\"./dist-es/runtimeConfig\":\"./dist-es/runtimeConfig.native\"},\"homepage\":\"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/aws/aws-sdk-js-v3.git\",\"directory\":\"clients/client-s3\"}}");


var $7652e3ffbb9aff11$exports = {};
"use strict";
Object.defineProperty($7652e3ffbb9aff11$exports, "__esModule", {
    value: true
});
$7652e3ffbb9aff11$exports.WebCryptoSha1 = $7652e3ffbb9aff11$exports.Ie11Sha1 = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e92a88086909c563$var$extendStatics = function(d, b) {
    $e92a88086909c563$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e92a88086909c563$var$extendStatics(d, b);
};
function $e92a88086909c563$export$a8ba968b8961cb8a(d, b) {
    $e92a88086909c563$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e92a88086909c563$export$18ce0697a983be9b = function() {
    $e92a88086909c563$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e92a88086909c563$export$18ce0697a983be9b.apply(this, arguments);
};
function $e92a88086909c563$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e92a88086909c563$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e92a88086909c563$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e92a88086909c563$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e92a88086909c563$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e92a88086909c563$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e92a88086909c563$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e92a88086909c563$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e92a88086909c563$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e92a88086909c563$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e92a88086909c563$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e92a88086909c563$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e92a88086909c563$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e92a88086909c563$export$10c90e4f7922046c(v) {
    return this instanceof $e92a88086909c563$export$10c90e4f7922046c ? (this.v = v, this) : new $e92a88086909c563$export$10c90e4f7922046c(v);
}
function $e92a88086909c563$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e92a88086909c563$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e92a88086909c563$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e92a88086909c563$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e92a88086909c563$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e92a88086909c563$export$19a8beecd37a4c45 === "function" ? $e92a88086909c563$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e92a88086909c563$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e92a88086909c563$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e92a88086909c563$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e92a88086909c563$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e92a88086909c563$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



$e92a88086909c563$export$f33643c0debef087((parcelRequire("enfq1")), $7652e3ffbb9aff11$exports);

var $8Z3pj = parcelRequire("8Z3pj");
Object.defineProperty($7652e3ffbb9aff11$exports, "Ie11Sha1", {
    enumerable: true,
    get: function() {
        return $8Z3pj.Sha1;
    }
});

var $4VZJ5 = parcelRequire("4VZJ5");
Object.defineProperty($7652e3ffbb9aff11$exports, "WebCryptoSha1", {
    enumerable: true,
    get: function() {
        return $4VZJ5.Sha1;
    }
});


var $3ce7992f05548527$exports = {};
"use strict";
Object.defineProperty($3ce7992f05548527$exports, "__esModule", {
    value: true
});
$3ce7992f05548527$exports.WebCryptoSha256 = $3ce7992f05548527$exports.Ie11Sha256 = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b34072d902a04152$var$extendStatics = function(d, b) {
    $b34072d902a04152$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b34072d902a04152$var$extendStatics(d, b);
};
function $b34072d902a04152$export$a8ba968b8961cb8a(d, b) {
    $b34072d902a04152$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b34072d902a04152$export$18ce0697a983be9b = function() {
    $b34072d902a04152$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b34072d902a04152$export$18ce0697a983be9b.apply(this, arguments);
};
function $b34072d902a04152$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b34072d902a04152$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b34072d902a04152$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b34072d902a04152$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b34072d902a04152$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b34072d902a04152$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b34072d902a04152$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b34072d902a04152$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b34072d902a04152$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b34072d902a04152$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b34072d902a04152$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b34072d902a04152$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b34072d902a04152$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b34072d902a04152$export$10c90e4f7922046c(v) {
    return this instanceof $b34072d902a04152$export$10c90e4f7922046c ? (this.v = v, this) : new $b34072d902a04152$export$10c90e4f7922046c(v);
}
function $b34072d902a04152$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b34072d902a04152$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b34072d902a04152$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b34072d902a04152$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b34072d902a04152$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b34072d902a04152$export$19a8beecd37a4c45 === "function" ? $b34072d902a04152$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b34072d902a04152$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b34072d902a04152$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b34072d902a04152$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b34072d902a04152$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b34072d902a04152$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



$b34072d902a04152$export$f33643c0debef087((parcelRequire("dZNvx")), $3ce7992f05548527$exports);

var $jLgwE = parcelRequire("jLgwE");
Object.defineProperty($3ce7992f05548527$exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $jLgwE.Sha256;
    }
});

var $iS0p3 = parcelRequire("iS0p3");
Object.defineProperty($3ce7992f05548527$exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $iS0p3.Sha256;
    }
});


var $03dc96944173e4d6$exports = {};
!function(e, t) {
    $03dc96944173e4d6$exports = t();
}($03dc96944173e4d6$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


const $36ab7aff4f97a5b5$export$69d579f32876892f = ({ serviceId: serviceId, clientVersion: clientVersion })=>async ()=>{
        const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($03dc96944173e4d6$exports))).parse(window.navigator.userAgent) : undefined;
        const sections = [
            [
                "aws-sdk-js",
                clientVersion
            ],
            [
                "ua",
                "2.0"
            ],
            [
                `os/${parsedUA?.os?.name || "other"}`,
                parsedUA?.os?.version
            ],
            [
                "lang/js"
            ],
            [
                "md/browser",
                `${parsedUA?.browser?.name ?? "unknown"}_${parsedUA?.browser?.version ?? "unknown"}`
            ]
        ];
        if (serviceId) sections.push([
            `api/${serviceId}`,
            clientVersion
        ]);
        return sections;
    };




function $266ff673567ba280$export$3071cd8be9cd01e0(source) {
    let currentMessageTotalLength = 0;
    let currentMessagePendingLength = 0;
    let currentMessage = null;
    let messageLengthBuffer = null;
    const allocateMessage = (size)=>{
        if (typeof size !== "number") throw new Error("Attempted to allocate an event message where size was not a number: " + size);
        currentMessageTotalLength = size;
        currentMessagePendingLength = 4;
        currentMessage = new Uint8Array(size);
        const currentMessageView = new DataView(currentMessage.buffer);
        currentMessageView.setUint32(0, size, false);
    };
    const iterator = async function*() {
        const sourceIterator = source[Symbol.asyncIterator]();
        while(true){
            const { value: value, done: done } = await sourceIterator.next();
            if (done) {
                if (!currentMessageTotalLength) return;
                else if (currentMessageTotalLength === currentMessagePendingLength) yield currentMessage;
                else throw new Error("Truncated event message received.");
                return;
            }
            const chunkLength = value.length;
            let currentOffset = 0;
            while(currentOffset < chunkLength){
                if (!currentMessage) {
                    const bytesRemaining = chunkLength - currentOffset;
                    if (!messageLengthBuffer) messageLengthBuffer = new Uint8Array(4);
                    const numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining);
                    messageLengthBuffer.set(value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
                    currentMessagePendingLength += numBytesForTotal;
                    currentOffset += numBytesForTotal;
                    if (currentMessagePendingLength < 4) break;
                    allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
                    messageLengthBuffer = null;
                }
                const numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset);
                currentMessage.set(value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
                currentMessagePendingLength += numBytesToWrite;
                currentOffset += numBytesToWrite;
                if (currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength) {
                    yield currentMessage;
                    currentMessage = null;
                    currentMessageTotalLength = 0;
                    currentMessagePendingLength = 0;
                }
            }
        }
    };
    return {
        [Symbol.asyncIterator]: iterator
    };
}


function $19b551b7ad6ebcdf$export$a1a364c5c6ddc1b4(source, options) {
    const messageUnmarshaller = $19b551b7ad6ebcdf$export$5ecf053b59827691(options.deserializer, options.toUtf8);
    return {
        [Symbol.asyncIterator]: async function*() {
            for await (const chunk of source){
                const message = options.eventStreamCodec.decode(chunk);
                const type = await messageUnmarshaller(message);
                if (type === undefined) continue;
                yield type;
            }
        }
    };
}
function $19b551b7ad6ebcdf$export$5ecf053b59827691(deserializer, toUtf8) {
    return async function(message) {
        const { value: messageType } = message.headers[":message-type"];
        if (messageType === "error") {
            const unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
            unmodeledError.name = message.headers[":error-code"].value;
            throw unmodeledError;
        } else if (messageType === "exception") {
            const code = message.headers[":exception-type"].value;
            const exception = {
                [code]: message
            };
            const deserializedException = await deserializer(exception);
            if (deserializedException.$unknown) {
                const error = new Error(toUtf8(message.body));
                error.name = code;
                throw error;
            }
            throw deserializedException[code];
        } else if (messageType === "event") {
            const event = {
                [message.headers[":event-type"].value]: message
            };
            const deserialized = await deserializer(event);
            if (deserialized.$unknown) return;
            return deserialized;
        } else throw Error(`Unrecognizable event type: ${message.headers[":event-type"].value}`);
    };
}


class $a6e929a05891d10a$export$b64afa0aa6ce60e2 {
    constructor({ utf8Encoder: utf8Encoder, utf8Decoder: utf8Decoder }){
        this.eventStreamCodec = new (0, $971d27a5548b3be2$export$60e2ad0c77b6bab)(utf8Encoder, utf8Decoder);
        this.utfEncoder = utf8Encoder;
    }
    deserialize(body, deserializer) {
        const inputStream = (0, $266ff673567ba280$export$3071cd8be9cd01e0)(body);
        return new (0, $57bed3f14ed14353$export$c78403d78d3ee8a)({
            messageStream: new (0, $fbc75239fe6580e5$export$4ffe73dc7dfe29dd)({
                inputStream: inputStream,
                decoder: this.eventStreamCodec
            }),
            deserializer: (0, $19b551b7ad6ebcdf$export$5ecf053b59827691)(deserializer, this.utfEncoder)
        });
    }
    serialize(inputStream, serializer) {
        return new (0, $430fdc8a7f5897c3$export$1204278c33e35f1b)({
            messageStream: new (0, $e30bf2e44d4a3f27$export$96361fe9dd919a8e)({
                inputStream: inputStream,
                serializer: serializer
            }),
            encoder: this.eventStreamCodec,
            includeEndFrame: true
        });
    }
}



const $d16762fdb1b1c0fe$export$9d23a885702ebafb = (options)=>new (0, $a6e929a05891d10a$export$b64afa0aa6ce60e2)(options);




const $6074dfde03540584$export$2346526b0991dd88 = (readableStream)=>({
        [Symbol.asyncIterator]: async function*() {
            const reader = readableStream.getReader();
            try {
                while(true){
                    const { done: done, value: value } = await reader.read();
                    if (done) return;
                    yield value;
                }
            } finally{
                reader.releaseLock();
            }
        }
    });
const $6074dfde03540584$export$92326f9d37f111f = (asyncIterable)=>{
    const iterator = asyncIterable[Symbol.asyncIterator]();
    return new ReadableStream({
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) return controller.close();
            controller.enqueue(value);
        }
    });
};


class $3e649c7e0c0ca5cf$export$b64afa0aa6ce60e2 {
    constructor({ utf8Encoder: utf8Encoder, utf8Decoder: utf8Decoder }){
        this.universalMarshaller = new (0, $a6e929a05891d10a$export$b64afa0aa6ce60e2)({
            utf8Decoder: utf8Decoder,
            utf8Encoder: utf8Encoder
        });
    }
    deserialize(body, deserializer) {
        const bodyIterable = $3e649c7e0c0ca5cf$var$isReadableStream(body) ? (0, $6074dfde03540584$export$2346526b0991dd88)(body) : body;
        return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    }
    serialize(input, serializer) {
        const serialziedIterable = this.universalMarshaller.serialize(input, serializer);
        return typeof ReadableStream === "function" ? (0, $6074dfde03540584$export$92326f9d37f111f)(serialziedIterable) : serialziedIterable;
    }
}
const $3e649c7e0c0ca5cf$var$isReadableStream = (body)=>typeof ReadableStream === "function" && body instanceof ReadableStream;



const $96a9c773c3e47a59$export$9d23a885702ebafb = (options)=>new (0, $3e649c7e0c0ca5cf$export$b64afa0aa6ce60e2)(options);






function $bb3782a06e3d3056$export$7541dba16c2127c8(blob, onChunk, chunkSize = 1048576) {
    return new Promise((resolve, reject)=>{
        const fileReader = new FileReader();
        fileReader.addEventListener("error", reject);
        fileReader.addEventListener("abort", reject);
        const size = blob.size;
        let totalBytesRead = 0;
        function read() {
            if (totalBytesRead >= size) {
                resolve();
                return;
            }
            fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize)));
        }
        fileReader.addEventListener("load", (event)=>{
            const result = event.target.result;
            onChunk(new Uint8Array(result));
            totalBytesRead += result.byteLength;
            read();
        });
        read();
    });
}


const $47629ed131b942bb$export$ea66e9c498b7933c = async function blobHasher(hashCtor, blob) {
    const hash = new hashCtor();
    await (0, $bb3782a06e3d3056$export$7541dba16c2127c8)(blob, (chunk)=>{
        hash.update(chunk);
    });
    return hash.digest();
};


const $00052ea55f86919c$export$8b6362171c4dfa64 = (message)=>()=>{
        throw new Error(message);
    };


const $f02e3c97a2fee0d8$export$d59dd53963f8f3d5 = (message)=>()=>Promise.reject(message);





const $0ceab8b4236748e7$export$b2e3d6d444266a5c = 64;
const $0ceab8b4236748e7$export$d7bd469488748c5f = 16;
const $0ceab8b4236748e7$export$d788bc089976c004 = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];


class $22d6c48826499a0b$export$9f5a3dfc7a9f5dd {
    constructor(){
        this.reset();
    }
    update(sourceData) {
        if ($22d6c48826499a0b$var$isEmptyData(sourceData)) return;
        else if (this.finished) throw new Error("Attempted to update an already finished hash.");
        const data = $22d6c48826499a0b$var$convertToBuffer(sourceData);
        let position = 0;
        let { byteLength: byteLength } = data;
        this.bytesHashed += byteLength;
        while(byteLength > 0){
            this.buffer.setUint8(this.bufferLength++, data[position++]);
            byteLength--;
            if (this.bufferLength === (0, $0ceab8b4236748e7$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    }
    async digest() {
        if (!this.finished) {
            const { buffer: buffer, bufferLength: undecoratedLength, bytesHashed: bytesHashed } = this;
            const bitsHashed = bytesHashed * 8;
            buffer.setUint8(this.bufferLength++, 128);
            if (undecoratedLength % (0, $0ceab8b4236748e7$export$b2e3d6d444266a5c) >= (0, $0ceab8b4236748e7$export$b2e3d6d444266a5c) - 8) {
                for(let i = this.bufferLength; i < (0, $0ceab8b4236748e7$export$b2e3d6d444266a5c); i++)buffer.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(let i = this.bufferLength; i < (0, $0ceab8b4236748e7$export$b2e3d6d444266a5c) - 8; i++)buffer.setUint8(i, 0);
            buffer.setUint32((0, $0ceab8b4236748e7$export$b2e3d6d444266a5c) - 8, bitsHashed >>> 0, true);
            buffer.setUint32((0, $0ceab8b4236748e7$export$b2e3d6d444266a5c) - 4, Math.floor(bitsHashed / 0x100000000), true);
            this.hashBuffer();
            this.finished = true;
        }
        const out = new DataView(new ArrayBuffer((0, $0ceab8b4236748e7$export$d7bd469488748c5f)));
        for(let i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
        return new Uint8Array(out.buffer, out.byteOffset, out.byteLength);
    }
    hashBuffer() {
        const { buffer: buffer, state: state } = this;
        let a = state[0], b = state[1], c = state[2], d = state[3];
        a = $22d6c48826499a0b$var$ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
        d = $22d6c48826499a0b$var$ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
        c = $22d6c48826499a0b$var$ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
        b = $22d6c48826499a0b$var$ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
        a = $22d6c48826499a0b$var$ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
        d = $22d6c48826499a0b$var$ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
        c = $22d6c48826499a0b$var$ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
        b = $22d6c48826499a0b$var$ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
        a = $22d6c48826499a0b$var$ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
        d = $22d6c48826499a0b$var$ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
        c = $22d6c48826499a0b$var$ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
        b = $22d6c48826499a0b$var$ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
        a = $22d6c48826499a0b$var$ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
        d = $22d6c48826499a0b$var$ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
        c = $22d6c48826499a0b$var$ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
        b = $22d6c48826499a0b$var$ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
        a = $22d6c48826499a0b$var$gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
        d = $22d6c48826499a0b$var$gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
        c = $22d6c48826499a0b$var$gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
        b = $22d6c48826499a0b$var$gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
        a = $22d6c48826499a0b$var$gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
        d = $22d6c48826499a0b$var$gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
        c = $22d6c48826499a0b$var$gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
        b = $22d6c48826499a0b$var$gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
        a = $22d6c48826499a0b$var$gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
        d = $22d6c48826499a0b$var$gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
        c = $22d6c48826499a0b$var$gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
        b = $22d6c48826499a0b$var$gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
        a = $22d6c48826499a0b$var$gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
        d = $22d6c48826499a0b$var$gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
        c = $22d6c48826499a0b$var$gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
        b = $22d6c48826499a0b$var$gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
        a = $22d6c48826499a0b$var$hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
        d = $22d6c48826499a0b$var$hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
        c = $22d6c48826499a0b$var$hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
        b = $22d6c48826499a0b$var$hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
        a = $22d6c48826499a0b$var$hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
        d = $22d6c48826499a0b$var$hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
        c = $22d6c48826499a0b$var$hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
        b = $22d6c48826499a0b$var$hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
        a = $22d6c48826499a0b$var$hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
        d = $22d6c48826499a0b$var$hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
        c = $22d6c48826499a0b$var$hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
        b = $22d6c48826499a0b$var$hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
        a = $22d6c48826499a0b$var$hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
        d = $22d6c48826499a0b$var$hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
        c = $22d6c48826499a0b$var$hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
        b = $22d6c48826499a0b$var$hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
        a = $22d6c48826499a0b$var$ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
        d = $22d6c48826499a0b$var$ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
        c = $22d6c48826499a0b$var$ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
        b = $22d6c48826499a0b$var$ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
        a = $22d6c48826499a0b$var$ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
        d = $22d6c48826499a0b$var$ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
        c = $22d6c48826499a0b$var$ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
        b = $22d6c48826499a0b$var$ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
        a = $22d6c48826499a0b$var$ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
        d = $22d6c48826499a0b$var$ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
        c = $22d6c48826499a0b$var$ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
        b = $22d6c48826499a0b$var$ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
        a = $22d6c48826499a0b$var$ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
        d = $22d6c48826499a0b$var$ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
        c = $22d6c48826499a0b$var$ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
        b = $22d6c48826499a0b$var$ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
        state[0] = a + state[0] & 0xffffffff;
        state[1] = b + state[1] & 0xffffffff;
        state[2] = c + state[2] & 0xffffffff;
        state[3] = d + state[3] & 0xffffffff;
    }
    reset() {
        this.state = Uint32Array.from((0, $0ceab8b4236748e7$export$d788bc089976c004));
        this.buffer = new DataView(new ArrayBuffer((0, $0ceab8b4236748e7$export$b2e3d6d444266a5c)));
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
    }
}
function $22d6c48826499a0b$var$cmn(q, a, b, x, s, t) {
    a = (a + q & 0xffffffff) + (x + t & 0xffffffff) & 0xffffffff;
    return (a << s | a >>> 32 - s) + b & 0xffffffff;
}
function $22d6c48826499a0b$var$ff(a, b, c, d, x, s, t) {
    return $22d6c48826499a0b$var$cmn(b & c | ~b & d, a, b, x, s, t);
}
function $22d6c48826499a0b$var$gg(a, b, c, d, x, s, t) {
    return $22d6c48826499a0b$var$cmn(b & d | c & ~d, a, b, x, s, t);
}
function $22d6c48826499a0b$var$hh(a, b, c, d, x, s, t) {
    return $22d6c48826499a0b$var$cmn(b ^ c ^ d, a, b, x, s, t);
}
function $22d6c48826499a0b$var$ii(a, b, c, d, x, s, t) {
    return $22d6c48826499a0b$var$cmn(c ^ (b | ~d), a, b, x, s, t);
}
function $22d6c48826499a0b$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
function $22d6c48826499a0b$var$convertToBuffer(data) {
    if (typeof data === "string") return (0, $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


const $b08e507d63327dfa$export$967f3527bf233bc0 = (body)=>{
    if (typeof body === "string") {
        let len = body.length;
        for(let i = len - 1; i >= 0; i--){
            const code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error(`Body Length computation failed for ${body}`);
};







class $e756b3611af3d36e$export$9b641ca3a5f7a09 {
    constructor(options){
        this.sigv4Signer = new (0, $332513fcfabd50ca$export$20baf4d3f65eb30c)(options);
        this.signerOptions = options;
    }
    async sign(requestToSign, options = {}) {
        if (options.signingRegion === "*") {
            if (this.signerOptions.runtime !== "node") throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
            return this.getSigv4aSigner().sign(requestToSign, options);
        }
        return this.sigv4Signer.sign(requestToSign, options);
    }
    async presign(originalRequest, options = {}) {
        if (options.signingRegion === "*") {
            if (this.signerOptions.runtime !== "node") throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
            return this.getSigv4aSigner().presign(originalRequest, options);
        }
        return this.sigv4Signer.presign(originalRequest, options);
    }
    getSigv4aSigner() {
        if (!this.sigv4aSigner) {
            let CrtSignerV4;
            try {
                CrtSignerV4 = (parcelRequire("kjyEk")).CrtSignerV4;
                if (typeof CrtSignerV4 !== "function") throw new Error();
            } catch (e) {
                e.message = `${e.message}\nPlease check if you have installed "@aws-sdk/signature-v4-crt" package explicitly. \n` + "For more information please go to " + "https://github.com/aws/aws-sdk-js-v3#functionality-requiring-aws-common-runtime-crt";
                throw e;
            }
            this.sigv4aSigner = new CrtSignerV4({
                ...this.signerOptions,
                signingAlgorithm: 1
            });
        }
        return this.sigv4aSigner;
    }
}










const $288d0070e366bd12$var$bJ = "required", $288d0070e366bd12$var$bK = "type", $288d0070e366bd12$var$bL = "conditions", $288d0070e366bd12$var$bM = "fn", $288d0070e366bd12$var$bN = "argv", $288d0070e366bd12$var$bO = "ref", $288d0070e366bd12$var$bP = "assign", $288d0070e366bd12$var$bQ = "url", $288d0070e366bd12$var$bR = "properties", $288d0070e366bd12$var$bS = "authSchemes", $288d0070e366bd12$var$bT = "disableDoubleEncoding", $288d0070e366bd12$var$bU = "signingName", $288d0070e366bd12$var$bV = "signingRegion", $288d0070e366bd12$var$bW = "headers";
const $288d0070e366bd12$var$a = false, $288d0070e366bd12$var$b = true, $288d0070e366bd12$var$c = "isSet", $288d0070e366bd12$var$d = "tree", $288d0070e366bd12$var$e = "booleanEquals", $288d0070e366bd12$var$f = "error", $288d0070e366bd12$var$g = "aws.partition", $288d0070e366bd12$var$h = "stringEquals", $288d0070e366bd12$var$i = "getAttr", $288d0070e366bd12$var$j = "name", $288d0070e366bd12$var$k = "substring", $288d0070e366bd12$var$l = "hardwareType", $288d0070e366bd12$var$m = "regionPrefix", $288d0070e366bd12$var$n = "bucketAliasSuffix", $288d0070e366bd12$var$o = "outpostId", $288d0070e366bd12$var$p = "isValidHostLabel", $288d0070e366bd12$var$q = "not", $288d0070e366bd12$var$r = "parseURL", $288d0070e366bd12$var$s = "s3-outposts", $288d0070e366bd12$var$t = "endpoint", $288d0070e366bd12$var$u = "aws.isVirtualHostableS3Bucket", $288d0070e366bd12$var$v = "s3", $288d0070e366bd12$var$w = "{url#scheme}://{url#authority}{url#normalizedPath}{Bucket}", $288d0070e366bd12$var$x = "{url#scheme}://{Bucket}.{url#authority}{url#path}", $288d0070e366bd12$var$y = "https://{Bucket}.s3-accelerate.{partitionResult#dnsSuffix}", $288d0070e366bd12$var$z = "https://{Bucket}.s3.{partitionResult#dnsSuffix}", $288d0070e366bd12$var$A = "aws.parseArn", $288d0070e366bd12$var$B = "bucketArn", $288d0070e366bd12$var$C = "arnType", $288d0070e366bd12$var$D = "", $288d0070e366bd12$var$E = "s3-object-lambda", $288d0070e366bd12$var$F = "accesspoint", $288d0070e366bd12$var$G = "accessPointName", $288d0070e366bd12$var$H = "{url#scheme}://{accessPointName}-{bucketArn#accountId}.{url#authority}{url#path}", $288d0070e366bd12$var$I = "mrapPartition", $288d0070e366bd12$var$J = "outpostType", $288d0070e366bd12$var$K = "arnPrefix", $288d0070e366bd12$var$L = "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", $288d0070e366bd12$var$M = "https://s3.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", $288d0070e366bd12$var$N = "{url#scheme}://{url#authority}{url#path}", $288d0070e366bd12$var$O = "https://s3.{partitionResult#dnsSuffix}", $288d0070e366bd12$var$P = {
    [$288d0070e366bd12$var$bJ]: false,
    [$288d0070e366bd12$var$bK]: "String"
}, $288d0070e366bd12$var$Q = {
    [$288d0070e366bd12$var$bJ]: true,
    "default": false,
    [$288d0070e366bd12$var$bK]: "Boolean"
}, $288d0070e366bd12$var$R = {
    [$288d0070e366bd12$var$bJ]: false,
    [$288d0070e366bd12$var$bK]: "Boolean"
}, $288d0070e366bd12$var$S = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "Accelerate"
        },
        true
    ]
}, $288d0070e366bd12$var$T = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "UseFIPS"
        },
        true
    ]
}, $288d0070e366bd12$var$U = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "UseDualStack"
        },
        true
    ]
}, $288d0070e366bd12$var$V = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "Endpoint"
        }
    ]
}, $288d0070e366bd12$var$W = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$g,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "Region"
        }
    ],
    [$288d0070e366bd12$var$bP]: "partitionResult"
}, $288d0070e366bd12$var$X = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
            [$288d0070e366bd12$var$bN]: [
                {
                    [$288d0070e366bd12$var$bO]: "partitionResult"
                },
                $288d0070e366bd12$var$j
            ]
        },
        "aws-cn"
    ]
}, $288d0070e366bd12$var$Y = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "Bucket"
        }
    ]
}, $288d0070e366bd12$var$Z = {
    [$288d0070e366bd12$var$bO]: "Bucket"
}, $288d0070e366bd12$var$aa = {
    [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$l
}, $288d0070e366bd12$var$ab = {
    [$288d0070e366bd12$var$bL]: [
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
            [$288d0070e366bd12$var$bN]: [
                $288d0070e366bd12$var$V
            ]
        }
    ],
    [$288d0070e366bd12$var$f]: "Expected a endpoint to be specified but no endpoint was found",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$ac = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
    [$288d0070e366bd12$var$bN]: [
        $288d0070e366bd12$var$V
    ]
}, $288d0070e366bd12$var$ad = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$r,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "Endpoint"
        }
    ],
    [$288d0070e366bd12$var$bP]: "url"
}, $288d0070e366bd12$var$ae = {
    [$288d0070e366bd12$var$bS]: [
        {
            [$288d0070e366bd12$var$bT]: true,
            [$288d0070e366bd12$var$j]: "sigv4",
            [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$s,
            [$288d0070e366bd12$var$bV]: "{Region}"
        }
    ]
}, $288d0070e366bd12$var$af = {}, $288d0070e366bd12$var$ag = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "ForcePathStyle"
        },
        false
    ]
}, $288d0070e366bd12$var$ah = {
    [$288d0070e366bd12$var$bO]: "ForcePathStyle"
}, $288d0070e366bd12$var$ai = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "Accelerate"
        },
        false
    ]
}, $288d0070e366bd12$var$aj = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "Region"
        },
        "aws-global"
    ]
}, $288d0070e366bd12$var$ak = {
    [$288d0070e366bd12$var$bS]: [
        {
            [$288d0070e366bd12$var$bT]: true,
            [$288d0070e366bd12$var$j]: "sigv4",
            [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$v,
            [$288d0070e366bd12$var$bV]: "us-east-1"
        }
    ]
}, $288d0070e366bd12$var$al = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
    [$288d0070e366bd12$var$bN]: [
        $288d0070e366bd12$var$aj
    ]
}, $288d0070e366bd12$var$am = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "UseGlobalEndpoint"
        },
        true
    ]
}, $288d0070e366bd12$var$an = {
    [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: {
        [$288d0070e366bd12$var$bS]: [
            {
                [$288d0070e366bd12$var$bT]: true,
                [$288d0070e366bd12$var$j]: "sigv4",
                [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$v,
                [$288d0070e366bd12$var$bV]: "{Region}"
            }
        ]
    },
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$ao = {
    [$288d0070e366bd12$var$bS]: [
        {
            [$288d0070e366bd12$var$bT]: true,
            [$288d0070e366bd12$var$j]: "sigv4",
            [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$v,
            [$288d0070e366bd12$var$bV]: "{Region}"
        }
    ]
}, $288d0070e366bd12$var$ap = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "UseGlobalEndpoint"
        },
        false
    ]
}, $288d0070e366bd12$var$aq = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "UseDualStack"
        },
        false
    ]
}, $288d0070e366bd12$var$ar = {
    [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3-fips.{Region}.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$as = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "UseFIPS"
        },
        false
    ]
}, $288d0070e366bd12$var$at = {
    [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3-accelerate.dualstack.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$au = {
    [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3.dualstack.{Region}.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$av = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
            [$288d0070e366bd12$var$bN]: [
                {
                    [$288d0070e366bd12$var$bO]: "url"
                },
                "isIp"
            ]
        },
        true
    ]
}, $288d0070e366bd12$var$aw = {
    [$288d0070e366bd12$var$bO]: "url"
}, $288d0070e366bd12$var$ax = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
            [$288d0070e366bd12$var$bN]: [
                $288d0070e366bd12$var$aw,
                "isIp"
            ]
        },
        false
    ]
}, $288d0070e366bd12$var$ay = {
    [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$w,
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$az = {
    [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$x,
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$aA = {
    [$288d0070e366bd12$var$t]: $288d0070e366bd12$var$az,
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
}, $288d0070e366bd12$var$aB = {
    [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$y,
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$aC = {
    [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3.{Region}.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$aD = {
    [$288d0070e366bd12$var$f]: "Invalid region: region was not a valid DNS name.",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aE = {
    [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$B
}, $288d0070e366bd12$var$aF = {
    [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$C
}, $288d0070e366bd12$var$aG = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
    [$288d0070e366bd12$var$bN]: [
        $288d0070e366bd12$var$aE,
        "service"
    ]
}, $288d0070e366bd12$var$aH = {
    [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$G
}, $288d0070e366bd12$var$aI = {
    [$288d0070e366bd12$var$bL]: [
        $288d0070e366bd12$var$U
    ],
    [$288d0070e366bd12$var$f]: "S3 Object Lambda does not support Dual-stack",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aJ = {
    [$288d0070e366bd12$var$bL]: [
        $288d0070e366bd12$var$S
    ],
    [$288d0070e366bd12$var$f]: "S3 Object Lambda does not support S3 Accelerate",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aK = {
    [$288d0070e366bd12$var$bL]: [
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
            [$288d0070e366bd12$var$bN]: [
                {
                    [$288d0070e366bd12$var$bO]: "DisableAccessPoints"
                }
            ]
        },
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
            [$288d0070e366bd12$var$bN]: [
                {
                    [$288d0070e366bd12$var$bO]: "DisableAccessPoints"
                },
                true
            ]
        }
    ],
    [$288d0070e366bd12$var$f]: "Access points are not supported for this operation",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aL = {
    [$288d0070e366bd12$var$bL]: [
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
            [$288d0070e366bd12$var$bN]: [
                {
                    [$288d0070e366bd12$var$bO]: "UseArnRegion"
                }
            ]
        },
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
            [$288d0070e366bd12$var$bN]: [
                {
                    [$288d0070e366bd12$var$bO]: "UseArnRegion"
                },
                false
            ]
        },
        {
            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
            [$288d0070e366bd12$var$bN]: [
                {
                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                    [$288d0070e366bd12$var$bN]: [
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                            [$288d0070e366bd12$var$bN]: [
                                $288d0070e366bd12$var$aE,
                                "region"
                            ]
                        },
                        "{Region}"
                    ]
                }
            ]
        }
    ],
    [$288d0070e366bd12$var$f]: "Invalid configuration: region from ARN `{bucketArn#region}` does not match client region `{Region}` and UseArnRegion is `false`",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aM = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
    [$288d0070e366bd12$var$bN]: [
        {
            [$288d0070e366bd12$var$bO]: "bucketPartition"
        },
        $288d0070e366bd12$var$j
    ]
}, $288d0070e366bd12$var$aN = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
    [$288d0070e366bd12$var$bN]: [
        $288d0070e366bd12$var$aE,
        "accountId"
    ]
}, $288d0070e366bd12$var$aO = {
    [$288d0070e366bd12$var$bS]: [
        {
            [$288d0070e366bd12$var$bT]: true,
            [$288d0070e366bd12$var$j]: "sigv4",
            [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$E,
            [$288d0070e366bd12$var$bV]: "{bucketArn#region}"
        }
    ]
}, $288d0070e366bd12$var$aP = {
    [$288d0070e366bd12$var$f]: "Invalid ARN: The access point name may only contain a-z, A-Z, 0-9 and `-`. Found: `{accessPointName}`",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aQ = {
    [$288d0070e366bd12$var$f]: "Invalid ARN: The account id may only contain a-z, A-Z, 0-9 and `-`. Found: `{bucketArn#accountId}`",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aR = {
    [$288d0070e366bd12$var$f]: "Invalid region in ARN: `{bucketArn#region}` (invalid DNS name)",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aS = {
    [$288d0070e366bd12$var$f]: "Client was configured for partition `{partitionResult#name}` but ARN (`{Bucket}`) has `{bucketPartition#name}`",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aT = {
    [$288d0070e366bd12$var$f]: "Invalid ARN: The ARN may only contain a single resource component after `accesspoint`.",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aU = {
    [$288d0070e366bd12$var$f]: "Invalid ARN: Expected a resource of the format `accesspoint:<accesspoint name>` but no name was provided",
    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
}, $288d0070e366bd12$var$aV = {
    [$288d0070e366bd12$var$bS]: [
        {
            [$288d0070e366bd12$var$bT]: true,
            [$288d0070e366bd12$var$j]: "sigv4",
            [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$v,
            [$288d0070e366bd12$var$bV]: "{bucketArn#region}"
        }
    ]
}, $288d0070e366bd12$var$aW = {
    [$288d0070e366bd12$var$bS]: [
        {
            [$288d0070e366bd12$var$bT]: true,
            [$288d0070e366bd12$var$j]: "sigv4",
            [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$s,
            [$288d0070e366bd12$var$bV]: "{bucketArn#region}"
        }
    ]
}, $288d0070e366bd12$var$aX = {
    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$A,
    [$288d0070e366bd12$var$bN]: [
        $288d0070e366bd12$var$Z
    ]
}, $288d0070e366bd12$var$aY = {
    [$288d0070e366bd12$var$bQ]: "https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$aZ = {
    [$288d0070e366bd12$var$bQ]: "https://s3-fips.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$ba = {
    [$288d0070e366bd12$var$bQ]: "https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$bb = {
    [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$L,
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$bc = {
    [$288d0070e366bd12$var$bQ]: "https://s3.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$bd = {
    [$288d0070e366bd12$var$bO]: "UseObjectLambdaEndpoint"
}, $288d0070e366bd12$var$be = {
    [$288d0070e366bd12$var$bS]: [
        {
            [$288d0070e366bd12$var$bT]: true,
            [$288d0070e366bd12$var$j]: "sigv4",
            [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$E,
            [$288d0070e366bd12$var$bV]: "{Region}"
        }
    ]
}, $288d0070e366bd12$var$bf = {
    [$288d0070e366bd12$var$bQ]: "https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$bg = {
    [$288d0070e366bd12$var$bQ]: "https://s3-fips.{Region}.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$bh = {
    [$288d0070e366bd12$var$bQ]: "https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$bi = {
    [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$N,
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$bj = {
    [$288d0070e366bd12$var$bQ]: "https://s3.{Region}.{partitionResult#dnsSuffix}",
    [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
    [$288d0070e366bd12$var$bW]: {}
}, $288d0070e366bd12$var$bk = [
    {
        [$288d0070e366bd12$var$bO]: "Region"
    }
], $288d0070e366bd12$var$bl = [
    {
        [$288d0070e366bd12$var$bO]: "Endpoint"
    }
], $288d0070e366bd12$var$bm = [
    $288d0070e366bd12$var$Z
], $288d0070e366bd12$var$bn = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$p,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$o
            },
            false
        ]
    }
], $288d0070e366bd12$var$bo = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$m
            },
            "beta"
        ]
    }
], $288d0070e366bd12$var$bp = [
    $288d0070e366bd12$var$V,
    $288d0070e366bd12$var$ad
], $288d0070e366bd12$var$bq = [
    $288d0070e366bd12$var$Y
], $288d0070e366bd12$var$br = [
    $288d0070e366bd12$var$W
], $288d0070e366bd12$var$bs = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$p,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bO]: "Region"
            },
            false
        ]
    }
], $288d0070e366bd12$var$bt = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bO]: "Region"
            },
            "us-east-1"
        ]
    }
], $288d0070e366bd12$var$bu = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
        [$288d0070e366bd12$var$bN]: [
            $288d0070e366bd12$var$aF,
            $288d0070e366bd12$var$F
        ]
    }
], $288d0070e366bd12$var$bv = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
        [$288d0070e366bd12$var$bN]: [
            $288d0070e366bd12$var$aE,
            "resourceId[1]"
        ],
        [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$G
    },
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                [$288d0070e366bd12$var$bN]: [
                    $288d0070e366bd12$var$aH,
                    $288d0070e366bd12$var$D
                ]
            }
        ]
    }
], $288d0070e366bd12$var$bw = [
    $288d0070e366bd12$var$aE,
    "resourceId[1]"
], $288d0070e366bd12$var$bx = [
    $288d0070e366bd12$var$U
], $288d0070e366bd12$var$by = [
    $288d0070e366bd12$var$S
], $288d0070e366bd12$var$bz = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                [$288d0070e366bd12$var$bN]: [
                    {
                        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                        [$288d0070e366bd12$var$bN]: [
                            $288d0070e366bd12$var$aE,
                            "region"
                        ]
                    },
                    $288d0070e366bd12$var$D
                ]
            }
        ]
    }
], $288d0070e366bd12$var$bA = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
                [$288d0070e366bd12$var$bN]: [
                    {
                        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                        [$288d0070e366bd12$var$bN]: [
                            $288d0070e366bd12$var$aE,
                            "resourceId[2]"
                        ]
                    }
                ]
            }
        ]
    }
], $288d0070e366bd12$var$bB = [
    $288d0070e366bd12$var$aE,
    "resourceId[2]"
], $288d0070e366bd12$var$bC = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$g,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                [$288d0070e366bd12$var$bN]: [
                    $288d0070e366bd12$var$aE,
                    "region"
                ]
            }
        ],
        [$288d0070e366bd12$var$bP]: "bucketPartition"
    }
], $288d0070e366bd12$var$bD = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
        [$288d0070e366bd12$var$bN]: [
            $288d0070e366bd12$var$aM,
            {
                [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                [$288d0070e366bd12$var$bN]: [
                    {
                        [$288d0070e366bd12$var$bO]: "partitionResult"
                    },
                    $288d0070e366bd12$var$j
                ]
            }
        ]
    }
], $288d0070e366bd12$var$bE = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$p,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                [$288d0070e366bd12$var$bN]: [
                    $288d0070e366bd12$var$aE,
                    "region"
                ]
            },
            true
        ]
    }
], $288d0070e366bd12$var$bF = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$p,
        [$288d0070e366bd12$var$bN]: [
            $288d0070e366bd12$var$aN,
            false
        ]
    }
], $288d0070e366bd12$var$bG = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$p,
        [$288d0070e366bd12$var$bN]: [
            $288d0070e366bd12$var$aH,
            false
        ]
    }
], $288d0070e366bd12$var$bH = [
    $288d0070e366bd12$var$T
], $288d0070e366bd12$var$bI = [
    {
        [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$p,
        [$288d0070e366bd12$var$bN]: [
            {
                [$288d0070e366bd12$var$bO]: "Region"
            },
            true
        ]
    }
];
const $288d0070e366bd12$var$_data = {
    version: "1.0",
    parameters: {
        Bucket: $288d0070e366bd12$var$P,
        Region: $288d0070e366bd12$var$P,
        UseFIPS: $288d0070e366bd12$var$Q,
        UseDualStack: $288d0070e366bd12$var$Q,
        Endpoint: $288d0070e366bd12$var$P,
        ForcePathStyle: $288d0070e366bd12$var$Q,
        Accelerate: $288d0070e366bd12$var$Q,
        UseGlobalEndpoint: $288d0070e366bd12$var$Q,
        UseObjectLambdaEndpoint: $288d0070e366bd12$var$R,
        DisableAccessPoints: $288d0070e366bd12$var$R,
        DisableMultiRegionAccessPoints: $288d0070e366bd12$var$Q,
        UseArnRegion: $288d0070e366bd12$var$R
    },
    rules: [
        {
            [$288d0070e366bd12$var$bL]: [
                {
                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
                    [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bk
                }
            ],
            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
            rules: [
                {
                    [$288d0070e366bd12$var$bL]: [
                        $288d0070e366bd12$var$S,
                        $288d0070e366bd12$var$T
                    ],
                    error: "Accelerate cannot be used with FIPS",
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                },
                {
                    [$288d0070e366bd12$var$bL]: [
                        $288d0070e366bd12$var$U,
                        $288d0070e366bd12$var$V
                    ],
                    error: "Cannot set dual-stack in combination with a custom endpoint.",
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                },
                {
                    [$288d0070e366bd12$var$bL]: [
                        $288d0070e366bd12$var$V,
                        $288d0070e366bd12$var$T
                    ],
                    error: "A custom endpoint cannot be combined with FIPS",
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                },
                {
                    [$288d0070e366bd12$var$bL]: [
                        $288d0070e366bd12$var$V,
                        $288d0070e366bd12$var$S
                    ],
                    error: "A custom endpoint cannot be combined with S3 Accelerate",
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                },
                {
                    [$288d0070e366bd12$var$bL]: [
                        $288d0070e366bd12$var$T,
                        $288d0070e366bd12$var$W,
                        $288d0070e366bd12$var$X
                    ],
                    error: "Partition does not support FIPS",
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                },
                {
                    [$288d0070e366bd12$var$bL]: [
                        $288d0070e366bd12$var$Y,
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$k,
                            [$288d0070e366bd12$var$bN]: [
                                $288d0070e366bd12$var$Z,
                                49,
                                50,
                                $288d0070e366bd12$var$b
                            ],
                            [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$l
                        },
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$k,
                            [$288d0070e366bd12$var$bN]: [
                                $288d0070e366bd12$var$Z,
                                8,
                                12,
                                $288d0070e366bd12$var$b
                            ],
                            [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$m
                        },
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$k,
                            [$288d0070e366bd12$var$bN]: [
                                $288d0070e366bd12$var$Z,
                                0,
                                7,
                                $288d0070e366bd12$var$b
                            ],
                            [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$n
                        },
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$k,
                            [$288d0070e366bd12$var$bN]: [
                                $288d0070e366bd12$var$Z,
                                32,
                                49,
                                $288d0070e366bd12$var$b
                            ],
                            [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$o
                        },
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$g,
                            [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bk,
                            [$288d0070e366bd12$var$bP]: "regionPartition"
                        },
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                            [$288d0070e366bd12$var$bN]: [
                                {
                                    [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$n
                                },
                                "--op-s3"
                            ]
                        }
                    ],
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                    rules: [
                        {
                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bn,
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                            rules: [
                                {
                                    [$288d0070e366bd12$var$bL]: [
                                        {
                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                            [$288d0070e366bd12$var$bN]: [
                                                $288d0070e366bd12$var$aa,
                                                "e"
                                            ]
                                        }
                                    ],
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                    rules: [
                                        {
                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bo,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                $288d0070e366bd12$var$ab,
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bp,
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://{Bucket}.ec2.{url#authority}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ae,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        {
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: "https://{Bucket}.ec2.s3-outposts.{Region}.{regionPartition#dnsSuffix}",
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ae,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        }
                                    ]
                                },
                                {
                                    [$288d0070e366bd12$var$bL]: [
                                        {
                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                            [$288d0070e366bd12$var$bN]: [
                                                $288d0070e366bd12$var$aa,
                                                "o"
                                            ]
                                        }
                                    ],
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                    rules: [
                                        {
                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bo,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                $288d0070e366bd12$var$ab,
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bp,
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://{Bucket}.op-{outpostId}.{url#authority}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ae,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        {
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: "https://{Bucket}.op-{outpostId}.s3-outposts.{Region}.{regionPartition#dnsSuffix}",
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ae,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        }
                                    ]
                                },
                                {
                                    error: "Unrecognized hardware type: \"Expected hardware type o or e but got {hardwareType}\"",
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                }
                            ]
                        },
                        {
                            error: "Invalid ARN: The outpost Id must only contain a-z, A-Z, 0-9 and `-`.",
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                        }
                    ]
                },
                {
                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bq,
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                    rules: [
                        {
                            [$288d0070e366bd12$var$bL]: [
                                $288d0070e366bd12$var$V,
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
                                    [$288d0070e366bd12$var$bN]: [
                                        {
                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
                                            [$288d0070e366bd12$var$bN]: [
                                                {
                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$r,
                                                    [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bl
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            error: "Custom endpoint `{Endpoint}` was not a valid URI",
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                        },
                        {
                            [$288d0070e366bd12$var$bL]: [
                                $288d0070e366bd12$var$ag,
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$u,
                                    [$288d0070e366bd12$var$bN]: [
                                        $288d0070e366bd12$var$Z,
                                        $288d0070e366bd12$var$a
                                    ]
                                }
                            ],
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                            rules: [
                                {
                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$br,
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                    rules: [
                                        {
                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bs,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$S,
                                                        $288d0070e366bd12$var$X
                                                    ],
                                                    error: "S3 Accelerate cannot be used in this region",
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            endpoint: $288d0070e366bd12$var$an,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$an,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3-fips.us-east-1.{partitionResult#dnsSuffix}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            endpoint: $288d0070e366bd12$var$ar,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$ar,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$S,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3-accelerate.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$S,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            endpoint: $288d0070e366bd12$var$at,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$S,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$at,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://{Bucket}.s3.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            endpoint: $288d0070e366bd12$var$au,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$au,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$av,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$w,
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$ax,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$x,
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$av,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bt,
                                                            endpoint: $288d0070e366bd12$var$ay,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        },
                                                        {
                                                            endpoint: $288d0070e366bd12$var$ay,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$ax,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bt,
                                                            endpoint: $288d0070e366bd12$var$az,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        },
                                                        $288d0070e366bd12$var$aA
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$av,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$ay,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$ax,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$az,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$S,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$y,
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$S,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bt,
                                                            endpoint: $288d0070e366bd12$var$aB,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        },
                                                        {
                                                            endpoint: $288d0070e366bd12$var$aB,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$S,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$aB,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$z,
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bt,
                                                            endpoint: {
                                                                [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$z,
                                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
                                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                            },
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        },
                                                        {
                                                            endpoint: $288d0070e366bd12$var$aC,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$ai,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$aC,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        $288d0070e366bd12$var$aD
                                    ]
                                }
                            ]
                        },
                        {
                            [$288d0070e366bd12$var$bL]: [
                                $288d0070e366bd12$var$V,
                                $288d0070e366bd12$var$ad,
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                    [$288d0070e366bd12$var$bN]: [
                                        {
                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                                            [$288d0070e366bd12$var$bN]: [
                                                $288d0070e366bd12$var$aw,
                                                "scheme"
                                            ]
                                        },
                                        "http"
                                    ]
                                },
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$u,
                                    [$288d0070e366bd12$var$bN]: [
                                        $288d0070e366bd12$var$Z,
                                        $288d0070e366bd12$var$b
                                    ]
                                },
                                $288d0070e366bd12$var$ag,
                                $288d0070e366bd12$var$as,
                                $288d0070e366bd12$var$aq,
                                $288d0070e366bd12$var$ai
                            ],
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                            rules: [
                                {
                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$br,
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                    rules: [
                                        {
                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bs,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                $288d0070e366bd12$var$aA
                                            ]
                                        },
                                        $288d0070e366bd12$var$aD
                                    ]
                                }
                            ]
                        },
                        {
                            [$288d0070e366bd12$var$bL]: [
                                $288d0070e366bd12$var$ag,
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$A,
                                    [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bm,
                                    [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$B
                                }
                            ],
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                            rules: [
                                {
                                    [$288d0070e366bd12$var$bL]: [
                                        {
                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                                            [$288d0070e366bd12$var$bN]: [
                                                $288d0070e366bd12$var$aE,
                                                "resourceId[0]"
                                            ],
                                            [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$C
                                        },
                                        {
                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
                                            [$288d0070e366bd12$var$bN]: [
                                                {
                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                                    [$288d0070e366bd12$var$bN]: [
                                                        $288d0070e366bd12$var$aF,
                                                        $288d0070e366bd12$var$D
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                    rules: [
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                {
                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                                    [$288d0070e366bd12$var$bN]: [
                                                        $288d0070e366bd12$var$aG,
                                                        $288d0070e366bd12$var$E
                                                    ]
                                                }
                                            ],
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bu,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bv,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                            rules: [
                                                                $288d0070e366bd12$var$aI,
                                                                $288d0070e366bd12$var$aJ,
                                                                {
                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bz,
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                    rules: [
                                                                        $288d0070e366bd12$var$aK,
                                                                        {
                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bA,
                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                            rules: [
                                                                                $288d0070e366bd12$var$aL,
                                                                                {
                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bC,
                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                    rules: [
                                                                                        {
                                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$br,
                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                            rules: [
                                                                                                {
                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bD,
                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                    rules: [
                                                                                                        {
                                                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bE,
                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                            rules: [
                                                                                                                {
                                                                                                                    [$288d0070e366bd12$var$bL]: [
                                                                                                                        {
                                                                                                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                                                                                                            [$288d0070e366bd12$var$bN]: [
                                                                                                                                $288d0070e366bd12$var$aN,
                                                                                                                                $288d0070e366bd12$var$D
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    error: "Invalid ARN: Missing account id",
                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                                                                },
                                                                                                                {
                                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bF,
                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                                    rules: [
                                                                                                                        {
                                                                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bG,
                                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                                            rules: [
                                                                                                                                {
                                                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bp,
                                                                                                                                    endpoint: {
                                                                                                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$H,
                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aO,
                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                    },
                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bH,
                                                                                                                                    endpoint: {
                                                                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}-{bucketArn#accountId}.s3-object-lambda-fips.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aO,
                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                    },
                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    endpoint: {
                                                                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}-{bucketArn#accountId}.s3-object-lambda.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aO,
                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                    },
                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        $288d0070e366bd12$var$aP
                                                                                                                    ]
                                                                                                                },
                                                                                                                $288d0070e366bd12$var$aQ
                                                                                                            ]
                                                                                                        },
                                                                                                        $288d0070e366bd12$var$aR
                                                                                                    ]
                                                                                                },
                                                                                                $288d0070e366bd12$var$aS
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        $288d0070e366bd12$var$aT
                                                                    ]
                                                                },
                                                                {
                                                                    error: "Invalid ARN: bucket ARN is missing a region",
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                }
                                                            ]
                                                        },
                                                        $288d0070e366bd12$var$aU
                                                    ]
                                                },
                                                {
                                                    error: "Invalid ARN: Object Lambda ARNs only support `accesspoint` arn types, but found: `{arnType}`",
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                }
                                            ]
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bu,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bv,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bz,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                            rules: [
                                                                {
                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bu,
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                    rules: [
                                                                        {
                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bz,
                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                            rules: [
                                                                                $288d0070e366bd12$var$aK,
                                                                                {
                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bA,
                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                    rules: [
                                                                                        $288d0070e366bd12$var$aL,
                                                                                        {
                                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bC,
                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                            rules: [
                                                                                                {
                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$br,
                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                    rules: [
                                                                                                        {
                                                                                                            [$288d0070e366bd12$var$bL]: [
                                                                                                                {
                                                                                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                                                                                                    [$288d0070e366bd12$var$bN]: [
                                                                                                                        $288d0070e366bd12$var$aM,
                                                                                                                        "{partitionResult#name}"
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                            rules: [
                                                                                                                {
                                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bE,
                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                                    rules: [
                                                                                                                        {
                                                                                                                            [$288d0070e366bd12$var$bL]: [
                                                                                                                                {
                                                                                                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                                                                                                                    [$288d0070e366bd12$var$bN]: [
                                                                                                                                        $288d0070e366bd12$var$aG,
                                                                                                                                        $288d0070e366bd12$var$v
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                                            rules: [
                                                                                                                                {
                                                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bF,
                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                                                    rules: [
                                                                                                                                        {
                                                                                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bG,
                                                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                                                            rules: [
                                                                                                                                                {
                                                                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$by,
                                                                                                                                                    error: "Access Points do not support S3 Accelerate",
                                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$288d0070e366bd12$var$bL]: [
                                                                                                                                                        $288d0070e366bd12$var$T,
                                                                                                                                                        $288d0070e366bd12$var$U
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint-fips.dualstack.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aV,
                                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                                    },
                                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$288d0070e366bd12$var$bL]: [
                                                                                                                                                        $288d0070e366bd12$var$T,
                                                                                                                                                        $288d0070e366bd12$var$aq
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint-fips.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aV,
                                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                                    },
                                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$288d0070e366bd12$var$bL]: [
                                                                                                                                                        $288d0070e366bd12$var$as,
                                                                                                                                                        $288d0070e366bd12$var$U
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint.dualstack.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aV,
                                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                                    },
                                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$288d0070e366bd12$var$bL]: [
                                                                                                                                                        $288d0070e366bd12$var$as,
                                                                                                                                                        $288d0070e366bd12$var$aq,
                                                                                                                                                        $288d0070e366bd12$var$V,
                                                                                                                                                        $288d0070e366bd12$var$ad
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$H,
                                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aV,
                                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                                    },
                                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    [$288d0070e366bd12$var$bL]: [
                                                                                                                                                        $288d0070e366bd12$var$as,
                                                                                                                                                        $288d0070e366bd12$var$aq
                                                                                                                                                    ],
                                                                                                                                                    endpoint: {
                                                                                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aV,
                                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                                    },
                                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        $288d0070e366bd12$var$aP
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                $288d0070e366bd12$var$aQ
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            error: "Invalid ARN: The ARN was not for the S3 service, found: {bucketArn#service}",
                                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                $288d0070e366bd12$var$aR
                                                                                                            ]
                                                                                                        },
                                                                                                        $288d0070e366bd12$var$aS
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                $288d0070e366bd12$var$aT
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            [$288d0070e366bd12$var$bL]: [
                                                                {
                                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$p,
                                                                    [$288d0070e366bd12$var$bN]: [
                                                                        $288d0070e366bd12$var$aH,
                                                                        $288d0070e366bd12$var$b
                                                                    ]
                                                                }
                                                            ],
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                            rules: [
                                                                {
                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bx,
                                                                    error: "S3 MRAP does not support dual-stack",
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                },
                                                                {
                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bH,
                                                                    error: "S3 MRAP does not support FIPS",
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                },
                                                                {
                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$by,
                                                                    error: "S3 MRAP does not support S3 Accelerate",
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                },
                                                                {
                                                                    [$288d0070e366bd12$var$bL]: [
                                                                        {
                                                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
                                                                            [$288d0070e366bd12$var$bN]: [
                                                                                {
                                                                                    [$288d0070e366bd12$var$bO]: "DisableMultiRegionAccessPoints"
                                                                                },
                                                                                $288d0070e366bd12$var$b
                                                                            ]
                                                                        }
                                                                    ],
                                                                    error: "Invalid configuration: Multi-Region Access Point ARNs are disabled.",
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                },
                                                                {
                                                                    [$288d0070e366bd12$var$bL]: [
                                                                        {
                                                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$g,
                                                                            [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bk,
                                                                            [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$I
                                                                        }
                                                                    ],
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                    rules: [
                                                                        {
                                                                            [$288d0070e366bd12$var$bL]: [
                                                                                {
                                                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                                                                    [$288d0070e366bd12$var$bN]: [
                                                                                        {
                                                                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                                                                                            [$288d0070e366bd12$var$bN]: [
                                                                                                {
                                                                                                    [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$I
                                                                                                },
                                                                                                $288d0070e366bd12$var$j
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                                                                                            [$288d0070e366bd12$var$bN]: [
                                                                                                $288d0070e366bd12$var$aE,
                                                                                                "partition"
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                            rules: [
                                                                                {
                                                                                    endpoint: {
                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}.accesspoint.s3-global.{mrapPartition#dnsSuffix}",
                                                                                        [$288d0070e366bd12$var$bR]: {
                                                                                            [$288d0070e366bd12$var$bS]: [
                                                                                                {
                                                                                                    [$288d0070e366bd12$var$bT]: $288d0070e366bd12$var$b,
                                                                                                    name: "sigv4a",
                                                                                                    [$288d0070e366bd12$var$bU]: $288d0070e366bd12$var$v,
                                                                                                    signingRegionSet: [
                                                                                                        "*"
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                    },
                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            error: "Client was configured for partition `{mrapPartition#name}` but bucket referred to partition `{bucketArn#partition}`",
                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            error: "Invalid Access Point Name",
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                        }
                                                    ]
                                                },
                                                $288d0070e366bd12$var$aU
                                            ]
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                {
                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                                    [$288d0070e366bd12$var$bN]: [
                                                        $288d0070e366bd12$var$aG,
                                                        $288d0070e366bd12$var$s
                                                    ]
                                                }
                                            ],
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bx,
                                                    error: "S3 Outposts does not support Dual-stack",
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bH,
                                                    error: "S3 Outposts does not support FIPS",
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$by,
                                                    error: "S3 Outposts does not support S3 Accelerate",
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        {
                                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
                                                            [$288d0070e366bd12$var$bN]: [
                                                                {
                                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                                                                    [$288d0070e366bd12$var$bN]: [
                                                                        $288d0070e366bd12$var$aE,
                                                                        "resourceId[4]"
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    error: "Invalid Arn: Outpost Access Point ARN contains sub resources",
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        {
                                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                                                            [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bw,
                                                            [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$o
                                                        }
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bn,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                            rules: [
                                                                $288d0070e366bd12$var$aL,
                                                                {
                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bC,
                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                    rules: [
                                                                        {
                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$br,
                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                            rules: [
                                                                                {
                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bD,
                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                    rules: [
                                                                                        {
                                                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bE,
                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                            rules: [
                                                                                                {
                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bF,
                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                    rules: [
                                                                                                        {
                                                                                                            [$288d0070e366bd12$var$bL]: [
                                                                                                                {
                                                                                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                                                                                                                    [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bB,
                                                                                                                    [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$J
                                                                                                                }
                                                                                                            ],
                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                            rules: [
                                                                                                                {
                                                                                                                    [$288d0070e366bd12$var$bL]: [
                                                                                                                        {
                                                                                                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$i,
                                                                                                                            [$288d0070e366bd12$var$bN]: [
                                                                                                                                $288d0070e366bd12$var$aE,
                                                                                                                                "resourceId[3]"
                                                                                                                            ],
                                                                                                                            [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$G
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                                    rules: [
                                                                                                                        {
                                                                                                                            [$288d0070e366bd12$var$bL]: [
                                                                                                                                {
                                                                                                                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                                                                                                                    [$288d0070e366bd12$var$bN]: [
                                                                                                                                        {
                                                                                                                                            [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$J
                                                                                                                                        },
                                                                                                                                        $288d0070e366bd12$var$F
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                                                                                            rules: [
                                                                                                                                {
                                                                                                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bp,
                                                                                                                                    endpoint: {
                                                                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}-{bucketArn#accountId}.{outpostId}.{url#authority}",
                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aW,
                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                    },
                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    endpoint: {
                                                                                                                                        [$288d0070e366bd12$var$bQ]: "https://{accessPointName}-{bucketArn#accountId}.{outpostId}.s3-outposts.{bucketArn#region}.{bucketPartition#dnsSuffix}",
                                                                                                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$aW,
                                                                                                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                                                                                                    },
                                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            error: "Expected an outpost type `accesspoint`, found {outpostType}",
                                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    error: "Invalid ARN: expected an access point name",
                                                                                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            error: "Invalid ARN: Expected a 4-component resource",
                                                                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                $288d0070e366bd12$var$aQ
                                                                                            ]
                                                                                        },
                                                                                        $288d0070e366bd12$var$aR
                                                                                    ]
                                                                                },
                                                                                $288d0070e366bd12$var$aS
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            error: "Invalid ARN: The outpost Id may only contain a-z, A-Z, 0-9 and `-`. Found: `{outpostId}`",
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                        }
                                                    ]
                                                },
                                                {
                                                    error: "Invalid ARN: The Outpost Id was not set",
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                                }
                                            ]
                                        },
                                        {
                                            error: "Invalid ARN: Unrecognized format: {Bucket} (type: {arnType})",
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                        }
                                    ]
                                },
                                {
                                    error: "Invalid ARN: No ARN type specified",
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                }
                            ]
                        },
                        {
                            [$288d0070e366bd12$var$bL]: [
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$k,
                                    [$288d0070e366bd12$var$bN]: [
                                        $288d0070e366bd12$var$Z,
                                        0,
                                        4,
                                        $288d0070e366bd12$var$a
                                    ],
                                    [$288d0070e366bd12$var$bP]: $288d0070e366bd12$var$K
                                },
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$h,
                                    [$288d0070e366bd12$var$bN]: [
                                        {
                                            [$288d0070e366bd12$var$bO]: $288d0070e366bd12$var$K
                                        },
                                        "arn:"
                                    ]
                                },
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
                                    [$288d0070e366bd12$var$bN]: [
                                        {
                                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
                                            [$288d0070e366bd12$var$bN]: [
                                                $288d0070e366bd12$var$aX
                                            ]
                                        }
                                    ]
                                }
                            ],
                            error: "Invalid ARN: `{Bucket}` was not a valid ARN",
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                        },
                        {
                            [$288d0070e366bd12$var$bL]: [
                                {
                                    [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
                                    [$288d0070e366bd12$var$bN]: [
                                        $288d0070e366bd12$var$ah,
                                        $288d0070e366bd12$var$b
                                    ]
                                },
                                $288d0070e366bd12$var$aX
                            ],
                            error: "Path-style addressing cannot be used with ARN buckets",
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                        },
                        {
                            [$288d0070e366bd12$var$bL]: [
                                {
                                    [$288d0070e366bd12$var$bM]: "uriEncode",
                                    [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bm,
                                    [$288d0070e366bd12$var$bP]: "uri_encoded_bucket"
                                }
                            ],
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                            rules: [
                                {
                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$br,
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                    rules: [
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$ai
                                            ],
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            endpoint: $288d0070e366bd12$var$aY,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$aY,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://s3-fips.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            endpoint: $288d0070e366bd12$var$aZ,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$T,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$aZ,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: "https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}",
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            endpoint: $288d0070e366bd12$var$ba,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$U,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$ba,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$L,
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bt,
                                                            endpoint: $288d0070e366bd12$var$bb,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        },
                                                        {
                                                            endpoint: $288d0070e366bd12$var$bb,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$V,
                                                        $288d0070e366bd12$var$ad,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$bb,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$aj
                                                    ],
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$M,
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$am
                                                    ],
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                                    rules: [
                                                        {
                                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bt,
                                                            endpoint: {
                                                                [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$M,
                                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
                                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                            },
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        },
                                                        {
                                                            endpoint: $288d0070e366bd12$var$bc,
                                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                        }
                                                    ]
                                                },
                                                {
                                                    [$288d0070e366bd12$var$bL]: [
                                                        $288d0070e366bd12$var$aq,
                                                        $288d0070e366bd12$var$ac,
                                                        $288d0070e366bd12$var$as,
                                                        $288d0070e366bd12$var$al,
                                                        $288d0070e366bd12$var$ap
                                                    ],
                                                    endpoint: $288d0070e366bd12$var$bc,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        {
                                            error: "Path-style addressing cannot be used with S3 Accelerate",
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    [$288d0070e366bd12$var$bL]: [
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$c,
                            [$288d0070e366bd12$var$bN]: [
                                $288d0070e366bd12$var$bd
                            ]
                        },
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$e,
                            [$288d0070e366bd12$var$bN]: [
                                $288d0070e366bd12$var$bd,
                                $288d0070e366bd12$var$b
                            ]
                        }
                    ],
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                    rules: [
                        {
                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$br,
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                            rules: [
                                {
                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bI,
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                    rules: [
                                        $288d0070e366bd12$var$aI,
                                        $288d0070e366bd12$var$aJ,
                                        {
                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bp,
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$N,
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$be,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bH,
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: "https://s3-object-lambda-fips.{Region}.{partitionResult#dnsSuffix}",
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$be,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: "https://s3-object-lambda.{Region}.{partitionResult#dnsSuffix}",
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$be,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        }
                                    ]
                                },
                                $288d0070e366bd12$var$aD
                            ]
                        }
                    ]
                },
                {
                    [$288d0070e366bd12$var$bL]: [
                        {
                            [$288d0070e366bd12$var$bM]: $288d0070e366bd12$var$q,
                            [$288d0070e366bd12$var$bN]: $288d0070e366bd12$var$bq
                        }
                    ],
                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                    rules: [
                        {
                            [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$br,
                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                            rules: [
                                {
                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bI,
                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                    rules: [
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$T,
                                                $288d0070e366bd12$var$U,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$aj
                                            ],
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: "https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$T,
                                                $288d0070e366bd12$var$U,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$am
                                            ],
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    endpoint: $288d0070e366bd12$var$bf,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$T,
                                                $288d0070e366bd12$var$U,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$ap
                                            ],
                                            endpoint: $288d0070e366bd12$var$bf,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$T,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$aj
                                            ],
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: "https://s3-fips.us-east-1.{partitionResult#dnsSuffix}",
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$T,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$am
                                            ],
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    endpoint: $288d0070e366bd12$var$bg,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$T,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$ap
                                            ],
                                            endpoint: $288d0070e366bd12$var$bg,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$U,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$aj
                                            ],
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: "https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}",
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$U,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$am
                                            ],
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    endpoint: $288d0070e366bd12$var$bh,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$U,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$ap
                                            ],
                                            endpoint: $288d0070e366bd12$var$bh,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$V,
                                                $288d0070e366bd12$var$ad,
                                                $288d0070e366bd12$var$aj
                                            ],
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$N,
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$V,
                                                $288d0070e366bd12$var$ad,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$am
                                            ],
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bt,
                                                    endpoint: $288d0070e366bd12$var$bi,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    endpoint: $288d0070e366bd12$var$bi,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$V,
                                                $288d0070e366bd12$var$ad,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$ap
                                            ],
                                            endpoint: $288d0070e366bd12$var$bi,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$aj
                                            ],
                                            endpoint: {
                                                [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$O,
                                                [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ak,
                                                [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                            },
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$am
                                            ],
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$d,
                                            rules: [
                                                {
                                                    [$288d0070e366bd12$var$bL]: $288d0070e366bd12$var$bt,
                                                    endpoint: {
                                                        [$288d0070e366bd12$var$bQ]: $288d0070e366bd12$var$O,
                                                        [$288d0070e366bd12$var$bR]: $288d0070e366bd12$var$ao,
                                                        [$288d0070e366bd12$var$bW]: $288d0070e366bd12$var$af
                                                    },
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                },
                                                {
                                                    endpoint: $288d0070e366bd12$var$bj,
                                                    [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                                }
                                            ]
                                        },
                                        {
                                            [$288d0070e366bd12$var$bL]: [
                                                $288d0070e366bd12$var$as,
                                                $288d0070e366bd12$var$aq,
                                                $288d0070e366bd12$var$ac,
                                                $288d0070e366bd12$var$al,
                                                $288d0070e366bd12$var$ap
                                            ],
                                            endpoint: $288d0070e366bd12$var$bj,
                                            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$t
                                        }
                                    ]
                                },
                                $288d0070e366bd12$var$aD
                            ]
                        }
                    ]
                }
            ]
        },
        {
            error: "A region must be set when sending requests to S3.",
            [$288d0070e366bd12$var$bK]: $288d0070e366bd12$var$f
        }
    ]
};
const $288d0070e366bd12$export$7b249e066372152f = $288d0070e366bd12$var$_data;


const $eae66cd99ba18ac1$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return (0, $5904fe9d0ba50fed$export$48b88e4e5ecac119)((0, $288d0070e366bd12$export$7b249e066372152f), {
        endpointParams: endpointParams,
        logger: context.logger
    });
};


const $314de0eca3c00112$export$ad0966540b0e71e5 = (config)=>({
        apiVersion: "2006-03-01",
        base64Decoder: config?.base64Decoder ?? (0, $26e2ba55729a8e75$export$c537b38001c583b7),
        base64Encoder: config?.base64Encoder ?? (0, $b8e9e9e3b0dc2c27$export$37cc283d8fbd3462),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $eae66cd99ba18ac1$export$47fc6e98c86e06e3),
        getAwsChunkedEncodingStream: config?.getAwsChunkedEncodingStream ?? (0, $bf7e86ef23159abe$export$cc0c9507624e70d1),
        logger: config?.logger ?? new (0, $7a64dcbd6d1e06f1$export$4147bde06f294c2e)(),
        sdkStreamMixin: config?.sdkStreamMixin ?? (0, $4afa527ae68dfced$export$5f9760b56bbf9f65),
        serviceId: config?.serviceId ?? "S3",
        signerConstructor: config?.signerConstructor ?? (0, $e756b3611af3d36e$export$9b641ca3a5f7a09),
        signingEscapePath: config?.signingEscapePath ?? false,
        urlParser: config?.urlParser ?? (0, $b71e56dcf280298d$export$7a5253c0f62e0150),
        useArnRegion: config?.useArnRegion ?? false,
        utf8Decoder: config?.utf8Decoder ?? (0, $115b7b7cc5a24eaf$export$c7c5cef950a4d2fc),
        utf8Encoder: config?.utf8Encoder ?? (0, $2554f7a5fe934436$export$b4b216764bb846eb)
    });





const $dfb731a3601e9996$export$32aeb2667d16f7c1 = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];


const $c04fc604b66e97d3$export$b146d618450007ac = ({ defaultsMode: defaultsMode } = {})=>(0, $4ee178ba25e8e3b7$export$fc10aeed3a532e2a)(async ()=>{
        const mode = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
        switch(mode?.toLowerCase()){
            case "auto":
                return Promise.resolve($c04fc604b66e97d3$var$isMobileBrowser() ? "mobile" : "standard");
            case "mobile":
            case "in-region":
            case "cross-region":
            case "standard":
            case "legacy":
                return Promise.resolve(mode?.toLocaleLowerCase());
            case undefined:
                return Promise.resolve("legacy");
            default:
                throw new Error(`Invalid parameter for "defaultsMode", expect ${(0, $dfb731a3601e9996$export$32aeb2667d16f7c1).join(", ")}, got ${mode}`);
        }
    });
const $c04fc604b66e97d3$var$isMobileBrowser = ()=>{
    const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($03dc96944173e4d6$exports))).parse(window.navigator.userAgent) : undefined;
    const platform = parsedUA?.platform?.type;
    return platform === "tablet" || platform === "mobile";
};




const $4fe0f7cdfebd6cd7$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $c04fc604b66e97d3$export$b146d618450007ac)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $76d6722ee679f099$export$b6e2b46631b45a92));
    const clientSharedValues = (0, $314de0eca3c00112$export$ad0966540b0e71e5)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $b08e507d63327dfa$export$967f3527bf233bc0),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $36ab7aff4f97a5b5$export$69d579f32876892f)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($8bab7e469a6afe26$exports))).version
        }),
        eventStreamSerdeProvider: config?.eventStreamSerdeProvider ?? (0, $96a9c773c3e47a59$export$9d23a885702ebafb),
        maxAttempts: config?.maxAttempts ?? (0, $534adb1defad154b$export$2c7e51f38ba5a406),
        md5: config?.md5 ?? (0, $22d6c48826499a0b$export$9f5a3dfc7a9f5dd),
        region: config?.region ?? (0, $f02e3c97a2fee0d8$export$d59dd53963f8f3d5)("Region is missing"),
        requestHandler: config?.requestHandler ?? new (0, $9cbb653eb839bbf4$export$83588b87edbfa7e0)(defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $534adb1defad154b$export$41315747b7c5d042)),
        sha1: config?.sha1 ?? (0, $7652e3ffbb9aff11$exports.Sha1),
        sha256: config?.sha256 ?? (0, $3ce7992f05548527$exports.Sha256),
        streamCollector: config?.streamCollector ?? (0, $08bb3d04fbb6f025$export$17bf97b72e307d52),
        streamHasher: config?.streamHasher ?? (0, $47629ed131b942bb$export$ea66e9c498b7933c),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $d668a1f94de4394e$export$beb01fae7626c427))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $c7e78c882a40b6b4$export$5555deeca435a10b)))
    };
};


class $e099fe821dfb1d71$export$b5be36c66bc46237 extends (0, $1e332f05d1ae8c15$export$1f2bb630327ac4b6) {
    constructor(...[configuration]){
        const _config_0 = (0, $4fe0f7cdfebd6cd7$export$ad0966540b0e71e5)(configuration || {});
        const _config_1 = (0, $a66d5922af5b4baa$export$70b6341cd51750a8)(_config_0);
        const _config_2 = (0, $237f0f9cb76337ce$export$7696ef37558bd0ec)(_config_1);
        const _config_3 = (0, $2b8ecfb31dd9a46b$export$8c5b66831e3f26ff)(_config_2);
        const _config_4 = (0, $13d2904175ea6339$export$ca7f6138f2c98476)(_config_3);
        const _config_5 = (0, $88d2ee7e36f5c90f$export$c1625bf0b32b4481)(_config_4);
        const _config_6 = (0, $cbefa977fc2921db$export$1dd62920de1feabb)(_config_5);
        const _config_7 = (0, $c69f352e0da94b39$export$9acff03461140bb6)(_config_6);
        const _config_8 = (0, $754475b8730b53d4$export$ec9a2d5663958cb)(_config_7);
        const _config_9 = (0, $907652720ee87f40$export$5e2ae00bf65442f0)(_config_8);
        super(_config_9);
        this.config = _config_9;
        this.middlewareStack.use((0, $bd9ede8b9dd2c907$export$c73199e2b1df9340)(this.config));
        this.middlewareStack.use((0, $ec9f63e670cded24$export$7e6ddf9365a30fe9)(this.config));
        this.middlewareStack.use((0, $88d2ee7e36f5c90f$export$23d3b647211be53a)(this.config));
        this.middlewareStack.use((0, $8add791fe0d5d356$export$f6ef65d7766fc255)(this.config));
        this.middlewareStack.use((0, $60c3e4d6205418db$export$11d0b9345788bd5)(this.config));
        this.middlewareStack.use((0, $88d408844032d892$export$59c2b7ad30ed4046)(this.config));
        this.middlewareStack.use((0, $0268e8cb6b99ca31$export$c30d61978fbb3ad8)(this.config));
        this.middlewareStack.use((0, $b93203295d94535b$export$7692e5e7214e5cd1)(this.config));
        this.middlewareStack.use((0, $7b3c99e5173f4767$export$5393c0d2d7f4f5f0)(this.config));
    }
    destroy() {
        super.destroy();
    }
}








class $963ab64b3cf8cd04$export$20fd13f6cebe56f0 extends (0, $9b91565ddaedd0f1$export$cc7e12c76513e857) {
    static getEndpointParameterInstructions() {
        return {
            Bucket: {
                type: "contextParams",
                name: "Bucket"
            },
            ForcePathStyle: {
                type: "clientContextParams",
                name: "forcePathStyle"
            },
            UseArnRegion: {
                type: "clientContextParams",
                name: "useArnRegion"
            },
            DisableMultiRegionAccessPoints: {
                type: "clientContextParams",
                name: "disableMultiregionAccessPoints"
            },
            Accelerate: {
                type: "clientContextParams",
                name: "useAccelerateEndpoint"
            },
            UseGlobalEndpoint: {
                type: "builtInParams",
                name: "useGlobalEndpoint"
            },
            UseFIPS: {
                type: "builtInParams",
                name: "useFipsEndpoint"
            },
            Endpoint: {
                type: "builtInParams",
                name: "endpoint"
            },
            Region: {
                type: "builtInParams",
                name: "region"
            },
            UseDualStack: {
                type: "builtInParams",
                name: "useDualstackEndpoint"
            }
        };
    }
    constructor(input){
        super();
        this.input = input;
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use((0, $7b67ff6108e5be33$export$53fdc69654553fd4)(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use((0, $e3a5472d351bf15f$export$946c80457b765eab)(configuration, $963ab64b3cf8cd04$export$20fd13f6cebe56f0.getEndpointParameterInstructions()));
        this.middlewareStack.use((0, $f373a583c4de1c5c$export$baf25e0187b0946b)(configuration));
        this.middlewareStack.use((0, $3894f853c046795a$export$b3c55b56128dbf17)(configuration, {
            input: this.input,
            requestAlgorithmMember: "ChecksumAlgorithm",
            requestChecksumRequired: false
        }));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const clientName = "S3Client";
        const commandName = "UploadPartCommand";
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: (0, $1b94a343f91115e4$export$d8157ceb4def2c93),
            outputFilterSensitiveLog: (0, $1b94a343f91115e4$export$16e90045ae9e0c88)
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return (0, $695e66930879143f$export$83a6b460ef4fd1f8)(input, context);
    }
    deserialize(output, context) {
        return (0, $695e66930879143f$export$c970fb418cbd6bb1)(output, context);
    }
}


var $a86455099caa6415$require$S3Client = $e099fe821dfb1d71$export$b5be36c66bc46237;
var $a86455099caa6415$require$PutObjectCommand = $6c1c275f9407a048$export$4afa2352f8871c26;
var $a86455099caa6415$require$GetObjectCommand = $2de2536a47252ea3$export$25364b3fa12a4666;
var $a86455099caa6415$require$HeadObjectCommand = $6f263ee8fed03a95$export$ce09a87958bd6882;
var $a86455099caa6415$require$CreateMultipartUploadCommand = $bd5a45fbaa7b2945$export$76155123c96043b8;
var $a86455099caa6415$require$UploadPartCommand = $963ab64b3cf8cd04$export$20fd13f6cebe56f0;
var $a86455099caa6415$require$CompleteMultipartUploadCommand = $d61edaf1bc0c0a33$export$f827ea0301b4eeff;
var $a86455099caa6415$require$AbortMultipartUploadCommand = $4321cea269e1a859$export$87d2388f8662d995;
var $67cf979a1473aa80$exports = {};
"use strict";

// Representing an index file in the cloud
// It's a file containing a list of files that have 
// been uploaded to the cloud.
const $67cf979a1473aa80$var$IndexFile = function() {
    // Name of the cloud sharing group
    this.GroupName = "";
    // Entries in the index file
    this.Entries = {};
    // Deserialize the index file from an array of json bytes
    this.Deserialize = function(bytes) {
        // Get json string from bytes
        let bytesView = new Uint8Array(bytes);
        let json = new TextDecoder().decode(bytesView);
        var indexObj = JSON.parse(json);
        console.log(indexObj);
        this.GroupName = indexObj.GroupName;
        this.Entries = indexObj.Entries;
    };
    // Serialize the index file to json code bytes
    this.Serialize = function() {
        var indexfile = {};
        indexfile.GroupName = this.GroupName;
        indexfile.Entries = this.Entries;
        var json = JSON.stringify(indexfile);
        var jsonBytes = new TextEncoder().encode(json);
        return jsonBytes;
    };
    // For checking if an entry is expired
    this.IsEntryExpired = function(entry) {
        const currentDT = new Date();
        const entryExpires = entry.Expires;
        const entryExpiresDT = $2163fab358138a9e$exports.cloudEntryDateStringToDate(entryExpires);
        if (currentDT > entryExpiresDT) return true;
        return false;
    };
    // Removes an entry from the index file
    this.RemoveEntry = function(entryHash) {
        delete this.Entries[entryHash];
    };
    // Removes expired entries from the index file
    this.RemoveExpiredEntries = function() {
        for(const key in this.Entries){
            let entry = this.Entries[key];
            let expired = this.IsEntryExpired(entry);
            if (expired) delete this.Entries[key];
        }
    };
    // Get the entries as an array
    this.GetEntriesAsArray = function() {
        let entryArr = [];
        for(const key in this.Entries)entryArr.push({
            entryHash: key,
            entryValue: this.Entries[key]
        });
        return entryArr;
    };
};
$67cf979a1473aa80$exports = $67cf979a1473aa80$var$IndexFile;






var $90f256c567e4c320$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($90f256c567e4c320$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $90f256c567e4c320$exports = g;
});


// Check if a S3 http error is a not found error
// Also checking if it is a 403 error and treating it like
// a 404 not found error, because of how some things work on AWS.
const $a86455099caa6415$var$isNotFoundError = (code)=>{
    return code === 403 || code === 404;
};
const $a86455099caa6415$var$getAWSCred = function() {
    let k = new Uint8Array([
        192,
        145,
        88,
        100,
        32,
        67,
        220,
        176,
        12,
        254,
        141,
        72,
        17,
        90,
        105,
        10,
        209,
        121,
        64,
        100,
        32,
        67,
        220,
        176,
        12,
        254,
        141,
        72,
        17,
        222,
        69,
        135
    ]);
    let h = "552F98DB3E53EB9EBAF6EE78FD839A8EC80512E4";
    let aki0 = 'GlSA5aCi9ptu27siWkjM0I';
    let aki1 = '8kJyUu5Wb7zHQ0L0QfIUo=';
    let sak0 = 'rPdLSMKvW8M7o9YqIJrvaHnU7tQrUeos';
    let sak1 = '5+6I9FlaWEMhzhTUM9i2COFEuk2xA5OV';
    return {
        accessKeyId: $4532b754c156253d$exports.decryptString(k, h, aki0 + aki1),
        secretAccessKey: $4532b754c156253d$exports.decryptString(k, h, sak0 + sak1)
    };
};
// The S3 client for interacting with amazon
const $a86455099caa6415$var$s3 = new $a86455099caa6415$require$S3Client({
    region: "us-east-2",
    credentials: $a86455099caa6415$var$getAWSCred()
});
// Get the encryption key for encrypting and decrypting
// the file of an entry that is stored in the file bucket
const $a86455099caa6415$var$getEntryObjectEncryptionKey = (entry, groupID)=>{
    let result = null;
    if (entry.Key) result = $4532b754c156253d$exports.base64ToBytes(entry.Key);
    else result = groupID;
    return result;
};
const $a86455099caa6415$var$getEntryObjectName = (entry, entryID)=>{
    return entry.Key ? $4532b754c156253d$exports.createHashBase64OfString(entryID + entry.Key) : entryID;
};
// Get index object name
const $a86455099caa6415$var$getIndexObjectName = function(groupInfo) {
    let grid = groupInfo.groupID;
    return "IB/" + (groupInfo.version !== $b9e88d59535bb3ce$exports.CloudSystemVersionZero ? $4532b754c156253d$exports.createHashBase64(grid) : $4532b754c156253d$exports.bytesToBase64(grid));
};
// Method for calculating the needed size of parts
// when splitting an array into n smaller parts
// totalLength : The length of the array
// n : The number of parts
// Example if totalLength is 10 and n is 3 then 4 should be returned
// if totalLength is 9 and n is 3 then 3 should be returned
const $a86455099caa6415$var$getBytePartSize = function(totalLength, n) {
    if (totalLength < n) return 1;
    var partSize = Math.floor(totalLength / n);
    return totalLength % n == 0 ? partSize : partSize + 1;
};
// Get sub array in an array of a bytes
// bytes : The original byte array
// index : Index where to start
// maxLength : Maximum length of the sub array.
// In many cases the returned array will have this length
// but in case maxLength would result in getting values out of the bounds
// of the array the length of the returned array will be smaller
const $a86455099caa6415$var$getSubByteArray = function(bytes, index, maxLength) {
    var byteLen = bytes.length;
    if (index < byteLen) {
        var endIndex = index + maxLength - 1;
        var maxIndex = byteLen - 1;
        if (endIndex > maxIndex) endIndex = maxIndex;
        var output = [];
        for(var i = index; i <= endIndex; i++)output.push(bytes[i]);
        return new Uint8Array(output);
    } else // index not within array
    return null;
};
// Takes in array of Uint8Array objects
// and joins them into one big Uint8Array
// object
const $a86455099caa6415$var$joinBytes = function(bytes) {
    var arrayCount = bytes.length;
    // Compute the size needed
    var size = 0;
    var i = 0;
    for(i = 0; i < arrayCount; i++)size += bytes[i].length;
    // Create new Uint8Array for the joined bytes
    var joinedBytes = new Uint8Array(size);
    var nextIndex = 0;
    for(i = 0; i < arrayCount; i++){
        if (i == 0) joinedBytes.set(bytes[i]);
        else joinedBytes.set(bytes[i], nextIndex);
        nextIndex += bytes[i].length;
    }
    return joinedBytes;
};
// Get an object from the cloud given a bucket name and the key of the object
// in that bucket
const $a86455099caa6415$var$getObject = async (bucketName, key)=>{
    console.log('Getting object from ' + bucketName);
    var result = {};
    result.success = false;
    try {
        const bucketParams = {
            Bucket: bucketName,
            Key: key,
            ResponseCacheControl: 'no-store'
        };
        const data = await $a86455099caa6415$var$s3.send(new $a86455099caa6415$require$GetObjectCommand(bucketParams));
        const statusCode = data.$metadata.httpStatusCode;
        console.log('getObject status code=' + statusCode);
        result.httpStatusCode = statusCode;
        if (statusCode == 200) {
            // Getting content of object from bucket
            result.objectBytes = await $fbf091ffd61010f8$exports.streamToBuffer(data.Body);
            result.success = true;
            return result;
        }
    } catch (err) {
        if (err.$metadata != null) {
            if (err.$metadata.httpStatusCode != null) result.httpStatusCode = err.$metadata.httpStatusCode;
        }
        if ($a86455099caa6415$var$isNotFoundError(result.httpStatusCode)) console.log("Did not find object in " + bucketName);
        else console.error('Error in getObject: ', err);
    }
    return result;
};
// Calculate optimal part size and count for a given file size
// Returns { partSize, numParts }
// - partSize will never be smaller than minPartSize
// - numParts will never be larger than maxNumParts
// - Parts will be optimally sized to avoid small leftover parts
const $a86455099caa6415$var$calcPartSize = (totalSize, minPartSize = 8388608, maxNumParts = 10)=>{
    // For small files, just use a single part
    if (totalSize <= minPartSize) return {
        partSize: totalSize,
        numParts: 1
    };
    // Calculate initial part size and count
    let partSize = minPartSize;
    let numParts = Math.ceil(totalSize / partSize);
    // If we have too many parts, increase part size to reduce part count
    if (numParts > maxNumParts) {
        // Calculate minimum size needed to stay under maxNumParts
        partSize = Math.ceil(totalSize / maxNumParts);
        numParts = Math.ceil(totalSize / partSize);
    }
    // Ensure we don't end up with a tiny last part
    // Similar to the C# implementation, aim for a more even distribution
    if (numParts > 1) {
        const lastPartSize = totalSize % partSize;
        const minLastPartSize = minPartSize / 4; // Minimum acceptable last part size
        // If last part is too small, redistribute the load
        if (lastPartSize > 0 && lastPartSize < minLastPartSize) {
            // Slightly increase part size to distribute data more evenly
            partSize = Math.ceil(totalSize / (numParts - 0.5));
            numParts = Math.ceil(totalSize / partSize);
        }
    }
    console.log(`File size: ${totalSize} bytes, Part size: ${partSize} bytes, Parts: ${numParts}`);
    return {
        partSize: partSize,
        numParts: numParts
    };
};
// Downloads object using byte ranges in parallel
// Returns joined bytes of all the parts
const $a86455099caa6415$var$getObjectWithByteRanges = async (bucketName, objectName, totalSize)=>{
    const { partSize: partSize, numParts: numParts } = $a86455099caa6415$var$calcPartSize(totalSize);
    console.log(`Downloading ${objectName} in ${numParts} parts using byte ranges.`);
    var result = {};
    result.success = false;
    try {
        const downloadPromises = [];
        for(let i = 0; i < numParts; i++){
            const startByte = i * partSize;
            // For all parts except the last one, use exactly partSize bytes
            // For the last part, only go up to the end of the file
            const endByte = Math.min(startByte + partSize - 1, totalSize - 1);
            const range = `bytes=${startByte}-${endByte}`;
            const getParams = {
                Bucket: bucketName,
                Key: objectName,
                Range: range,
                ResponseCacheControl: 'no-store' // Ensure fresh data
            };
            console.log(`Requesting part ${i + 1}/${numParts}: ${range}`);
            downloadPromises.push($a86455099caa6415$var$s3.send(new $a86455099caa6415$require$GetObjectCommand(getParams)));
        }
        const responses = await Promise.all(downloadPromises);
        const bufferPromises = responses.map((response, index)=>{
            if (response.$metadata.httpStatusCode !== 206 && response.$metadata.httpStatusCode !== 200) {
                console.error(`Failed to download part ${index + 1}. Status: ${response.$metadata.httpStatusCode}`);
                throw new Error(`Part download failed with status ${response.$metadata.httpStatusCode}`);
            }
            return $fbf091ffd61010f8$exports.streamToBuffer(response.Body);
        });
        const buffers = await Promise.all(bufferPromises);
        const joinedBytes = $a86455099caa6415$var$joinBytes(buffers);
        if (joinedBytes.length !== totalSize) {
            console.error(`Joined byte length (${joinedBytes.length}) does not match total size (${totalSize})`);
            throw new Error("Final data size mismatch.");
        }
        result.joinedBytes = joinedBytes;
        result.success = true;
        console.log(`Successfully downloaded ${objectName} using byte ranges.`);
        return result;
    } catch (err) {
        console.error('Error in getObjectWithByteRanges: ', err);
        result.httpStatusCode = err?.$metadata?.httpStatusCode; // Capture status code if available
    }
    return result;
};
// Downloads object in multiple parts
// in parallel from file bucket
// Returns joined bytes of all the parts
const $a86455099caa6415$var$getMultiPartObjectBytes = async (hash, nrOfParts)=>{
    var result = {};
    result.success = false;
    try {
        var tasks = [];
        for(var i = 0; i < nrOfParts; i++){
            var partName = hash + "." + i;
            tasks.push($a86455099caa6415$var$getObject($a86455099caa6415$var$AwsExchangeFileBucketName, partName));
        }
        // Executes all the tasks in parallel
        const responses = await Promise.all(tasks);
        var byteArrays = [];
        for (let response of responses){
            if (!response.success) return result;
            byteArrays.push(response.objectBytes);
        }
        var joinedBytes = $a86455099caa6415$var$joinBytes(byteArrays);
        result.joinedBytes = joinedBytes;
        result.success = true;
        return result;
    } catch (err) {
        console.error('Error in getMultiPartObjectBytes: '.err);
    }
    return result;
};
// Method for uploading an object to aws s3
// bucketName : name of the bucket
// objectName : name of the object
// bytes : The bytes to send
const $a86455099caa6415$var$putObjectRaw = async (bucketName, objectName, bytes)=>{
    console.log("Sending data to " + bucketName);
    var result = {};
    result.success = false;
    var data = new Uint8Array(bytes);
    const uploadParams = {
        Bucket: bucketName,
        Key: objectName,
        Body: data
    };
    try {
        const putRes = await $a86455099caa6415$var$s3.send(new $a86455099caa6415$require$PutObjectCommand(uploadParams));
        result.httpStatusCode = putRes.$metadata.httpStatusCode;
        if (result.httpStatusCode === 200) {
            result.success = true;
            console.log("Successfully uploaded data to cloud.");
        }
    } catch (err) {
        console.error('Error in putObjectRaw: ', err);
    }
    return result;
};
// Helper to calculate upload part size for AWS S3 Multipart Upload
// Respects minimum part size (5MB) and maximum part count (10000)
const $a86455099caa6415$var$calcUploadPartSize = (totalSize, minPartSize = 5242880, maxNumParts = 10000)=>{
    if (totalSize === 0) return {
        partSize: 0,
        numParts: 0
    };
    // Ensure partSize is at least minPartSize
    let partSize = Math.max(minPartSize, Math.ceil(totalSize / maxNumParts));
    // Adjust partSize upwards if the calculated size results in too many parts
    let numParts = Math.ceil(totalSize / partSize);
    if (numParts > maxNumParts) {
        // This calculation ensures we stay *under* the max parts limit
        // by slightly increasing part size. We subtract a small epsilon (or 1 from divisor)
        // in the denominator conceptually to ensure ceiling gives correct number.
        partSize = Math.ceil(totalSize / (maxNumParts - 1));
        numParts = Math.ceil(totalSize / partSize);
    }
    // Final check, should not happen with above logic, but safety first.
    if (numParts > maxNumParts) {
        console.warn(`Calculated numParts ${numParts} exceeds max ${maxNumParts}. Adjusting partSize upwards.`);
        partSize = Math.ceil(totalSize / maxNumParts);
        numParts = maxNumParts;
    }
    console.log(`Upload calc: totalSize=${totalSize}, minPartSize=${minPartSize}, maxNumParts=${maxNumParts} -> partSize=${partSize}, numParts=${numParts}`);
    return {
        partSize: partSize,
        numParts: numParts
    };
};
/**
 * Uploads a file to the cloud using AWS S3 multipart upload.
 * This function handles both the legacy (V0) and modern (V1+) upload logic.
 * For V1+, it uses the native S3 multipart upload capabilities for large files.
 * For V0, it uses a custom multipart logic.
 * The data is encrypted before being uploaded.
 *
 * @param {object} groupInfo - Information about the cloud group, including groupID and version.
 * @param {Uint8Array} bytes - The raw byte data of the file to upload.
 * @param {function(string): void} onMessage - A callback function to display progress messages.
 * @param {Uint8Array|null} cryptoKey - The encryption key for V1+ uploads. If null, the groupID is used.
 * @param {string} entryObjectName - The name/key of the object to be created in the S3 bucket.
 * @returns {Promise<object>} A promise that resolves to an object with the following properties:
 * - {boolean} success - True if the upload was successful, otherwise false.
 * - {number} nrOfPartsOnEntry - The number of parts to record in the index file. 0 for V1+ uploads.
 * - {number} totalNrOfBytes - The total size of the encrypted data in bytes.
 */ const $a86455099caa6415$var$multipartUpload = async (groupInfo, bytes, onMessage, cryptoKey, entryObjectName)=>{
    let result = {
        success: false,
        nrOfPartsOnEntry: -1,
        totalNrOfBytes: 0
    };
    let isV1orGreater = groupInfo.version !== null && groupInfo.version !== $b9e88d59535bb3ce$exports.CloudSystemVersionZero;
    try {
        // Encrypt the data before sending it to the cloud
        onMessage("Encrypting data...");
        let dataToSend = $4532b754c156253d$exports.encryptObjectData(cryptoKey ? cryptoKey : groupInfo.groupID, cryptoKey ? $4532b754c156253d$exports.createHashBase64(cryptoKey) : entryObjectName, bytes);
        result.totalNrOfBytes = dataToSend.length;
        // The number of parts that gets added to the entry data
        // When using the AWS multipart upload functionality, we just set this to 0
        // even though the actual number of parts may not be 0. By doing this, we can
        // know that the entry was uploaded using the new AWS multipart upload functionality.
        // When using the old multipart upload logic, we set this to the actual number of parts.
        let nrOfPartsOnEntry = 0;
        onMessage("Sending data to cloud...");
        if (isV1orGreater) {
            // --- V1 or greater logic ---
            // Use AWS multipart upload functionality
            console.log("Using V1 AWS multipart upload logic.");
            const totalSize = dataToSend.length;
            const { partSize: partSize, numParts: numParts } = $a86455099caa6415$var$calcUploadPartSize(totalSize); // Use AWS part size calc
            // Use standard PutObject for small files OR if calculation resulted in 0/1 part
            if (totalSize === 0 || numParts <= 1) {
                console.log(`Uploading ${entryObjectName} as single object (size: ${totalSize})`);
                const putRes = await $a86455099caa6415$var$putObjectRaw($a86455099caa6415$var$AwsExchangeFileBucketName, entryObjectName, dataToSend);
                if (!putRes.success) {
                    console.error(`Single object upload failed for ${entryObjectName}`);
                    return result; // Early exit, result.success is already false
                }
                console.log(`Single object upload successful for ${entryObjectName}`);
            // NrOfParts is already 0 (from nrOfPartsOnEntry) for V1
            } else {
                console.log(`Starting multipart upload for ${entryObjectName} (${numParts} parts, size ${partSize})`);
                let uploadId = null;
                let uploadedParts = [];
                try {
                    // 1. Initiate Upload
                    const createUploadParams = {
                        Bucket: $a86455099caa6415$var$AwsExchangeFileBucketName,
                        Key: entryObjectName
                    };
                    const createUploadResponse = await $a86455099caa6415$var$s3.send(new $a86455099caa6415$require$CreateMultipartUploadCommand(createUploadParams));
                    uploadId = createUploadResponse.UploadId;
                    if (!uploadId) throw new Error("Failed to initiate multipart upload: No UploadId received.");
                    console.log(`Multipart upload initiated. UploadId: ${uploadId}`);
                    // 2. Upload Parts
                    console.log(`Uploading part 1 of ${numParts}...`);
                    const partUploadPromises = [];
                    for(let i = 0; i < numParts; i++){
                        const start = i * partSize;
                        const end = Math.min(start + partSize, totalSize);
                        const partNumber = i + 1;
                        // Slice creates a view, not a copy, which is efficient
                        const partData = dataToSend.slice(start, end);
                        const uploadPartParams = {
                            Bucket: $a86455099caa6415$var$AwsExchangeFileBucketName,
                            Key: entryObjectName,
                            UploadId: uploadId,
                            PartNumber: partNumber,
                            Body: partData
                        };
                        console.log(`Uploading part ${partNumber}/${numParts}, bytes ${start}-${end - 1}`);
                        // We don't await here, collect promises to run potentially in parallel
                        partUploadPromises.push($a86455099caa6415$var$s3.send(new $a86455099caa6415$require$UploadPartCommand(uploadPartParams)).then((response)=>{
                            console.log(`Part ${partNumber} uploaded. ETag: ${response.ETag}`);
                            // Update progress message periodically
                            if (partNumber % 5 === 0 || partNumber === numParts) console.log(`Uploading part ${partNumber} of ${numParts}...`);
                            return {
                                PartNumber: partNumber,
                                ETag: response.ETag
                            };
                        }).catch((err)=>{
                            console.error(`Failed to upload part ${partNumber}:`, err);
                            throw new Error(`Part ${partNumber} upload failed`); // Re-throw to fail Promise.all
                        }));
                    }
                    // Wait for all parts to finish uploading
                    uploadedParts = await Promise.all(partUploadPromises);
                    // 3. Complete Upload
                    console.log(`Completing upload...`);
                    const completeParams = {
                        Bucket: $a86455099caa6415$var$AwsExchangeFileBucketName,
                        Key: entryObjectName,
                        UploadId: uploadId,
                        MultipartUpload: {
                            // Ensure parts are sorted by PartNumber as required by S3
                            Parts: uploadedParts.sort((a, b)=>a.PartNumber - b.PartNumber)
                        }
                    };
                    console.log("Completing multipart upload...");
                    const completeResponse = await $a86455099caa6415$var$s3.send(new $a86455099caa6415$require$CompleteMultipartUploadCommand(completeParams));
                    console.log("Multipart upload completed successfully.", completeResponse);
                // NrOfParts is already 0 (from nrOfPartsOnEntry) for V1
                } catch (multipartError) {
                    console.error("Error during S3 multipart upload process:", multipartError);
                    // Abort the multipart upload if it was initiated
                    if (uploadId) {
                        console.log(`Aborting multipart upload ${uploadId}...`);
                        try {
                            await $a86455099caa6415$var$s3.send(new $a86455099caa6415$require$AbortMultipartUploadCommand({
                                Bucket: $a86455099caa6415$var$AwsExchangeFileBucketName,
                                Key: entryObjectName,
                                UploadId: uploadId
                            }));
                            console.log("Multipart upload aborted.");
                        } catch (abortError) {
                            // Log abort error but proceed with returning failure
                            console.error("Failed to abort multipart upload:", abortError);
                        }
                    }
                    return result; // Return failure, result.success is already false
                }
            }
        } else {
            // --- Old V0 multipart upload logic ---
            // Does not use the built-in AWS multipart upload functionality
            // Number of parts for multipart upload
            let nrOfParts = $b9e88d59535bb3ce$exports.MultipartNrOfParts;
            nrOfPartsOnEntry = nrOfParts;
            // Split data into parts and create an uploading task for each part
            let tasks = [];
            let partSize = $a86455099caa6415$var$getBytePartSize(dataToSend.length, nrOfParts);
            for(var i = 0; i < nrOfParts; i++)tasks.push($a86455099caa6415$var$putObjectRaw($a86455099caa6415$var$AwsExchangeFileBucketName, entryObjectName + "." + i, $a86455099caa6415$var$getSubByteArray(dataToSend, i * partSize, partSize)));
            // Executes all the tasks in parallel
            const responses = await Promise.all(tasks);
            for (let response of responses)// If one fails then we consider this to be a failure
            if (!response.success) return result;
        }
        result.nrOfPartsOnEntry = nrOfPartsOnEntry;
        result.success = true;
    } catch (err) {
        console.error('Error in multipartUpload: ', err);
    }
    return result;
};
// For uploading a file to the file bucket on the cloud
// Uploads data in multiple parts
// encryptionKey : Encryption key for encrypting the data
// entryID : ID of the entry in the index file
// fileInfo : Object with info about the file
// fileCount: Number of files that were uploaded
// In case a single zip file was uploaded and nothing
// else it should be the number of files inside that zip
// bytes : The data to send
// onMessage : Method for showing messages
// 
const $a86455099caa6415$var$putObject = async (groupInfo, entryID, fileInfo, fileCount, bytes, onMessage)=>{
    let result = {
        success: false
    };
    let isV1orGreater = groupInfo.version !== null && groupInfo.version !== $b9e88d59535bb3ce$exports.CloudSystemVersionZero;
    let cryptoKey = isV1orGreater ? $4532b754c156253d$exports.createRandomEncryptionKey() : null;
    let entry = $a86455099caa6415$var$createAndInitializeIndexFileEntry(cryptoKey ? $4532b754c156253d$exports.bytesToBase64(cryptoKey) : null);
    let finalEntryObjectName = $a86455099caa6415$var$getEntryObjectName(entry, entryID);
    try {
        const uploadResult = await $a86455099caa6415$var$multipartUpload(groupInfo, bytes, onMessage, cryptoKey, finalEntryObjectName);
        if (!uploadResult.success) return result; // Upload failed, so we exit early.
        // Add entry to the index file
        entry.File = {};
        entry.File.Filename = fileInfo.mainFile;
        entry.File.FileCount = fileCount;
        entry.File.Icon = fileInfo.icon;
        entry.File.NrOfParts = uploadResult.nrOfPartsOnEntry;
        entry.File.TotalNrOfBytes = uploadResult.totalNrOfBytes;
        entry.File.ArkioImport = {};
        result.entry = entry;
        onMessage("Updating index file...");
        let indexRes = await $a86455099caa6415$var$addToIndex(entryID, entry, groupInfo);
        if (indexRes.indexFile != null) result.indexFile = indexRes.indexFile;
        // If adding the entry to the index file fails then we can consider this
        // to have failed because there is no use in just uploading the file
        // if it's entry does not get added to the index file
        result.success = indexRes.success;
    } catch (err) {
        console.error('Error in putObject: ', err);
    }
    return result;
};
// Get index file from cloud
// success parameter is set to true if an index file was retrieved successfully
// If success is false, that may happen because of a few reasons, e.g. if index
// does not exist because it has not been uploaded yet or because of some error
// use httpStatusCode to check what kind of error happened
const $a86455099caa6415$var$getIndexFromCloud = async (groupInfo)=>{
    var result = {};
    result.success = false;
    try {
        var indexObjectName = $a86455099caa6415$var$getIndexObjectName(groupInfo);
        console.log("Getting current index for " + indexObjectName);
        const getRes = await $a86455099caa6415$var$getObject($a86455099caa6415$var$AwsExchangeIndexBucketName, indexObjectName);
        result.httpStatusCode = getRes.httpStatusCode;
        if (getRes.success) {
            let groupID = groupInfo.groupID;
            let indexData = groupInfo.version !== $b9e88d59535bb3ce$exports.CloudSystemVersionZero ? $4532b754c156253d$exports.decryptObjectData(groupID, $4532b754c156253d$exports.createHashBase64(groupID), getRes.objectBytes) : getRes.objectBytes;
            result.indexFile = new $67cf979a1473aa80$exports();
            result.indexFile.Deserialize(indexData);
            // Removes entries from index file that have expired, because we don't want those
            result.indexFile.RemoveExpiredEntries();
            result.success = true;
            console.log('Got index file from cloud.');
        } else {
            // If the status code is 404 then the index file was not found
            // If it was not 404 then some error has happened and it is
            // safest to abort the whole process of adding to the index
            if (!$a86455099caa6415$var$isNotFoundError(getRes.httpStatusCode)) return result;
        }
    } catch (err) {
        console.error('Error in getIndexFromCloud: ', err);
    }
    return result;
};
// Creates a new cloud index file entry object
// and initializes it with the Created and Expires dates set
// cryptoKey : Optional cryptographic key to add to the entry, for encrypting the data
// Should be a base64 encoded string
const $a86455099caa6415$var$createAndInitializeIndexFileEntry = function(cryptoKeyBase64) {
    let entry = {};
    if (cryptoKeyBase64) entry.Key = cryptoKeyBase64;
    entry.Created = $2163fab358138a9e$exports.getCurrentFormattedUTCDate();
    let expires = new Date();
    expires.setMilliseconds(expires.getMilliseconds() + $b9e88d59535bb3ce$exports.EntryLifespan);
    entry.Expires = $2163fab358138a9e$exports.getFormattedUTCDate(expires);
    return entry;
};
// Method for uploading index file to the cloud
// Takes care of removing expired entries, serializing and encrypting
const $a86455099caa6415$var$uploadIndex = async (indexFile, groupInfo)=>{
    let result = {
        success: false
    };
    try {
        // Remove expired entries as we don't want them there
        indexFile.RemoveExpiredEntries();
        result.indexFile = indexFile;
        let indexBytes = indexFile.Serialize();
        let groupID = groupInfo.groupID;
        if (groupInfo.version !== $b9e88d59535bb3ce$exports.CloudSystemVersionZero) indexBytes = $4532b754c156253d$exports.encryptObjectData(groupID, $4532b754c156253d$exports.createHashBase64(groupID), indexBytes);
        var indexObjectName = $a86455099caa6415$var$getIndexObjectName(groupInfo);
        console.log("Uploading index file to cloud.");
        var putRes = await $a86455099caa6415$var$putObjectRaw($a86455099caa6415$var$AwsExchangeIndexBucketName, indexObjectName, indexBytes);
        if (putRes.success) {
            console.log("Uploaded index file " + indexObjectName + ", " + indexBytes.length + " bytes.");
            result.success = true;
        }
    } catch (err) {
        console.error('Error in uploadIndex: ', err);
    }
    return result;
};
// Get index file from cloud or create new IndexFile object
// in case the index file is not found in the cloud.
const $a86455099caa6415$var$getOrCreateNewIndex = async (groupInfo)=>{
    let indexRes = await $a86455099caa6415$var$getIndexFromCloud(groupInfo);
    return indexRes.success ? indexRes.indexFile : $a86455099caa6415$var$isNotFoundError(indexRes.httpStatusCode) ? new $67cf979a1473aa80$exports() : null;
};
// Add entry to index file in the cloud
const $a86455099caa6415$var$addToIndex = async (hash, entry, groupInfo)=>{
    let indexFile = await $a86455099caa6415$var$getOrCreateNewIndex(groupInfo);
    if (indexFile) {
        indexFile.Entries[hash] = entry;
        return await $a86455099caa6415$var$uploadIndex(indexFile, groupInfo);
    }
    return {
        success: false
    };
};
// Remove entry from index
const $a86455099caa6415$var$removeFromIndex = async (entryHash, groupInfo)=>{
    let result = {
        success: false
    };
    let indexRes = await $a86455099caa6415$var$getIndexFromCloud(groupInfo);
    let indexFile = null;
    if (indexRes.success) indexFile = indexRes.indexFile;
    else if ($a86455099caa6415$var$isNotFoundError(indexRes.httpStatusCode)) // If index file is not found, then nothing needs to be removed
    result.success = true;
    if (indexFile) {
        try {
            // Remove the entry
            indexFile.RemoveEntry(entryHash);
        } catch (err) {
            console.error('Error in removing entry from index: ', err);
            return result;
        }
        return await $a86455099caa6415$var$uploadIndex(indexFile, groupInfo);
    }
    return result;
};
// Set the group name in the index file
const $a86455099caa6415$var$setGroupName = async function(groupName, groupInfo) {
    let indexFile = await $a86455099caa6415$var$getOrCreateNewIndex(groupInfo);
    if (indexFile) {
        indexFile.GroupName = groupName;
        return await $a86455099caa6415$var$uploadIndex(indexFile, groupInfo);
    }
    return {
        success: false
    };
};
// Verify that an entry is in the index file
// Polls the index file until entry is found or maxWaitingTime is reached
// entryHash : The hash of the entry to check
// encryptionKey : Encryption key for accessing the index file
//
// Returns object with the following properties:
// success : true if it was verified that the entry exists in the index file
// indexFile : The last index file object that was retrieved from the cloud
// in case it was verified.
const $a86455099caa6415$var$verifyIndexEntry = async function(entryHash, groupInfo) {
    let result = {};
    result.success = false;
    let startTime = new Date();
    try {
        let curTime = new Date();
        while(curTime - startTime < $b9e88d59535bb3ce$exports.VerificationTimeout){
            console.log('verifyIndexEntry request');
            let indexRes = await $a86455099caa6415$var$getIndexFromCloud(groupInfo);
            if (indexRes.success) {
                let indexFile = indexRes.indexFile;
                // See if we can find the entry
                if (entryHash in indexFile.Entries) {
                    // The entry is now in the index in the cloud
                    console.log('Index entry verified');
                    result.success = true;
                    result.indexFile = indexFile;
                    return result;
                }
            }
            await $2163fab358138a9e$exports.sleep($b9e88d59535bb3ce$exports.VerificationSleepTime);
            curTime = new Date();
        }
    } catch (err) {
        console.error('Error in verifyIndexEntry:', err);
    }
    return result;
};
// Polls cloud until group name is verified to be groupName
// groupName : The expected group name
// encryptionKey : Encryption key decrypting data from cloud
// Returns true if successfully verfied else false
const $a86455099caa6415$var$verifyGroupName = async function(groupName, groupInfo) {
    let startTime = new Date();
    try {
        let curTime = new Date();
        while(curTime - startTime < $b9e88d59535bb3ce$exports.VerificationTimeout){
            console.log('verifyGroupName request');
            let indexRes = await $a86455099caa6415$var$getIndexFromCloud(groupInfo);
            if (indexRes.success) {
                if (indexRes.indexFile.GroupName == groupName) {
                    console.log('Group name verified');
                    return true;
                }
            }
            await $2163fab358138a9e$exports.sleep($b9e88d59535bb3ce$exports.VerificationSleepTime);
            curTime = new Date();
        }
    } catch (err) {
        console.error('Error in verifyGroupName:', err);
    }
    return false;
};
// Create an invite code for an already existing group
const $a86455099caa6415$var$getNewInviteCode = async (encryptionKey, usageCode)=>{
    try {
        let bytesToAppend = null;
        if (usageCode !== null) bytesToAppend = new Uint8Array([
            usageCode,
            0
        ]);
        let bytesToSend = new Uint8Array(encryptionKey.length + (usageCode !== null ? bytesToAppend.length : 0));
        bytesToSend.set(encryptionKey, 0);
        if (usageCode !== null) bytesToSend.set(bytesToAppend, encryptionKey.length);
        let invCode = $4532b754c156253d$exports.createRandomInviteCode();
        let putRes = await $a86455099caa6415$var$putObjectRaw($a86455099caa6415$var$AwsExchangeKeyBucketName, "KEB/" + invCode, bytesToSend);
        if (putRes.success) return {
            success: true,
            inviteCode: invCode
        };
    } catch (err) {
        console.error('Error in getNewInviteCode', err);
    }
    return {
        success: false
    };
};
// Create new group in the cloud
// Get the encryption key for it
// and a 6 character invite code
const $a86455099caa6415$var$createGroup = async (usageCode)=>{
    var result = {};
    result.success = false;
    try {
        // Create new encryption key
        var encryptionKey = $4532b754c156253d$exports.createRandomEncryptionKey();
        var inviteRes = await $a86455099caa6415$var$getNewInviteCode(encryptionKey, usageCode);
        if (inviteRes.success) {
            result.encryptionKey = encryptionKey;
            result.inviteCode = inviteRes.inviteCode;
            result.success = true;
            return result;
        }
    } catch (err) {
        console.error('Error in createGroup: ', err);
    }
    return result;
};
// Makes a request to the cloud to get the group ID/encryption key
// in exchange for a 6 letter keycode
const $a86455099caa6415$var$getGroupID = async (keycode)=>{
    let result = {
        success: false
    };
    const getObjectResult = await $a86455099caa6415$var$getObject($a86455099caa6415$var$AwsExchangeKeyBucketName, "KEB/" + keycode);
    result.httpStatusCode = getObjectResult.httpStatusCode;
    if (getObjectResult.success) {
        const objectBytes = getObjectResult.objectBytes; // objectBytes is a Uint8Array
        if (objectBytes.length === 34) {
            // In cloud group version 1 there are 34 bytes in the exchange key file
            // The first 32 are they encryption key/group id, the last two are a usage code.
            // Need to do this in a bit of a special way to make sure that
            // both the Uint8Array and it's buffer both have only the first 32 bytes.
            // New ArrayBuffer
            const newBuffer = new ArrayBuffer(32);
            // Create a new Uint8Array view over the new ArrayBuffer
            result.groupID = new Uint8Array(newBuffer);
            // Copy the first 32 bytes from objectBytes to the new Uint8Array
            result.groupID.set(objectBytes.subarray(0, 32));
            result.version = $b9e88d59535bb3ce$exports.CurrentVersion;
        } else if (objectBytes.length === 32) {
            // Older cloud group version
            result.groupID = objectBytes;
            result.version = $b9e88d59535bb3ce$exports.CloudSystemVersionZero;
        } else throw new Error(`Unexpected byte length in exchange key file: ${objectBytes.length}`);
        result.success = true;
    }
    return result;
};
// For downloading a cloud resource in a browser
// Will download object with name objectName
// Uses multipart downloading or byte range downloading
// Takes care of decrypting the data
const $a86455099caa6415$var$getCloudFileBytes = async (objectName, encryptionKey, nrOfParts, cloudGroupVersion)=>{
    try {
        let getRes = null;
        if (nrOfParts === 0) {
            // If number of parts is 0, then we use the new way of downloading
            // We downloading using byte ranges
            // First, get the object size
            const headParams = {
                Bucket: $a86455099caa6415$var$AwsExchangeFileBucketName,
                Key: objectName
            };
            const headData = await $a86455099caa6415$var$s3.send(new $a86455099caa6415$require$HeadObjectCommand(headParams));
            const totalSize = headData.ContentLength;
            console.log(`Object size for byte range download: ${totalSize}`);
            if (totalSize > 0) getRes = await $a86455099caa6415$var$getObjectWithByteRanges($a86455099caa6415$var$AwsExchangeFileBucketName, objectName, totalSize);
            else {
                console.warn("Object size is 0, nothing to download.");
                return {
                    success: true,
                    decryptedBytes: new Uint8Array(0)
                };
            }
        } else // We use the old multipart download method
        getRes = await $a86455099caa6415$var$getMultiPartObjectBytes(objectName, nrOfParts);
        if (getRes && getRes.success) // Need to decrypt the data
        return {
            decryptedBytes: new Uint8Array($4532b754c156253d$exports.decryptObjectData(encryptionKey, cloudGroupVersion === $b9e88d59535bb3ce$exports.CloudSystemVersionZero ? objectName : $4532b754c156253d$exports.createHashBase64(encryptionKey), getRes.joinedBytes)),
            success: true
        };
    } catch (err) {
        console.error('Error in getCloudFile: ', err);
    }
    return {
        success: false
    };
};
// Opens save dialog to save bytes in a file
// bytes should be Uint8Array
// example of dataType for zip file: "application/zip"
// example filename: 'download.zip'
const $a86455099caa6415$var$saveBytesAsFile = function(bytes, dataType, filename) {
    var blob = new Blob([
        bytes
    ], {
        type: dataType
    });
    $90f256c567e4c320$exports.saveAs(blob, filename);
};
// Sort an array of entries by date
// newest first
const $a86455099caa6415$var$sortEntriesByDate = function(entries) {
    const compareMethod = function(a, b) {
        let aCreated = $2163fab358138a9e$exports.cloudEntryDateStringToDate(a.entryValue.Created);
        let bCreated = $2163fab358138a9e$exports.cloudEntryDateStringToDate(b.entryValue.Created);
        let diff = bCreated - aCreated;
        return diff;
    };
    entries = entries.sort(compareMethod);
    return entries;
};
$a86455099caa6415$exports = {
    getObject: $a86455099caa6415$var$getObject,
    putObject: $a86455099caa6415$var$putObject,
    addToIndex: $a86455099caa6415$var$addToIndex,
    putObjectRaw: $a86455099caa6415$var$putObjectRaw,
    getNewInviteCode: $a86455099caa6415$var$getNewInviteCode,
    createGroup: $a86455099caa6415$var$createGroup,
    verifyGroupName: $a86455099caa6415$var$verifyGroupName,
    verifyIndexEntry: $a86455099caa6415$var$verifyIndexEntry,
    getGroupID: $a86455099caa6415$var$getGroupID,
    getIndexFromCloud: $a86455099caa6415$var$getIndexFromCloud,
    setGroupName: $a86455099caa6415$var$setGroupName,
    getCloudFileBytes: $a86455099caa6415$var$getCloudFileBytes,
    saveBytesAsFile: $a86455099caa6415$var$saveBytesAsFile,
    sortEntriesByDate: $a86455099caa6415$var$sortEntriesByDate,
    getIndexObjectName: $a86455099caa6415$var$getIndexObjectName,
    getEntryObjectName: $a86455099caa6415$var$getEntryObjectName,
    getEntryObjectEncryptionKey: $a86455099caa6415$var$getEntryObjectEncryptionKey,
    removeFromIndex: $a86455099caa6415$var$removeFromIndex,
    createAndInitializeIndexFileEntry: $a86455099caa6415$var$createAndInitializeIndexFileEntry,
    multipartUpload: $a86455099caa6415$var$multipartUpload
};


var $9465db1467a1fca9$exports = {};
"use strict";
// Some code for dealing with .arkio files
/**
 * Reads a variable-length unsigned 32-bit integer from a Uint8Array.
 * @param {Uint8Array} buffer The buffer to read from.
 * @param {number} offset The starting offset in the buffer.
 * @returns {{value: number, newOffset: number}} The decoded value and the new offset after reading.
 */ const $9465db1467a1fca9$var$readVarUInt32 = function(buffer, offset) {
    let value = 0;
    let shift = 0;
    let currentOffset = offset;
    let byte;
    do {
        if (currentOffset >= buffer.length) throw new Error("Buffer underflow while reading VarInt");
        byte = buffer[currentOffset++];
        value |= (byte & 0x7f) << shift;
        shift += 7;
    }while (byte >= 128);
    return {
        value: value,
        newOffset: currentOffset
    };
};
/**
 * Writes a variable-length unsigned 32-bit integer.
 * @param {number} value The integer to write.
 * @returns {Uint8Array} A buffer containing the encoded integer.
 */ const $9465db1467a1fca9$var$writeVarUInt32 = function(value) {
    const bytes = [];
    while(value >= 0x80){
        bytes.push(value & 0x7f | 0x80);
        value >>>= 7;
    }
    bytes.push(value & 0x7f);
    return new Uint8Array(bytes);
};
/**
 * Extracts the JSON metadata preamble from the bytes of an .arkio file.
 * @param {Uint8Array} fileBytes The raw bytes of the .arkio file.
 * @returns {string} The metadata preamble as a JSON string.
 */ const $9465db1467a1fca9$var$getArkioPreamble = function(fileBytes) {
    // 1. Skip header (Magic Number + Version, 8 bytes total)
    const preambleLengthOffset = 8;
    // 2. Read preamble length (VarInt)
    const { value: preambleLength, newOffset: offsetAfterVarInt } = $9465db1467a1fca9$var$readVarUInt32(fileBytes, preambleLengthOffset);
    // 3. Read preamble
    const preambleBytes = fileBytes.slice(offsetAfterVarInt, offsetAfterVarInt + preambleLength);
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(preambleBytes);
};
/**
 * Updates the JSON metadata in an .arkio file's bytes.
 * @param {Uint8Array} originalFileBytes The raw bytes of the original .arkio file.
 * @param {string} newJsonPreamble The new metadata to write, as a JSON string.
 * @returns {Blob} A Blob containing the bytes of the new, updated .arkio file.
 */ const $9465db1467a1fca9$var$updateArkioPreamble = function(originalFileBytes, newJsonPreamble) {
    // 1. Get the header from the original file (first 8 bytes)
    const fileHeader = originalFileBytes.slice(0, 8);
    // 2. Find where the original preamble ends to get the rest of the file
    const { value: oldPreambleLength, newOffset: offsetAfterOldVarInt } = $9465db1467a1fca9$var$readVarUInt32(originalFileBytes, 8);
    const restOfFile = originalFileBytes.slice(offsetAfterOldVarInt + oldPreambleLength);
    // 3. Serialize the new JSON preamble into a compact string and encode it
    const parsedJson = JSON.parse(newJsonPreamble);
    const compactJsonString = JSON.stringify(parsedJson);
    const encoder = new TextEncoder();
    const newPreambleBytes = encoder.encode(compactJsonString);
    // 4. Encode the new preamble length as a VarInt
    const newPreambleLengthBytes = $9465db1467a1fca9$var$writeVarUInt32(newPreambleBytes.length);
    // 5. Assemble the new file from its parts and return as a Blob
    const newFileParts = [
        fileHeader,
        newPreambleLengthBytes,
        newPreambleBytes,
        restOfFile
    ];
    return new Blob(newFileParts, {
        type: 'application/octet-stream'
    });
};
$9465db1467a1fca9$exports = {
    readVarUInt32: $9465db1467a1fca9$var$readVarUInt32,
    writeVarUInt32: $9465db1467a1fca9$var$writeVarUInt32,
    getArkioPreamble: $9465db1467a1fca9$var$getArkioPreamble,
    updateArkioPreamble: $9465db1467a1fca9$var$updateArkioPreamble
};


// Makes these functions and objects available in the browser
window.Constants = $b9e88d59535bb3ce$exports;
window.DataUtil = $fbf091ffd61010f8$exports;
window.CryptoUtil = $4532b754c156253d$exports;
window.Util = $2163fab358138a9e$exports;
window.Cloud = $a86455099caa6415$exports;
window.ArkioFileUtil = $9465db1467a1fca9$exports;


//# sourceMappingURL=repo.2eaf6b16.js.map
